






var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, e) {
        return e.a = n, e.f = r, e;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(e) {
                return n(r, e);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(e) {
                return function(t) {
                    return n(r, e, t);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return n(r, e, t, a);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return n(r, e, t, a, u);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return n(r, e, t, a, u, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return function(o) {
                                    return n(r, e, t, a, u, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return n(r, e, t, a, u, i, o, c);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return r(9, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return n(r, e, t, a, u, i, o, c, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, e) {
        return 2 === n.a ? n.f(r, e) : n(r)(e);
    }
    function A3(n, r, e, t) {
        return 3 === n.a ? n.f(r, e, t) : n(r)(e)(t);
    }
    function A4(n, r, e, t, a) {
        return 4 === n.a ? n.f(r, e, t, a) : n(r)(e)(t)(a);
    }
    function A5(n, r, e, t, a, u) {
        return 5 === n.a ? n.f(r, e, t, a, u) : n(r)(e)(t)(a)(u);
    }
    function A6(n, r, e, t, a, u, i) {
        return 6 === n.a ? n.f(r, e, t, a, u, i) : n(r)(e)(t)(a)(u)(i);
    }
    function A7(n, r, e, t, a, u, i, o) {
        return 7 === n.a ? n.f(r, e, t, a, u, i, o) : n(r)(e)(t)(a)(u)(i)(o);
    }
    function A8(n, r, e, t, a, u, i, o, c) {
        return 8 === n.a ? n.f(r, e, t, a, u, i, o, c) : n(r)(e)(t)(a)(u)(i)(o)(c);
    }
    function A9(n, r, e, t, a, u, i, o, c, f) {
        return 9 === n.a ? n.f(r, e, t, a, u, i, o, c, f) : n(r)(e)(t)(a)(u)(i)(o)(c)(f);
    }
    function e(n, r) {
        for(var e, a = [], u = t(n, r, 0, a); u && (e = a.pop()); u = t(e.a, e.b, 0, a));
        return u;
    }
    function t(n, r, e, a) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && H(5), !1;
        if (e > 100) return a.push(o(n, r)), !0;
        for(var u in 0 > n.$ && (n = de(n), r = de(r)), n)if (!t(n[u], r[u], e + 1, a)) return !1;
        return !0;
    }
    var a = F2(e);
    function u(n, r, e) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (e = u(n.a, r.a)) || (e = u(n.b, r.b)) ? e : u(n.c, r.c);
        for(; n.b && r.b && !(e = u(n.a, r.a)); n = n.b, r = r.b);
        return e || (n.b ? 1 : r.b ? -1 : 0);
    }
    var i = F2(function(n, r) {
        var e = u(n, r);
        return 0 > e ? be : e ? fe : ce;
    });
    function o(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function c(n, r, e) {
        return {
            a: n,
            b: r,
            c: e
        };
    }
    function f(n) {
        return n;
    }
    function b(n, r) {
        var e = {};
        for(var t in n)e[t] = n[t];
        for(var t in r)e[t] = r[t];
        return e;
    }
    function s(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var e = d(n.a, r);
        n = n.b;
        for(var t = e; n.b; n = n.b)t = t.b = d(n.a, r);
        return e;
    }
    var M = {
        $: 0
    };
    function d(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var C = F2(d);
    function l(n) {
        for(var r = M, e = n.length; e--;)r = d(n[e], r);
        return r;
    }
    function v(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var g = F3(function(n, r, e) {
        for(var t = []; r.b && e.b; r = r.b, e = e.b)t.push(A2(n, r.a, e.a));
        return l(t);
    }), h = F2(function(n, r) {
        return l(v(r).sort(function(r, e) {
            return u(n(r), n(e));
        }));
    }), p = F2(function(n, r) {
        return l(v(r).sort(function(r, e) {
            var t = A2(n, r, e);
            return t === ce ? 0 : t === be ? -1 : 1;
        }));
    }), L = F3(function(n, r, e) {
        for(var t = Array(n), a = 0; n > a; a++)t[a] = e(r + a);
        return t;
    }), w = F2(function(n, r) {
        for(var e = Array(n), t = 0; n > t && r.b; t++)e[t] = r.a, r = r.b;
        return e.length = t, o(e, r);
    }), Z = F2(function(n, r) {
        return r[n];
    }), m = F3(function(n, r, e) {
        for(var t = e.length, a = Array(t), u = 0; t > u; u++)a[u] = e[u];
        return a[n] = r, a;
    }), S = F2(function(n, r) {
        for(var e = r.length, t = Array(e + 1), a = 0; e > a; a++)t[a] = r[a];
        return t[e] = n, t;
    }), $ = F3(function(n, r, e) {
        for(var t = e.length, a = 0; t > a; a++)r = A2(n, e[a], r);
        return r;
    }), D = F3(function(n, r, e) {
        for(var t = e.length - 1; t >= 0; t--)r = A2(n, e[t], r);
        return r;
    }), y = F2(function(n, r) {
        for(var e = r.length, t = Array(e), a = 0; e > a; a++)t[a] = n(r[a]);
        return t;
    }), z = F3(function(n, r, e) {
        for(var t = e.length, a = Array(t), u = 0; t > u; u++)a[u] = A2(n, r + u, e[u]);
        return a;
    }), K = F3(function(n, r, e) {
        return e.slice(n, r);
    }), x = F3(function(n, r, e) {
        var t = r.length, a = n - t;
        a > e.length && (a = e.length);
        for(var u = Array(t + a), i = 0; t > i; i++)u[i] = r[i];
        for(i = 0; a > i; i++)u[i + t] = e[i];
        return u;
    });
    function H(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var k = F2(function(n, r) {
        return n + r;
    }), B = F2(function(n, r) {
        var e = r % n;
        return 0 === n ? H(11) : e > 0 && 0 > n || 0 > e && n > 0 ? e + n : e;
    }), O = Math.ceil, G = Math.floor, W = Math.round, q = Math.sqrt, U = Math.log, A = F2(function(n, r) {
        return n + r;
    }), E = F3(function(n, r, e) {
        for(var t = e.length; t--;){
            var a = e[t], u = e.charCodeAt(t);
            56320 > u || u > 57343 || (a = e[--t] + a), r = A2(n, f(a), r);
        }
        return r;
    }), T = F2(function(n, r) {
        return r.split(n);
    }), I = F2(function(n, r) {
        return r.join(n);
    }), j = F3(function(n, r, e) {
        return e.slice(n, r);
    }), R = F2(function(n, r) {
        for(var e = r.length; e--;){
            var t = r[e], a = r.charCodeAt(e);
            if (56320 > a || a > 57343 || (t = r[--e] + t), !n(f(t))) return !1;
        }
        return !0;
    }), Q = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), P = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), V = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    }), F = F2(function(n, r) {
        var e = n.length;
        if (1 > e) return M;
        for(var t = 0, a = []; (t = r.indexOf(n, t)) > -1;)a.push(t), t += e;
        return l(a);
    });
    function N(n) {
        return n + "";
    }
    function J(n) {
        return {
            $: 2,
            b: n
        };
    }
    var _ = J(function(n) {
        return "number" != typeof n ? gn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? we(n) : !isFinite(n) || n % 1 ? gn("an INT", n) : we(n);
    }), Y = J(function(n) {
        return "boolean" == typeof n ? we(n) : gn("a BOOL", n);
    }), X = J(function(n) {
        return "number" == typeof n ? we(n) : gn("a FLOAT", n);
    }), nn = J(function(n) {
        return we(n);
    }), rn = J(function(n) {
        return "string" == typeof n ? we(n) : n instanceof String ? we(n + "") : gn("a STRING", n);
    }), en = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function tn(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var an = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), un = F2(function(n, r) {
        return tn(n, [
            r
        ]);
    }), on = F3(function(n, r, e) {
        return tn(n, [
            r,
            e
        ]);
    }), cn = F4(function(n, r, e, t) {
        return tn(n, [
            r,
            e,
            t
        ]);
    }), fn = F7(function(n, r, e, t, a, u, i) {
        return tn(n, [
            r,
            e,
            t,
            a,
            u,
            i
        ]);
    }), bn = F9(function(n, r, e, t, a, u, i, o, c) {
        return tn(n, [
            r,
            e,
            t,
            a,
            u,
            i,
            o,
            c
        ]);
    }), sn = F2(function(n, r) {
        try {
            return dn(n, JSON.parse(r));
        } catch (n) {
            return ge(A2(he, "This is not valid JSON! " + n.message, r));
        }
    }), Mn = F2(function(n, r) {
        return dn(n, r);
    });
    function dn(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? we(n.c) : gn("null", r);
            case 3:
                return ln(r) ? Cn(n.b, r, l) : gn("a LIST", r);
            case 4:
                return ln(r) ? Cn(n.b, r, vn) : gn("an ARRAY", r);
            case 6:
                var e = n.d;
                if ("object" != typeof r || null === r || !(e in r)) return gn("an OBJECT with a field named `" + e + "`", r);
                var t = dn(n.b, r[e]);
                return Ct(t) ? t : ge(A2(pe, e, t.a));
            case 7:
                var a = n.e;
                return ln(r) ? r.length > a ? (t = dn(n.b, r[a]), Ct(t) ? t : ge(A2(Le, a, t.a))) : gn("a LONGER array. Need index " + a + " but only see " + r.length + " entries", r) : gn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || ln(r)) return gn("an OBJECT", r);
                var u = M;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (t = dn(n.b, r[i]), !Ct(t)) return ge(A2(pe, i, t.a));
                    u = d(o(i, t.a), u);
                }
                return we(Ie(u));
            case 9:
                for(var c = n.f, f = n.g, b = 0; f.length > b; b++){
                    if (t = dn(f[b], r), !Ct(t)) return t;
                    c = c(t.a);
                }
                return we(c);
            case 10:
                return t = dn(n.b, r), Ct(t) ? dn(n.h(t.a), r) : t;
            case 11:
                for(var s = M, C = n.g; C.b; C = C.b){
                    if (t = dn(C.a, r), Ct(t)) return t;
                    s = d(t.a, s);
                }
                return ge(Ze(Ie(s)));
            case 1:
                return ge(A2(he, n.a, r));
            case 0:
                return we(n.a);
        }
    }
    function Cn(n, r, e) {
        for(var t = r.length, a = Array(t), u = 0; t > u; u++){
            var i = dn(n, r[u]);
            if (!Ct(i)) return ge(A2(Le, u, i.a));
            a[u] = i.a;
        }
        return we(e(a));
    }
    function ln(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function vn(n) {
        return A2(dt, n.length, function(r) {
            return n[r];
        });
    }
    function gn(n, r) {
        return ge(A2(he, "Expecting " + n, r));
    }
    function hn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return hn(n.b, r.b);
            case 6:
                return n.d === r.d && hn(n.b, r.b);
            case 7:
                return n.e === r.e && hn(n.b, r.b);
            case 9:
                return n.f === r.f && pn(n.g, r.g);
            case 10:
                return n.h === r.h && hn(n.b, r.b);
            case 11:
                return pn(n.g, r.g);
        }
    }
    function pn(n, r) {
        var e = n.length;
        if (e !== r.length) return !1;
        for(var t = 0; e > t; t++)if (!hn(n[t], r[t])) return !1;
        return !0;
    }
    var Ln = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function wn(n) {
        return n;
    }
    function Zn(n) {
        return n;
    }
    var mn = F3(function(n, r, e) {
        return e[n] = r, e;
    });
    function Sn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function $n(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var Dn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), yn = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), zn = 0;
    function Kn(n) {
        var r = {
            $: 0,
            e: zn++,
            f: n,
            g: null,
            h: []
        };
        return Gn(r), r;
    }
    function xn(n) {
        return $n(function(r) {
            r(Sn(Kn(n)));
        });
    }
    function Hn(n, r) {
        n.h.push(r), Gn(n);
    }
    var kn = F2(function(n, r) {
        return $n(function(e) {
            Hn(n, r), e(Sn(0));
        });
    }), Bn = !1, On = [];
    function Gn(n) {
        if (On.push(n), !Bn) {
            for(Bn = !0; n = On.shift();)Wn(n);
            Bn = !1;
        }
    }
    function Wn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, Gn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function qn(n) {
        return $n(function(r) {
            var e = setTimeout(function() {
                r(Sn(0));
            }, n);
            return function() {
                clearTimeout(e);
            };
        });
    }
    var Un = {};
    function An(n, r, e, t, a) {
        return {
            b: n,
            c: r,
            d: e,
            e: t,
            f: a
        };
    }
    function En(n, r) {
        var e = {
            g: r,
            h: void 0
        }, t = n.c, a = n.d, u = n.e, i = n.f;
        function o(n) {
            return A2(Dn, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(a, e, o, n) : u && i ? A4(t, e, o.i, o.j, n) : A3(t, e, u ? o.i : o.j, n);
                }
            });
        }
        return e.h = Kn(A2(Dn, o, n.b));
    }
    var Tn = F2(function(n, r) {
        return $n(function(e) {
            n.g(r), e(Sn(0));
        });
    }), In = F2(function(n, r) {
        return A2(kn, n.h, {
            $: 0,
            a: r
        });
    });
    function jn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function Rn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Qn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), Pn = [], Vn = !1;
    function Fn(n, r, e) {
        if (Pn.push({
            p: n,
            q: r,
            r: e
        }), !Vn) {
            Vn = !0;
            for(var t; t = Pn.shift();)Nn(t.p, t.q, t.r);
            Vn = !1;
        }
    }
    function Nn(n, r, e) {
        var t = {};
        for(var a in Jn(!0, r, t, null), Jn(!1, e, t, null), n)Hn(n[a], {
            $: "fx",
            a: t[a] || {
                i: M,
                j: M
            }
        });
    }
    function Jn(n, r, e, t) {
        switch(r.$){
            case 1:
                var a = r.k, u = function(n, r, e, t) {
                    function a(n) {
                        for(var r = e; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? Un[r].e : Un[r].f, a, t);
                }(n, a, t, r.l);
                return void (e[a] = function(n, r, e) {
                    return e = e || {
                        i: M,
                        j: M
                    }, n ? e.i = d(r, e.i) : e.j = d(r, e.j), e;
                }(n, u, e[a]));
            case 2:
                for(var i = r.m; i.b; i = i.b)Jn(n, i.a, e, t);
                return;
            case 3:
                return void Jn(n, r.o, e, {
                    s: r.n,
                    t: t
                });
        }
    }
    function _n(n) {
        Un[n] && H(3);
    }
    function Yn(n, r) {
        return _n(n), Un[n] = {
            e: Xn,
            u: r,
            a: nr
        }, jn(n);
    }
    var Xn = F2(function(n, r) {
        return r;
    });
    function nr(n) {
        var r = [], e = Un[n].u, t = qn(0);
        return Un[n].b = t, Un[n].c = F3(function(n, a) {
            for(; a.b; a = a.b)for(var u = r, i = Zn(e(a.a)), o = 0; u.length > o; o++)u[o](i);
            return t;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var e = (r = r.slice()).indexOf(n);
                0 > e || r.splice(e, 1);
            }
        };
    }
    function rr(n, r) {
        return _n(n), Un[n] = {
            f: tr,
            u: r,
            a: ar
        }, jn(n);
    }
    var er, tr = F2(function(n, r) {
        return function(e) {
            return n(r(e));
        };
    });
    function ar(n, r) {
        var e = M, t = Un[n].u, a = Sn(null);
        return Un[n].b = a, Un[n].c = F3(function(n, r) {
            return e = r, a;
        }), {
            send: function(n) {
                var a = A2(Mn, t, n);
                Ct(a) || H(4);
                for(var u = a.a, i = e; i.b; i = i.b)r(i.a(u));
            }
        };
    }
    var ur = "undefined" != typeof document ? document : {};
    function ir(n, r) {
        n.appendChild(r);
    }
    function or(n) {
        return {
            $: 0,
            a: n
        };
    }
    var cr, fr = F2(function(n, r) {
        return F2(function(e, t) {
            for(var a = [], u = 0; t.b; t = t.b){
                var i = t.a;
                u += i.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 1,
                c: r,
                d: Sr(e),
                e: a,
                f: n,
                b: u
            };
        });
    }), br = fr(void 0), sr = F2(function(n, r) {
        return F2(function(e, t) {
            for(var a = [], u = 0; t.b; t = t.b){
                var i = t.a;
                u += i.b.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 2,
                c: r,
                d: Sr(e),
                e: a,
                f: n,
                b: u
            };
        });
    })(void 0), Mr = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), dr = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), Cr = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), lr = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), vr = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), gr = F3(function(n, r, e) {
        return {
            $: "a4",
            n: r,
            o: {
                f: n,
                o: e
            }
        };
    }), hr = /^script$/i, pr = /^(on|formAction$)/i, Lr = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, wr = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function Zr(n) {
        return hr.test(n) ? "p" : n;
    }
    function mr(n) {
        return wr.test(n) ? "" : n;
    }
    function Sr(n) {
        for(var r = {}; n.b; n = n.b){
            var e = n.a, t = e.$, a = e.n, u = e.o;
            if ("a2" !== t) {
                var i = r[t] || (r[t] = {});
                "a3" === t && "class" === a ? $r(i, a, u) : i[a] = u;
            } else "className" === a ? $r(r, a, Zn(u)) : r[a] = Zn(u);
        }
        return r;
    }
    function $r(n, r, e) {
        var t = n[r];
        n[r] = t ? t + " " + e : e;
    }
    function Dr(n, r) {
        var e = n.$;
        if (5 === e) return Dr(n.k || (n.k = n.m()), r);
        if (0 === e) return ur.createTextNode(n.a);
        if (4 === e) {
            for(var t = n.k, a = n.j; 4 === t.$;)"object" != typeof a ? a = [
                a,
                t.j
            ] : a.push(t.j), t = t.k;
            var u = {
                j: a,
                p: r
            };
            return (i = Dr(t, u)).elm_event_node_ref = u, i;
        }
        if (3 === e) return yr(i = n.h(n.g), r, n.d), i;
        var i = n.f ? ur.createElementNS(n.f, n.c) : ur.createElement(n.c);
        er && "a" == n.c && i.addEventListener("click", er(i)), yr(i, r, n.d);
        for(var o = n.e, c = 0; o.length > c; c++)ir(i, Dr(1 === e ? o[c] : o[c].b, r));
        return i;
    }
    function yr(n, r, e) {
        for(var t in e){
            var a = e[t];
            "a1" === t ? zr(n, a) : "a0" === t ? Hr(n, r, a) : "a3" === t ? Kr(n, a) : "a4" === t ? xr(n, a) : ("value" !== t && "checked" !== t || n[t] !== a) && (n[t] = a);
        }
    }
    function zr(n, r) {
        var e = n.style;
        for(var t in r)e[t] = r[t];
    }
    function Kr(n, r) {
        for(var e in r){
            var t = r[e];
            void 0 !== t ? n.setAttribute(e, t) : n.removeAttribute(e);
        }
    }
    function xr(n, r) {
        for(var e in r){
            var t = r[e], a = t.f, u = t.o;
            void 0 !== u ? n.setAttributeNS(a, e, u) : n.removeAttributeNS(a, e);
        }
    }
    function Hr(n, r, e) {
        var t = n.elmFs || (n.elmFs = {});
        for(var a in e){
            var u = e[a], i = t[a];
            if (u) {
                if (i) {
                    if (i.q.$ === u.$) {
                        i.q = u;
                        continue;
                    }
                    n.removeEventListener(a, i);
                }
                i = kr(r, u), n.addEventListener(a, i, cr && {
                    passive: 2 > ht(u)
                }), t[a] = i;
            } else n.removeEventListener(a, i), t[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                cr = !0;
            }
        }));
    } catch (n) {}
    function kr(n, r) {
        function e(r) {
            var t = e.q, a = dn(t.a, r);
            if (Ct(a)) {
                for(var u, i = ht(t), o = a.a, c = i ? 3 > i ? o.a : o.cN : o, f = 1 == i ? o.b : 3 == i && o.as, b = (f && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.ao) && r.preventDefault(), n); u = b.j;){
                    if ("function" == typeof u) c = u(c);
                    else for(var s = u.length; s--;)c = u[s](c);
                    b = b.p;
                }
                b(c, f);
            }
        }
        return e.q = r, e;
    }
    function Br(n, r) {
        return n.$ == r.$ && hn(n.a, r.a);
    }
    function Or(n, r, e, t) {
        var a = {
            $: r,
            r: e,
            s: t,
            t: void 0,
            u: void 0
        };
        return n.push(a), a;
    }
    function Gr(n, r, e, t) {
        if (n !== r) {
            var a = n.$, u = r.$;
            if (a !== u) {
                if (1 !== a || 2 !== u) return void Or(e, 0, t, r);
                r = function(n) {
                    for(var r = n.e, e = r.length, t = Array(e), a = 0; e > a; a++)t[a] = r[a].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: t,
                        f: n.f,
                        b: n.b
                    };
                }(r), u = 1;
            }
            switch(u){
                case 5:
                    for(var i = n.l, o = r.l, c = i.length, f = c === o.length; f && c--;)f = i[c] === o[c];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var b = [];
                    return Gr(n.k, r.k, b, 0), void (b.length > 0 && Or(e, 1, t, b));
                case 4:
                    for(var s = n.j, M = r.j, d = !1, C = n.k; 4 === C.$;)d = !0, "object" != typeof s ? s = [
                        s,
                        C.j
                    ] : s.push(C.j), C = C.k;
                    for(var l = r.k; 4 === l.$;)d = !0, "object" != typeof M ? M = [
                        M,
                        l.j
                    ] : M.push(l.j), l = l.k;
                    return d && s.length !== M.length ? void Or(e, 0, t, r) : ((d ? function(n, r) {
                        for(var e = 0; n.length > e; e++)if (n[e] !== r[e]) return !1;
                        return !0;
                    }(s, M) : s === M) || Or(e, 2, t, M), void Gr(C, l, e, t + 1));
                case 0:
                    return void (n.a !== r.a && Or(e, 3, t, r.a));
                case 1:
                    return void Wr(n, r, e, t, Ur);
                case 2:
                    return void Wr(n, r, e, t, Ar);
                case 3:
                    if (n.h !== r.h) return void Or(e, 0, t, r);
                    var v = qr(n.d, r.d);
                    v && Or(e, 4, t, v);
                    var g = r.i(n.g, r.g);
                    return void (g && Or(e, 5, t, g));
            }
        }
    }
    function Wr(n, r, e, t, a) {
        if (n.c === r.c && n.f === r.f) {
            var u = qr(n.d, r.d);
            u && Or(e, 4, t, u), a(n, r, e, t);
        } else Or(e, 0, t, r);
    }
    function qr(n, r, e) {
        var t;
        for(var a in n)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in r) {
                var u = n[a], i = r[a];
                u === i && "value" !== a && "checked" !== a || "a0" === e && Br(u, i) || ((t = t || {})[a] = i);
            } else (t = t || {})[a] = e ? "a1" === e ? "" : "a0" === e || "a3" === e ? void 0 : {
                f: n[a].f,
                o: void 0
            } : "string" == typeof n[a] ? "" : null;
        } else {
            var o = qr(n[a], r[a] || {}, a);
            o && ((t = t || {})[a] = o);
        }
        for(var c in r)c in n || ((t = t || {})[c] = r[c]);
        return t;
    }
    function Ur(n, r, e, t) {
        var a = n.e, u = r.e, i = a.length, o = u.length;
        i > o ? Or(e, 6, t, {
            v: o,
            i: i - o
        }) : o > i && Or(e, 7, t, {
            v: i,
            e: u
        });
        for(var c = o > i ? i : o, f = 0; c > f; f++){
            var b = a[f];
            Gr(b, u[f], e, ++t), t += b.b || 0;
        }
    }
    function Ar(n, r, e, t) {
        for(var a = [], u = {}, i = [], o = n.e, c = r.e, f = o.length, b = c.length, s = 0, M = 0, d = t; f > s && b > M;){
            var C = (D = o[s]).a, l = (y = c[M]).a, v = D.b, g = y.b, h = void 0, p = void 0;
            if (C !== l) {
                var L = o[s + 1], w = c[M + 1];
                if (L) {
                    var Z = L.a, m = L.b;
                    p = l === Z;
                }
                if (w) {
                    var S = w.a, $ = w.b;
                    h = C === S;
                }
                if (h && p) Gr(v, $, a, ++d), Tr(u, a, C, g, M, i), d += v.b || 0, Ir(u, a, C, m, ++d), d += m.b || 0, s += 2, M += 2;
                else if (h) d++, Tr(u, a, l, g, M, i), Gr(v, $, a, d), d += v.b || 0, s += 1, M += 2;
                else if (p) Ir(u, a, C, v, ++d), d += v.b || 0, Gr(m, g, a, ++d), d += m.b || 0, s += 2, M += 1;
                else {
                    if (!L || Z !== S) break;
                    Ir(u, a, C, v, ++d), Tr(u, a, l, g, M, i), d += v.b || 0, Gr(m, $, a, ++d), d += m.b || 0, s += 2, M += 2;
                }
            } else Gr(v, g, a, ++d), d += v.b || 0, s++, M++;
        }
        for(; f > s;){
            var D;
            d++, Ir(u, a, (D = o[s]).a, v = D.b, d), d += v.b || 0, s++;
        }
        for(; b > M;){
            var y, z = z || [];
            Tr(u, a, (y = c[M]).a, y.b, void 0, z), M++;
        }
        (a.length > 0 || i.length > 0 || z) && Or(e, 8, t, {
            w: a,
            x: i,
            y: z
        });
    }
    var Er = "_elmW6BL";
    function Tr(n, r, e, t, a, u) {
        var i = n[e];
        if (!i) return u.push({
            r: a,
            A: i = {
                c: 0,
                z: t,
                r: a,
                s: void 0
            }
        }), void (n[e] = i);
        if (1 === i.c) {
            u.push({
                r: a,
                A: i
            }), i.c = 2;
            var o = [];
            return Gr(i.z, t, o, i.r), i.r = a, void (i.s.s = {
                w: o,
                A: i
            });
        }
        Tr(n, r, e + Er, t, a, u);
    }
    function Ir(n, r, e, t, a) {
        var u = n[e];
        if (u) {
            if (0 === u.c) {
                u.c = 2;
                var i = [];
                return Gr(t, u.z, i, a), void Or(r, 9, a, {
                    w: i,
                    A: u
                });
            }
            Ir(n, r, e + Er, t, a);
        } else {
            var o = Or(r, 9, a, void 0);
            n[e] = {
                c: 1,
                z: t,
                r: a,
                s: o
            };
        }
    }
    function jr(n, r, e, t) {
        Rr(n, r, e, 0, 0, r.b, t);
    }
    function Rr(n, r, e, t, a, u, i) {
        for(var o = e[t], c = o.r; c === a;){
            var f = o.$;
            if (1 === f) jr(n, r.k, o.s, i);
            else if (8 === f) o.t = n, o.u = i, (b = o.s.w).length > 0 && Rr(n, r, b, 0, a, u, i);
            else if (9 === f) {
                o.t = n, o.u = i;
                var b, s = o.s;
                s && (s.A.s = n, (b = s.w).length > 0 && Rr(n, r, b, 0, a, u, i));
            } else o.t = n, o.u = i;
            if (!(o = e[++t]) || (c = o.r) > u) return t;
        }
        var M = r.$;
        if (4 === M) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return Rr(n, d, e, t, a + 1, u, n.elm_event_node_ref);
        }
        for(var C = r.e, l = n.childNodes, v = 0; C.length > v; v++){
            a++;
            var g = 1 === M ? C[v] : C[v].b, h = a + (g.b || 0);
            if (!(a > c || c > h || (o = e[t = Rr(l[v], g, e, t, a, h, i)]) && (c = o.r) <= u)) return t;
            a = h;
        }
        return t;
    }
    function Qr(n, r) {
        for(var e = 0; r.length > e; e++){
            var t = r[e], a = t.t, u = Pr(a, t);
            a === n && (n = u);
        }
        return n;
    }
    function Pr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, e) {
                    var t = n.parentNode, a = Dr(r, e);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = n.elm_event_node_ref), t && a !== n && t.replaceChild(a, n), a;
                }(n, r.s, r.u);
            case 4:
                return yr(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Qr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var e = r.s, t = 0; e.i > t; t++)n.removeChild(n.childNodes[e.v]);
                return n;
            case 7:
                for(var a = (e = r.s).e, u = n.childNodes[t = e.v]; a.length > t; t++)n.insertBefore(Dr(a[t], r.u), u);
                return n;
            case 9:
                if (!(e = r.s)) return n.parentNode.removeChild(n), n;
                var i = e.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Qr(n, e.w), n;
            case 8:
                return function(n, r) {
                    var e = r.s, t = function(n, r) {
                        if (n) {
                            for(var e = ur.createDocumentFragment(), t = 0; n.length > t; t++){
                                var a = n[t].A;
                                ir(e, 2 === a.c ? a.s : Dr(a.z, r.u));
                            }
                            return e;
                        }
                    }(e.y, r);
                    n = Qr(n, e.w);
                    for(var a = e.x, u = 0; a.length > u; u++){
                        var i = a[u], o = i.A, c = 2 === o.c ? o.s : Dr(o.z, r.u);
                        n.insertBefore(c, n.childNodes[i.r]);
                    }
                    return t && ir(n, t), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                H(10);
        }
    }
    function Vr(n) {
        if (3 === n.nodeType) return or(n.textContent);
        if (1 !== n.nodeType) return or("");
        for(var r = M, e = n.attributes, t = e.length; t--;){
            var a = e[t];
            r = d(A2(vr, a.name, a.value), r);
        }
        var u = n.tagName.toLowerCase(), i = M, o = n.childNodes;
        for(t = o.length; t--;)i = d(Vr(o[t]), i);
        return A3(br, u, r, i);
    }
    var Fr = F4(function(n, r, e, t) {
        return function(n, r, e, t, a, u) {
            var i = A2(Mn, n, r ? r.flags : void 0);
            Ct(i) || H(2);
            var o = {}, c = e(i.a), f = c.a, b = u(M, f), s = function(n, r) {
                var e;
                for(var t in Un){
                    var a = Un[t];
                    a.a && ((e = e || {})[t] = a.a(t, r)), n[t] = En(a, r);
                }
                return e;
            }(o, M);
            function M(n, r) {
                var e = A2(t, n, f);
                b(f = e.a, r), Fn(o, e.b, a(f));
            }
            return Fn(o, c.b, a(f)), s ? {
                ports: s
            } : {};
        }(r, t, n.cv, n.dF, n.dq, function(r, e) {
            var t = n.aq && n.aq(r), a = n.dI, u = ur.title, i = ur.body, o = Vr(i);
            return function(n, r) {
                r(n);
                var e = 0;
                function t() {
                    e = 1 === e ? 0 : (Nr(t), r(n), 1);
                }
                return function(a, u) {
                    n = a, u ? (r(n), 2 === e && (e = 1)) : (0 === e && Nr(t), e = 2);
                };
            }(e, function(n) {
                er = t;
                var e = a(n), c = br("body")(M)(e.bI), f = function(n, r) {
                    var e = [];
                    return Gr(n, r, e, 0), e;
                }(o, c);
                i = function(n, r, e, t) {
                    return 0 === e.length ? n : (jr(n, r, e, t), Qr(n, e));
                }(i, o, f, r), o = c, er = 0, u !== e.dy && (ur.title = u = e.dy);
            });
        });
    }), Nr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    function Jr() {
        return Ot(ur.location.href).a || H(1);
    }
    var _r = F2(function(n, r) {
        return A2(Jt, Gt, $n(function() {
            history.pushState({}, "", r), n();
        }));
    }), Yr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, Xr = "undefined" != typeof document ? document : Yr, ne = "undefined" != typeof window ? window : Yr, re = F3(function(n, r, e) {
        return xn($n(function() {
            function t(n) {
                Kn(e(n));
            }
            return n.addEventListener(r, t, cr && {
                passive: !0
            }), function() {
                n.removeEventListener(r, t);
            };
        }));
    }), ee = F2(function(n, r) {
        var e = dn(n, r);
        return Ct(e) ? Se(e.a) : $e;
    });
    var te = F3(function(n, r, e) {
        return $n(function(t) {
            function a(n) {
                t(r(e.b5.a(n)));
            }
            var u = new XMLHttpRequest;
            u.addEventListener("error", function() {
                a(_i);
            }), u.addEventListener("timeout", function() {
                a(no);
            }), u.addEventListener("load", function() {
                a(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? Ji : Fi, function(n) {
                        return {
                            dG: n.responseURL,
                            dk: n.status,
                            dl: n.statusText,
                            aD: ae(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(e.b5.b, u));
            }), ro(e.be) && function(n, r, e) {
                r.upload.addEventListener("progress", function(t) {
                    r.c || Kn(A2(eo, n, o(e, Xi({
                        dd: t.loaded,
                        a7: t.total
                    }))));
                }), r.addEventListener("progress", function(t) {
                    r.c || Kn(A2(eo, n, o(e, Yi({
                        c5: t.loaded,
                        a7: t.lengthComputable ? Se(t.total) : $e
                    }))));
                });
            }(n, u, e.be.a);
            try {
                u.open(e.cO, e.dG, !0);
            } catch (n) {
                return a(Ni(e.dG));
            }
            return function(n, r) {
                for(var e = r.aD; e.b; e = e.b)n.setRequestHeader(e.a.a, e.a.b);
                n.timeout = r.dx.a || 0, n.responseType = r.b5.d, n.withCredentials = r.bp;
            }(u, e), e.bI.a && u.setRequestHeader("Content-Type", e.bI.a), u.send(e.bI.b), function() {
                u.c = !0, u.abort();
            };
        });
    });
    function ae(n) {
        if (!n) return eu;
        for(var r = eu, e = n.split("\r\n"), t = e.length; t--;){
            var a = e[t], u = a.indexOf(": ");
            if (u > 0) {
                var i = a.substring(0, u), o = a.substring(u + 2);
                r = A3(to, i, function(n) {
                    return Se(ro(n) ? o + ", " + n.a : o);
                }, r);
            }
        }
        return r;
    }
    var ue = F3(function(n, r, e) {
        return {
            $: 0,
            d: n,
            b: r,
            a: e
        };
    }), ie = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(e) {
                return n(r.a(e));
            }
        };
    }), oe = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ce = 1, fe = 2, be = 0, se = C, Me = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.d, a = n, u = A3(n, e.b, e.c, A3(Me, n, r, e.e));
            n = a, r = u, e = t;
        }
    }), de = function(n) {
        return A3(Me, F3(function(n, r, e) {
            return A2(se, o(n, r), e);
        }), M, n);
    }, Ce = D, le = F3(function(n, r, e) {
        var t = e.c, a = e.d, u = F2(function(r, e) {
            return A3(Ce, r.$ ? n : u, e, r.a);
        });
        return A3(Ce, u, A3(Ce, n, r, a), t);
    }), ve = function(n) {
        return A3(le, se, M, n);
    }, ge = function(n) {
        return {
            $: 1,
            a: n
        };
    }, he = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), pe = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Le = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), we = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ze = function(n) {
        return {
            $: 2,
            a: n
        };
    }, me = k, Se = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $e = {
        $: 1
    }, De = R, ye = Ln, ze = N, Ke = F2(function(n, r) {
        return A2(I, n, v(r));
    }), xe = F2(function(n, r) {
        return l(A2(T, n, r));
    }), He = function(n) {
        return A2(Ke, "\n    ", A2(xe, "\n", n));
    }, ke = F3(function(n, r, e) {
        for(;;){
            if (!e.b) return r;
            var t = e.b, a = n, u = A2(n, e.a, r);
            n = a, r = u, e = t;
        }
    }), Be = function(n) {
        return A3(ke, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Oe = g, Ge = F3(function(n, r, e) {
        for(;;){
            if (u(n, r) >= 1) return e;
            var t = n, a = r - 1, i = A2(se, r, e);
            n = t, r = a, e = i;
        }
    }), We = F2(function(n, r) {
        return A3(Ge, n, r, M);
    }), qe = F2(function(n, r) {
        return A3(Oe, n, A2(We, 0, Be(r) - 1), r);
    }), Ue = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Ae = function(n) {
        var r = Ue(n);
        return r >= 97 && 122 >= r;
    }, Ee = function(n) {
        var r = Ue(n);
        return 90 >= r && r >= 65;
    }, Te = function(n) {
        return Ae(n) || Ee(n) || function(n) {
            var r = Ue(n);
            return 57 >= r && r >= 48;
        }(n);
    }, Ie = function(n) {
        return A3(ke, se, M, n);
    }, je = F2(function(n, r) {
        return "\n\n(" + ze(n + 1) + ") " + He(Re(r));
    }), Re = function(n) {
        return A2(Qe, n, M);
    }, Qe = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var e = n.a, t = n.b, a = function() {
                    var n, r, t = (r = (n = e).charCodeAt(0), isNaN(r) ? $e : Se(55296 > r || r > 56319 ? o(n[0], n.slice(1)) : o(n[0] + n[1], n.slice(2))));
                    if (1 === t.$) return !1;
                    var a, u = t.a, i = u.b;
                    return (Ae(a = u.a) || Ee(a)) && A2(De, Te, i);
                }();
                n = t, r = A2(se, a ? "." + e : "['" + e + "']", r);
                continue n;
            case 1:
                t = n.b;
                var u = "[" + ze(n.a) + "]";
                n = t, r = A2(se, u, r);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var c = function() {
                            return r.b ? "The Json.Decode.oneOf at json" + A2(Ke, "", Ie(r)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + ze(Be(i)) + " ways:";
                        return A2(Ke, "\n\n", A2(se, c, A2(qe, je, i)));
                    }
                    n = t = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return r.b ? " at json" + A2(Ke, "", Ie(r)) : "!";
                }();
            default:
                var f = n.a, b = n.b;
                return (c = function() {
                    return r.b ? "Problem with the value at json" + A2(Ke, "", Ie(r)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + (He(A2(ye, 4, b)) + "\n\n") + f;
        }
    }), Pe = 32, Ve = F4(function(n, r, e, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), Fe = [], Ne = O, Je = F2(function(n, r) {
        return U(r) / U(n);
    }), _e = Ne(A2(Je, 2, Pe)), Ye = A4(Ve, 0, _e, Fe, Fe), Xe = L, nt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rt = F2(function(n, r) {
        return n(r);
    }), et = a, tt = G, at = function(n) {
        return n.length;
    }, ut = F2(function(n, r) {
        return u(n, r) > 0 ? n : r;
    }), it = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ot = w, ct = F2(function(n, r) {
        for(;;){
            var e = A2(ot, Pe, n), t = e.b, a = A2(se, it(e.a), r);
            if (!t.b) return Ie(a);
            n = t, r = a;
        }
    }), ft = function(n) {
        return n.a;
    }, bt = F2(function(n, r) {
        for(;;){
            var e = Ne(r / Pe);
            if (1 === e) return A2(ot, Pe, n).a;
            n = A2(ct, n, M), r = e;
        }
    }), st = F2(function(n, r) {
        if (r.a) {
            var e = r.a * Pe, t = tt(A2(Je, Pe, e - 1)), a = n ? Ie(r.d) : r.d, u = A2(bt, a, r.a);
            return A4(Ve, at(r.c) + e, A2(ut, 5, t * _e), u, r.c);
        }
        return A4(Ve, at(r.c), _e, Fe, r.c);
    }), Mt = F5(function(n, r, e, t, a) {
        for(;;){
            if (0 > r) return A2(st, !1, {
                d: t,
                a: e / Pe | 0,
                c: a
            });
            var u = nt(A3(Xe, Pe, r, n));
            r -= Pe, t = A2(se, u, t);
        }
    }), dt = F2(function(n, r) {
        if (n > 0) {
            var e = n % Pe;
            return A5(Mt, r, n - e - Pe, n, M, A3(Xe, e, n - e, r));
        }
        return Ye;
    }), Ct = function(n) {
        return !n.$;
    }, lt = un, vt = on, gt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ht = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, pt = function(n) {
        return n;
    }, Lt = F6(function(n, r, e, t, a, u) {
        return {
            aB: u,
            aG: r,
            aR: t,
            aT: e,
            aW: n,
            aX: a
        };
    }), wt = Q, Zt = function(n) {
        return n.length;
    }, mt = j, St = F2(function(n, r) {
        return 1 > n ? r : A3(mt, n, Zt(r), r);
    }), $t = F, Dt = function(n) {
        return "" === n;
    }, yt = F2(function(n, r) {
        return 1 > n ? "" : A3(mt, 0, n, r);
    }), zt = function(n) {
        for(var r = 0, e = n.charCodeAt(0), t = 43 == e || 45 == e ? 1 : 0, a = t; n.length > a; ++a){
            var u = n.charCodeAt(a);
            if (48 > u || u > 57) return $e;
            r = 10 * r + u - 48;
        }
        return a == t ? $e : Se(45 == e ? -r : r);
    }, Kt = F5(function(n, r, e, t, a) {
        if (Dt(a) || A2(wt, "@", a)) return $e;
        var u = A2($t, ":", a);
        if (u.b) {
            if (u.b.b) return $e;
            var i = u.a, o = zt(A2(St, i + 1, a));
            if (1 === o.$) return $e;
            var c = o;
            return Se(A6(Lt, n, A2(yt, i, a), c, r, e, t));
        }
        return Se(A6(Lt, n, a, $e, r, e, t));
    }), xt = F4(function(n, r, e, t) {
        if (Dt(t)) return $e;
        var a = A2($t, "/", t);
        if (a.b) {
            var u = a.a;
            return A5(Kt, n, A2(St, u, t), r, e, A2(yt, u, t));
        }
        return A5(Kt, n, "/", r, e, t);
    }), Ht = F3(function(n, r, e) {
        if (Dt(e)) return $e;
        var t = A2($t, "?", e);
        if (t.b) {
            var a = t.a;
            return A4(xt, n, Se(A2(St, a + 1, e)), r, A2(yt, a, e));
        }
        return A4(xt, n, $e, r, e);
    }), kt = F2(function(n, r) {
        if (Dt(r)) return $e;
        var e = A2($t, "#", r);
        if (e.b) {
            var t = e.a;
            return A3(Ht, n, Se(A2(St, t + 1, r)), A2(yt, t, r));
        }
        return A3(Ht, n, $e, r);
    }), Bt = P, Ot = function(n) {
        return A2(Bt, "http://", n) ? A2(kt, 0, A2(St, 7, n)) : A2(Bt, "https://", n) ? A2(kt, 1, A2(St, 8, n)) : $e;
    }, Gt = function() {
        for(;;);
    }, Wt = Sn, qt = Wt(0), Ut = F4(function(n, r, e, t) {
        if (t.b) {
            var a = t.a, u = t.b;
            if (u.b) {
                var i = u.a, o = u.b;
                if (o.b) {
                    var c = o.a, f = o.b;
                    if (f.b) {
                        var b = f.b;
                        return A2(n, a, A2(n, i, A2(n, c, A2(n, f.a, e > 500 ? A3(ke, n, r, Ie(b)) : A4(Ut, n, r, e + 1, b)))));
                    }
                    return A2(n, a, A2(n, i, A2(n, c, r)));
                }
                return A2(n, a, A2(n, i, r));
            }
            return A2(n, a, r);
        }
        return r;
    }), At = F3(function(n, r, e) {
        return A4(Ut, n, r, 0, e);
    }), Et = F2(function(n, r) {
        return A3(At, F2(function(r, e) {
            return A2(se, n(r), e);
        }), M, r);
    }), Tt = Dn, It = F2(function(n, r) {
        return A2(Tt, function(r) {
            return Wt(n(r));
        }, r);
    }), jt = F3(function(n, r, e) {
        return A2(Tt, function(r) {
            return A2(Tt, function(e) {
                return Wt(A2(n, r, e));
            }, e);
        }, r);
    }), Rt = function(n) {
        return A3(At, jt(se), Wt(M), n);
    }, Qt = Tn, Pt = F2(function(n, r) {
        var e = r;
        return xn(A2(Tt, Qt(n), e));
    });
    Un.Task = An(qt, F3(function(n, r) {
        return A2(It, function() {
            return 0;
        }, Rt(A2(Et, Pt(n), r)));
    }), F3(function() {
        return Wt(0);
    }), F2(function(n, r) {
        return A2(It, n, r);
    }));
    var Vt, Ft, Nt = jn("Task"), Jt = F2(function(n, r) {
        return Nt(A2(It, n, r));
    }), _t = function(n) {
        return {
            q: n.q
        };
    }, Yt = F3(function(n, r, e) {
        return r(n(e));
    }), Xt = Rn, na = function(n) {
        return 1e3 * n;
    }, ra = pt, ea = function(n) {
        return n;
    }, ta = W, aa = F2(function(n, r) {
        return ra(n + ta(na(r)));
    }), ua = function(n) {
        return A2(aa, n.aa, n.O);
    }, ia = wn, oa = function(n) {
        return ia(n);
    }, ca = wn, fa = A2(Yt, na, ca), ba = function(n) {
        return A3(ke, F2(function(n, r) {
            return A3(mn, n.a, n.b, r);
        }), {}, n);
    }, sa = function(n) {
        if (n.$) return null;
        var r = n.a;
        return ba(l([
            o("loopStart", fa(r.aM)),
            o("loopEnd", fa(r.aL))
        ]));
    }, Ma = A2(Yt, ea, ia), da = F2(function(n, r) {
        return A3(ke, function(n) {
            return F2(function(r, e) {
                return e.push(n(r)), e;
            });
        }(n), [], r);
    }), Ca = function(n) {
        return A2(se, n.a, n.b);
    }, la = function(n) {
        return A2(da, function(n) {
            var r = n.b;
            return ba(l([
                o("time", Ma(n.a)),
                o("volume", ca(r))
            ]));
        }, Ca(n));
    }, va = wn, ga = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ha = F2(function(n, r) {
        var e = r.b;
        return A2(ga, n(r.a), A2(Et, n, e));
    }), pa = F2(function(n, r) {
        var e = r.b;
        return o(n(r.a), e);
    }), La = function(n) {
        return A2(Et, ha(pa(function(r) {
            return A2(aa, r, n.O);
        })), n.af);
    }, wa = F2(function(n, r) {
        var e;
        return ba(l([
            o("action", va("startSound")),
            o("nodeGroupId", ia(n)),
            o("bufferId", oa((e = r.I, e.V))),
            o("startTime", Ma(ua(r))),
            o("startAt", fa(r.x)),
            o("volume", ca(r.S)),
            o("volumeTimelines", A2(da, la, La(r))),
            o("loop", sa(r.C)),
            o("playbackRate", ca(r.E))
        ]));
    }), Za = F2(function(n, r) {
        return r.b ? A3(At, se, r, n) : n;
    }), ma = function(n) {
        return A3(At, Za, M, n);
    }, Sa = F2(function(n, r) {
        return r + n;
    }), $a = function(n) {
        switch(n.$){
            case 0:
                return ma(A2(Et, $a, n.a));
            case 1:
                var r = n.a.de;
                return l([
                    {
                        C: r.C,
                        O: 0,
                        E: r.E,
                        I: n.a.I,
                        x: r.x,
                        aa: n.a.aa,
                        S: 1,
                        af: M
                    }
                ]);
            default:
                var e = n.a, t = e.ag;
                switch(t.$){
                    case 0:
                        var a = t.a;
                        return A2(Et, function(n) {
                            return b(n, {
                                S: a.a2 * n.S
                            });
                        }, $a(e.bA));
                    case 1:
                        var u = t.a.bj;
                        return A2(Et, function(n) {
                            return b(n, {
                                af: A2(se, u, n.af)
                            });
                        }, $a(e.bA));
                    default:
                        var i = t.a;
                        return A2(Et, function(n) {
                            return b(n, {
                                O: A2(Sa, i, n.O)
                            });
                        }, $a(e.bA));
                }
        }
    }, Da = F5(function(n, r, e, t, a) {
        return {
            $: -1,
            a: n,
            b: r,
            c: e,
            d: t,
            e: a
        };
    }), ya = {
        $: -2
    }, za = F5(function(n, r, e, t, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== t.$ || t.a || -1 !== t.d.$ || t.d.a) return A5(Da, n, r, e, t, a);
            var u = t.d;
            return i = t.e, A5(Da, 0, t.b, t.c, A5(Da, 1, u.b, u.c, u.d, u.e), A5(Da, 1, r, e, i, a));
        }
        var i, o = a.b, c = a.c, f = a.d, b = a.e;
        return -1 !== t.$ || t.a ? A5(Da, n, o, c, A5(Da, 0, r, e, t, f), b) : A5(Da, 0, r, e, A5(Da, 1, t.b, t.c, t.d, i = t.e), A5(Da, 1, o, c, f, b));
    }), Ka = i, xa = F3(function(n, r, e) {
        if (-2 === e.$) return A5(Da, 0, n, r, ya, ya);
        var t = e.a, a = e.b, u = e.c, i = e.d, o = e.e;
        switch(A2(Ka, n, a)){
            case 0:
                return A5(za, t, a, u, A3(xa, n, r, i), o);
            case 1:
                return A5(Da, t, a, r, i, o);
            default:
                return A5(za, t, a, u, i, A3(xa, n, r, o));
        }
    }), Ha = F3(function(n, r, e) {
        var t = A3(xa, n, r, e);
        return -1 !== t.$ || t.a ? t : A5(Da, 1, t.b, t.c, t.d, t.e);
    }), ka = F2(function(n, r) {
        return ba(l([
            o("nodeGroupId", ia(n)),
            o("action", va("setLoopConfig")),
            o("loop", sa(r))
        ]));
    }), Ba = F2(function(n, r) {
        return ba(l([
            o("nodeGroupId", ia(n)),
            o("action", va("setPlaybackRate")),
            o("playbackRate", ca(r))
        ]));
    }), Oa = F2(function(n, r) {
        return ba(l([
            o("nodeGroupId", ia(n)),
            o("action", va("setVolume")),
            o("volume", ca(r))
        ]));
    }), Ga = F2(function(n, r) {
        return ba(l([
            o("nodeGroupId", ia(n)),
            o("action", va("setVolumeAt")),
            o("volumeAt", A2(da, la, r))
        ]));
    }), Wa = F2(function(n, r) {
        return A3(At, F2(function(r, e) {
            return n(r) ? A2(se, r, e) : e;
        }), M, r);
    }), qa = F3(function(n, r, e) {
        var t = n(r);
        return t.$ ? e : A2(se, t.a, e);
    }), Ua = F2(function(n, r) {
        return A3(At, qa(n), M, r);
    }), Aa = F2(function(n, r) {
        for(;;){
            if (!r.b) return $e;
            var e = r.a, t = r.b;
            if (n(e)) return Se(e);
            r = t;
        }
    }), Ea = F2(function(n, r) {
        return o(n, r);
    }), Ta = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, e = n.e;
                return i = e.b, o = e.c, t = e.d, b = e.e, A5(Da, 1, n.b, n.c, A5(Da, 0, r.b, r.c, r.d, r.e), A5(Da, 0, i, o, t, b));
            }
            var t, a = n.d, u = n.e, i = u.b, o = u.c, c = (t = u.d).d, f = t.e, b = u.e;
            return A5(Da, 0, t.b, t.c, A5(Da, 1, n.b, n.c, A5(Da, 0, a.b, a.c, a.d, a.e), c), A5(Da, 1, i, o, f, b));
        }
        return n;
    }, Ia = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, e = n.e;
                return f = e.b, b = e.c, s = e.d, M = e.e, A5(Da, 1, t = n.b, a = n.c, A5(Da, 0, r.b, r.c, r.d, o = r.e), A5(Da, 0, f, b, s, M));
            }
            var t = n.b, a = n.c, u = n.d, i = u.d, o = u.e, c = n.e, f = c.b, b = c.c, s = c.d, M = c.e;
            return A5(Da, 0, u.b, u.c, A5(Da, 1, i.b, i.c, i.d, i.e), A5(Da, 1, t, a, o, A5(Da, 0, f, b, s, M)));
        }
        return n;
    }, ja = F7(function(n, r, e, t, a, u, i) {
        if (-1 !== u.$ || u.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return Ia(r);
                        break n;
                    }
                    return Ia(r);
                }
                break n;
            }
            return r;
        }
        return A5(Da, e, u.b, u.c, u.d, A5(Da, 0, t, a, u.e, i));
    }), Ra = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, e = n.b, t = n.c, a = n.d, u = a.d, i = n.e;
            if (1 === a.a) {
                if (-1 !== u.$ || u.a) {
                    var o = Ta(n);
                    if (-1 === o.$) {
                        var c = o.e;
                        return A5(za, o.a, o.b, o.c, Ra(o.d), c);
                    }
                    return ya;
                }
                return A5(Da, r, e, t, Ra(a), i);
            }
            return A5(Da, r, e, t, Ra(a), i);
        }
        return ya;
    }, Qa = F2(function(n, r) {
        if (-2 === r.$) return ya;
        var e = r.a, t = r.b, a = r.c, i = r.d, o = r.e;
        if (0 > u(n, t)) {
            if (-1 === i.$ && 1 === i.a) {
                var c = i.d;
                if (-1 !== c.$ || c.a) {
                    var f = Ta(r);
                    if (-1 === f.$) {
                        var b = f.e;
                        return A5(za, f.a, f.b, f.c, A2(Qa, n, f.d), b);
                    }
                    return ya;
                }
                return A5(Da, e, t, a, A2(Qa, n, i), o);
            }
            return A5(Da, e, t, a, A2(Qa, n, i), o);
        }
        return A2(Pa, n, A7(ja, n, r, e, t, a, i, o));
    }), Pa = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, a = r.b, u = r.c, i = r.d, o = r.e;
            if (e(n, a)) {
                var c = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(o);
                return -1 === c.$ ? A5(za, t, c.b, c.c, i, Ra(o)) : ya;
            }
            return A5(za, t, a, u, i, A2(Qa, n, o));
        }
        return ya;
    }), Va = F2(function(n, r) {
        var e = A2(Qa, n, r);
        return -1 !== e.$ || e.a ? e : A5(Da, 1, e.b, e.c, e.d, e.e);
    }), Fa = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Na = F3(function(n, r, e) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var t = r.a;
                    n -= 1, r = r.b, e = A2(se, t, e);
                    continue n;
                }
                return e;
            }
            return e;
        }
    }), Ja = F2(function(n, r) {
        return Ie(A3(Na, n, r, M));
    }), _a = F3(function(n, r, e) {
        if (r > 0) {
            var t = o(r, e);
            n: for(;;){
                r: for(;;){
                    if (!t.b.b) return e;
                    if (!t.b.b.b) {
                        if (1 === t.a) break n;
                        break r;
                    }
                    switch(t.a){
                        case 1:
                            break n;
                        case 2:
                            var a = t.b;
                            return l([
                                a.a,
                                a.b.a
                            ]);
                        case 3:
                            if (t.b.b.b.b) {
                                var u = t.b, i = u.b;
                                return l([
                                    u.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (t.b.b.b.b && t.b.b.b.b.b) {
                                var c = t.b, f = c.b, b = f.b, s = b.b, d = s.b;
                                return A2(se, c.a, A2(se, f.a, A2(se, b.a, A2(se, s.a, n > 1e3 ? A2(Ja, r - 4, d) : A3(_a, n + 1, r - 4, d)))));
                            }
                            break r;
                    }
                }
                return e;
            }
            return l([
                t.b.a
            ]);
        }
        return M;
    }), Ya = F2(function(n, r) {
        return A3(_a, 0, n, r);
    }), Xa = F2(function(n, r) {
        if (0 > n) return r;
        var e, t = (e = A2(Fa, n, r)).b ? Se(e.b) : $e;
        return 1 === t.$ ? r : A2(Za, A2(Ya, n, r), t.a);
    }), nu = F2(function(n, r) {
        var t = n.a, a = n.b, u = r.a, i = r.b, f = r.c, b = A2(Wa, function(n) {
            var r = n.b;
            return e(r.I, a.I) && e(ua(r), ua(a)) && e(r.x, a.x);
        }, A2(qe, Ea, u)), M = A2(Aa, function(n) {
            return e(n.b, a);
        }, b);
        if (M.$) {
            if (b.b) {
                var d = b.a, C = d.a, v = d.b, g = F2(function(n, r) {
                    return e(n(a), n(v)) ? $e : Se(A2(r, t, n(v)));
                }), h = A2(Ua, pt, l([
                    A2(g, function(n) {
                        return n.S;
                    }, Oa),
                    A2(g, function(n) {
                        return n.C;
                    }, ka),
                    A2(g, function(n) {
                        return n.E;
                    }, Ba),
                    A2(g, La, Ga)
                ]));
                return c(A2(Xa, C, u), A3(Ha, t, v, i), s(h, f));
            }
            return c(u, A2(Va, t, i), A2(se, function(n) {
                return ba(l([
                    o("action", va("stopSound")),
                    o("nodeGroupId", ia(n))
                ]));
            }(t), f));
        }
        return c(A2(Xa, C = M.a.a, u), i, f);
    }), ru = F3(function(n, r, e) {
        var t = A3(ke, nu, c($a(e), r, M), de(r)), a = t.a, u = t.b, i = t.c, o = A3(ke, F2(function(n, r) {
            var e = r.a, t = r.c;
            return c(e + 1, A3(Ha, e, n, r.b), A2(se, A2(wa, e, n), t));
        }), c(n, u, i), a);
        return c(o.b, o.a, o.c);
    }), eu = ya, tu = F2(function(n, r) {
        return ba(l([
            o("audioUrl", va(r.U)),
            o("requestId", ia(n))
        ]));
    }), au = function(n) {
        return n.$ ? ma(A2(Et, au, n.a)) : l([
            n.a
        ]);
    }, uu = function(n) {
        return A3(ke, F2(function(n, r) {
            return A3(Ha, n.a, n.b, r);
        }), eu, n);
    }, iu = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.e, a = n, u = A3(n, e.b, e.c, A3(iu, n, r, e.d));
            n = a, r = u, e = t;
        }
    }), ou = F2(function(n, r) {
        return A3(iu, Ha, r, n);
    }), cu = F2(function(n, r) {
        var e = n, t = au(r), a = A2(qe, F2(function(n, r) {
            return o(e.G + n, r);
        }), t);
        return o(b(e, {
            f: A2(ou, e.f, uu(a)),
            G: e.G + Be(t)
        }), A2(da, pt, A2(Et, function(n) {
            return A2(tu, n.a, n.b);
        }, a)));
    }), fu = Qn, bu = F3(function(n, r, e) {
        var t = e.a, a = e.b, u = e.c, i = A3(ru, 0, eu, A2(r, {
            q: eu
        }, t)), c = i.c, f = A2(cu, {
            K: i.a,
            N: i.b,
            f: eu,
            G: 0,
            H: $e,
            q: eu,
            z: t
        }, u), b = f.a, s = f.b, M = ba(l([
            o("audio", A2(da, pt, c)),
            o("audioCmds", s)
        ]));
        return o(b, Xt(l([
            A2(fu, oe, a),
            n(M)
        ])));
    }), su = Mr, Mu = Rn, du = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Cu = an, lu = _, vu = A2(lt, pt, lu), gu = rn, hu = A2(Cu, function(n) {
        switch(n){
            case "NetworkError":
                return gt(1);
            case "MediaDecodeAudioDataUnknownContentType":
            case "DOMException: The buffer passed to decodeAudioData contains an unknown content type.":
                return gt(0);
            default:
                return gt(2);
        }
    }, gu), pu = en, Lu = X, wu = cn, Zu = A2(Cu, function(n) {
        switch(n){
            case 0:
                return A3(vt, F2(function(n, r) {
                    return {
                        $: 1,
                        a: {
                            X: r,
                            ai: n
                        }
                    };
                }), A2(pu, "requestId", lu), A2(pu, "error", hu));
            case 1:
                return A4(wu, F3(function(n, r, e) {
                    return {
                        $: 0,
                        a: {
                            V: r,
                            W: e,
                            ai: n
                        }
                    };
                }), A2(pu, "requestId", lu), A2(pu, "bufferId", vu), A2(pu, "durationInSeconds", Lu));
            case 2:
                return A2(lt, function(n) {
                    return {
                        $: 2,
                        a: {
                            H: n
                        }
                    };
                }, A2(pu, "samplesPerSecond", lu));
            default:
                return gt(du({
                    X: "Type " + ze(n) + " not handled."
                }));
        }
    }, A2(pu, "type", lu)), mu = Mn, Su = function(n) {
        var r = A2(mu, Zu, n);
        return {
            $: 0,
            a: r.$ ? du({
                X: Re(r.a)
            }) : r.a
        };
    }, $u = Qn, Du = F2(function(n, r) {
        var e = r;
        return Mu(l([
            A2($u, oe, A2(n.dq, _t(e), e.z)),
            n.bD.ce(Su)
        ]));
    }), yu = F3(function(n, r, e) {
        return A2(n, e, r);
    }), zu = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return $e;
            var e = r.c, t = r.d, a = r.e;
            switch(A2(Ka, n, r.b)){
                case 0:
                    r = t;
                    continue n;
                case 1:
                    return Se(e);
                default:
                    r = a;
                    continue n;
            }
        }
    }), Ku = function(n) {
        return n.a;
    }, xu = Xt(M), Hu = F4(function(n, r, e, t) {
        var a = t, u = _t(a), i = A2(e, u, a.z), c = i.a, f = i.b, s = i.c, M = A3(ru, a.N, a.K, A2(r, u, c)), d = M.c, C = b(a, {
            K: M.a,
            N: M.b,
            z: c
        }), v = A2(cu, C, s), g = v.a, h = v.b, p = ba(l([
            o("audio", A2(da, pt, d)),
            o("audioCmds", h)
        ]));
        return o(g, Xt(l([
            A2(fu, oe, f),
            n(p)
        ])));
    }), ku = F3(function(n, r, e) {
        var t = e;
        if (1 === r.$) return A4(Hu, n.bD.dz, n.bA, A2(yu, n.dF, r.a), t);
        var a = r.a;
        switch(a.$){
            case 0:
                var u = a.a.V, i = a.a.W, c = A2(zu, C = a.a.ai, t.f);
                if (c.$) return o(t, xu);
                var f = c.a, s = A3(Ha, u, {
                    W: i
                }, t.q), M = we({
                    V: u
                }), d = A2(Aa, A2(Yt, ft, et(M)), Ca(f.A));
                return A4(Hu, n.bD.dz, n.bA, A2(yu, n.dF, d.$ ? Ku(f.A).b : d.a.b), b(t, {
                    f: A2(Va, C, t.f),
                    q: s
                }));
            case 1:
                var C, l = a.a.X, v = A2(zu, C = a.a.ai, t.f);
                if (v.$) return o(t, xu);
                f = v.a;
                var g = ge(l), h = A2(Aa, A2(Yt, ft, et(g)), Ca(f.A));
                return A4(Hu, n.bD.dz, n.bA, A2(yu, n.dF, h.$ ? Ku(f.A).b : h.a.b), b(t, {
                    f: A2(Va, C, t.f)
                }));
            case 2:
                return o(b(t, {
                    H: Se(a.a.H)
                }), xu);
            default:
                return l = a.a.X, o(t, xu);
        }
    }), Bu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ou = F2(function(n, r) {
        var e;
        return Bu({
            bA: r,
            ag: (e = n, {
                $: 2,
                a: e
            })
        });
    }), Gu = A2(Yt, function(n) {
        return b(n, {
            bA: F2(function(r, e) {
                return A2(Ou, .05, A2(n.bA, r, e));
            })
        });
    }, function(n) {
        var r, e, t, a;
        return r = {
            cv: F3(function(r, e, t) {
                return A3(bu, n.bD.dz, n.bA, A3(n.cv, r, e, t));
            }),
            cY: A2(Yt, n.cY, oe),
            cZ: A2(Yt, n.cZ, oe),
            dq: Du(n),
            dF: ku(n),
            dI: function(r) {
                var e = A2(n.dI, _t(r), function(n) {
                    return n.z;
                }(r)), t = e.dy, a = e.bI;
                return {
                    bI: A2(Et, su(oe), a),
                    dy: t
                };
            }
        }, e = r.cY, t = r.cZ, a = function() {
            a.a(e(Jr()));
        }, Fr({
            aq: function(n) {
                return a.a = n, ne.addEventListener("popstate", a), 0 > ne.navigator.userAgent.indexOf("Trident") || ne.addEventListener("hashchange", a), F2(function(r, e) {
                    if (!(e.ctrlKey || e.metaKey || e.shiftKey || e.button >= 1 || r.target || r.hasAttribute("download"))) {
                        e.preventDefault();
                        var a = r.href, u = Jr(), i = Ot(a).a;
                        n(t(i && u.aW === i.aW && u.aG === i.aG && u.aT.a === i.aT.a ? {
                            $: 0,
                            a: i
                        } : {
                            $: 1,
                            a: a
                        }));
                    }
                });
            },
            cv: function(n) {
                return A3(r.cv, n, Jr(), a);
            },
            dI: r.dI,
            dF: r.dF,
            dq: r.dq
        });
    }), Wu = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var e = r.b;
            if (n(r.a)) return !0;
            r = e;
        }
    }), qu = {
        C: $e,
        E: 1,
        x: 0
    }, Uu = F3(function(n, r, e) {
        return {
            $: 1,
            a: {
                de: n,
                I: r,
                aa: e
            }
        };
    }), Au = F2(function(n, r) {
        return A3(Uu, qu, n, r);
    }), Eu = F2(function(n, r) {
        return o(r.a, n(r.b));
    }), Tu = p, Iu = F3(function(n, r, e) {
        if (e.b) {
            var t = e.a, a = e.b;
            return A2(n, t, r) ? A2(ga, r, e) : A2(ga, t, A2(Tu, n, A2(se, r, a)));
        }
        return A2(ga, r, M);
    }), ju = h, Ru = F2(function(n, r) {
        var e = r.a, t = r.b;
        return A3(Iu, F2(function(r, e) {
            return A2(Ka, n(r), n(e));
        }), e, A2(ju, n, t));
    }), Qu = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Pu = F2(function(n, r) {
        var e, t, a;
        return Bu({
            bA: r,
            ag: (t = {
                bj: A2(Ru, A2(Yt, ft, ea), A2(ha, Eu(ut(0)), A2(Qu, (e = o(ra(0), 1), A2(ga, e, M)), (a = n, a.b ? Se(A2(ga, a.a, a.b)) : $e))))
            }, {
                $: 1,
                a: t
            })
        });
    }), Vu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Fu = Vu(M), Nu = function(n) {
        if (1 !== n.$) return Fu;
        var r = n.a, e = r.c2;
        switch(e.$){
            case 0:
                return Fu;
            case 1:
                return A2(Au, r.di, e.a);
            default:
                var t = e.a, a = e.b;
                return A2(Pu, l([
                    o(a, 1),
                    o(A2(aa, a, 2), 0)
                ]), A2(Au, r.di, t));
        }
    }, Ju = F2(function(n, r) {
        return A3(iu, F3(function(r, e, t) {
            return A2(n, r, e) ? A3(Ha, r, e, t) : t;
        }), eu, r);
    }), _u = F2(function(n, r) {
        var t = r.bW, a = r.bC, u = A2(Et, function(n) {
            return Nu(n.b);
        }, de(A2(Ju, F2(function(n) {
            return A2(Wu, function(r) {
                return e(r, n);
            }, t);
        }), a.dK))), i = A2(Et, function(n) {
            return Nu(n.b);
        }, de(A2(Ju, F2(function(n) {
            return A2(Wu, function(r) {
                return e(r, n);
            }, t);
        }), a.dj))), o = A2(Et, function(n) {
            return Nu(n.b);
        }, de(A2(Ju, F2(function(n) {
            return A2(Wu, function(r) {
                return e(r, n);
            }, t);
        }), a.cF)));
        return Vu(A2(Za, i, A2(Za, u, o)));
    }), Yu = rr("audioPortFromJS", nn), Xu = Yn("audioPortToJS", pt), ni = function(n) {
        return {
            $: 15,
            a: n
        };
    }, ri = F3(function(n, r, e) {
        return n(r(e));
    }), ei = yn, ti = F2(function(n, r) {
        return Nt(A2(ei, A2(ri, A2(ri, Wt, n), ge), A2(Tt, A2(ri, A2(ri, Wt, n), we), r)));
    }), ai = {
        $: 0
    }, ui = (Ft = function() {
        var n, r;
        return {
            a3: (n = Xr.body, r = Xr.documentElement, {
                bk: Math.max(n.scrollWidth, n.offsetWidth, r.scrollWidth, r.offsetWidth, r.clientWidth),
                aE: Math.max(n.scrollHeight, n.offsetHeight, r.scrollHeight, r.offsetHeight, r.clientHeight)
            }),
            dJ: {
                bl: ne.pageXOffset,
                bm: ne.pageYOffset,
                bk: Xr.documentElement.clientWidth,
                aE: Xr.documentElement.clientHeight
            }
        };
    }, $n(function(n) {
        Nr(function() {
            n(Sn(Ft()));
        });
    })), ii = A3(F3(function(n, r, e) {
        return {
            cF: r,
            dj: n,
            dK: e
        };
    }), eu, eu, eu), oi = A3(F3(function(n, r, e) {
        return {
            bT: e,
            dc: n,
            dM: r
        };
    }), $e, M, 0), ci = {
        cB: !1,
        cR: $e,
        cS: $e,
        cT: $e
    }, fi = A5(F5(function(n, r, e, t, a) {
        return {
            bq: e,
            bu: t,
            bv: n,
            bV: r,
            cc: a
        };
    }), M, 0, $e, !1, !1), bi = A9(F9(function(n, r, e, t, a, u, i, o, c) {
        return {
            b3: n,
            cp: r,
            cI: c,
            cU: e,
            cX: t,
            c$: a,
            du: u,
            dw: o,
            dE: i
        };
    }), 0, 0, 0, 0, 0, 0, 0, Ye, M), si = F2(function(n, r) {
        return {
            cr: n,
            aO: r
        };
    }), Mi = A6(F6(function(n, r, e, t, a, u) {
        return {
            b_: e,
            b4: t,
            cL: u,
            cM: n,
            df: a,
            dH: r
        };
    }), A2(si, 0, 1), 1, 1, 1, 1, 1), di = F4(function(n, r, e, t) {
        return {
            cs: t,
            cJ: e,
            c7: n,
            a5: r
        };
    }), Ci = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), li = function(n) {
        var r = n.b;
        return A2(Ci, 1664525 * n.a + r >>> 0, r);
    }, vi = function(n) {
        var r = li(A2(Ci, 0, 1013904223));
        return li(A2(Ci, r.a + n >>> 0, r.b));
    }, gi = vi(0), hi = A4(di, gi, gi, gi, gi), pi = F8(function(n, r, e, t, a, u, i, o) {
        return {
            br: t,
            bs: u,
            bt: a,
            cf: i,
            cn: o,
            c_: n,
            dt: e,
            dD: r
        };
    }), Li = A8(pi, 0, 0, 0, !1, !1, !1, 0, $e), wi = A4(F4(function(n, r, e, t) {
        return {
            aF: t,
            aQ: e,
            a8: n,
            bd: r
        };
    }), !0, !0, !0, !0), Zi = {
        dh: 2
    }, mi = A7(F7(function(n, r, e, t, a, u, i) {
        return {
            cd: a,
            co: t,
            cy: r,
            cz: e,
            c3: i,
            db: u,
            dr: n
        };
    }), $e, $e, $e, $e, $e, $e, M), Si = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $i = function(n) {
        return Si(n);
    }, Di = F3(function(n, r, e) {
        return {
            al: e,
            cV: n,
            aR: r
        };
    }), yi = function(n) {
        return "../Audio/SoundEffects/" + n;
    }, zi = A3(Di, "correctAnswer", yi("Correct Answer.wav"), 0), Ki = A3(Di, "CurrentKanaSound", yi("CurrentKanaSound.wav"), 0), xi = A3(Di, "invalidClickSwap", yi("Error.wav"), 0), Hi = function(n) {
        var r = "Match" + ze(n);
        return A3(Di, r, "../Audio/SoundEffects/Match/" + r + ".wav", 0);
    }, ki = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Bi = F3(function(n, r, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: e
        };
    }), Oi = A2(ga, ge(3), s(l([
        ge(0),
        ge(1),
        ge(2)
    ]), A2(Et, function(n) {
        return we({
            V: n
        });
    }, A2(We, 0, 1e3)))), Gi = F2(function(n, r) {
        return {
            $: 0,
            a: {
                U: r,
                A: A2(ha, function(r) {
                    return o(r, n(r));
                }, Oi)
            }
        };
    }), Wi = function(n) {
        return A2(Gi, function(r) {
            return ki(A3(Bi, n.al, n.cV, r));
        }, n.aR);
    }, qi = A3(Di, "victory", yi("Victory Jingle.wav"), 0), Ui = $i(l([
        Wi(zi),
        Wi(Hi(1)),
        Wi(Hi(2)),
        Wi(Hi(3)),
        Wi(Hi(4)),
        Wi(Hi(5)),
        Wi(xi),
        Wi(qi),
        Wi(Ki)
    ])), Ai = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ei = {
        $: 3
    }, Ti = {
        $: 0
    }, Ii = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), ji = {
        $: 2
    }, Ri = function(n) {
        var r = n.a, e = 277803737 * (r ^ r >>> (r >>> 28) + 4);
        return (e >>> 22 ^ e) >>> 0;
    }, Qi = F2(function(n, r) {
        return function(e) {
            var t = 0 > u(n, r) ? o(n, r) : o(r, n), a = t.a, i = t.b - a + 1;
            if (i - 1 & i) {
                var c = (-i >>> 0) % i >>> 0;
                return function(n) {
                    for(;;){
                        var r = Ri(n), e = li(n);
                        if (u(r, c) >= 0) return o(r % i + a, e);
                        n = e;
                    }
                }(e);
            }
            return o(((i - 1 & Ri(e)) >>> 0) + a, li(e));
        };
    }), Pi = A2(Qi, -2147483648, 2147483647), Vi = sn, Fi = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Ni = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ji = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), _i = {
        $: 2
    }, Yi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xi = function(n) {
        return {
            $: 0,
            a: n
        };
    }, no = {
        $: 1
    }, ro = function(n) {
        return !n.$;
    }, eo = In, to = F3(function(n, r, e) {
        var t = r(A2(zu, n, e));
        return t.$ ? A2(Va, n, e) : A3(Ha, n, t.a, e);
    }), ao = F2(function(n, r) {
        return A3(ue, "", pt, A2(Yt, r, n));
    }), uo = F2(function(n, r) {
        return r.$ ? ge(n(r.a)) : we(r.a);
    }), io = function(n) {
        return {
            $: 4,
            a: n
        };
    }, oo = {
        $: 2
    }, co = {
        $: 1
    }, fo = F2(function(n, r) {
        switch(r.$){
            case 0:
                return ge({
                    $: 0,
                    a: r.a
                });
            case 1:
                return ge(co);
            case 2:
                return ge(oo);
            case 3:
                return ge({
                    $: 3,
                    a: r.a.dk
                });
            default:
                return A2(uo, io, n(r.b));
        }
    }), bo = F2(function(n, r) {
        return A2(ao, n, fo(function(n) {
            return A2(uo, Re, A2(Vi, r, n));
        }));
    }), so = (Vt = ra, $n(function(n) {
        n(Sn(Vt(Date.now())));
    })), Mo = A2(Tt, function(n) {
        return Wt(vi(n));
    }, so), Co = F2(function(n, r) {
        return n(r);
    }), lo = F3(function(n, r, e) {
        if (r.b) {
            var t = r.b, a = A2(Co, r.a, e), u = a.b;
            return A2(Tt, function() {
                return A3(lo, n, t, u);
            }, A2(Qt, n, a.a));
        }
        return Wt(e);
    }), vo = F3(function(n, r, e) {
        return Wt(e);
    }), go = F2(function(n, r) {
        var e = r;
        return function(r) {
            var t = e(r), a = t.b;
            return o(n(t.a), a);
        };
    });
    Un.Random = An(Mo, lo, vo, F2(function(n, r) {
        return A2(go, n, r);
    }));
    var ho = jn("Random"), po = F2(function(n, r) {
        return ho(A2(go, n, r));
    }), Lo = {
        $: 0
    }, wo = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Zo = F2(function(n, r) {
        return {
            aZ: n,
            ba: r
        };
    }), mo = Wt(A2(Zo, eu, M)), So = function(n) {
        return $n(function(r) {
            var e = n.f;
            2 === e.$ && e.c && e.c(), n.f = null, r(Sn(0));
        });
    }, $o = xn, Do = F3(function(n, r, e) {
        n: for(;;){
            if (r.b) {
                var t = r.a, a = r.b;
                if (t.$) {
                    var u = t.a;
                    return A2(Tt, function(r) {
                        var t = u.be;
                        return A3(Do, n, a, 1 === t.$ ? e : A3(Ha, t.a, r, e));
                    }, $o(A3(te, n, Qt(n), u)));
                }
                var i = t.a, o = A2(zu, i, e);
                if (1 === o.$) {
                    r = a;
                    continue n;
                }
                return A2(Tt, function() {
                    return A3(Do, n, a, A2(Va, i, e));
                }, So(o.a));
            }
            return Wt(e);
        }
    }), yo = F4(function(n, r, e, t) {
        return A2(Tt, function(n) {
            return Wt(A2(Zo, n, e));
        }, A3(Do, n, r, t.aZ));
    }), zo = F4(function(n, r, t, a) {
        var u = a.b;
        return e(r, a.a) ? Se(A2(Qt, n, u(t))) : $e;
    }), Ko = F3(function(n, r, e) {
        return A2(Tt, function() {
            return Wt(e);
        }, Rt(A2(Ua, A3(zo, n, r.a, r.b), e.ba)));
    }), xo = F2(function(n, r) {
        if (r.$) {
            var e = r.a;
            return wo({
                bp: e.bp,
                bI: e.bI,
                b5: A2(ie, n, e.b5),
                aD: e.aD,
                cO: e.cO,
                dx: e.dx,
                be: e.be,
                dG: e.dG
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), Ho = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    Un.Http = An(mo, yo, Ko, xo, F2(function(n, r) {
        return A2(Ho, r.a, A2(Yt, r.b, n));
    }));
    var ko, Bo, Oo = jn("Http"), Go = (jn("Http"), function(n) {
        return function(n) {
            return Oo(wo({
                bp: !1,
                bI: n.bI,
                b5: n.b5,
                aD: n.aD,
                cO: n.cO,
                dx: n.dx,
                be: n.be,
                dG: n.dG
            }));
        }({
            bI: Lo,
            b5: n.b5,
            aD: M,
            cO: "GET",
            dx: $e,
            be: $e,
            dG: n.dG
        });
    }), Wo = function(n) {
        return "https://api.kanaparty.com/v1/level/" + ze(n);
    }, qo = F9(function(n, r, e, t, a, u, i, o, c) {
        return {
            b3: n,
            cp: r,
            cI: c,
            cU: e,
            cX: t,
            c$: a,
            du: u,
            dw: i,
            dE: o
        };
    }), Uo = F6(function(n, r, e, t, a, u) {
        return {
            bM: n,
            b2: r,
            cp: e,
            cw: t,
            cG: u,
            cH: a
        };
    }), Ao = A3(vt, F2(function(n, r) {
        return {
            bR: n,
            cE: r
        };
    }), A2(pu, "colornumber", lu), A2(pu, "kana", gu)), Eo = function(n) {
        return {
            $: 3,
            b: n
        };
    }, To = function(n) {
        return {
            $: 5,
            c: n
        };
    }, Io = function(n) {
        return {
            $: 11,
            g: n
        };
    }, jo = A7(fn, Uo, A2(pu, "categoryID", lu), A2(pu, "englishTranslation", gu), A2(pu, "id", lu), A2(pu, "initialKana", (ko = gu, Io(l([
        To($e),
        A2(lt, Se, ko)
    ])))), A2(pu, "kanaWordString", gu), A2(pu, "kanaToColorLookup", Eo(Ao))), Ro = A3(vt, rt, A9(bn, qo, A2(pu, "episodeNumber", lu), A2(pu, "id", lu), A2(pu, "movesCount", lu), A2(pu, "numberOfKanaToCompleteAnimation", lu), A2(pu, "oneStarScore", lu), A2(pu, "threeStarScore", lu), A2(pu, "tiles", gu), A2(pu, "twoStarScore", lu)), A2(pu, "kanaWords", Eo(jo))), Qo = _r, Po = F2(function(n, r) {
        return Xt(l([
            Go({
                b5: A2(bo, function(n) {
                    return ki({
                        $: 1,
                        a: n
                    });
                }, Ro),
                dG: Wo(r)
            }),
            A2(Qo, n, "/?level=" + ze(r)),
            A2(po, Ii(Ti), Pi),
            A2(po, Ii(Ai(xu)), Pi),
            A2(po, Ii(ji), Pi),
            A2(po, Ii(Ei), Pi)
        ]));
    }), Vo = F2(function(n, r) {
        return r.$ ? $e : n(r.a);
    }), Fo = function(n) {
        return A2(Vo, function(n) {
            return n;
        }, n);
    }, No = F2(function(n, r) {
        return function(e) {
            return r(A2(Qu, M, A2(zu, n, e)));
        };
    }), Jo = F5(function(n, r, e, t, a) {
        return {
            B: t,
            D: e,
            y: r,
            u: a,
            J: n
        };
    }), _o = (Bo = A2(No, "level", function(n) {
        return n.b && !n.b.b ? zt(n.a) : $e;
    }), function(n) {
        var r = n.D;
        return l([
            A5(Jo, n.J, n.y, r, n.B, (0, n.u)(Bo(r)))
        ]);
    }), Yo = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(se, n.a, Yo(n.b)) : M;
    }, Xo = F2(function(n, r) {
        return Se(1 === r.$ ? l([
            n
        ]) : A2(se, n, r.a));
    }), nc = function(n) {
        try {
            return Se(decodeURIComponent(n));
        } catch (n) {
            return $e;
        }
    }, rc = F2(function(n, r) {
        var e = A2(xe, "=", n);
        if (e.b && e.b.b && !e.b.b.b) {
            var t = e.b.a, a = nc(e.a);
            if (1 === a.$) return r;
            var u = a.a, i = nc(t);
            return 1 === i.$ ? r : A3(to, u, Xo(i.a), r);
        }
        return r;
    }), ec = F2(function(n, r) {
        var e;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, e = r.y;
                    if (e.b) {
                        if ("" !== e.a || e.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return Se(r.u);
                    }
                    return Se(r.u);
                }
                return $e;
            }
        }(n(A5(Jo, M, function(n) {
            var r = A2(xe, "/", n);
            return Yo(r.b && "" === r.a ? r.b : r);
        }(r.aR), 1 === (e = r.aX).$ ? eu : A3(At, rc, eu, A2(xe, "&", e.a)), r.aB, pt)));
    }), tc = function(n) {
        var r = Fo(A2(ec, _o, n));
        if (r.$) return 1;
        var e = r.a;
        return e > 0 && 1 > u(e, 300) ? e : 1;
    }, ac = F3(function(n, r, e) {
        var t;
        return c((t = Ye, function(n) {
            return function(r) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(b) {
                                                return function(s) {
                                                    return function(M) {
                                                        return function(d) {
                                                            return function(C) {
                                                                return function(l) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return function(p) {
                                                                                    return function(L) {
                                                                                        return function(w) {
                                                                                            return function(Z) {
                                                                                                return function(m) {
                                                                                                    return function(S) {
                                                                                                        return function($) {
                                                                                                            return function(D) {
                                                                                                                return function(y) {
                                                                                                                    return function(z) {
                                                                                                                        return function(K) {
                                                                                                                            return function(x) {
                                                                                                                                return function(H) {
                                                                                                                                    return function(k) {
                                                                                                                                        return function(B) {
                                                                                                                                            return {
                                                                                                                                                bw: p,
                                                                                                                                                bx: o,
                                                                                                                                                by: v,
                                                                                                                                                bC: B,
                                                                                                                                                bG: t,
                                                                                                                                                bH: L,
                                                                                                                                                bN: u,
                                                                                                                                                bS: M,
                                                                                                                                                bW: h,
                                                                                                                                                bX: f,
                                                                                                                                                bY: C,
                                                                                                                                                b$: H,
                                                                                                                                                b7: i,
                                                                                                                                                ca: r,
                                                                                                                                                cb: n,
                                                                                                                                                cg: K,
                                                                                                                                                cq: b,
                                                                                                                                                ct: m,
                                                                                                                                                cx: k,
                                                                                                                                                cA: z,
                                                                                                                                                cC: s,
                                                                                                                                                cG: l,
                                                                                                                                                cK: d,
                                                                                                                                                cQ: $,
                                                                                                                                                cW: D,
                                                                                                                                                c4: y,
                                                                                                                                                c8: Z,
                                                                                                                                                da: S,
                                                                                                                                                de: g,
                                                                                                                                                dg: w,
                                                                                                                                                a5: c,
                                                                                                                                                ds: a,
                                                                                                                                                dC: e,
                                                                                                                                                dJ: x
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        })(Ye)(M)(M)(mi)(M)(M)(M)(Zi)(ra(0))(ra(0))(!1)(1)(bi)($e)(eu)(1)(wi)(M)(fi)(M)(M)(0)(oi)(Li)(Mi)(e)(hi)(!1)(ai)($e)({
            bP: 0,
            c1: 0
        })(ci)(ii), Xt(l([
            A2(Po, e, tc(r)),
            A2(ti, function(n) {
                return ni({
                    $: 1,
                    a: n
                });
            }, ui)
        ])), Ui);
    }), uc = function(n) {
        return {
            $: 12,
            a: n
        };
    }, ic = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), oc = rr("highScoresPortFromJS", gu), cc = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), fc = function(n) {
        return {
            $: 9,
            a: n
        };
    }, bc = Mu(M), sc = F3(function(n, r, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e
        };
    }), Mc = F2(function(n, r) {
        return {
            aS: r,
            ba: n
        };
    }), dc = Wt(A2(Mc, M, eu)), Cc = function(n) {
        return o(s(n.a ? "w_" : "d_", n.b), n);
    }, lc = F6(function(n, r, e, t, a, i) {
        var c = A3(iu, F3(function(t, a, i) {
            n: for(;;){
                var c = i.a, f = i.b;
                if (c.b) {
                    var b = c.a, s = b.a, M = b.b, d = c.b;
                    if (0 > u(s, t)) {
                        i = o(d, A3(n, s, M, f));
                        continue n;
                    }
                    return u(s, t) > 0 ? o(c, A3(e, t, a, f)) : o(d, A4(r, s, M, a, f));
                }
                return o(c, A3(e, t, a, f));
            }
        }), o(de(t), i), a), f = c.a, b = c.b;
        return A3(ke, F2(function(r, e) {
            return A3(n, r.a, r.b, e);
        }), b, f);
    }), vc = F2(function(n, r) {
        return {
            aA: r,
            aJ: n
        };
    }), gc = F3(function(n, r, e) {
        return A2(It, function(n) {
            return o(r, n);
        }, A3(re, e.a ? ne : Xr, e.b, function(e) {
            return A2(eo, n, A2(vc, r, e));
        }));
    }), hc = F3(function(n, r, e) {
        var t = F3(function(r, e, t) {
            var a = t.c;
            return c(t.a, t.b, A2(se, A3(gc, n, r, e), a));
        }), a = F3(function(n, r, e) {
            var t = e.b, a = e.c;
            return c(A2(se, r, e.a), t, a);
        }), u = F4(function(n, r, e, t) {
            var a = t.c;
            return c(t.a, A3(Ha, n, r, t.b), a);
        }), i = A2(Et, Cc, r), o = A6(lc, a, u, t, e.aS, uu(i), c(M, eu, M)), f = o.b, b = o.c;
        return A2(Tt, function(n) {
            return Wt(A2(Mc, i, A2(ou, f, uu(n))));
        }, A2(Tt, function() {
            return Rt(b);
        }, Rt(A2(Et, So, o.a))));
    }), pc = F3(function(n, r, t) {
        var a = r.aJ, u = r.aA, i = function(n) {
            var r = n.b.c;
            return e(n.a, a) ? A2(ee, r, u) : $e;
        }, o = A2(Ua, i, t.ba);
        return A2(Tt, function() {
            return Wt(t);
        }, Rt(A2(Et, Qt(n), o)));
    });
    Un["Browser.Events"] = An(dc, hc, pc, 0, F2(function(n, r) {
        return A3(sc, r.a, r.b, A2(lt, n, r.c));
    }));
    var Lc, wc = jn("Browser.Events"), Zc = F3(function(n, r, e) {
        return wc(A3(sc, n, r, e));
    }), mc = A2(Zc, 0, "mousemove"), Sc = function(n) {
        return n.cx.cB ? mc(A3(vt, F2(function(n, r) {
            return fc(A2(cc, n, r));
        }), A2(pu, "clientX", Lu), A2(pu, "clientY", Lu))) : bc;
    }, $c = Y, Dc = rr("settingsPortFromJS", A2(Cu, function(n) {
        return A2(Cu, function(r) {
            return A2(Cu, function(e) {
                return A2(Cu, function(t) {
                    return gt({
                        aF: t,
                        aQ: e,
                        a8: r,
                        bd: n
                    });
                }, A2(pu, "hintsEnabled", Io(l([
                    To($e),
                    A2(lt, Se, $c)
                ]))));
            }, A2(pu, "musicEnabled", Io(l([
                To($e),
                A2(lt, Se, $c)
            ]))));
        }, A2(pu, "soundEffectsEnabled", Io(l([
            To($e),
            A2(lt, Se, $c)
        ]))));
    }, A2(pu, "textAudioEnabled", Io(l([
        To($e),
        A2(lt, Se, $c)
    ]))))), yc = F2(function(n, r) {
        var e;
        return Mu(l([
            oc(function(n) {
                return uc({
                    $: 0,
                    a: n
                });
            }),
            Dc(function(n) {
                return uc({
                    $: 1,
                    a: n
                });
            }),
            (e = F2(function(n, r) {
                return ni(A2(ic, n, r));
            }), A3(Zc, 1, "resize", A2(pu, "target", A3(vt, e, A2(pu, "innerWidth", lu), A2(pu, "innerHeight", lu))))),
            Sc(r)
        ]));
    }), zc = Si(M), Kc = function(n) {
        return b(n, {
            cq: n.bX,
            cC: !1
        });
    }, xc = Yn("highScoresPortToJS", va), Hc = "messageType", kc = function(n) {
        return A2(Qu, xu, A2(Vo, function(n) {
            return Se(function(n) {
                return xc(A2(ye, 0, ba(l([
                    o(Hc, va("requestScoreByLevelID")),
                    o("levelID", ia(n))
                ]))));
            }(n));
        }, function(n) {
            return Fo(A2(ec, _o, n));
        }(n)));
    }, Bc = Yn("settingsPortToJS", va), Oc = Bc(A2(ye, 0, ba(l([
        o(Hc, va("requestSettings"))
    ])))), Gc = F3(function(n, r, e) {
        return {
            $: 1,
            a: n,
            b: r,
            c: e
        };
    }), Wc = function(n) {
        return {
            $: 11,
            a: n
        };
    }, qc = F2(function(n, r) {
        return r.$ ? $e : Se(n(r.a));
    }), Uc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ac = F2(function(n, r) {
        var e;
        return 1 === r.$ ? Uc(b(r.a, {
            c2: (e = n, {
                $: 1,
                a: e
            })
        })) : r;
    }), Ec = F3(function(n, r, e) {
        var t = e.bC;
        return b(e, {
            bC: b(t, {
                cF: A3(to, n, qc(Ac(r)), t.cF)
            }),
            bW: A2(se, n, e.bW)
        });
    }), Tc = F3(function(n, r, e) {
        var t = e.bC;
        return b(e, {
            bC: b(t, {
                dK: A3(to, n, qc(Ac(r)), t.dK)
            }),
            bW: A2(se, n, e.bW)
        });
    }), Ic = F3(function(n, r, e) {
        var t = e.bC;
        return b(e, {
            bC: b(t, {
                dj: A3(to, n, qc(Ac(r)), t.dj)
            }),
            bW: A2(se, n, e.bW)
        });
    }), jc = uu(l([
        o("\u30A2", "\u3042"),
        o("\u30A4", "\u3044"),
        o("\u30A6", "\u3046"),
        o("\u30A8", "\u3048"),
        o("\u30AA", "\u304A"),
        o("\u30AB", "\u304B"),
        o("\u30AD", "\u304D"),
        o("\u30AF", "\u304F"),
        o("\u30B1", "\u3051"),
        o("\u30B3", "\u3053"),
        o("\u30B5", "\u3055"),
        o("\u30B7", "\u3057"),
        o("\u30B9", "\u3059"),
        o("\u30BB", "\u305B"),
        o("\u30BD", "\u305D"),
        o("\u30BF", "\u305F"),
        o("\u30C1", "\u3061"),
        o("\u30C4", "\u3064"),
        o("\u30C6", "\u3066"),
        o("\u30C8", "\u3068"),
        o("\u30CA", "\u306A"),
        o("\u30CB", "\u306B"),
        o("\u30CC", "\u306C"),
        o("\u30CD", "\u306D"),
        o("\u30CE", "\u306E"),
        o("\u30CF", "\u306F"),
        o("\u30D2", "\u3072"),
        o("\u30D5", "\u3075"),
        o("\u30D8", "\u3078"),
        o("\u30DB", "\u307B"),
        o("\u30DE", "\u307E"),
        o("\u30DF", "\u307F"),
        o("\u30E0", "\u3080"),
        o("\u30E1", "\u3081"),
        o("\u30E2", "\u3082"),
        o("\u30E4", "\u3084"),
        o("\u30E6", "\u3086"),
        o("\u30E8", "\u3088"),
        o("\u30E9", "\u3089"),
        o("\u30EA", "\u308A"),
        o("\u30EB", "\u308B"),
        o("\u30EC", "\u308C"),
        o("\u30ED", "\u308D"),
        o("\u30AC", "\u304C"),
        o("\u30AE", "\u304E"),
        o("\u30B0", "\u3050"),
        o("\u30B2", "\u3052"),
        o("\u30B4", "\u3054"),
        o("\u30B6", "\u3056"),
        o("\u30B8", "\u3058"),
        o("\u30BA", "\u305A"),
        o("\u30BC", "\u305C"),
        o("\u30BE", "\u305E"),
        o("\u30C0", "\u3060"),
        o("\u30C2", "\u3062"),
        o("\u30C5", "\u3065"),
        o("\u30C7", "\u3067"),
        o("\u30C9", "\u3069"),
        o("\u30D0", "\u3070"),
        o("\u30D3", "\u3073"),
        o("\u30D6", "\u3076"),
        o("\u30D9", "\u3079"),
        o("\u30DC", "\u307C"),
        o("\u30D1", "\u3071"),
        o("\u30D4", "\u3074"),
        o("\u30D7", "\u3077"),
        o("\u30DA", "\u307A"),
        o("\u30DD", "\u307D"),
        o("\u30EF", "\u308F"),
        o("\u30F2", "\u3092"),
        o("\u30AD\u30E3", "\u304D\u3083"),
        o("\u30AD\u30E5", "\u304D\u3085"),
        o("\u30AD\u30E7", "\u304D\u3087"),
        o("\u30B7\u30E3", "\u3057\u3083"),
        o("\u30B7\u30E5", "\u3057\u3085"),
        o("\u30B7\u30E7", "\u3057\u3087"),
        o("\u30C1\u30E3", "\u3061\u3083"),
        o("\u30C1\u30E5", "\u3061\u3085"),
        o("\u30C1\u30E7", "\u3061\u3087"),
        o("\u30CB\u30E3", "\u306B\u3083"),
        o("\u30CB\u30E5", "\u306B\u3085"),
        o("\u30CB\u30E7", "\u306B\u3087"),
        o("\u30D2\u30E3", "\u3072\u3083"),
        o("\u30D2\u30E5", "\u3072\u3085"),
        o("\u30D2\u30E7", "\u3072\u3087"),
        o("\u30DF\u30E3", "\u307F\u3083"),
        o("\u30DF\u30E5", "\u307F\u3085"),
        o("\u30DF\u30E7", "\u307F\u3087"),
        o("\u30EA\u30E3", "\u308A\u3083"),
        o("\u30EA\u30E5", "\u308A\u3085"),
        o("\u30EA\u30E7", "\u308A\u3087"),
        o("\u30AE\u30E3", "\u304E\u3083"),
        o("\u30AE\u30E5", "\u304E\u3085"),
        o("\u30AE\u30E7", "\u304E\u3087"),
        o("\u30B8\u30E3", "\u3058\u3083"),
        o("\u30B8\u30E5", "\u3058\u3085"),
        o("\u30B8\u30E7", "\u3058\u3087"),
        o("\u30C2\u30E3", "\u3062\u3083"),
        o("\u30C2\u30E5", "\u3062\u3085"),
        o("\u30C2\u30E7", "\u3062\u3087"),
        o("\u30D3\u30E3", "\u3073\u3083"),
        o("\u30D3\u30E5", "\u3073\u3085"),
        o("\u30D3\u30E7", "\u3073\u3087"),
        o("\u30D4\u30E3", "\u3074\u3083"),
        o("\u30D4\u30E5", "\u3074\u3085"),
        o("\u30D4\u30E7", "\u3074\u3087"),
        o("\u30C3\u30AD", "\u3063\u304D"),
        o("\u30F3", "\u3093")
    ])), Rc = F2(function(n, r) {
        if (n.$) {
            t = n.a, a = n.b;
            var e = n.c;
            return c(function() {
                switch(t){
                    case 1:
                        return A3(Ec, a, e, r);
                    case 2:
                        return A3(Tc, a, e, r);
                    default:
                        return A3(Ic, a, e, r);
                }
            }(), xu, zc);
        }
        var t = n.a, a = n.b;
        return c(r, A2(Jt, function(n) {
            var r;
            return Wc(A3(Gc, t, A2(Qu, r = a, A2(zu, r, jc)), n));
        }, so), zc);
    }), Qc = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Pc = uu(l([
        o("\u3042", 3),
        o("\u3044", 2),
        o("\u3046", 2),
        o("\u3048", 2),
        o("\u304A", 3),
        o("\u304B", 3),
        o("\u304D", 4),
        o("\u304F", 1),
        o("\u3051", 3),
        o("\u3053", 2),
        o("\u3055", 3),
        o("\u3057", 1),
        o("\u3059", 2),
        o("\u305B", 3),
        o("\u305D", 1),
        o("\u305F", 4),
        o("\u3061", 2),
        o("\u3064", 1),
        o("\u3066", 1),
        o("\u3068", 2),
        o("\u306A", 4),
        o("\u306B", 3),
        o("\u306C", 2),
        o("\u306D", 2),
        o("\u306E", 1),
        o("\u306F", 3),
        o("\u3072", 1),
        o("\u3075", 4),
        o("\u3078", 1),
        o("\u307B", 4),
        o("\u307E", 3),
        o("\u307F", 2),
        o("\u3080", 3),
        o("\u3081", 2),
        o("\u3082", 3),
        o("\u3084", 3),
        o("\u3086", 2),
        o("\u3088", 2),
        o("\u3089", 2),
        o("\u308A", 2),
        o("\u308B", 1),
        o("\u308C", 2),
        o("\u308D", 1),
        o("\u304C", 5),
        o("\u304E", 6),
        o("\u3050", 3),
        o("\u3052", 5),
        o("\u3054", 4),
        o("\u3056", 5),
        o("\u3058", 3),
        o("\u305A", 4),
        o("\u305C", 5),
        o("\u305E", 3),
        o("\u3060", 6),
        o("\u3062", 4),
        o("\u3065", 3),
        o("\u3067", 3),
        o("\u3069", 4),
        o("\u3070", 5),
        o("\u3073", 3),
        o("\u3076", 6),
        o("\u3079", 3),
        o("\u307C", 6),
        o("\u3071", 4),
        o("\u3074", 2),
        o("\u3077", 5),
        o("\u307A", 2),
        o("\u307D", 5),
        o("\u308F", 2),
        o("\u3092", 3),
        o("\u3093", 1),
        o("\u3083", 3),
        o("\u3085", 2),
        o("\u3087", 2),
        o("\u30A2", 2),
        o("\u30A4", 2),
        o("\u30A6", 3),
        o("\u30A8", 3),
        o("\u30AA", 3),
        o("\u30AB", 2),
        o("\u30AD", 3),
        o("\u30AF", 2),
        o("\u30B1", 3),
        o("\u30B3", 2),
        o("\u30B5", 3),
        o("\u30B7", 3),
        o("\u30B9", 2),
        o("\u30BB", 2),
        o("\u30BD", 2),
        o("\u30BF", 3),
        o("\u30C1", 3),
        o("\u30C4", 3),
        o("\u30C6", 3),
        o("\u30C8", 2),
        o("\u30CA", 2),
        o("\u30CB", 2),
        o("\u30CC", 2),
        o("\u30CD", 4),
        o("\u30CE", 1),
        o("\u30CF", 2),
        o("\u30D2", 2),
        o("\u30D5", 1),
        o("\u30D8", 1),
        o("\u30DB", 4),
        o("\u30DE", 2),
        o("\u30DF", 3),
        o("\u30E0", 2),
        o("\u30E1", 1),
        o("\u30E2", 3),
        o("\u30E4", 2),
        o("\u30E6", 2),
        o("\u30E8", 3),
        o("\u30E9", 2),
        o("\u30EA", 2),
        o("\u30EB", 2),
        o("\u30EC", 1),
        o("\u30ED", 3),
        o("\u30EF", 2),
        o("\u30F0", 4),
        o("\u30F1", 3),
        o("\u30F2", 3),
        o("\u30F3", 2),
        o("\u30AC", 4),
        o("\u30AE", 5),
        o("\u30B0", 4),
        o("\u30B2", 5),
        o("\u30B4", 4),
        o("\u30B6", 5),
        o("\u30B8", 5),
        o("\u30BA", 4),
        o("\u30BC", 4),
        o("\u30BE", 4),
        o("\u30C0", 5),
        o("\u30C2", 5),
        o("\u30C5", 5),
        o("\u30C7", 5),
        o("\u30C9", 4),
        o("\u30D0", 4),
        o("\u30D3", 4),
        o("\u30D6", 3),
        o("\u30D9", 3),
        o("\u30DC", 6),
        o("\u30D1", 3),
        o("\u30D4", 3),
        o("\u30D7", 2),
        o("\u30DA", 2),
        o("\u30DD", 5),
        o("\u30E3", 2),
        o("\u30E5", 2),
        o("\u30E7", 3),
        o("\u30C3", 3)
    ])), Vc = function(n) {
        return A3(ke, me, 0, n);
    }, Fc = A, Nc = function(n) {
        return A2(Fc, n, "");
    }, Jc = E, _c = function(n) {
        return A3(Jc, se, M, n);
    }, Yc = function(n) {
        return A2(Et, function(n) {
            return Nc(n);
        }, _c(n));
    }, Xc = F2(function(n, r) {
        return A2(Qu, !1, A2(Vo, function(r) {
            var t = Yc(n.cD);
            n: for(;;){
                if (t.b) {
                    if (t.b.b) {
                        if (t.b.b.b) break n;
                        var a = t.b.a, i = A2(Vo, function(r) {
                            return Se(Vc(A2(Ya, r, n.$7)));
                        }, A2(zu, o = t.a, Pc));
                        return i.$ ? Se(!1) : 0 > u(n.bZ, i.a) ? Se(e(r, o)) : Se(e(r, a));
                    }
                    var o;
                    return Se(e(r, o = t.a));
                }
                break n;
            }
            return Se(!1);
        }, r));
    }), nf = function(n) {
        return n.b ? Se(n.a) : $e;
    }, rf = F2(function(n, r) {
        return nf(A2(Fa, n, r));
    }), ef = F7(function(n, r, e, t, a, u, i) {
        return {
            bB: n,
            bZ: i,
            cD: u,
            cV: a,
            dn: t,
            $7: e,
            dp: r
        };
    }), tf = A7(ef, 9999, l([
        c("M 21.78,38.74 C 30.41,46.04 67.51,19.79 75.18,36.4 84.42,56.4 56.84,70.78 43.9,70.52", $e, 10),
        c("M 21.78,38.74 C 30.41,46.04 67.51,19.79 75.18,36.4 84.42,56.4 56.84,70.78 43.9,70.52", $e, 10)
    ]), M, 1, "unknown", "unknown", 0), af = function(n) {
        return A2(Qu, tf, A2(rf, n.bV, n.bv));
    }, uf = F2(function(n, r) {
        var e = af(n.bw);
        switch(r.$){
            case 9:
            case 11:
            case 7:
            case 8:
            case 10:
                return A2(Xc, e, r.a);
            default:
                return !1;
        }
    }), of = F2(function(n, r) {
        return A2(Wu, function(r) {
            return A2(uf, n, r);
        }, A2(Et, function(n) {
            return n.bF;
        }, r));
    }), cf = F2(function(n, r) {
        return !A2(of, n, r);
    }), ff = function(n) {
        return A2(Et, function(r) {
            return o(r, n.bS);
        }, A2(Wa, cf(n), n.bN));
    }, bf = 4294967295 >>> 32 - _e, sf = Z, Mf = F3(function(n, r, e) {
        for(;;){
            var t = A2(sf, bf & r >>> n, e);
            if (t.$) return A2(sf, bf & r, t.a);
            n -= _e, e = t.a;
        }
    }), df = function(n) {
        return n >>> 5 << 5;
    }, Cf = F2(function(n, r) {
        var e = r.a, t = r.b, a = r.c, i = r.d;
        return 0 > n || u(n, e) > -1 ? $e : u(n, df(e)) > -1 ? Se(A2(sf, bf & n, i)) : Se(A3(Mf, t, n, a));
    }), lf = function(n) {
        return A2(Qu, !1, A2(Vo, function(n) {
            return Se(1 === n);
        }, n));
    }, vf = F2(function(n, r) {
        var e = n.a;
        return lf(A2(Vo, Cf(n.b), A2(Cf, e, r)));
    }), gf = F2(function(n, r) {
        return A2(vf, r, n);
    }), hf = F2(function(n, r) {
        return A2(Wu, function(r) {
            return A2(Wu, function(r) {
                return e(r.aw, n);
            }, r);
        }, r);
    }), pf = $, Lf = F3(function(n, r, e) {
        var t = e.c, a = e.d, u = F2(function(r, e) {
            return A3(pf, r.$ ? n : u, e, r.a);
        });
        return A3(pf, n, A3(pf, u, r, t), a);
    }), wf = F3(function(n, r, e) {
        return A3(Lf, F2(function(r, e) {
            var t = e.a;
            return o(t + 1, A3(n, t, e.b, r));
        }), o(0, r), e).b;
    }), Zf = F3(function(n, r, e) {
        return A3(wf, F3(function(r, e, t) {
            return A3(wf, F3(function(e, t, a) {
                return A3(n, o(r, e), t, a);
            }), e, t);
        }), r, e);
    }), mf = F3(function(n, r, e) {
        return A3(Zf, F3(function(n, t) {
            return A2(hf, n, t) ? t : A2(Qu, t, A2(Vo, function(n) {
                return Se(s(t, l([
                    n
                ])));
            }, A2(r, n, e)));
        }), n, e);
    }), Sf = F2(function(n, r) {
        return u(Be(r), n) > -1 ? Se(r) : $e;
    }), $f = function(n) {
        return o(n.a + 1, n.b);
    }, Df = F2(function(n, r) {
        return 5 !== n.bQ && 5 !== n.bQ && e(n.bQ, r.bQ);
    }), yf = F2(function(n, r) {
        var e = n.a;
        return Fo(A2(Vo, Cf(n.b), A2(Cf, e, r)));
    }), zf = F3(function(n, r, e) {
        return A2(Vo, function(n) {
            return Se(A2(Df, e, n));
        }, A2(yf, n, r));
    }), Kf = F3(function(n, r, e) {
        return A2(Qu, !1, A2(Vo, A2(zf, r, e), A2(yf, n, e)));
    }), xf = F3(function(n, r, e) {
        var t = r(n);
        if (A3(Kf, n, t, e)) {
            var a = A2(yf, t, e);
            return a.$ ? M : A2(se, a.a, A3(xf, t, r, e));
        }
        return M;
    }), Hf = F2(function(n, r) {
        return A3(xf, n, $f, r);
    }), kf = F3(function(n, r, e) {
        return A2(Vo, function(t) {
            return A2(Sf, n, A2(se, t, A2(Hf, r, e)));
        }, A2(yf, r, e));
    }), Bf = F3(function(n, r, e) {
        return A3(mf, r, kf(n), e);
    }), Of = F2(function(n, r) {
        return A3(Bf, 3, r, n);
    }), Gf = function(n) {
        return o(n.a, n.b + 1);
    }, Wf = F2(function(n, r) {
        return A3(xf, n, Gf, r);
    }), qf = F3(function(n, r, e) {
        return A2(Vo, function(t) {
            return A2(Sf, n, A2(se, t, A2(Wf, r, e)));
        }, A2(yf, r, e));
    }), Uf = F3(function(n, r, e) {
        return A3(mf, r, qf(n), e);
    }), Af = F2(function(n, r) {
        return A3(Uf, 3, r, n);
    }), Ef = function(n) {
        return A2(Of, n, A2(Af, n, M));
    }, Tf = function(n) {
        return n.a;
    }, If = F2(function(n, r) {
        return A2(Qu, !0, A2(Vo, function(n) {
            return Se(0 > r || u(r, Tf(n)) > -1);
        }, A2(Cf, 0, n)));
    }), jf = F2(function(n, r) {
        return 0 > r || u(r, Tf(n)) > -1;
    }), Rf = F2(function(n, r) {
        var e = n.a;
        return A2(If, r, n.b) || A2(jf, r, e);
    }), Qf = F2(function(n, r) {
        var e = n.b;
        return A2(Rf, n.a, r) || A2(Rf, e, r);
    }), Pf = m, Vf = F4(function(n, r, e, t) {
        var a = bf & r >>> n, u = A2(sf, a, t);
        return A3(Pf, a, u.$ ? nt(A3(Pf, bf & r, e, u.a)) : it(A4(Vf, n - _e, r, e, u.a)), t);
    }), Ff = F3(function(n, r, e) {
        var t = e.a, a = e.b, i = e.c, o = e.d;
        return 0 > n || u(n, t) > -1 ? e : u(n, df(t)) > -1 ? A4(Ve, t, a, i, A3(Pf, bf & n, r, o)) : A4(Ve, t, a, A4(Vf, a, n, r, i), o);
    }), Nf = F3(function(n, r, e) {
        var t = n.a, a = n.b;
        return A3(Ff, t, A2(Qu, Ye, A2(Vo, function(n) {
            return Se(A3(Ff, a, r, n));
        }, A2(Cf, t, e))), e);
    }), Jf = F2(function(n, r) {
        return A2(Vo, function(r) {
            return Se(b(r, {
                aw: n
            }));
        }, r);
    }), _f = F2(function(n, r) {
        return A2(Qf, n, r) ? r : A3(Nf, n.b, A2(Jf, n.b, A2(yf, n.a, r)), A3(Nf, n.a, A2(Jf, n.a, A2(yf, n.b, r)), r));
    }), Yf = F4(function(n, r, e, t) {
        var a = r.b;
        return n(r.a) && n(a) && Be(Ef(A2(_f, r, e))) ? s(t, l([
            r
        ])) : t;
    }), Xf = F2(function(n, r) {
        return A3(Zf, F3(function(e, t) {
            return A4(Yf, n, o(e, $f(e)), r, A4(Yf, n, o(e, Gf(e)), r, t));
        }), M, r);
    }), nb = F3(function(n, r, e) {
        return A3(le, F2(function(r, e) {
            var t = e.a;
            return o(t - 1, A3(n, t, e.b, r));
        }), o(Tf(e) - 1, r), e).b;
    }), rb = F2(function(n, r) {
        for(;;){
            if (1 > n || u(n, Tf(r)) > -1) return $e;
            if (!Fo(A2(Cf, n - 1, r)).$) return Se(n - 1);
            n -= 1;
        }
    }), eb = F2(function(n, r) {
        return o(n, r.b);
    }), tb = F2(function(n, r) {
        return A2(Vo, function(r) {
            return Se(b(r, {
                aw: A2(eb, n, r.aw)
            }));
        }, r);
    }), ab = F3(function(n, r, e) {
        return A2(Qu, e, A2(Vo, function(t) {
            return A2(Vo, function(a) {
                return Se(A3(Ff, r, A2(tb, r, t), A3(Ff, n, A2(tb, n, a), e)));
            }, A2(Cf, r, e));
        }, A2(Cf, n, e)));
    }), ub = F2(function(n, r) {
        return A2(Qu, r, A2(Vo, function(e) {
            return Se(A3(ab, n, e, r));
        }, A2(rb, n, r)));
    }), ib = F3(function(n, r, e) {
        return A3(nb, F3(function(e, t) {
            return A2(r, e, n) && 1 === Fo(A2(Cf, e, t)).$ ? A2(ub, e, t) : t;
        }), e, e);
    }), ob = z, cb = F2(function(n, r) {
        var e = r.c, t = r.d, a = {
            d: M,
            a: 0,
            c: A3(ob, n, df(r.a), t)
        }, u = F2(function(r, e) {
            if (r.$) {
                var t = nt(A3(ob, n, e.a * Pe, r.a));
                return {
                    d: A2(se, t, e.d),
                    a: e.a + 1,
                    c: e.c
                };
            }
            return A3(pf, u, e, r.a);
        });
        return A2(st, !0, A3(pf, u, a, e));
    }), fb = x, bb = K, sb = F2(function(n, r) {
        var e = at(n), t = Pe - at(r.c) - e, a = A3(fb, Pe, r.c, n);
        return 0 > t ? {
            d: A2(se, nt(a), r.d),
            a: r.a + 1,
            c: A3(bb, t, e, n)
        } : t ? {
            d: r.d,
            a: r.a,
            c: a
        } : {
            d: A2(se, nt(a), r.d),
            a: r.a + 1,
            c: Fe
        };
    }), Mb = S, db = function(n) {
        return [
            n
        ];
    }, Cb = F4(function(n, r, e, t) {
        var a = bf & r >>> n;
        if (u(a, at(t)) > -1) {
            if (5 === n) return A2(Mb, nt(e), t);
            var i = it(A4(Cb, n - _e, r, e, Fe));
            return A2(Mb, i, t);
        }
        var o = A2(sf, a, t);
        if (o.$) return i = it(A4(Cb, n - _e, r, e, db(o))), A3(Pf, a, i, t);
        i = it(A4(Cb, n - _e, r, e, o.a));
        return A3(Pf, a, i, t);
    }), lb = F2(function(n, r) {
        var t = r.a, a = r.b, i = r.c, o = at(r.d), c = at(n), f = t + (c - o);
        if (e(c, Pe)) {
            if (u(f >>> _e, 1 << a) > 0) {
                var b = a + _e, s = A4(Cb, b, t, n, db(it(i)));
                return A4(Ve, f, b, s, Fe);
            }
            return A4(Ve, f, a, A4(Cb, a, t, n, i), Fe);
        }
        return A4(Ve, f, a, i, n);
    }), vb = F2(function(n, r) {
        var e = r.d, t = at(n), a = Pe - at(e) - t, u = A2(lb, A3(fb, Pe, e, n), r);
        return 0 > a ? A2(lb, A3(bb, a, t, n), u) : u;
    }), gb = F2(function(n, r) {
        var e, t = r.c, a = r.d;
        return 1 > u(r.a, 128) ? A2(vb, a, A3(pf, e = F2(function(n, r) {
            return n.$ ? A2(vb, n.a, r) : A3(pf, e, r, n.a);
        }), n, t)) : A2(st, !0, A2(sb, a, A3(pf, e = F2(function(n, r) {
            return n.$ ? A2(sb, n.a, r) : A3(pf, e, r, n.a);
        }), function(n) {
            var r = n.a, e = n.c, t = n.d, a = F2(function(n, r) {
                return n.$ ? A2(se, n, r) : A3(pf, a, r, n.a);
            });
            return {
                d: A3(pf, a, M, e),
                a: r / Pe | 0,
                c: t
            };
        }(n), t)));
    }), hb = F2(function(n, r) {
        return A2(lb, A2(Mb, n, r.d), r);
    }), pb = F2(function(n, r) {
        var e = r.a, t = r.c, a = r.d;
        if (n) {
            if (u(n, df(e)) > -1) return A4(Ve, e - n, _e, Fe, A3(bb, n - df(e), at(a), a));
            var i = n / Pe | 0, o = F2(function(n, r) {
                return n.$ ? A2(se, n.a, r) : A3(Ce, o, r, n.a);
            }), c = A3(Ce, o, l([
                a
            ]), t), f = A2(Fa, i, c);
            if (f.b) {
                var b = f.a, s = f.b, d = {
                    d: M,
                    a: 0,
                    c: A3(bb, n - i * Pe, at(b), b)
                };
                return A2(st, !0, A3(ke, sb, d, s));
            }
            return Ye;
        }
        return r;
    }), Lb = F4(function(n, r, e, t) {
        for(;;){
            var a = A2(sf, bf & e >>> n, t);
            if (a.$) return A3(bb, 0, bf & r, a.a);
            n -= _e, t = a.a;
        }
    }), wb = F3(function(n, r, e) {
        for(;;){
            if (1 > u(n, r) || !at(e)) return e;
            var t = A2(sf, 0, e);
            if (t.$) return e;
            n -= _e, e = t.a;
        }
    }), Zb = F3(function(n, r, e) {
        var t = bf & r >>> n, a = A2(sf, t, e);
        if (a.$) return A3(bb, 0, t, e);
        var u = A3(Zb, n - _e, r, a.a);
        return at(u) ? A3(Pf, t, it(u), A3(bb, 0, t + 1, e)) : A3(bb, 0, t, e);
    }), mb = F2(function(n, r) {
        var t = r.a, a = r.b, i = r.c, o = r.d;
        if (e(n, t)) return r;
        if (u(n, df(t)) > -1) return A4(Ve, n, a, i, A3(bb, 0, bf & n, o));
        var c = df(n), f = tt(A2(Je, Pe, A2(ut, 1, c - 1))), b = A2(ut, 5, f * _e);
        return A4(Ve, n, b, A3(wb, a, b, A3(Zb, a, c, i)), A4(Lb, a, n, c, i));
    }), Sb = F2(function(n, r) {
        var e = r.a, t = 0 > n ? e + n : n;
        return 0 > t ? 0 : u(t, e) > 0 ? e : t;
    }), $b = F3(function(n, r, e) {
        var t = A2(Sb, r, e), a = A2(Sb, n, e);
        return u(a, t) > 0 ? Ye : A2(pb, a, A2(mb, t, e));
    }), Db = F2(function(n, r) {
        return function(e) {
            if (n >= 0 && 1 > u(n, Tf(e))) {
                var t = A3($b, 0, n, e), a = A3($b, n, Tf(e), e);
                return A2(gb, A2(hb, r, t), a);
            }
            return e;
        };
    }), yb = F3(function(n, r, e) {
        for(;;){
            var t = A2(ot, Pe, n), a = t.a, i = t.b;
            if (0 > u(at(a), Pe)) return A2(st, !0, {
                d: r,
                a: e,
                c: a
            });
            n = i, r = A2(se, nt(a), r), e += 1;
        }
    }), zb = function(n) {
        return n.b ? A3(yb, n, M, 0) : Ye;
    }, Kb = F3(function(n, r, e) {
        return zb(A3(Oe, n, ve(r), ve(e)));
    }), xb = F2(function(n, r) {
        return A2(dt, n, function() {
            return r;
        });
    }), Hb = function(n) {
        return A3(le, Kb(Db(0)), A2(xb, function(n) {
            var r = A2(Cf, 0, n);
            return 1 === r.$ ? 0 : Tf(r.a);
        }(n), Ye), n);
    }, kb = F2(function(n, r) {
        return Hb(A2(cb, function(r) {
            return A2(ib, r, n);
        }, Hb(r)));
    }), Bb = F3(function(n, r, e) {
        return A2(wt, e, af(n).cD);
    }), Ob = function(n) {
        var r = n.bY, e = n.bw;
        return A2(Qu, o(0, 0), A2(Vo, function(n) {
            var r = nf(de(A2(Ju, Bb(e), n.cG)));
            return Se(o(23, r.$ ? -1 : r.a.a));
        }, r));
    }, Gb = F3(function(n, r, e) {
        return A2(vf, o(r, e), n);
    }), Wb = zb(l([
        0,
        1,
        2,
        3,
        4
    ])), qb = F4(function(n, r, e, t) {
        return {
            bF: t,
            bQ: e,
            aw: r,
            cp: n
        };
    }), Ub = {
        $: 1
    }, Ab = F4(function(n, r, e, t) {
        switch(r){
            case 0:
                return Se(A4(qb, n, t, r, {
                    $: 11,
                    a: e
                }));
            case 2:
                return Se(A4(qb, n, t, r, {
                    $: 7,
                    a: e
                }));
            case 1:
                return Se(A4(qb, n, t, r, function(n) {
                    return {
                        $: 9,
                        a: n
                    };
                }(e)));
            case 3:
                return Se(A4(qb, n, t, r, function(n) {
                    return {
                        $: 10,
                        a: n
                    };
                }(e)));
            case 4:
                return Se(A4(qb, n, t, r, function(n) {
                    return {
                        $: 8,
                        a: n
                    };
                }(e)));
            default:
                return $e;
        }
    }), Eb = F2(function(n, r) {
        return A2(Vo, function(n) {
            return A2(zu, n, r);
        }, zt(Nc(n)));
    }), Tb = F4(function(n, r, e, t) {
        var a = A2(Eb, r, t);
        switch(r){
            case "0":
                return A4(Ab, n, 0, a, e);
            case "1":
                return A4(Ab, n, 1, a, e);
            case "2":
                return A4(Ab, n, 2, a, e);
            case "3":
                return A4(Ab, n, 3, a, e);
            case "4":
                return A4(Ab, n, 4, a, e);
            case "\u5927":
                return Se(A4(qb, n, e, 5, Ub));
            default:
                return $e;
        }
    }), Ib = {
        $: 0
    }, jb = F4(function(n, r, e, t) {
        switch(r){
            case 0:
                return Se(A4(qb, n, e, r, {
                    $: 6,
                    a: t
                }));
            case 2:
                return Se(A4(qb, n, e, r, {
                    $: 2,
                    a: t
                }));
            case 1:
                return Se(A4(qb, n, e, r, function(n) {
                    return {
                        $: 4,
                        a: n
                    };
                }(t)));
            case 3:
                return Se(A4(qb, n, e, r, function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(t)));
            case 4:
                return Se(A4(qb, n, e, r, function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(t)));
            default:
                return $e;
        }
    }), Rb = function(n) {
        switch(n){
            case "0":
                return Se(0);
            case "1":
                return Se(1);
            case "2":
                return Se(2);
            case "3":
                return Se(3);
            case "4":
                return Se(4);
            default:
                return $e;
        }
    }, Qb = F3(function(n, r, e) {
        n: for(; r.b && r.b.b && "_" === r.b.a && r.b.b.b;){
            if (!r.b.b.b.b) {
                if ("\u7530" === r.a) return A2(Vo, function(r) {
                    return Se(A4(qb, n, e, r, Ib));
                }, Rb(r.b.b.a));
                break n;
            }
            if ("\u6C34" !== r.a || "_" !== r.b.b.b.a || !r.b.b.b.b.b || r.b.b.b.b.b.b) break n;
            switch(r.b.b.b.b.a){
                case "H":
                    return A2(Vo, function(r) {
                        return A4(jb, n, r, e, 0);
                    }, Rb(r.b.b.a));
                case "V":
                    return A2(Vo, function(r) {
                        return A4(jb, n, r, e, 1);
                    }, Rb(r.b.b.a));
                default:
                    break n;
            }
        }
        return $e;
    }), Pb = F4(function(n, r, e, t) {
        return A2(Vo, function(r) {
            var a = _c(r);
            n: for(;;){
                if (a.b) {
                    if (a.b.b) {
                        if (a.b.b.b) {
                            if (a.b.b.b.b) {
                                if (a.b.b.b.b.b && !a.b.b.b.b.b.b) return A3(Qb, n, a, e);
                                break n;
                            }
                            return A3(Qb, n, a, e);
                        }
                        break n;
                    }
                    return A4(Tb, n, a.a, e, t);
                }
                break n;
            }
            return $e;
        }, r);
    }), Vb = function(n) {
        return 0 > n ? -n : n;
    }, Fb = F2(function(n, r) {
        return function(e) {
            var t = li(e), a = Vb(r - n), u = Ri(t);
            return o((1 * (67108863 & Ri(e)) * 134217728 + 1 * (134217727 & u)) / 9007199254740992 * a + n, li(t));
        };
    }), Nb = F3(function(n, r, e) {
        for(;;){
            var t = n.a, a = n.b;
            if (!r.b) return a;
            var i = r.a, o = r.b;
            if (1 > u(e, Vb(t))) return a;
            n = i, r = o, e -= Vb(t);
        }
    }), Jb = F2(function(n, r) {
        var e = function(n) {
            return Vb(n.a);
        }, t = e(n) + Vc(A2(Et, e, r));
        return A2(go, A2(Nb, n, r), A2(Fb, 0, t));
    }), _b = F2(function(n, r) {
        var e = n.a;
        return A2(Jb, o(e, n.b), A2(Et, function(n) {
            return o(e / (Tf(r) - 1), n);
        }, ve(r)));
    }), Yb = F2(function(n, r) {
        return A3(mt, n - 1, n, r);
    }), Xb = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", ns = Zt(Xb), rs = F3(function(n, r, e) {
        var t = A2(Co, A2(Qi, 0, ns), r), a = t.b;
        return n ? A3(rs, n - 1, a, s(e, A2(Yb, t.a, Xb))) : o(e, a);
    }), es = F2(function(n, r) {
        return A3(rs, n, r, "");
    }), ts = function(n) {
        return A2(es, 6, n);
    }, as = F3(function(n, r, e) {
        var t = A2(Co, A2(_b, n, e), r), a = t.b, u = A2(Qu, -1, A2(Cf, t.a, e));
        return c(ts(r).a, u, a);
    }), us = F6(function(n, r, t, a, u, i) {
        var c = u.a, f = u.b, b = A3(as, n, f, Wb), s = b.a, M = b.b, d = b.c;
        return e(i, $e) && t(a) ? o(A3(Nf, a, A4(Pb, s, Se(ze(M)), a, r), c), d) : o(c, f);
    }), is = F5(function(n, r, e, t, a) {
        return A3(Zf, A3(us, n, r, e), o(a, t), a).a;
    }), os = function(n) {
        return A5(is, Ob(n), n.cG, gf(n.cK.dw), n.c4.c7, A2(kb, Gb(n.cK.dw), n.bG));
    }, cs = F3(function(n, r, e) {
        return A2(Qu, M, A2(Vo, function(e) {
            return Se(l([
                o(o(e, r), o(n, r))
            ]));
        }, A2(rb, n, e)));
    }), fs = F3(function(n, r, e) {
        return A3(nb, F3(function(e, t) {
            var a = t.a, u = t.b;
            return 1 === Fo(A2(Cf, e, a)).$ && A2(n, e, r) ? o(A2(ub, e, a), s(u, A3(cs, e, r, a))) : o(a, u);
        }), o(e, M), e).b;
    }), bs = F2(function(n, r) {
        return A3(nb, F3(function(r, e, t) {
            return s(e, A3(fs, n, r, t));
        }), M, Hb(r));
    }), ss = {
        bE: 0,
        ch: 0,
        c6: 0
    }, Ms = {
        bE: 255,
        ch: 135,
        c6: 93
    }, ds = {
        bE: 240,
        ch: 234,
        c6: 0
    }, Cs = {
        bE: 241,
        ch: 111,
        c6: 188
    }, ls = {
        bE: 0,
        ch: 0,
        c6: 255
    }, vs = {
        bE: 0,
        ch: 215,
        c6: 255
    }, gs = function(n) {
        switch(n){
            case 0:
                return ls;
            case 2:
                return vs;
            case 1:
                return Ms;
            case 3:
                return Cs;
            case 4:
                return ds;
            default:
                return ss;
        }
    }, hs = F2(function(n, r) {
        return !A2(uf, n, r);
    }), ps = function(n) {
        return A2(qe, F2(function(r, e) {
            var t;
            return c(e.aw, gs(e.bQ), A2(Qu, 0, (t = A2(Et, function(n) {
                return n.c;
            }, n.b7)).b ? Se(A3(ke, ut, t.a, t.b)) : $e) + r + 1);
        }), A2(Wa, function(r) {
            return A2(hs, n, r.bF);
        }, ma(n.bN)));
    }, Ls = F2(function(n, r) {
        return A2(hs, n, r.bF);
    }), ws = function(n) {
        var r = n.bN;
        return b(n, {
            dg: A2(Wa, Ls(n), ma(r))
        });
    }, Zs = function(n) {
        return !n.b;
    }, ms = function(n) {
        var r = n.a5;
        return Zs(n.ds.c3) && n.cK.cU > 0 ? b(n, {
            a5: b(r, {
                dh: 3
            })
        }) : n;
    }, Ss = F2(function(n, r) {
        return A2(Wu, function(r) {
            return e(r, n);
        }, r);
    }), $s = F2(function(n, r) {
        var e;
        return A2(Ss, n, r) || A2(Ss, o((e = n).b, e.a), r);
    }), Ds = function(n) {
        var r = n.bG, e = n.ds;
        return A2(Qu, n, A2(Vo, function(n) {
            return Se(function(n) {
                return b(n, {
                    ds: b(n.ds, {
                        dr: $e
                    })
                });
            }(n));
        }, A2(Vo, function(t) {
            return Se(A2($s, t, e.c3) ? b(n, {
                bG: A2(_f, t, r),
                ds: b(e, {
                    c3: M
                })
            }) : n);
        }, e.dr)));
    }, ys = F2(function(n, r) {
        return A3(Bf, 5, r, n);
    }), zs = F2(function(n, r) {
        return A3(Bf, 4, r, n);
    }), Ks = F2(function(n, r) {
        return A3(Uf, 4, r, n);
    }), xs = F2(function(n, r) {
        return A3(ke, F2(function(n, e) {
            return e || A2(Ss, n, r);
        }), !1, n);
    }), Hs = F2(function(n, r) {
        return A2(xs, n, r) ? Se(A3(ke, F2(function(n, r) {
            return A2(Ss, n, r) ? r : s(r, l([
                n
            ]));
        }), r, n)) : $e;
    }), ks = F2(function(n, r) {
        var e = A2(Fa, Be(r), A3(Bf, 3, r, n)), t = A2(Fa, Be(r), A3(Uf, 3, r, n));
        return A3(ke, F2(function(n, r) {
            return A3(ke, F2(function(r, e) {
                var t = A2(Hs, n, r);
                return t.$ ? e : s(e, l([
                    t.a
                ]));
            }), r, e);
        }), r, t);
    }), Bs = function(n) {
        return A2(Of, n, A2(Af, n, A2(zs, n, A2(Ks, n, A2(ks, n, A2(ys, n, function(n) {
            return A3(Uf, 5, M, n);
        }(n)))))));
    }, Os = function(n) {
        return b(n, {
            cQ: b(n.cQ, {
                b_: 0
            })
        });
    }, Gs = F2(function(n) {
        return n;
    }), Ws = qn, qs = F2(function(n, r) {
        return A2(Jt, pt, A2(Tt, Gs(Wt(r)), Ws(n)));
    }), Us = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), As = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Es = {
        $: 2
    }, Ts = function(n) {
        return !n;
    }, Is = function(n) {
        return !Zs(n);
    }, js = F2(function(n, r) {
        return Is(A2(Wa, n, ma(r)));
    }), Rs = F2(function(n, r) {
        return A2(uf, n, r.bF);
    }), Qs = function(n) {
        return A2(js, Rs(n), n.bN);
    }, Ps = function(n) {
        return A2(Jt, Gs(n), Wt(0));
    }, Vs = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Fs = function(n) {
        return Wc(A2(Vs, n.al, n.cV));
    }, Ns = function(n) {
        return Ps(Fs(n));
    }, Js = F3(function(n, r, e) {
        if (!r.de.a8 || !n) return xu;
        switch(e){
            case 1:
                return Ns(Hi(1));
            case 2:
                return Ns(Hi(2));
            case 3:
                return Ns(Hi(3));
            case 4:
                return Ns(Hi(4));
            default:
                return Ns(Hi(5));
        }
    }), _s = function(n) {
        return A2(Wa, Rs(n), ma(n.bN));
    }, Ys = F2(function(n, r) {
        return A2(qs, n, Fs(r));
    }), Xs = F2(function(n, r) {
        return r.de.a8 && n ? A2(Ys, 200, Ki) : xu;
    }), nM = A2(Jt, function(n) {
        return {
            $: 14,
            a: {
                $: 1,
                a: n
            }
        };
    }, so), rM = function(n) {
        return A2(qs, 750, n);
    }, eM = function(n) {
        return Is(n.bN) ? function(n) {
            var r;
            return Xt(l([
                A2(Xs, Qs(n), n),
                A3(Js, A2(js, Ls(n), n.bN), n, n.bS),
                A2(po, Ii(Ai((r = Qc(1), A2(qs, 200, r)))), Pi),
                nM,
                rM(Es),
                function() {
                    if (Qs(n)) {
                        var r = _s(n);
                        return r.b ? A2(Qu, xu, A2(Vo, function(r) {
                            return Se(function(n) {
                                return A2(qs, 1250, n);
                            }(As(A2(Us, Be(_s(n)), r))));
                        }, function(n) {
                            switch(n.$){
                                case 9:
                                case 11:
                                case 7:
                                case 8:
                                case 10:
                                    return n.a;
                                default:
                                    return $e;
                            }
                        }(r.a.bF))) : xu;
                    }
                    return xu;
                }()
            ]));
        }(n) : nM;
    }, tM = F2(function(n, r) {
        return A3(Nf, n.aw, $e, r);
    }), aM = F2(function(n, r) {
        return A3(ke, tM, r, n);
    }), uM = function(n) {
        return b(n, {
            bG: A3(ke, aM, n.bG, n.bN),
            bN: M
        });
    }, iM = function(n) {
        return {
            $: 4,
            a: n
        };
    }, oM = function(n) {
        return A2(qs, 400, n);
    }, cM = function(n) {
        return Zs(n.ds.c3) && n.cK.cU > 0 ? oM(iM(1)) : xu;
    }, fM = F2(function(n, r) {
        var t = n.a, a = r.a;
        return e(n.b, r.b) && u(a, t) > 0;
    }), bM = F2(function(n, r) {
        var e = o(n, r);
        return !e.a.$ && !e.b.$ && A2(fM, e.a.a.aw, e.b.a.aw);
    }), sM = F2(function(n, r) {
        return Be(A2(Wa, function(n) {
            return A2(bM, r.a, n);
        }, A2(Et, ft, n)));
    }), MM = F4(function(n, r, e, t) {
        var a = A3(as, n, t, Wb), u = a.c;
        return o(A4(Pb, a.a, Se(ze(a.b)), r, e), u);
    }), dM = F2(function(n, r) {
        return A2(Qu, Ye, A2(Cf, n, Hb(r)));
    }), CM = F5(function(n, r, e, t, a) {
        if (a.b) {
            var u = a.b;
            return A2(t, r + 1, e) ? 0 : 1 + A5(CM, n, r + 1, e, t, u);
        }
        return 0;
    }), lM = F3(function(n, r, e) {
        return A5(CM, 0, 0, n, r, ve(A2(dM, n, e)));
    }), vM = F3(function(n, r, e) {
        return A3(lM, n.b, r, e);
    }), gM = F7(function(n, r, t, a, u, i, f) {
        var b = u.a, M = u.b, d = i.a, C = i.b, v = i.c;
        if (e(f, $e) && A2(a, b, M)) {
            var g = A4(MM, n, u, r, C), h = g.a, p = g.b;
            return c(A3(Nf, u, h, d), p, s(v, l([
                o(h, o(A3(vM, u, a, t), M))
            ])));
        }
        return c(d, C, v);
    }), hM = F5(function(n, r, e, t, a) {
        return function(n) {
            return A2(Et, function(r) {
                return A2(Eu, function(e) {
                    var t = e.b;
                    return o(e.a - A2(sM, n, r), t);
                }, r);
            }, n);
        }(A3(Zf, A4(gM, n, r, a, e), c(a, t, M), a).c);
    }), pM = function(n) {
        return b(n, {
            bH: A2(Za, n.bH, _s(n))
        });
    }, LM = function(n) {
        return b(n, {
            bN: Bs(n.bG)
        });
    }, wM = F2(function(n, r) {
        return b(r, {
            cf: r.cf + n
        });
    }), ZM = F2(function(n, r) {
        return u(n, r) > -1 ? 1 : n / r;
    }), mM = F3(function(n, r, e) {
        return 0 > u(n, r) ? 0 : u(n, e) > -1 ? 1 : (n - r) / (e - r);
    }), SM = F3(function(n, r, e) {
        return 0 > u(n, r) ? 0 : u(n, e) > -1 ? 1 : (n - r) / (e - r);
    }), $M = function(n) {
        return b(n, {
            da: b(n.da, {
                c_: A2(ZM, n.da.cf, n.cK.c$),
                dt: n.da.bt ? A3(mM, n.da.cf, n.cK.dE, n.cK.du) : 0,
                dD: n.da.br ? A3(SM, n.da.cf, n.cK.c$, n.cK.dE) : 0
            })
        });
    }, DM = F2(function(n, r) {
        return $M(b(r, {
            da: A2(wM, n, r.da)
        }));
    }), yM = F2(function(n, r) {
        switch(Be(n)){
            case 3:
                return 60 * r;
            case 4:
                return 120 * r;
            case 5:
            case 6:
                return 200 * r;
            default:
                return 0;
        }
    }), zM = F2(function(n, r) {
        return A3(ke, F2(function(r, e) {
            return e + A2(yM, r, n);
        }), 0, r);
    }), KM = function(n) {
        return A2(DM, A2(zM, n.bS, n.bN), n);
    }, xM = F2(function(n, r) {
        switch(n){
            case 0:
                return c(uM(function(n) {
                    return b(n, {
                        bx: ff(n)
                    });
                }(function(n) {
                    return b(n, {
                        b7: ps(n)
                    });
                }(pM(ws(KM(LM(Ds(r)))))))), eM(pM(LM(Ds(r)))), zc);
            case 1:
                var e = Ob(r);
                return c(t = b(r, {
                    ca: A2(bs, Gb(r.cK.dw), r.bG),
                    dC: A5(hM, e, r.cG, Gb(r.cK.dw), r.c4.c7, A2(kb, Gb(r.cK.dw), r.bG))
                }), function(n) {
                    return A2(qs, 800, n);
                }(Qc(2)), zc);
            default:
                var t = function(n) {
                    return n.bw.cc && !n.cA ? b(n, {
                        by: 6
                    }) : n;
                }(function(n) {
                    return 1 > n.cK.cU ? Os(n) : Zs(Bs(n.bG)) ? function(n) {
                        return b(n, {
                            cA: !1
                        });
                    }(function(n) {
                        return b(n, {
                            bW: M
                        });
                    }(function(n) {
                        return b(n, {
                            bS: 1
                        });
                    }(n))) : n;
                }(ms(function(n) {
                    return b(n, {
                        bx: s(n.bx, ff(n))
                    });
                }(function(n) {
                    return b(n, {
                        b7: s(n.b7, ps(n))
                    });
                }(function(n) {
                    return Is(n.dg) ? function(n) {
                        return b(n, {
                            bS: n.bS + 1
                        });
                    }(n) : n;
                }(pM(ws(KM(LM(function(n) {
                    return b(n, {
                        ds: b(n.ds, {
                            c3: A2(Xf, gf(n.cK.dw), os(n))
                        })
                    });
                }(function(n) {
                    return b(n, {
                        bG: os(n)
                    });
                }(function(n) {
                    return b(n, {
                        ca: M,
                        dC: M
                    });
                }(r)))))))))))));
                return c(uM(t), Xt(l([
                    eM(t),
                    cM(t)
                ])), zc);
        }
    }), HM = F2(function(n, r) {
        return 0 > u(n, r) ? n : r;
    }), kM = function(n) {
        return function(n) {
            return {
                bP: 768 > A2(HM, n.bk, n.aE) ? 0 : n.aE > 820 ? 1080 > n.aE ? 2 : 3 : 1,
                c1: 0 > u(n.bk, n.aE) ? 0 : 1
            };
        }({
            aE: ta(n.dJ.aE),
            bk: ta(n.dJ.bk)
        });
    }, BM = Yn("deviceClassPortToJS", va), OM = function(n) {
        var r;
        return r = function(n) {
            switch(n.bP){
                case 0:
                    return "phone";
                case 1:
                    return "tablet";
                case 2:
                    return "desktop";
                default:
                    return "big-desktop";
            }
        }(n), BM(r);
    }, GM = F3(function(n, r, e) {
        var t = e.dJ;
        return b(e, {
            a3: b(e.a3, {
                aE: r,
                bk: n
            }),
            dJ: b(t, {
                aE: r,
                bk: n
            })
        });
    }), WM = F2(function(n, r) {
        if (1 === n.$) {
            var e = n.a;
            if (e.$) return c(b(r, {
                dJ: $e
            }), xu, zc);
            var t = e.a;
            return c(b(r, {
                b$: kM(t),
                dJ: Se(t)
            }), OM(kM(t)), zc);
        }
        var a = n.a, u = n.b, i = A2(Vo, function(n) {
            return Se(A3(GM, a, u, n));
        }, r.dJ);
        return c(b(r, {
            b$: A2(Qu, {
                bP: 0,
                c1: 0
            }, A2(Vo, function(n) {
                return Se(kM(n));
            }, i)),
            dJ: i
        }), A2(Qu, xu, A2(Vo, function(n) {
            return Se(OM(kM(n)));
        }, r.dJ)), zc);
    }), qM = function(n) {
        return {
            $: 13,
            a: n
        };
    }, UM = function(n) {
        return {
            $: 1,
            a: n
        };
    }, AM = F2(function(n, r) {
        var t = r.ds;
        switch(n.$){
            case 2:
                return c(r, A2(po, function(n) {
                    return qM({
                        $: 0,
                        a: n
                    });
                }, A2(Qi, 0, Be(r.ds.c3) - 1)), zc);
            case 0:
                var a = n.a;
                return c(Kc(r), A2(Jt, Gs(qM(UM(A2(rf, a, r.ds.c3)))), Wt(A2(rf, a, r.ds.c3))), zc);
            default:
                var u = n.a;
                return c(b(r, {
                    ds: b(t, {
                        co: u
                    })
                }), e(u, $e) ? xu : function(n) {
                    return A2(qs, 1e3, n);
                }(qM(UM($e))), zc);
        }
    }), EM = function(n) {
        return b(n, {
            cQ: b(n.cQ, {
                cL: 0
            })
        });
    }, TM = F2(function(n, r) {
        var t = o(r, n);
        if (t.a.b && t.a.b.b && t.a.b.b.b && t.a.b.b.b.b && !t.a.b.b.b.b.b) {
            if (1 === t.b.$) return Se(t.a.a);
            var a = t.a, u = a.b, i = u.a, c = u.b, f = c.a, b = c.b.a, s = t.b.a;
            return e(s, a.a) ? Se(i) : e(s, i) ? Se(f) : e(s, f) ? Se(b) : $e;
        }
        return $e;
    }), IM = F2(function(n, r) {
        return A2(cb, F2(function(r, e) {
            return A2(cb, F2(function(e, t) {
                return A2(n, o(r, e), t);
            }), e);
        }), r);
    }), jM = zb(A2(We, 0, 4)), RM = F3(function(n, r, e) {
        return n(r) ? e : A2(hb, r, e);
    }), QM = F2(function(n, r) {
        return A3(Lf, RM(n), Ye, r);
    }), PM = F3(function(n, r, t) {
        return n && e(t, r);
    }), VM = F2(function(n, r) {
        var e = n.a;
        return A2(Vo, Cf(n.b), A2(Cf, e, r));
    }), FM = F3(function(n, r, t) {
        var a = Tf(n), u = Tf(r), i = A2(Qu, -1, Fo(A2(Vo, function(n) {
            return Se(n.b);
        }, A2(Cf, u - 1, r)))), c = A2(Qu, -1, Fo(A2(Vo, function(n) {
            return Se(n.b);
        }, A2(Cf, u - 2, r)))), f = i >= 0 && c >= 0 && e(i, c), b = A2(Qu, -1, Fo(A2(Vo, function(n) {
            return Se(n.b);
        }, A2(VM, o(a - 1, u), n)))), s = A2(Qu, -1, Fo(A2(Vo, function(n) {
            return Se(n.b);
        }, A2(VM, o(a - 2, u), n)))), M = b >= 0 && s >= 0 && e(b, s);
        return A2(QM, A2(PM, M, b), A2(QM, A2(PM, f, i), t));
    }), NM = F5(function(n, r, e, t, a) {
        var i = A3(as, n, r, A3(FM, t, a, jM)), c = i.a, f = i.b, b = i.c;
        return 0 > u(Tf(a), e) ? A5(NM, n, b, e, t, A2(hb, o(c, Se(f)), a)) : o(a, b);
    }), JM = F6(function(n, r, e, t, a, i) {
        if (0 > u(Tf(i), e)) {
            var o = A5(NM, n, r, t, i, Ye);
            return A6(JM, n, o.b, e, t, a, A2(hb, o.a, i));
        }
        return i;
    }), _M = F6(function(n, r, e, t, a, u) {
        return A2(IM, F2(function(n, r) {
            var e = r.a, t = r.b;
            return a(n) ? A2(Vo, function(r) {
                return A4(Pb, e, Se(ze(r)), n, u);
            }, t) : $e;
        }), A6(JM, n, r, e, t, a, Ye));
    }), YM = {
        $: 1
    }, XM = function(n) {
        return {
            $: 6,
            a: n
        };
    }, nd = {
        $: 2
    }, rd = {
        $: 2
    }, ed = F2(function(n, r) {
        return n.de.a8 && r ? Ns(zi) : xu;
    }), td = function(n) {
        return A2(qs, 250, n);
    }, ad = function(n) {
        return A2(qs, 3e3, n);
    }, ud = F2(function(n, r) {
        var e;
        return l(r ? [
            (e = XM(YM), A2(qs, 4750, e)),
            ad(As(nd)),
            A2(ed, n, r)
        ] : [
            td(XM(rd))
        ]);
    }), id = function(n) {
        return n.de.a8 && 7 === n.by ? Ns(qi) : xu;
    }, od = F3(function(n, r, t) {
        var a = o(e(n, Se(r)), Be(t.dM));
        return a.a ? a.b ? 500 : 2e3 : 0;
    }), cd = function(n) {
        return A2(Co, Pi, n).b;
    }, fd = F2(function(n, r) {
        var e = r.c4;
        switch(n.$){
            case 0:
                return b(r, {
                    c4: b(e, {
                        cJ: cd(e.cJ)
                    })
                });
            case 1:
                return b(r, {
                    c4: b(e, {
                        c7: cd(e.c7)
                    })
                });
            case 2:
                return b(r, {
                    c4: b(e, {
                        a5: cd(e.a5)
                    })
                });
            default:
                return b(r, {
                    c4: b(e, {
                        cs: cd(e.cs)
                    })
                });
        }
    }), bd = A7(ef, 1, l([
        c("M 33.33,27.81 C 40.52,33.93 66.51,29.66 70.93,27.62", $e, 9.47),
        c("M 57.6,16.78 C 54.28,19.33 40.62,61.41 48.47,72.26", $e, 9.47),
        c("M 66.65,42.26 C 66.65,48.37 47.98,88.06 31.81,80.99 17.23,74.61 26.31,47.91 50.01,46.92 71.33,47.76 83.35,66.05 69.83,83.94", $e, 9.47)
    ]), l([
        39,
        58,
        162
    ]), 1, "a", "\u3042", 0), sd = A7(ef, 1, l([
        c("M 21,22 L 79,22 C 79,22 72.81,35.81 59.67,46.55", $e, 10),
        c("M 48.84,35.81 C 48.84,35.81 51.16,70.33 30.28,78", $e, 10)
    ]), l([
        90,
        49
    ]), 1, "a", "\u30A2", 0), Md = A7(ef, 61, l([
        c("M 21.13,23.16 C 26.12,31.04 9.34,80.92 18.65,85.48 23.8,87.99 26.7,75.05 30.07,72.53", $e, 9.47),
        c("M 45.85,36.2 C 53.99,38.06 72.35,33.17 76.77,33.41", $e, 9.47),
        c("M 64.91,21.78 C 65.53,37.64 75.69,84.82 56.54,83.39 47.24,82.69 40.94,79.76 41.9,72.69 43.71,59.34 65.34,67.55 76.15,77.08", $e, 9.47),
        c("M 75.31,16 C 75.31,16 77.98,16 80.64,19 83.31,22 83.31,25 83.31,25", Se("M 73.13,15.06 C 72.83,15.35 72.99,15.53 74.27,16.3 76.68,17.76 79.7,21.22 81.95,25.13 82.8,26.59 83.52,27.16 84.31,26.96 85.95,26.56 85.48,21.6 83.57,19.32 82.69,18.26 79.52,16.67 76.37,15.7 73.69,14.89 73.37,14.82 73.13,15.06 Z M 73.13,15.06"), 5),
        c("M 80.31,10 C 80.31,10 82.98,10 85.64,13 88.31,16 88.31,19 88.31,19", Se("M 78.13,9.06 C 77.83,9.35 77.99,9.53 79.27,10.3 81.68,11.76 84.7,15.22 86.95,19.13 87.8,20.59 88.52,21.16 89.31,20.96 90.95,20.56 90.48,15.6 88.57,13.32 87.69,12.26 84.52,10.67 81.37,9.7 78.69,8.89 78.37,8.82 78.13,9.06 Z M 78.13,9.06"), 5)
    ]), l([
        83,
        32,
        130,
        14,
        14
    ]), 1, "ba", "\u3070", 0), dd = A7(ef, 61, l([
        c("M 36.71,28.52 C 36.71,28.52 34.43,55.81 20,74", $e, 10),
        c("M 59.49,27 C 59.49,27 74.68,46.71 80,74", $e, 10),
        c("M 71.47,20.53 C 71.47,20.53 74.14,20.53 76.8,23.53 79.47,26.53 79.47,29.53 79.47,29.53", Se("M 69.29,19.59 C 68.99,19.88 69.15,20.05 70.43,20.82 72.84,22.28 75.86,25.75 78.11,29.66 78.96,31.11 79.68,31.69 80.47,31.49 82.11,31.09 81.64,26.12 79.73,23.85 78.85,22.79 75.68,21.2 72.53,20.23 69.85,19.41 69.53,19.35 69.29,19.59 Z M 69.29,19.59"), 5),
        c("M 76.47,14.53 C 76.47,14.53 79.14,14.53 81.8,17.53 84.47,20.53 84.47,23.53 84.47,23.53", Se("M 74.29,13.59 C 73.99,13.88 74.15,14.05 75.43,14.82 77.84,16.28 80.86,19.75 83.11,23.66 83.96,25.11 84.68,25.69 85.47,25.49 87.11,25.09 86.64,20.12 84.73,17.85 83.85,16.79 80.68,15.2 77.53,14.23 74.85,13.41 74.53,13.35 74.29,13.59 Z M 74.29,13.59"), 5)
    ]), l([
        50,
        53,
        14,
        14
    ]), 1, "ba", "\u30D0", 0), Cd = A7(ef, 64, l([
        c("M 17.78,60.06 C 25.32,54.85 30.91,43.44 34.64,38.78 41.18,44.42 62.75,56.65 80.86,63.16", $e, 9.47),
        c("M 65.31,24 C 65.31,24 67.98,24 70.64,27 73.31,30 73.31,33 73.31,33", Se("M 63.13,23.06 C 62.83,23.35 62.99,23.53 64.27,24.3 66.68,25.76 69.7,29.22 71.95,33.13 72.8,34.59 73.52,35.16 74.31,34.96 75.95,34.56 75.48,29.6 73.57,27.32 72.69,26.26 69.52,24.67 66.37,23.7 63.69,22.89 63.37,22.82 63.13,23.06 Z M 63.13,23.06"), 5),
        c("M 70.31,18 C 70.31,18 72.98,18 75.64,21 78.31,24 78.31,27 78.31,27", Se("M 68.13,17.06 C 67.83,17.35 67.99,17.53 69.27,18.3 71.68,19.76 74.7,23.22 76.95,27.13 77.8,28.59 78.52,29.16 79.31,28.96 80.95,28.56 80.48,23.6 78.57,21.32 77.69,20.26 74.52,18.67 71.37,17.7 68.69,16.89 68.37,16.82 68.13,17.06 Z M 68.13,17.06"), 5)
    ]), l([
        81,
        14,
        14
    ]), 1, "be", "\u3079", 0), ld = A7(ef, 64, l([
        c("M 17,55.49 C 17,55.49 35.46,31 40.27,31 45.09,31 82,71 82,71", $e, 10),
        c("M 62.31,23.79 C 62.31,23.79 64.97,23.79 67.64,26.79 70.31,29.79 70.31,32.79 70.31,32.79", Se("M 60.12,22.86 C 59.83,23.14 59.99,23.32 61.27,24.09 63.68,25.55 66.69,29.02 68.94,32.92 69.8,34.38 70.52,34.95 71.3,34.76 72.95,34.36 72.47,29.39 70.56,27.12 69.68,26.06 66.51,24.47 63.36,23.5 60.68,22.68 60.37,22.61 60.12,22.86 Z M 60.12,22.86"), 5),
        c("M 67.31,17.79 C 67.31,17.79 69.97,17.79 72.64,20.79 75.31,23.79 75.31,26.79 75.31,26.79", Se("M 65.12,16.86 C 64.83,17.14 64.99,17.32 66.27,18.09 68.68,19.55 71.69,23.02 73.94,26.92 74.8,28.38 75.52,28.95 76.3,28.76 77.95,28.36 77.47,23.39 75.56,21.12 74.68,20.06 71.51,18.47 68.36,17.5 65.68,16.68 65.37,16.61 65.12,16.86 Z M 65.12,16.86"), 5)
    ]), l([
        92,
        14,
        14
    ]), 1, "be", "\u30D9", 0), vd = A7(ef, 62, l([
        c("M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7", $e, 9.47),
        c("M 75.31,21 C 75.31,21 77.98,21 80.64,24 83.31,27 83.31,30 83.31,30", Se("M 73.13,20.06 C 72.83,20.35 72.99,20.53 74.27,21.3 76.68,22.76 79.7,26.22 81.95,30.13 82.8,31.59 83.52,32.16 84.31,31.96 85.95,31.56 85.48,26.6 83.57,24.32 82.69,23.26 79.52,21.67 76.37,20.7 73.69,19.89 73.37,19.82 73.13,20.06 Z M 73.13,20.06"), 5),
        c("M 80.31,15 C 80.31,15 82.98,15 85.64,18 88.31,21 88.31,24 88.31,24", Se("M 78.13,14.06 C 77.83,14.35 77.99,14.53 79.27,15.3 81.68,16.76 84.7,20.22 86.95,24.13 87.8,25.59 88.52,26.16 89.31,25.96 90.95,25.56 90.48,20.6 88.57,18.32 87.69,17.26 84.52,15.67 81.37,14.7 78.69,13.89 78.37,13.82 78.13,14.06 Z M 78.13,14.06"), 5)
    ]), l([
        168,
        14,
        14
    ]), 1, "bi", "\u3073", 0), gd = A7(ef, 62, l([
        c("M 27.15,50.86 C 27.15,50.86 49.58,48.43 71.18,35.43", $e, 10),
        c("M 26.32,20 C 26.32,20 18.85,71.17 26.32,77.67 33.8,84.17 77,77.67 77,77.67", $e, 10),
        c("M 71.47,20.53 C 71.47,20.53 74.14,20.53 76.8,23.53 79.47,26.53 79.47,29.53 79.47,29.53", Se("M 69.29,19.59 C 68.99,19.88 69.15,20.05 70.43,20.82 72.84,22.28 75.86,25.75 78.11,29.66 78.96,31.11 79.68,31.69 80.47,31.49 82.11,31.09 81.64,26.12 79.73,23.85 78.85,22.79 75.68,21.2 72.53,20.23 69.85,19.41 69.53,19.35 69.29,19.59 Z M 69.29,19.59"), 5),
        c("M 76.47,14.53 C 76.47,14.53 79.14,14.53 81.8,17.53 84.47,20.53 84.47,23.53 84.47,23.53", Se("M 74.29,13.59 C 73.99,13.88 74.15,14.05 75.43,14.82 77.84,16.28 80.86,19.75 83.11,23.66 83.96,25.11 84.68,25.69 85.47,25.49 87.11,25.09 86.64,20.12 84.73,17.85 83.85,16.79 80.68,15.2 77.53,14.23 74.85,13.41 74.53,13.35 74.29,13.59 Z M 74.29,13.59"), 5)
    ]), l([
        47,
        110,
        14,
        14
    ]), 1, "bi", "\u30D3", 0), hd = A7(ef, 65, l([
        c("M 23.68,27.78 C 18.01,35.26 15.15,80.9 21.03,81.29 24.7,81.54 29.19,67.25 29.19,67.25", $e, 9.47),
        c("M 49.48,29.62 C 56.47,28.12 72.83,29.46 76.82,30.6", $e, 9.47),
        c("M 48.95,48.19 C 56,52.38 73.17,49.27 77.31,47.5", $e, 9.47),
        c("M 62.91,30.6 C 65.68,56.03 74.11,88.55 49.19,82.27 39.34,79.79 43.01,63.22 52.13,64.64 65.86,66.78 72.9,69.49 77.8,77.09", $e, 9.47),
        c("M 78.31,15 C 78.31,15 80.98,15 83.64,18 86.31,21 86.31,24 86.31,24", Se("M 76.13,14.06 C 75.83,14.35 75.99,14.53 77.27,15.3 79.68,16.76 82.7,20.22 84.95,24.13 85.8,25.59 86.52,26.16 87.31,25.96 88.95,25.56 88.48,20.6 86.57,18.32 85.69,17.26 82.52,15.67 79.37,14.7 76.69,13.89 76.37,13.82 76.13,14.06 Z M 76.13,14.06"), 5),
        c("M 83.31,9 C 83.31,9 85.98,9 88.64,12 91.31,15 91.31,18 91.31,18", Se("M 81.13,8.06 C 80.83,8.35 80.99,8.53 82.27,9.3 84.68,10.76 87.7,14.22 89.95,18.13 90.8,19.59 91.52,20.16 92.31,19.96 93.95,19.56 93.48,14.6 91.57,12.32 90.69,11.26 87.52,9.67 84.37,8.7 81.69,7.89 81.37,7.82 81.13,8.06 Z M 81.13,8.06"), 5)
    ]), l([
        72,
        28,
        29,
        120,
        14,
        14
    ]), 1, "bo", "\u307C", 0), pd = A7(ef, 65, l([
        c("M 24.09,35.78 L 76.64,35.78", $e, 10),
        c("M 50,21 L 50,76.32 C 50,76.32 49.64,78.79 46.35,80.11 43.07,81.44 38.32,78.6 38.32,78.6", $e, 10),
        c("M 33.95,52.07 C 33.95,52.07 32.49,61.17 23,72.53", $e, 10),
        c("M 65.32,52.07 C 65.32,52.07 68.97,63.44 77,72.53", $e, 10),
        c("M 74.66,18.34 C 74.66,18.34 77.33,18.34 79.99,21.34 82.66,24.34 82.66,27.34 82.66,27.34", Se("M 72.48,17.4 C 72.18,17.69 72.34,17.86 73.62,18.64 76.03,20.09 79.05,23.56 81.3,27.47 82.15,28.92 82.87,29.5 83.66,29.3 85.3,28.9 84.83,23.93 82.92,21.66 82.04,20.6 78.87,19.01 75.72,18.04 73.04,17.22 72.72,17.16 72.48,17.4 Z M 72.48,17.4"), 5),
        c("M 79.66,12.34 C 79.66,12.34 82.33,12.34 84.99,15.34 87.66,18.34 87.66,21.34 87.66,21.34", Se("M 77.48,11.4 C 77.18,11.69 77.34,11.86 78.62,12.64 81.03,14.09 84.05,17.56 86.3,21.47 87.15,22.92 87.87,23.5 88.66,23.3 90.3,22.9 89.83,17.93 87.92,15.66 87.04,14.6 83.87,13.01 80.72,12.04 78.04,11.22 77.72,11.16 77.48,11.4 Z M 77.48,11.4"), 5)
    ]), l([
        53,
        70,
        24,
        24,
        14,
        14
    ]), 1, "bo", "\u30DC", 0), Ld = A7(ef, 63, l([
        c("M 44.09,19.78 C 45.89,23.85 48.42,26.98 50.73,28.5 L 46.37,30.78", $e, 9.47),
        c("M 46.58,45.21 C 58.43,50.96 57.51,79.75 47.2,80.88 41.54,81.51 38.7,74.66 38.7,74.66", $e, 9.47),
        c("M 30.4,49.39 C 29.36,54.79 25.55,64.17 18.78,68.02", $e, 9.47),
        c("M 70.99,45.55 C 76.87,54.76 82.64,67.33 80.49,69.2 77.39,71.9 72.78,65.61 71.47,64.91", $e, 9.47),
        c("M 69.31,18 C 69.31,18 71.98,18 74.64,21 77.31,24 77.31,27 77.31,27", Se("M 67.13,17.06 C 66.83,17.35 66.99,17.53 68.27,18.3 70.68,19.76 73.7,23.22 75.95,27.13 76.8,28.59 77.52,29.16 78.31,28.96 79.95,28.56 79.48,23.6 77.57,21.32 76.69,20.26 73.52,18.67 70.37,17.7 67.69,16.89 67.37,16.82 67.13,17.06 Z M 67.13,17.06"), 5),
        c("M 74.31,12 C 74.31,12 76.98,12 79.64,15 82.31,18 82.31,21 82.31,21", Se("M 72.13,11.06 C 71.83,11.35 71.99,11.53 73.27,12.3 75.68,13.76 78.7,17.22 80.95,21.13 81.8,22.59 82.52,23.16 83.31,22.96 84.95,22.56 84.48,17.6 82.57,15.32 81.69,14.26 78.52,12.67 75.37,11.7 72.69,10.89 72.37,10.82 72.13,11.06 Z M 72.13,11.06"), 5)
    ]), l([
        16,
        53,
        23,
        37,
        14,
        14
    ]), 1, "bu", "\u3076", 0), wd = A7(ef, 63, l([
        c("M 23,32 L 77,32 C 77,32 73.58,68.28 33.65,87", $e, 10),
        c("M 77.66,15.44 C 77.66,15.44 80.33,15.44 83,18.44 85.66,21.44 85.66,24.44 85.66,24.44", Se("M 75.48,14.5 C 75.19,14.79 75.35,14.96 76.63,15.74 79.04,17.19 82.05,20.66 84.3,24.57 85.16,26.02 85.88,26.6 86.66,26.4 88.31,26 87.83,21.03 85.92,18.76 85.04,17.7 81.87,16.11 78.72,15.14 76.04,14.32 75.73,14.26 75.48,14.5 Z M 75.48,14.5"), 5),
        c("M 82.66,9.44 C 82.66,9.44 85.33,9.44 88,12.44 90.66,15.44 90.66,18.44 90.66,18.44", Se("M 80.48,8.5 C 80.19,8.79 80.35,8.96 81.63,9.74 84.04,11.19 87.05,14.66 89.3,18.57 90.16,20.02 90.88,20.6 91.66,20.4 93.31,20 92.83,15.03 90.92,12.76 90.04,11.7 86.87,10.11 83.72,9.14 81.04,8.32 80.73,8.26 80.48,8.5 Z M 80.48,8.5"), 5)
    ]), l([
        127,
        14,
        14
    ]), 1, "bu", "\u30D6", 0), Zd = A7(ef, 98, l([
        c("M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7", $e, 9.47),
        c("M 75.31,21 C 75.31,21 77.98,21 80.64,24 83.31,27 83.31,30 83.31,30", Se("M 73.13,20.06 C 72.83,20.35 72.99,20.53 74.27,21.3 76.68,22.76 79.7,26.22 81.95,30.13 82.8,31.59 83.52,32.16 84.31,31.96 85.95,31.56 85.48,26.6 83.57,24.32 82.69,23.26 79.52,21.67 76.37,20.7 73.69,19.89 73.37,19.82 73.13,20.06 Z M 73.13,20.06"), 5),
        c("M 80.31,15 C 80.31,15 82.98,15 85.64,18 88.31,21 88.31,24 88.31,24", Se("M 78.13,14.06 C 77.83,14.35 77.99,14.53 79.27,15.3 81.68,16.76 84.7,20.22 86.95,24.13 87.8,25.59 88.52,26.16 89.31,25.96 90.95,25.56 90.48,20.6 88.57,18.32 87.69,17.26 84.52,15.67 81.37,14.7 78.69,13.89 78.37,13.82 78.13,14.06 Z M 78.13,14.06"), 5),
        c("M 95,56.64 C 100.57,59.29 127.47,44.95 130.85,48.53 136.28,54.28 127.73,61.36 125.83,64.75", $e, 7),
        c("M 116.46,42.78 C 116.46,47.06 118.99,55.36 120.8,58.11", $e, 7),
        c("M 100.02,46.03 C 102.61,48.09 115.51,76.39 115.23,82.73", $e, 7)
    ]), l([
        168,
        14,
        14,
        56,
        17,
        40
    ]), 1, "bya", "\u3073\u3083", 0), md = A7(ef, 98, l([
        c("M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43", $e, 10),
        c("M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67", $e, 10),
        c("M 82.31,17.7 C 82.31,17.7 84.97,17.7 87.64,20.7 90.31,23.7 90.31,26.7 90.31,26.7", Se("M 80.12,16.76 C 79.83,17.05 79.99,17.22 81.27,17.99 83.68,19.45 86.69,22.92 88.94,26.83 89.8,28.28 90.52,28.86 91.3,28.66 92.95,28.26 92.47,23.29 90.56,21.02 89.68,19.96 86.51,18.37 83.36,17.4 80.68,16.58 80.37,16.52 80.12,16.76 Z M 80.12,16.76"), 5),
        c("M 87.31,11.7 C 87.31,11.7 89.97,11.7 92.64,14.7 95.31,17.7 95.31,20.7 95.31,20.7", Se("M 85.12,10.76 C 84.83,11.05 84.99,11.22 86.27,11.99 88.68,13.45 91.69,16.92 93.94,20.83 94.8,22.28 95.52,22.86 96.3,22.66 97.95,22.26 97.47,17.29 95.56,15.02 94.68,13.96 91.51,12.37 88.36,11.4 85.68,10.58 85.37,10.52 85.12,10.76 Z M 85.12,10.76"), 5),
        c("M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92", $e, 7),
        c("M 115.35,43.46 L 123.45,81.46", $e, 7)
    ]), l([
        47,
        110,
        14,
        14,
        55,
        39
    ]), 1, "bya", "\u30D3\u30E3", 0), Sd = A7(ef, 100, l([
        c("M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7", $e, 9.47),
        c("M 75.31,21 C 75.31,21 77.98,21 80.64,24 83.31,27 83.31,30 83.31,30", Se("M 73.13,20.06 C 72.83,20.35 72.99,20.53 74.27,21.3 76.68,22.76 79.7,26.22 81.95,30.13 82.8,31.59 83.52,32.16 84.31,31.96 85.95,31.56 85.48,26.6 83.57,24.32 82.69,23.26 79.52,21.67 76.37,20.7 73.69,19.89 73.37,19.82 73.13,20.06 Z M 73.13,20.06"), 5),
        c("M 80.31,15 C 80.31,15 82.98,15 85.64,18 88.31,21 88.31,24 88.31,24", Se("M 78.13,14.06 C 77.83,14.35 77.99,14.53 79.27,15.3 81.68,16.76 84.7,20.22 86.95,24.13 87.8,25.59 88.52,26.16 89.31,25.96 90.95,25.56 90.48,20.6 88.57,18.32 87.69,17.26 84.52,15.67 81.37,14.7 78.69,13.89 78.37,13.82 78.13,14.06 Z M 78.13,14.06"), 5),
        c("M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81", $e, 7),
        c("M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78", $e, 7)
    ]), l([
        168,
        14,
        14,
        13,
        113
    ]), 1, "byo", "\u3073\u3087", 0), $d = A7(ef, 100, l([
        c("M 27.15,50.86 C 27.15,50.86 49.58,48.43 71.18,35.43", $e, 10),
        c("M 26.32,20 C 26.32,20 18.85,71.17 26.32,77.67 33.8,84.17 77,77.67 77,77.67", $e, 10),
        c("M 71.47,20.53 C 71.47,20.53 74.14,20.53 76.8,23.53 79.47,26.53 79.47,29.53 79.47,29.53", Se("M 69.29,19.59 C 68.99,19.88 69.15,20.05 70.43,20.82 72.84,22.28 75.86,25.75 78.11,29.66 78.96,31.11 79.68,31.69 80.47,31.49 82.11,31.09 81.64,26.12 79.73,23.85 78.85,22.79 75.68,21.2 72.53,20.23 69.85,19.41 69.53,19.35 69.29,19.59 Z M 69.29,19.59"), 5),
        c("M 76.47,14.53 C 76.47,14.53 79.14,14.53 81.8,17.53 84.47,20.53 84.47,23.53 84.47,23.53", Se("M 74.29,13.59 C 73.99,13.88 74.15,14.05 75.43,14.82 77.84,16.28 80.86,19.75 83.11,23.66 83.96,25.11 84.68,25.69 85.47,25.49 87.11,25.09 86.64,20.12 84.73,17.85 83.85,16.79 80.68,15.2 77.53,14.23 74.85,13.41 74.53,13.35 74.29,13.59 Z M 74.29,13.59"), 5),
        c("M 110.52,45 L 144,45 144,83", $e, 7),
        c("M 111.57,62.7 L 142.95,62.7", $e, 7),
        c("M 110,80.4 L 143.48,80.4", $e, 7)
    ]), l([
        47,
        110,
        14,
        14,
        72,
        32,
        34
    ]), 1, "byo", "\u30D3\u30E7", 0), Dd = A7(ef, 99, l([
        c("M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7", $e, 9.47),
        c("M 75.31,21 C 75.31,21 77.98,21 80.64,24 83.31,27 83.31,30 83.31,30", Se("M 73.13,20.06 C 72.83,20.35 72.99,20.53 74.27,21.3 76.68,22.76 79.7,26.22 81.95,30.13 82.8,31.59 83.52,32.16 84.31,31.96 85.95,31.56 85.48,26.6 83.57,24.32 82.69,23.26 79.52,21.67 76.37,20.7 73.69,19.89 73.37,19.82 73.13,20.06 Z M 73.13,20.06"), 5),
        c("M 80.31,15 C 80.31,15 82.98,15 85.64,18 88.31,21 88.31,24 88.31,24", Se("M 78.13,14.06 C 77.83,14.35 77.99,14.53 79.27,15.3 81.68,16.76 84.7,20.22 86.95,24.13 87.8,25.59 88.52,26.16 89.31,25.96 90.95,25.56 90.48,20.6 88.57,18.32 87.69,17.26 84.52,15.67 81.37,14.7 78.69,13.89 78.37,13.82 78.13,14.06 Z M 78.13,14.06"), 5),
        c("M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07", $e, 7),
        c("M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34", $e, 7)
    ]), l([
        168,
        14,
        14,
        107,
        47
    ]), 1, "byu", "\u3073\u3085", 0), yd = A7(ef, 99, l([
        c("M 27.15,50.86 C 27.15,50.86 49.58,48.43 71.18,35.43", $e, 10),
        c("M 26.32,20 C 26.32,20 18.85,71.17 26.32,77.67 33.8,84.17 77,77.67 77,77.67", $e, 10),
        c("M 71.47,20.53 C 71.47,20.53 74.14,20.53 76.8,23.53 79.47,26.53 79.47,29.53 79.47,29.53", Se("M 69.29,19.59 C 68.99,19.88 69.15,20.05 70.43,20.82 72.84,22.28 75.86,25.75 78.11,29.66 78.96,31.11 79.68,31.69 80.47,31.49 82.11,31.09 81.64,26.12 79.73,23.85 78.85,22.79 75.68,21.2 72.53,20.23 69.85,19.41 69.53,19.35 69.29,19.59 Z M 69.29,19.59"), 5),
        c("M 76.47,14.53 C 76.47,14.53 79.14,14.53 81.8,17.53 84.47,20.53 84.47,23.53 84.47,23.53", Se("M 74.29,13.59 C 73.99,13.88 74.15,14.05 75.43,14.82 77.84,16.28 80.86,19.75 83.11,23.66 83.96,25.11 84.68,25.69 85.47,25.49 87.11,25.09 86.64,20.12 84.73,17.85 83.85,16.79 80.68,15.2 77.53,14.23 74.85,13.41 74.53,13.35 74.29,13.59 Z M 74.29,13.59"), 5),
        c("M 112.73,48.63 L 140.23,48.63 137.64,77.53", $e, 7),
        c("M 107.02,80.13 L 148.02,80.13", $e, 7)
    ]), l([
        47,
        110,
        14,
        14,
        57,
        42
    ]), 1, "byu", "\u30D3\u30E5", 0), zd = A7(ef, 77, l([
        c("M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86", $e, 9.47),
        c("M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48", $e, 9.47),
        c("M 92.78,56.64 C 98.35,59.29 125.25,44.95 128.64,48.53 134.07,54.28 125.51,61.36 123.61,64.75", $e, 7),
        c("M 114.24,42.78 C 114.24,47.06 116.78,55.36 118.59,58.11", $e, 7),
        c("M 97.81,46.03 C 100.39,48.09 113.29,76.39 113.02,82.73", $e, 7)
    ]), l([
        49,
        138,
        56,
        17,
        40
    ]), 1, "cha", "\u3061\u3083", 0), Kd = A7(ef, 77, l([
        c("M 73.61,20 C 52.01,28.33 31.23,28.33 31.23,28.33", $e, 10),
        c("M 25,47.08 L 84,47.08", $e, 10),
        c("M 55.33,27.5 L 55.33,49.17 C 55.33,49.17 54.5,72.5 37.05,80", $e, 10),
        c("M 100,57.44 C 100,57.44 134.04,51.92 135.75,51.52 137.45,51.13 130.21,60.59 124.26,64.92", $e, 7),
        c("M 110.35,43.46 L 118.45,81.46", $e, 7)
    ]), l([
        44,
        60,
        60,
        55,
        39
    ]), 1, "cha", "\u30C1\u30E3", 0), xd = A7(ef, 17, l([
        c("M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86", $e, 9.47),
        c("M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48", $e, 9.47)
    ]), l([
        49,
        138
    ]), 1, "chi", "\u3061", 0), Hd = A7(ef, 17, l([
        c("M 68.61,20 C 47.01,28.33 26.23,28.33 26.23,28.33", $e, 10),
        c("M 20,47.08 L 79,47.08", $e, 10),
        c("M 50.33,27.5 L 50.33,49.17 C 50.33,49.17 49.5,72.5 32.05,80", $e, 10)
    ]), l([
        44,
        60,
        60
    ]), 1, "chi", "\u30C1", 0), kd = A7(ef, 79, l([
        c("M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86", $e, 9.47),
        c("M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48", $e, 9.47),
        c("M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81", $e, 7),
        c("M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78", $e, 7)
    ]), l([
        49,
        138,
        13,
        113
    ]), 1, "cho", "\u3061\u3087", 0), Bd = A7(ef, 79, l([
        c("M 78.61,20 C 57.01,28.33 36.23,28.33 36.23,28.33", $e, 10),
        c("M 30,47.08 L 89,47.08", $e, 10),
        c("M 60.33,27.5 L 60.33,49.17 C 60.33,49.17 59.5,72.5 42.05,80", $e, 10),
        c("M 110.52,45 L 144,45 144,83", $e, 7),
        c("M 111.57,62.7 L 142.95,62.7", $e, 7),
        c("M 110,80.4 L 143.48,80.4", $e, 7)
    ]), l([
        44,
        60,
        60,
        72,
        32,
        34
    ]), 1, "cho", "\u30C1\u30E7", 0), Od = A7(ef, 78, l([
        c("M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86", $e, 9.47),
        c("M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48", $e, 9.47),
        c("M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07", $e, 7),
        c("M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34", $e, 7)
    ]), l([
        49,
        138,
        107,
        47
    ]), 1, "chu", "\u3061\u3085", 0), Gd = A7(ef, 78, l([
        c("M 78.61,20 C 57.01,28.33 36.23,28.33 36.23,28.33", $e, 10),
        c("M 30,47.08 L 89,47.08", $e, 10),
        c("M 60.33,27.5 L 60.33,49.17 C 60.33,49.17 59.5,72.5 42.05,80", $e, 10),
        c("M 112.73,48.63 L 140.23,48.63 137.64,77.53", $e, 7),
        c("M 107.02,80.13 L 148.02,80.13", $e, 7)
    ]), l([
        44,
        60,
        60,
        57,
        42
    ]), 1, "chu", "\u30C1\u30E5", 0), Wd = A7(ef, 57, l([
        c("M 26.53,35.58 C 35.03,40.2 60.03,37.28 65.03,35.82", $e, 9.47),
        c("M 49.28,18.78 C 44.53,26.33 30.53,69.65 23.78,81.09", $e, 9.47),
        c("M 51.78,53.34 C 55.78,55.53 70.68,48.07 76.53,52.37", $e, 9.47),
        c("M 48.78,75.49 C 54.78,79.87 66.03,83.28 77.03,79.63", $e, 9.47),
        c("M 75.31,21 C 75.31,21 77.98,21 80.64,24 83.31,27 83.31,30 83.31,30", Se("M 73.13,20.06 C 72.83,20.35 72.99,20.53 74.27,21.3 76.68,22.76 79.7,26.22 81.95,30.13 82.8,31.59 83.52,32.16 84.31,31.96 85.95,31.56 85.48,26.6 83.57,24.32 82.69,23.26 79.52,21.67 76.37,20.7 73.69,19.89 73.37,19.82 73.13,20.06 Z M 73.13,20.06"), 5),
        c("M 80.31,15 C 80.31,15 82.98,15 85.64,18 88.31,21 88.31,24 88.31,24", Se("M 78.13,14.06 C 77.83,14.35 77.99,14.53 79.27,15.3 81.68,16.76 84.7,20.22 86.95,24.13 87.8,25.59 88.52,26.16 89.31,25.96 90.95,25.56 90.48,20.6 88.57,18.32 87.69,17.26 84.52,15.67 81.37,14.7 78.69,13.89 78.37,13.82 78.13,14.06 Z M 78.13,14.06"), 5)
    ]), l([
        39,
        68,
        26,
        30,
        14,
        14
    ]), 1, "da", "\u3060", 0), qd = A7(ef, 57, l([
        c("M 48.32,25 C 48.32,25 43.47,42.86 28.21,54.29", $e, 10),
        c("M 47.28,33.21 L 75.71,33.21 C 75.71,33.21 73.98,69.29 35.15,85", $e, 10),
        c("M 45.9,51.07 C 55.95,55 67.74,65.71 67.74,65.71", $e, 10),
        c("M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06", Se("M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12"), 5),
        c("M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06", Se("M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12"), 5)
    ]), l([
        37,
        98,
        27,
        14,
        14
    ]), 1, "da", "\u30C0", 0), Ud = A7(ef, 59, l([
        c("M 21.78,22.5 C 29.99,28.78 71.55,20.78 78.64,20.78 51.59,34.58 32.17,54.16 56.94,79.04", $e, 9.47),
        c("M 75.31,39 C 75.31,39 77.98,39 80.64,42 83.31,45 83.31,48 83.31,48", Se("M 73.13,38.06 C 72.83,38.35 72.99,38.53 74.27,39.3 76.68,40.76 79.7,44.22 81.95,48.13 82.8,49.59 83.52,50.16 84.31,49.96 85.95,49.56 85.48,44.6 83.57,42.32 82.69,41.26 79.52,39.67 76.37,38.7 73.69,37.89 73.37,37.82 73.13,38.06 Z M 73.13,38.06"), 5),
        c("M 80.31,33 C 80.31,33 82.98,33 85.64,36 88.31,39 88.31,42 88.31,42", Se("M 78.13,32.06 C 77.83,32.35 77.99,32.53 79.27,33.3 81.68,34.76 84.7,38.22 86.95,42.13 87.8,43.59 88.52,44.16 89.31,43.96 90.95,43.56 90.48,38.6 88.57,36.32 87.69,35.26 84.52,33.67 81.37,32.7 78.69,31.89 78.37,31.82 78.13,32.06 Z M 78.13,32.06"), 5)
    ]), l([
        136,
        14,
        14
    ]), 1, "de", "\u3067", 0), Ad = A7(ef, 59, l([
        c("M 27.5,26 L 71,26", $e, 10),
        c("M 20,47.09 L 80,47.09", $e, 10),
        c("M 51.5,49.73 C 51.5,49.73 51.12,74.96 31.62,84", $e, 10),
        c("M 78.75,16.22 C 78.75,16.22 81.42,16.22 84.08,19.22 86.75,22.22 86.75,25.22 86.75,25.22", Se("M 76.57,15.28 C 76.27,15.57 76.43,15.74 77.71,16.52 80.12,17.97 83.14,21.44 85.39,25.35 86.24,26.8 86.96,27.38 87.75,27.18 89.39,26.78 88.92,21.82 87.01,19.54 86.13,18.48 82.96,16.89 79.81,15.92 77.13,15.1 76.81,15.04 76.57,15.28 Z M 76.57,15.28"), 5),
        c("M 83.75,10.22 C 83.75,10.22 86.42,10.22 89.08,13.22 91.75,16.22 91.75,19.22 91.75,19.22", Se("M 81.57,9.28 C 81.27,9.57 81.43,9.74 82.71,10.52 85.12,11.97 88.14,15.44 90.39,19.35 91.24,20.8 91.96,21.38 92.75,21.18 94.39,20.78 93.92,15.82 92.01,13.54 91.13,12.48 87.96,10.89 84.81,9.92 82.13,9.1 81.81,9.04 81.57,9.28 Z M 81.57,9.28"), 5)
    ]), l([
        44,
        60,
        42,
        14,
        14
    ]), 1, "de", "\u30C7", 0), Ed = A7(ef, 60, l([
        c("M 19.78,22.78 C 21.99,28.66 29.38,44.46 34.32,47.85", $e, 9.47),
        c("M 64.21,31.56 C 44.35,47.91 18.85,54.41 20.33,71.69 21.5,85.41 42.38,83.86 67.52,83.01", $e, 9.47),
        c("M 70.31,21 C 70.31,21 72.98,21 75.64,24 78.31,27 78.31,30 78.31,30", Se("M 68.13,20.06 C 67.83,20.35 67.99,20.53 69.27,21.3 71.68,22.76 74.7,26.22 76.95,30.13 77.8,31.59 78.52,32.16 79.31,31.96 80.95,31.56 80.48,26.6 78.57,24.32 77.69,23.26 74.52,21.67 71.37,20.7 68.69,19.89 68.37,19.82 68.13,20.06 Z M 68.13,20.06"), 5),
        c("M 75.31,15 C 75.31,15 77.98,15 80.64,18 83.31,21 83.31,24 83.31,24", Se("M 73.13,14.06 C 72.83,14.35 72.99,14.53 74.27,15.3 76.68,16.76 79.7,20.22 81.95,24.13 82.8,25.59 83.52,26.16 84.31,25.96 85.95,25.56 85.48,20.6 83.57,18.32 82.69,17.26 79.52,15.67 76.37,14.7 73.69,13.89 73.37,13.82 73.13,14.06 Z M 73.13,14.06"), 5)
    ]), l([
        31,
        116,
        14,
        14
    ]), 1, "do", "\u3069", 0), Td = A7(ef, 60, l([
        c("M 40,20 L 40,80", $e, 10),
        c("M 42.57,44.22 C 42.57,44.22 56.13,46.75 73,53.98", $e, 10),
        c("M 61.48,26.29 C 61.48,26.29 64.15,26.29 66.81,29.29 69.48,32.29 69.48,35.29 69.48,35.29", Se("M 59.3,25.35 C 59,25.64 59.16,25.82 60.44,26.59 62.85,28.05 65.87,31.51 68.12,35.42 68.97,36.88 69.69,37.45 70.48,37.25 72.12,36.86 71.65,31.89 69.74,29.62 68.86,28.56 65.69,26.97 62.54,25.99 59.86,25.18 59.54,25.11 59.3,25.35 Z M 59.3,25.35"), 5),
        c("M 66.48,20.29 C 66.48,20.29 69.15,20.29 71.81,23.29 74.48,26.29 74.48,29.29 74.48,29.29", Se("M 64.3,19.35 C 64,19.64 64.16,19.82 65.44,20.59 67.85,22.05 70.87,25.51 73.12,29.42 73.97,30.88 74.69,31.45 75.48,31.25 77.12,30.86 76.65,25.89 74.74,23.62 73.86,22.56 70.69,20.97 67.54,19.99 64.86,19.18 64.54,19.11 64.3,19.35 Z M 64.3,19.35"), 5)
    ]), l([
        60,
        33,
        14,
        14
    ]), 1, "do", "\u30C9", 0), Id = A7(ef, 53, l([
        c("M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86", $e, 9.47),
        c("M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48", $e, 9.47),
        c("M 78.31,17 C 78.31,17 80.98,17 83.64,20 86.31,23 86.31,26 86.31,26", Se("M 76.13,16.06 C 75.83,16.35 75.99,16.53 77.27,17.3 79.68,18.76 82.7,22.22 84.95,26.13 85.8,27.59 86.52,28.16 87.31,27.96 88.95,27.56 88.48,22.6 86.57,20.32 85.69,19.26 82.52,17.67 79.37,16.7 76.69,15.89 76.37,15.82 76.13,16.06 Z M 76.13,16.06"), 5),
        c("M 83.31,11 C 83.31,11 85.98,11 88.64,14 91.31,17 91.31,20 91.31,20", Se("M 81.13,10.06 C 80.83,10.35 80.99,10.53 82.27,11.3 84.68,12.76 87.7,16.22 89.95,20.13 90.8,21.59 91.52,22.16 92.31,21.96 93.95,21.56 93.48,16.6 91.57,14.32 90.69,13.26 87.52,11.67 84.37,10.7 81.69,9.89 81.37,9.82 81.13,10.06 Z M 81.13,10.06"), 5)
    ]), l([
        49,
        138,
        14,
        14
    ]), 1, "dzi", "\u3062", 0), jd = A7(ef, 4, l([
        c("M 40.22,17.78 C 44.73,22.86 48.48,24.32 53.32,25.52", $e, 9.47),
        c("M 33.11,42.78 C 40.43,40.64 62.82,36.07 62.82,36.07 49.55,54.44 25.58,81.47 25.78,81.25 32.57,73.73 43.59,57.24 49.91,57.24 58.73,57.24 52.21,82.05 57.78,82.03 64.47,82.01 70.86,81.34 74.52,81.76", $e, 9.47)
    ]), l([
        17,
        170
    ]), 1, "e", "\u3048", 0), Rd = A7(ef, 4, l([
        c("M 25.38,26 L 74.62,26", $e, 10),
        c("M 50,29.89 L 50,71.89", $e, 10),
        c("M 20,75 L 80,75", $e, 10)
    ]), l([
        50,
        42,
        60
    ]), 1, "e", "\u30A8", 0), Qd = A7(ef, 28, l([
        c("M 44.09,19.78 C 45.89,23.85 48.42,26.98 50.73,28.5 L 46.37,30.78", $e, 9.47),
        c("M 46.58,45.21 C 58.43,50.96 57.51,79.75 47.2,80.88 41.54,81.51 38.7,74.66 38.7,74.66", $e, 9.47),
        c("M 30.4,49.39 C 29.36,54.79 25.55,64.17 18.78,68.02", $e, 9.47),
        c("M 70.99,45.55 C 76.87,54.76 82.64,67.33 80.49,69.2 77.39,71.9 72.78,65.61 71.47,64.91", $e, 9.47)
    ]), l([
        16,
        53,
        23,
        37
    ]), 1, "hu", "\u3075", 0), Pd = b(Qd, {
        cV: "fu"
    }), Vd = A7(ef, 28, l([
        c("M 23,26 L 77,26 C 77,26 73.58,62.28 33.65,81", $e, 10)
    ]), l([
        127
    ]), 1, "fu", "\u30D5", 0), Fd = A7(ef, 47, l([
        c("M 21.08,36.21 C 36.34,38.7 61.54,25.96 61.6,45.03 61.68,69.85 53.93,75.36 47.41,81.82 47.41,81.82 47.25,77.4 41.52,72.88", $e, 9.47),
        c("M 50.89,20 C 43.09,34.87 28.46,62.28 20,74.41", $e, 9.47),
        c("M 74.24,32.14 C 79.65,34.13 84.55,46.06 85.81,50.4", $e, 9.47),
        c("M 79,20 C 79,20 81.67,20 84.33,23 87,26 87,29 87,29", Se("M 76.82,19.06 C 76.52,19.35 76.68,19.53 77.96,20.3 80.37,21.76 83.39,25.22 85.64,29.13 86.49,30.59 87.21,31.16 88,30.96 89.64,30.56 89.17,25.6 87.26,23.32 86.38,22.26 83.21,20.67 80.06,19.7 77.38,18.89 77.06,18.82 76.82,19.06 Z M 76.82,19.06"), 5),
        c("M 84,14 C 84,14 86.67,14 89.33,17 92,20 92,23 92,23", Se("M 81.82,13.06 C 81.52,13.35 81.68,13.53 82.96,14.3 85.37,15.76 88.39,19.22 90.64,23.13 91.49,24.59 92.21,25.16 93,24.96 94.64,24.56 94.17,19.6 92.26,17.32 91.38,16.26 88.21,14.67 85.06,13.7 82.38,12.89 82.06,12.82 81.82,13.06 Z M 81.82,13.06"), 5)
    ]), l([
        101,
        64,
        24,
        14,
        14
    ]), 1, "ga", "\u304C", 0), Nd = A7(ef, 47, l([
        c("M 19,35.62 L 69.5,35.62 69.5,66.07 C 69.5,66.07 67.54,85.59 51.1,79.35", $e, 10),
        c("M 44.84,20 C 44.84,20 47.19,67.63 21.35,79.35", $e, 10),
        c("M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06", Se("M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12"), 5),
        c("M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06", Se("M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12"), 5)
    ]), l([
        108,
        68,
        14,
        14
    ]), 1, "ga", "\u30AC", 0), Jd = A7(ef, 50, l([
        c("M 31.56,20.79 C 24.41,31.08 19.68,71.19 25.19,82.09 25.38,82.47 31.48,75.91 37.17,68.81", $e, 9.47),
        c("M 42.63,38.47 C 49.91,34.84 70.31,31.22 77.29,34.24", $e, 9.47),
        c("M 61.62,17.78 C 64.56,26.43 71.47,61.29 60.97,82.75", $e, 9.47),
        c("M 77.31,16 C 77.31,16 79.98,16 82.64,19 85.31,22 85.31,25 85.31,25", Se("M 75.13,15.06 C 74.83,15.35 74.99,15.53 76.27,16.3 78.68,17.76 81.7,21.22 83.95,25.13 84.8,26.59 85.52,27.16 86.31,26.96 87.95,26.56 87.48,21.6 85.57,19.32 84.69,18.26 81.52,16.67 78.37,15.7 75.69,14.89 75.37,14.82 75.13,15.06 Z M 75.13,15.06"), 5),
        c("M 82.31,10 C 82.31,10 84.98,10 87.64,13 90.31,16 90.31,19 90.31,19", Se("M 80.13,9.06 C 79.83,9.35 79.99,9.53 81.27,10.3 83.68,11.76 86.7,15.22 88.95,19.13 89.8,20.59 90.52,21.16 91.31,20.96 92.95,20.56 92.48,15.6 90.57,13.32 89.69,12.26 86.52,10.67 83.37,9.7 80.69,8.89 80.37,8.82 80.13,9.06 Z M 80.13,9.06"), 5)
    ]), l([
        81,
        36,
        67,
        14,
        14
    ]), 1, "ge", "\u3052", 0), _d = A7(ef, 50, l([
        c("M 39.2,21 C 39.2,21 35.2,39.37 20,51.35", $e, 10),
        c("M 35.2,35.38 L 80,35.38", $e, 10),
        c("M 58.8,38.97 C 58.8,38.97 57.2,70.12 33.2,80.5", $e, 10),
        c("M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06", Se("M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12"), 5),
        c("M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06", Se("M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12"), 5)
    ]), l([
        37,
        46,
        52,
        14,
        14
    ]), 1, "ge", "\u30B2", 0), Yd = A7(ef, 48, l([
        c("M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97", $e, 9.47),
        c("M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85", $e, 9.47),
        c("M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23", $e, 9.47),
        c("M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12", $e, 9.47),
        c("M 73,16 C 73,16 75.67,16 78.33,19 81,22 81,25 81,25", Se("M 70.82,15.06 C 70.52,15.35 70.68,15.53 71.96,16.3 74.37,17.76 77.39,21.22 79.64,25.13 80.49,26.59 81.21,27.16 82,26.96 83.64,26.56 83.17,21.6 81.26,19.32 80.38,18.26 77.21,16.67 74.06,15.7 71.38,14.89 71.06,14.82 70.82,15.06 Z M 70.82,15.06"), 5),
        c("M 78,10 C 78,10 80.67,10 83.33,13 86,16 86,19 86,19", Se("M 75.82,9.06 C 75.52,9.35 75.68,9.53 76.96,10.3 79.37,11.76 82.39,15.22 84.64,19.13 85.49,20.59 86.21,21.16 87,20.96 88.64,20.56 88.17,15.6 86.26,13.32 85.38,12.26 82.21,10.67 79.06,9.7 76.38,8.89 76.06,8.82 75.82,9.06 Z M 75.82,9.06"), 5)
    ]), l([
        30,
        42,
        55,
        34,
        14,
        14
    ]), 1, "gi", "\u304E", 0), Xd = A7(ef, 48, l([
        c("M 16.64,37.84 L 67.44,31.35", $e, 10),
        c("M 15,59.73 L 74,52.43", $e, 10),
        c("M 39.58,20 L 47.78,80", $e, 10),
        c("M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06", Se("M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12"), 5),
        c("M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06", Se("M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12"), 5)
    ]), l([
        52,
        60,
        61,
        14,
        14
    ]), 1, "gi", "\u30AE", 0), nC = A7(ef, 51, l([
        c("M 32.45,27.06 C 38.11,30.47 56.01,18.26 66.26,24.68 72.94,28.87 64.28,33.19 61.89,36", $e, 9.47),
        c("M 30.78,66.21 C 34.95,77.97 60.4,79.19 68.58,74.56", $e, 9.47),
        c("M 77.31,16 C 77.31,16 79.98,16 82.64,19 85.31,22 85.31,25 85.31,25", Se("M 75.13,15.06 C 74.83,15.35 74.99,15.53 76.27,16.3 78.68,17.76 81.7,21.22 83.95,25.13 84.8,26.59 85.52,27.16 86.31,26.96 87.95,26.56 87.48,21.6 85.57,19.32 84.69,18.26 81.52,16.67 78.37,15.7 75.69,14.89 75.37,14.82 75.13,15.06 Z M 75.13,15.06"), 5),
        c("M 82.31,10 C 82.31,10 84.98,10 87.64,13 90.31,16 90.31,19 90.31,19", Se("M 80.13,9.06 C 79.83,9.35 79.99,9.53 81.27,10.3 83.68,11.76 86.7,15.22 88.95,19.13 89.8,20.59 90.52,21.16 91.31,20.96 92.95,20.56 92.48,15.6 90.57,13.32 89.69,12.26 86.52,10.67 83.37,9.7 80.69,8.89 80.37,8.82 80.13,9.06 Z M 80.13,9.06"), 5)
    ]), l([
        51,
        43,
        14,
        14
    ]), 1, "go", "\u3054", 0), rC = A7(ef, 51, l([
        c("M 21.73,34 L 70,34 70,84", $e, 10),
        c("M 21,80.15 L 70,80.15", $e, 10),
        c("M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06", Se("M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12"), 5),
        c("M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06", Se("M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12"), 5)
    ]), l([
        99,
        49,
        14,
        14
    ]), 1, "go", "\u30B4", 0), eC = A7(ef, 49, l([
        c("M 53.89,18.78 C 46.37,32.23 25.7,51.06 20.78,52.04 26.98,55.14 48.45,73.99 52.18,83.11", $e, 9.47),
        c("M 67.31,16 C 67.31,16 69.98,16 72.64,19 75.31,22 75.31,25 75.31,25", Se("M 65.13,15.06 C 64.83,15.35 64.99,15.53 66.27,16.3 68.68,17.76 71.7,21.22 73.95,25.13 74.8,26.59 75.52,27.16 76.31,26.96 77.95,26.56 77.48,21.6 75.57,19.32 74.69,18.26 71.52,16.67 68.37,15.7 65.69,14.89 65.37,14.82 65.13,15.06 Z M 65.13,15.06"), 5),
        c("M 72.31,10 C 72.31,10 74.98,10 77.64,13 80.31,16 80.31,19 80.31,19", Se("M 70.13,9.06 C 69.83,9.35 69.99,9.53 71.27,10.3 73.68,11.76 76.7,15.22 78.95,19.13 79.8,20.59 80.52,21.16 81.31,20.96 82.95,20.56 82.48,15.6 80.57,13.32 79.69,12.26 76.52,10.67 73.37,9.7 70.69,8.89 70.37,8.82 70.13,9.06 Z M 70.13,9.06"), 5)
    ]), l([
        93,
        14,
        14
    ]), 1, "gu", "\u3050", 0), tC = A7(ef, 49, l([
        c("M 42.06,20 C 42.06,20 35.44,36.83 20,50", $e, 10),
        c("M 39.85,29.51 L 70,29.51 C 70,29.51 68.53,63.17 31.03,80", $e, 10),
        c("M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06", Se("M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12"), 5),
        c("M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06", Se("M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12"), 5)
    ]), l([
        38,
        97,
        14,
        14
    ]), 1, "gu", "\u30B0", 0), aC = A7(ef, 92, l([
        c("M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97", $e, 9.47),
        c("M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85", $e, 9.47),
        c("M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23", $e, 9.47),
        c("M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12", $e, 9.47),
        c("M 73,16 C 73,16 75.67,16 78.33,19 81,22 81,25 81,25", Se("M 70.82,15.06 C 70.52,15.35 70.68,15.53 71.96,16.3 74.37,17.76 77.39,21.22 79.64,25.13 80.49,26.59 81.21,27.16 82,26.96 83.64,26.56 83.17,21.6 81.26,19.32 80.38,18.26 77.21,16.67 74.06,15.7 71.38,14.89 71.06,14.82 70.82,15.06 Z M 70.82,15.06"), 5),
        c("M 78,10 C 78,10 80.67,10 83.33,13 86,16 86,19 86,19", Se("M 75.82,9.06 C 75.52,9.35 75.68,9.53 76.96,10.3 79.37,11.76 82.39,15.22 84.64,19.13 85.49,20.59 86.21,21.16 87,20.96 88.64,20.56 88.17,15.6 86.26,13.32 85.38,12.26 82.21,10.67 79.06,9.7 76.38,8.89 76.06,8.82 75.82,9.06 Z M 75.82,9.06"), 5),
        c("M 95,56.64 C 100.57,59.29 127.47,44.95 130.85,48.53 136.28,54.28 127.73,61.36 125.83,64.75", $e, 7),
        c("M 116.46,42.78 C 116.46,47.06 118.99,55.36 120.8,58.11", $e, 7),
        c("M 100.02,46.03 C 102.61,48.09 115.51,76.39 115.23,82.73", $e, 7)
    ]), l([
        30,
        42,
        55,
        34,
        14,
        14,
        56,
        17,
        40
    ]), 1, "gya", "\u304E\u3083", 0), uC = A7(ef, 92, l([
        c("M 28.64,37.84 L 79.44,31.35", $e, 10),
        c("M 27,59.73 L 86,52.43", $e, 10),
        c("M 51.58,20 L 59.78,80", $e, 10),
        c("M 84.33,15.22 C 84.33,15.22 87,15.22 89.66,18.22 92.33,21.22 92.33,24.22 92.33,24.22", Se("M 82.14,14.28 C 81.85,14.57 82.01,14.75 83.29,15.52 85.7,16.98 88.72,20.44 90.97,24.35 91.82,25.81 92.54,26.38 93.33,26.18 94.97,25.78 94.5,20.82 92.59,18.54 91.71,17.48 88.54,15.89 85.39,14.92 82.71,14.11 82.39,14.04 82.14,14.28 Z M 82.14,14.28"), 5),
        c("M 89.33,9.22 C 89.33,9.22 92,9.22 94.66,12.22 97.33,15.22 97.33,18.22 97.33,18.22", Se("M 87.14,8.28 C 86.85,8.57 87.01,8.75 88.29,9.52 90.7,10.98 93.72,14.44 95.97,18.35 96.82,19.81 97.54,20.38 98.33,20.18 99.97,19.78 99.5,14.82 97.59,12.54 96.71,11.48 93.54,9.89 90.39,8.92 87.71,8.11 87.39,8.04 87.14,8.28 Z M 87.14,8.28"), 5),
        c("M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92", $e, 7),
        c("M 115.35,43.46 L 123.45,81.46", $e, 7)
    ]), l([
        52,
        60,
        61,
        14,
        14,
        55,
        39
    ]), 1, "gya", "\u30AE\u30E3", 0), iC = A7(ef, 94, l([
        c("M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97", $e, 9.47),
        c("M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85", $e, 9.47),
        c("M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23", $e, 9.47),
        c("M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12", $e, 9.47),
        c("M 73,16 C 73,16 75.67,16 78.33,19 81,22 81,25 81,25", Se("M 70.82,15.06 C 70.52,15.35 70.68,15.53 71.96,16.3 74.37,17.76 77.39,21.22 79.64,25.13 80.49,26.59 81.21,27.16 82,26.96 83.64,26.56 83.17,21.6 81.26,19.32 80.38,18.26 77.21,16.67 74.06,15.7 71.38,14.89 71.06,14.82 70.82,15.06 Z M 70.82,15.06"), 5),
        c("M 78,10 C 78,10 80.67,10 83.33,13 86,16 86,19 86,19", Se("M 75.82,9.06 C 75.52,9.35 75.68,9.53 76.96,10.3 79.37,11.76 82.39,15.22 84.64,19.13 85.49,20.59 86.21,21.16 87,20.96 88.64,20.56 88.17,15.6 86.26,13.32 85.38,12.26 82.21,10.67 79.06,9.7 76.38,8.89 76.06,8.82 75.82,9.06 Z M 75.82,9.06"), 5),
        c("M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81", $e, 7),
        c("M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78", $e, 7)
    ]), l([
        30,
        42,
        55,
        34,
        14,
        14,
        13,
        113
    ]), 1, "gyo", "\u304E\u3087", 0), oC = A7(ef, 94, l([
        c("M 28.64,37.84 L 79.44,31.35", $e, 10),
        c("M 27,59.73 L 86,52.43", $e, 10),
        c("M 51.58,20 L 59.78,80", $e, 10),
        c("M 82.87,14.74 C 82.87,14.74 85.53,14.74 88.2,17.74 90.87,20.74 90.87,23.74 90.87,23.74", Se("M 80.68,13.81 C 80.39,14.09 80.55,14.27 81.83,15.04 84.24,16.5 87.25,19.97 89.5,23.87 90.36,25.33 91.08,25.9 91.87,25.71 93.51,25.31 93.04,20.34 91.12,18.07 90.25,17.01 87.07,15.42 83.92,14.45 81.25,13.63 80.93,13.56 80.68,13.81 Z M 80.68,13.81"), 5),
        c("M 87.87,8.74 C 87.87,8.74 90.53,8.74 93.2,11.74 95.87,14.74 95.87,17.74 95.87,17.74", Se("M 85.68,7.81 C 85.39,8.09 85.55,8.27 86.83,9.04 89.24,10.5 92.25,13.97 94.5,17.87 95.36,19.33 96.08,19.9 96.87,19.71 98.51,19.31 98.04,14.34 96.12,12.07 95.25,11.01 92.07,9.42 88.92,8.45 86.25,7.63 85.93,7.56 85.68,7.81 Z M 85.68,7.81"), 5),
        c("M 110.52,45 L 144,45 144,83", $e, 7),
        c("M 111.57,62.7 L 142.95,62.7", $e, 7),
        c("M 110,80.4 L 143.48,80.4", $e, 7)
    ]), l([
        52,
        60,
        61,
        14,
        14,
        72,
        32,
        34
    ]), 1, "gyo", "\u30AE\u30E7", 0), cC = A7(ef, 93, l([
        c("M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97", $e, 9.47),
        c("M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85", $e, 9.47),
        c("M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23", $e, 9.47),
        c("M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12", $e, 9.47),
        c("M 73,16 C 73,16 75.67,16 78.33,19 81,22 81,25 81,25", Se("M 70.82,15.06 C 70.52,15.35 70.68,15.53 71.96,16.3 74.37,17.76 77.39,21.22 79.64,25.13 80.49,26.59 81.21,27.16 82,26.96 83.64,26.56 83.17,21.6 81.26,19.32 80.38,18.26 77.21,16.67 74.06,15.7 71.38,14.89 71.06,14.82 70.82,15.06 Z M 70.82,15.06"), 5),
        c("M 78,10 C 78,10 80.67,10 83.33,13 86,16 86,19 86,19", Se("M 75.82,9.06 C 75.52,9.35 75.68,9.53 76.96,10.3 79.37,11.76 82.39,15.22 84.64,19.13 85.49,20.59 86.21,21.16 87,20.96 88.64,20.56 88.17,15.6 86.26,13.32 85.38,12.26 82.21,10.67 79.06,9.7 76.38,8.89 76.06,8.82 75.82,9.06 Z M 75.82,9.06"), 5),
        c("M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07", $e, 7),
        c("M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34", $e, 7)
    ]), l([
        30,
        42,
        55,
        34,
        14,
        14,
        107,
        47
    ]), 1, "gyu", "\u304E\u3085", 0), fC = A7(ef, 93, l([
        c("M 28.64,37.84 L 79.44,31.35", $e, 10),
        c("M 27,59.73 L 86,52.43", $e, 10),
        c("M 51.58,20 L 59.78,80", $e, 10),
        c("M 82.87,14.74 C 82.87,14.74 85.53,14.74 88.2,17.74 90.87,20.74 90.87,23.74 90.87,23.74", Se("M 80.68,13.81 C 80.39,14.09 80.55,14.27 81.83,15.04 84.24,16.5 87.25,19.97 89.5,23.87 90.36,25.33 91.08,25.9 91.87,25.71 93.51,25.31 93.04,20.34 91.12,18.07 90.25,17.01 87.07,15.42 83.92,14.45 81.25,13.63 80.93,13.56 80.68,13.81 Z M 80.68,13.81"), 5),
        c("M 87.87,8.74 C 87.87,8.74 90.53,8.74 93.2,11.74 95.87,14.74 95.87,17.74 95.87,17.74", Se("M 85.68,7.81 C 85.39,8.09 85.55,8.27 86.83,9.04 89.24,10.5 92.25,13.97 94.5,17.87 95.36,19.33 96.08,19.9 96.87,19.71 98.51,19.31 98.04,14.34 96.12,12.07 95.25,11.01 92.07,9.42 88.92,8.45 86.25,7.63 85.93,7.56 85.68,7.81 Z M 85.68,7.81"), 5),
        c("M 112.73,48.63 L 140.23,48.63 137.64,77.53", $e, 7),
        c("M 107.02,80.13 L 148.02,80.13", $e, 7)
    ]), l([
        52,
        60,
        61,
        14,
        14,
        57,
        42
    ]), 1, "gyu", "\u30AE\u30E5", 0), bC = A7(ef, 26, l([
        c("M 25.13,19.16 C 30.12,27.04 13.34,76.92 22.65,81.48 27.8,83.99 30.7,71.05 34.07,68.53", $e, 9.47),
        c("M 49.85,32.2 C 57.99,34.06 76.35,29.17 80.77,29.41", $e, 9.47),
        c("M 68.91,17.78 C 69.53,33.64 79.69,80.82 60.54,79.39 51.24,78.69 44.94,75.76 45.9,68.69 47.71,55.34 69.34,63.55 80.15,73.08", $e, 9.47)
    ]), l([
        83,
        32,
        130
    ]), 1, "ha", "\u306F", 0), sC = A7(ef, 26, l([
        c("M 36.71,28.52 C 36.71,28.52 34.43,55.81 20,74", $e, 10),
        c("M 59.49,27 C 59.49,27 74.68,46.71 80,74", $e, 10)
    ]), l([
        50,
        53
    ]), 1, "ha", "\u30CF", 0), MC = A7(ef, 29, l([
        c("M 17.78,60.06 C 25.32,54.85 30.91,43.44 34.64,38.78 41.18,44.42 62.75,56.65 80.86,63.16", $e, 9.47)
    ]), l([
        81
    ]), 1, "he", "\u3078", 0), dC = A7(ef, 29, l([
        c("M 17,55.49 C 17,55.49 35.46,31 40.27,31 45.09,31 82,71 82,71", $e, 10)
    ]), l([
        92
    ]), 1, "he", "\u30D8", 0), CC = A7(ef, 27, l([
        c("M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7", $e, 9.47)
    ]), l([
        168
    ]), 1, "hi", "\u3072", 0), lC = A7(ef, 27, l([
        c("M 27.15,50.86 C 27.15,50.86 49.58,48.43 71.18,35.43", $e, 10),
        c("M 26.32,20 C 26.32,20 18.85,71.17 26.32,77.67 33.8,84.17 77,77.67 77,77.67", $e, 10)
    ]), l([
        47,
        110
    ]), 1, "hi", "\u30D2", 0), vC = A7(ef, 30, l([
        c("M 25.68,22.78 C 20.01,30.26 17.15,75.9 23.03,76.29 26.7,76.54 31.19,62.25 31.19,62.25", $e, 9.47),
        c("M 51.48,24.62 C 58.47,23.12 74.83,24.46 78.82,25.6", $e, 9.47),
        c("M 50.95,43.19 C 58,47.38 75.17,44.27 79.31,42.5", $e, 9.47),
        c("M 64.91,25.6 C 67.68,51.03 76.11,83.55 51.19,77.27 41.34,74.79 45.01,58.22 54.13,59.64 67.86,61.78 74.9,64.49 79.8,72.09", $e, 9.47)
    ]), l([
        72,
        28,
        29,
        120
    ]), 1, "ho", "\u307B", 0), gC = A7(ef, 30, l([
        c("M 24.09,35.78 L 76.64,35.78", $e, 10),
        c("M 50,21 L 50,76.32 C 50,76.32 49.64,78.79 46.35,80.11 43.07,81.44 38.32,78.6 38.32,78.6", $e, 10),
        c("M 33.95,52.07 C 33.95,52.07 32.49,61.17 23,72.53", $e, 10),
        c("M 65.32,52.07 C 65.32,52.07 68.97,63.44 77,72.53", $e, 10)
    ]), l([
        53,
        70,
        24,
        24
    ]), 1, "ho", "\u30DB", 0), hC = A7(ef, 83, l([
        c("M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7", $e, 9.47),
        c("M 102,56.64 C 107.57,59.29 134.47,44.95 137.85,48.53 143.28,54.28 134.73,61.36 132.83,64.75", $e, 7),
        c("M 123.46,42.78 C 123.46,47.06 125.99,55.36 127.8,58.11", $e, 7),
        c("M 107.02,46.03 C 109.61,48.09 122.51,76.39 122.23,82.73", $e, 7)
    ]), l([
        168,
        56,
        17,
        40
    ]), 1, "hya", "\u3072\u3083", 0), pC = A7(ef, 83, l([
        c("M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43", $e, 10),
        c("M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67", $e, 10),
        c("M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92", $e, 7),
        c("M 115.35,43.46 L 123.45,81.46", $e, 7)
    ]), l([
        47,
        110,
        55,
        39
    ]), 1, "hya", "\u30D2\u30E3", 0), LC = A7(ef, 85, l([
        c("M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7", $e, 9.47),
        c("M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81", $e, 7),
        c("M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78", $e, 7)
    ]), l([
        168,
        13,
        113
    ]), 1, "hyo", "\u3072\u3087", 0), wC = A7(ef, 85, l([
        c("M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43", $e, 10),
        c("M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67", $e, 10),
        c("M 110.52,45 L 144,45 144,83", $e, 7),
        c("M 111.57,62.7 L 142.95,62.7", $e, 7),
        c("M 110,80.4 L 143.48,80.4", $e, 7)
    ]), l([
        47,
        110,
        72,
        32,
        34
    ]), 1, "hyo", "\u30D2\u30E7", 0), ZC = A7(ef, 84, l([
        c("M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7", $e, 9.47),
        c("M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07", $e, 7),
        c("M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34", $e, 7)
    ]), l([
        168,
        107,
        47
    ]), 1, "hyu", "\u3072\u3085", 0), mC = A7(ef, 84, l([
        c("M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43", $e, 10),
        c("M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67", $e, 10),
        c("M 112.73,48.63 L 140.23,48.63 137.64,77.53", $e, 7),
        c("M 107.02,80.13 L 148.02,80.13", $e, 7)
    ]), l([
        47,
        110,
        57,
        42
    ]), 1, "hyu", "\u30D2\u30E5", 0), SC = A7(ef, 2, l([
        c("M 32.13,24.78 C 21.03,34.79 21.33,73.07 31.1,73.39 36.59,73.58 39.13,67.18 43.22,58.03", $e, 9.47),
        c("M 67.33,26.05 C 78.28,32.31 80.83,68.61 65.99,74.26", $e, 9.47)
    ]), l([
        75,
        56
    ]), 1, "i", "\u3044", 0), $C = A7(ef, 2, l([
        c("M 75,20 C 75,20 54.75,40.25 24,55.25", $e, 10),
        c("M 54,41.75 L 54,80", $e, 10)
    ]), l([
        63,
        39
    ]), 1, "i", "\u30A4", 0), DC = A7(ef, 95, l([
        c("M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42", $e, 9.47),
        c("M 57.31,17 C 57.31,17 59.98,17 62.64,20 65.31,23 65.31,26 65.31,26", Se("M 55.13,16.06 C 54.83,16.35 54.99,16.53 56.27,17.3 58.68,18.76 61.7,22.22 63.95,26.13 64.8,27.59 65.52,28.16 66.31,27.96 67.95,27.56 67.48,22.6 65.57,20.32 64.69,19.26 61.52,17.67 58.37,16.7 55.69,15.89 55.37,15.82 55.13,16.06 Z M 55.13,16.06"), 5),
        c("M 62.31,11 C 62.31,11 64.98,11 67.64,14 70.31,17 70.31,20 70.31,20", Se("M 60.13,10.06 C 59.83,10.35 59.99,10.53 61.27,11.3 63.68,12.76 66.7,16.22 68.95,20.13 69.8,21.59 70.52,22.16 71.31,21.96 72.95,21.56 72.48,16.6 70.57,14.32 69.69,13.26 66.52,11.67 63.37,10.7 60.69,9.89 60.37,9.82 60.13,10.06 Z M 60.13,10.06"), 5),
        c("M 95,56.64 C 100.57,59.29 127.47,44.95 130.85,48.53 136.28,54.28 127.73,61.36 125.83,64.75", $e, 7),
        c("M 116.46,42.78 C 116.46,47.06 118.99,55.36 120.8,58.11", $e, 7),
        c("M 100.02,46.03 C 102.61,48.09 115.51,76.39 115.23,82.73", $e, 7)
    ]), l([
        111,
        14,
        14,
        56,
        17,
        40
    ]), 1, "ja", "\u3058\u3083", 0), yC = A7(ef, 95, l([
        c("M 39.87,20 C 39.87,20 50.09,22.34 57.96,27.79", $e, 10),
        c("M 32,38.7 C 32,38.7 42.23,41.04 50.09,46.49", $e, 10),
        c("M 38.29,80 C 38.29,80 72.91,72.21 91,37.14", $e, 10),
        c("M 84.33,15.22 C 84.33,15.22 87,15.22 89.66,18.22 92.33,21.22 92.33,24.22 92.33,24.22", Se("M 82.14,14.28 C 81.85,14.57 82.01,14.75 83.29,15.52 85.7,16.98 88.72,20.44 90.97,24.35 91.82,25.81 92.54,26.38 93.33,26.18 94.97,25.78 94.5,20.82 92.59,18.54 91.71,17.48 88.54,15.89 85.39,14.92 82.71,14.11 82.39,14.04 82.14,14.28 Z M 82.14,14.28"), 5),
        c("M 89.33,9.22 C 89.33,9.22 92,9.22 94.66,12.22 97.33,15.22 97.33,18.22 97.33,18.22", Se("M 87.14,8.28 C 86.85,8.57 87.01,8.75 88.29,9.52 90.7,10.98 93.72,14.44 95.97,18.35 96.82,19.81 97.54,20.38 98.33,20.18 99.97,19.78 99.5,14.82 97.59,12.54 96.71,11.48 93.54,9.89 90.39,8.92 87.71,8.11 87.39,8.04 87.14,8.28 Z M 87.14,8.28"), 5),
        c("M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92", $e, 7),
        c("M 115.35,43.46 L 123.45,81.46", $e, 7)
    ]), l([
        20,
        20,
        70,
        14,
        14,
        55,
        39
    ]), 1, "ja", "\u30B8\u30E3", 0), zC = A7(ef, 95, l([
        c("M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86", $e, 9.47),
        c("M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48", $e, 9.47),
        c("M 78.31,17 C 78.31,17 80.98,17 83.64,20 86.31,23 86.31,26 86.31,26", Se("M 76.13,16.06 C 75.83,16.35 75.99,16.53 77.27,17.3 79.68,18.76 82.7,22.22 84.95,26.13 85.8,27.59 86.52,28.16 87.31,27.96 88.95,27.56 88.48,22.6 86.57,20.32 85.69,19.26 82.52,17.67 79.37,16.7 76.69,15.89 76.37,15.82 76.13,16.06 Z M 76.13,16.06"), 5),
        c("M 83.31,11 C 83.31,11 85.98,11 88.64,14 91.31,17 91.31,20 91.31,20", Se("M 81.13,10.06 C 80.83,10.35 80.99,10.53 82.27,11.3 84.68,12.76 87.7,16.22 89.95,20.13 90.8,21.59 91.52,22.16 92.31,21.96 93.95,21.56 93.48,16.6 91.57,14.32 90.69,13.26 87.52,11.67 84.37,10.7 81.69,9.89 81.37,9.82 81.13,10.06 Z M 81.13,10.06"), 5),
        c("M 95,56.64 C 100.57,59.29 127.47,44.95 130.85,48.53 136.28,54.28 127.73,61.36 125.83,64.75", $e, 7),
        c("M 116.46,42.78 C 116.46,47.06 118.99,55.36 120.8,58.11", $e, 7),
        c("M 100.02,46.03 C 102.61,48.09 115.51,76.39 115.23,82.73", $e, 7)
    ]), l([
        49,
        138,
        14,
        14,
        56,
        17,
        40
    ]), 1, "ja2", "\u3062\u3083", 0), KC = A7(ef, 95, l([
        c("M 75.61,20 C 54.01,28.33 33.23,28.33 33.23,28.33", $e, 10),
        c("M 27,47.08 L 86,47.08", $e, 10),
        c("M 57.33,27.5 L 57.33,49.17 C 57.33,49.17 56.5,72.5 39.05,80", $e, 10),
        c("M 81.46,28.52 C 81.46,28.52 84.12,28.52 86.79,31.52 89.46,34.52 89.46,37.52 89.46,37.52", Se("M 79.27,27.59 C 78.98,27.87 79.14,28.05 80.42,28.82 82.83,30.28 85.84,33.75 88.09,37.65 88.95,39.11 89.67,39.69 90.46,39.49 92.1,39.09 91.63,34.12 89.71,31.85 88.84,30.79 85.66,29.2 82.51,28.23 79.84,27.41 79.52,27.34 79.27,27.59 Z M 79.27,27.59"), 5),
        c("M 86.46,22.52 C 86.46,22.52 89.12,22.52 91.79,25.52 94.46,28.52 94.46,31.52 94.46,31.52", Se("M 84.27,21.59 C 83.98,21.87 84.14,22.05 85.42,22.82 87.83,24.28 90.84,27.75 93.09,31.65 93.95,33.11 94.67,33.69 95.46,33.49 97.1,33.09 96.63,28.12 94.71,25.85 93.84,24.79 90.66,23.2 87.51,22.23 84.84,21.41 84.52,21.34 84.27,21.59 Z M 84.27,21.59"), 5),
        c("M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92", $e, 7),
        c("M 115.35,43.46 L 123.45,81.46", $e, 7)
    ]), l([
        44,
        60,
        60,
        14,
        14,
        55,
        39
    ]), 1, "ja", "\u30C2\u30E3", 0), xC = A7(ef, 53, l([
        c("M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42", $e, 9.47),
        c("M 57.31,17 C 57.31,17 59.98,17 62.64,20 65.31,23 65.31,26 65.31,26", Se("M 55.13,16.06 C 54.83,16.35 54.99,16.53 56.27,17.3 58.68,18.76 61.7,22.22 63.95,26.13 64.8,27.59 65.52,28.16 66.31,27.96 67.95,27.56 67.48,22.6 65.57,20.32 64.69,19.26 61.52,17.67 58.37,16.7 55.69,15.89 55.37,15.82 55.13,16.06 Z M 55.13,16.06"), 5),
        c("M 62.31,11 C 62.31,11 64.98,11 67.64,14 70.31,17 70.31,20 70.31,20", Se("M 60.13,10.06 C 59.83,10.35 59.99,10.53 61.27,11.3 63.68,12.76 66.7,16.22 68.95,20.13 69.8,21.59 70.52,22.16 71.31,21.96 72.95,21.56 72.48,16.6 70.57,14.32 69.69,13.26 66.52,11.67 63.37,10.7 60.69,9.89 60.37,9.82 60.13,10.06 Z M 60.13,10.06"), 5)
    ]), l([
        111,
        14,
        14
    ]), 1, "ji", "\u3058", 0), HC = A7(ef, 53, l([
        c("M 32.87,20 C 32.87,20 43.09,22.34 50.96,27.79", $e, 10),
        c("M 25,38.7 C 25,38.7 35.23,41.04 43.09,46.49", $e, 10),
        c("M 31.29,80 C 31.29,80 65.91,72.21 84,37.14", $e, 10),
        c("M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06", Se("M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12"), 5),
        c("M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06", Se("M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12"), 5)
    ]), l([
        20,
        20,
        70,
        14,
        14
    ]), 1, "ji", "\u30B8", 0), kC = A7(ef, 97, l([
        c("M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42", $e, 9.47),
        c("M 57.31,17 C 57.31,17 59.98,17 62.64,20 65.31,23 65.31,26 65.31,26", Se("M 55.13,16.06 C 54.83,16.35 54.99,16.53 56.27,17.3 58.68,18.76 61.7,22.22 63.95,26.13 64.8,27.59 65.52,28.16 66.31,27.96 67.95,27.56 67.48,22.6 65.57,20.32 64.69,19.26 61.52,17.67 58.37,16.7 55.69,15.89 55.37,15.82 55.13,16.06 Z M 55.13,16.06"), 5),
        c("M 62.31,11 C 62.31,11 64.98,11 67.64,14 70.31,17 70.31,20 70.31,20", Se("M 60.13,10.06 C 59.83,10.35 59.99,10.53 61.27,11.3 63.68,12.76 66.7,16.22 68.95,20.13 69.8,21.59 70.52,22.16 71.31,21.96 72.95,21.56 72.48,16.6 70.57,14.32 69.69,13.26 66.52,11.67 63.37,10.7 60.69,9.89 60.37,9.82 60.13,10.06 Z M 60.13,10.06"), 5),
        c("M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81", $e, 7),
        c("M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78", $e, 7)
    ]), l([
        111,
        14,
        14,
        13,
        113
    ]), 1, "jo", "\u3058\u3087", 0), BC = A7(ef, 97, l([
        c("M 39.87,20 C 39.87,20 50.09,22.34 57.96,27.79", $e, 10),
        c("M 32,38.7 C 32,38.7 42.23,41.04 50.09,46.49", $e, 10),
        c("M 38.29,80 C 38.29,80 72.91,72.21 91,37.14", $e, 10),
        c("M 82.87,14.74 C 82.87,14.74 85.53,14.74 88.2,17.74 90.87,20.74 90.87,23.74 90.87,23.74", Se("M 80.68,13.81 C 80.39,14.09 80.55,14.27 81.83,15.04 84.24,16.5 87.25,19.97 89.5,23.87 90.36,25.33 91.08,25.9 91.87,25.71 93.51,25.31 93.04,20.34 91.12,18.07 90.25,17.01 87.07,15.42 83.92,14.45 81.25,13.63 80.93,13.56 80.68,13.81 Z M 80.68,13.81"), 5),
        c("M 87.87,8.74 C 87.87,8.74 90.53,8.74 93.2,11.74 95.87,14.74 95.87,17.74 95.87,17.74", Se("M 85.68,7.81 C 85.39,8.09 85.55,8.27 86.83,9.04 89.24,10.5 92.25,13.97 94.5,17.87 95.36,19.33 96.08,19.9 96.87,19.71 98.51,19.31 98.04,14.34 96.12,12.07 95.25,11.01 92.07,9.42 88.92,8.45 86.25,7.63 85.93,7.56 85.68,7.81 Z M 85.68,7.81"), 5),
        c("M 110.52,45 L 144,45 144,83", $e, 7),
        c("M 111.57,62.7 L 142.95,62.7", $e, 7),
        c("M 110,80.4 L 143.48,80.4", $e, 7)
    ]), l([
        20,
        20,
        70,
        14,
        14,
        72,
        32,
        34
    ]), 1, "jo", "\u30B8\u30E7", 0), OC = A7(ef, 97, l([
        c("M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86", $e, 9.47),
        c("M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48", $e, 9.47),
        c("M 78.31,17 C 78.31,17 80.98,17 83.64,20 86.31,23 86.31,26 86.31,26", Se("M 76.13,16.06 C 75.83,16.35 75.99,16.53 77.27,17.3 79.68,18.76 82.7,22.22 84.95,26.13 85.8,27.59 86.52,28.16 87.31,27.96 88.95,27.56 88.48,22.6 86.57,20.32 85.69,19.26 82.52,17.67 79.37,16.7 76.69,15.89 76.37,15.82 76.13,16.06 Z M 76.13,16.06"), 5),
        c("M 83.31,11 C 83.31,11 85.98,11 88.64,14 91.31,17 91.31,20 91.31,20", Se("M 81.13,10.06 C 80.83,10.35 80.99,10.53 82.27,11.3 84.68,12.76 87.7,16.22 89.95,20.13 90.8,21.59 91.52,22.16 92.31,21.96 93.95,21.56 93.48,16.6 91.57,14.32 90.69,13.26 87.52,11.67 84.37,10.7 81.69,9.89 81.37,9.82 81.13,10.06 Z M 81.13,10.06"), 5),
        c("M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81", $e, 7),
        c("M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78", $e, 7)
    ]), l([
        49,
        138,
        14,
        14,
        13,
        113
    ]), 1, "jo2", "\u3062\u3087", 0), GC = A7(ef, 97, l([
        c("M 75.61,20 C 54.01,28.33 33.23,28.33 33.23,28.33", $e, 10),
        c("M 27,47.08 L 86,47.08", $e, 10),
        c("M 57.33,27.5 L 57.33,49.17 C 57.33,49.17 56.5,72.5 39.05,80", $e, 10),
        c("M 82.83,28.71 C 82.83,28.71 85.5,28.71 88.17,31.71 90.83,34.71 90.83,37.71 90.83,37.71", Se("M 80.65,27.77 C 80.36,28.06 80.51,28.23 81.8,29.01 84.2,30.46 87.22,33.93 89.47,37.84 90.32,39.3 91.04,39.87 91.83,39.67 93.47,39.27 93,34.31 91.09,32.03 90.21,30.97 87.04,29.38 83.89,28.41 81.21,27.59 80.9,27.53 80.65,27.77 Z M 80.65,27.77"), 5),
        c("M 87.83,22.71 C 87.83,22.71 90.5,22.71 93.17,25.71 95.83,28.71 95.83,31.71 95.83,31.71", Se("M 85.65,21.77 C 85.36,22.06 85.51,22.23 86.8,23.01 89.2,24.46 92.22,27.93 94.47,31.84 95.32,33.3 96.04,33.87 96.83,33.67 98.47,33.27 98,28.31 96.09,26.03 95.21,24.97 92.04,23.38 88.89,22.41 86.21,21.59 85.9,21.53 85.65,21.77 Z M 85.65,21.77"), 5),
        c("M 110.52,45 L 144,45 144,83", $e, 7),
        c("M 111.57,62.7 L 142.95,62.7", $e, 7),
        c("M 110,80.4 L 143.48,80.4", $e, 7)
    ]), l([
        44,
        60,
        60,
        14,
        14,
        72,
        32,
        34
    ]), 1, "jo", "\u30C2\u30E7", 0), WC = A7(ef, 96, l([
        c("M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42", $e, 9.47),
        c("M 57.31,17 C 57.31,17 59.98,17 62.64,20 65.31,23 65.31,26 65.31,26", Se("M 55.13,16.06 C 54.83,16.35 54.99,16.53 56.27,17.3 58.68,18.76 61.7,22.22 63.95,26.13 64.8,27.59 65.52,28.16 66.31,27.96 67.95,27.56 67.48,22.6 65.57,20.32 64.69,19.26 61.52,17.67 58.37,16.7 55.69,15.89 55.37,15.82 55.13,16.06 Z M 55.13,16.06"), 5),
        c("M 62.31,11 C 62.31,11 64.98,11 67.64,14 70.31,17 70.31,20 70.31,20", Se("M 60.13,10.06 C 59.83,10.35 59.99,10.53 61.27,11.3 63.68,12.76 66.7,16.22 68.95,20.13 69.8,21.59 70.52,22.16 71.31,21.96 72.95,21.56 72.48,16.6 70.57,14.32 69.69,13.26 66.52,11.67 63.37,10.7 60.69,9.89 60.37,9.82 60.13,10.06 Z M 60.13,10.06"), 5),
        c("M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07", $e, 7),
        c("M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34", $e, 7)
    ]), l([
        111,
        14,
        14,
        107,
        47
    ]), 1, "ju", "\u3058\u3085", 0), qC = A7(ef, 96, l([
        c("M 39.87,20 C 39.87,20 50.09,22.34 57.96,27.79", $e, 10),
        c("M 32,38.7 C 32,38.7 42.23,41.04 50.09,46.49", $e, 10),
        c("M 38.29,80 C 38.29,80 72.91,72.21 91,37.14", $e, 10),
        c("M 82.87,14.74 C 82.87,14.74 85.53,14.74 88.2,17.74 90.87,20.74 90.87,23.74 90.87,23.74", Se("M 80.68,13.81 C 80.39,14.09 80.55,14.27 81.83,15.04 84.24,16.5 87.25,19.97 89.5,23.87 90.36,25.33 91.08,25.9 91.87,25.71 93.51,25.31 93.04,20.34 91.12,18.07 90.25,17.01 87.07,15.42 83.92,14.45 81.25,13.63 80.93,13.56 80.68,13.81 Z M 80.68,13.81"), 5),
        c("M 87.87,8.74 C 87.87,8.74 90.53,8.74 93.2,11.74 95.87,14.74 95.87,17.74 95.87,17.74", Se("M 85.68,7.81 C 85.39,8.09 85.55,8.27 86.83,9.04 89.24,10.5 92.25,13.97 94.5,17.87 95.36,19.33 96.08,19.9 96.87,19.71 98.51,19.31 98.04,14.34 96.12,12.07 95.25,11.01 92.07,9.42 88.92,8.45 86.25,7.63 85.93,7.56 85.68,7.81 Z M 85.68,7.81"), 5),
        c("M 112.73,48.63 L 140.23,48.63 137.64,77.53", $e, 7),
        c("M 107.02,80.13 L 148.02,80.13", $e, 7)
    ]), l([
        20,
        20,
        70,
        14,
        14,
        57,
        42
    ]), 1, "ju", "\u30B8\u30E5", 0), UC = A7(ef, 96, l([
        c("M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86", $e, 9.47),
        c("M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48", $e, 9.47),
        c("M 78.31,17 C 78.31,17 80.98,17 83.64,20 86.31,23 86.31,26 86.31,26", Se("M 76.13,16.06 C 75.83,16.35 75.99,16.53 77.27,17.3 79.68,18.76 82.7,22.22 84.95,26.13 85.8,27.59 86.52,28.16 87.31,27.96 88.95,27.56 88.48,22.6 86.57,20.32 85.69,19.26 82.52,17.67 79.37,16.7 76.69,15.89 76.37,15.82 76.13,16.06 Z M 76.13,16.06"), 5),
        c("M 83.31,11 C 83.31,11 85.98,11 88.64,14 91.31,17 91.31,20 91.31,20", Se("M 81.13,10.06 C 80.83,10.35 80.99,10.53 82.27,11.3 84.68,12.76 87.7,16.22 89.95,20.13 90.8,21.59 91.52,22.16 92.31,21.96 93.95,21.56 93.48,16.6 91.57,14.32 90.69,13.26 87.52,11.67 84.37,10.7 81.69,9.89 81.37,9.82 81.13,10.06 Z M 81.13,10.06"), 5),
        c("M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07", $e, 7),
        c("M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34", $e, 7)
    ]), l([
        49,
        138,
        14,
        14,
        107,
        47
    ]), 1, "ju2", "\u3062\u3085", 0), AC = A7(ef, 96, l([
        c("M 75.61,20 C 54.01,28.33 33.23,28.33 33.23,28.33", $e, 10),
        c("M 27,47.08 L 86,47.08", $e, 10),
        c("M 57.33,27.5 L 57.33,49.17 C 57.33,49.17 56.5,72.5 39.05,80", $e, 10),
        c("M 82.83,28.71 C 82.83,28.71 85.5,28.71 88.17,31.71 90.83,34.71 90.83,37.71 90.83,37.71", Se("M 80.65,27.77 C 80.36,28.06 80.51,28.23 81.8,29.01 84.2,30.46 87.22,33.93 89.47,37.84 90.32,39.3 91.04,39.87 91.83,39.67 93.47,39.27 93,34.31 91.09,32.03 90.21,30.97 87.04,29.38 83.89,28.41 81.21,27.59 80.9,27.53 80.65,27.77 Z M 80.65,27.77"), 5),
        c("M 87.83,22.71 C 87.83,22.71 90.5,22.71 93.17,25.71 95.83,28.71 95.83,31.71 95.83,31.71", Se("M 85.65,21.77 C 85.36,22.06 85.51,22.23 86.8,23.01 89.2,24.46 92.22,27.93 94.47,31.84 95.32,33.3 96.04,33.87 96.83,33.67 98.47,33.27 98,28.31 96.09,26.03 95.21,24.97 92.04,23.38 88.89,22.41 86.21,21.59 85.9,21.53 85.65,21.77 Z M 85.65,21.77"), 5),
        c("M 112.73,48.63 L 140.23,48.63 137.64,77.53", $e, 7),
        c("M 107.02,80.13 L 148.02,80.13", $e, 7)
    ]), l([
        44,
        60,
        60,
        14,
        14,
        57,
        42
    ]), 1, "ju", "\u30C2\u30E5", 0), EC = A7(ef, 6, l([
        c("M 21.08,36.21 C 36.34,38.7 61.54,25.96 61.6,45.03 61.68,69.85 53.93,75.36 47.41,81.82 47.41,81.82 47.25,77.4 41.52,72.88", $e, 9.47),
        c("M 50.89,20 C 43.09,34.87 28.46,62.28 20,74.41", $e, 9.47),
        c("M 74.24,32.14 C 79.65,34.13 84.55,46.06 85.81,50.4", $e, 9.47)
    ]), l([
        101,
        64,
        24
    ]), 1, "ka", "\u304B", 0), TC = A7(ef, 6, l([
        c("M 24,35.62 L 74.5,35.62 74.5,66.07 C 74.5,66.07 72.54,85.59 56.1,79.35", $e, 10),
        c("M 49.84,20 C 49.84,20 52.19,67.63 26.35,79.35", $e, 10)
    ]), l([
        108,
        68
    ]), 1, "ka", "\u30AB", 0), IC = A7(ef, 9, l([
        c("M 31.56,20.79 C 24.41,31.08 19.68,71.19 25.19,82.09 25.38,82.47 31.48,75.91 37.17,68.81", $e, 9.47),
        c("M 42.63,38.47 C 49.91,34.84 70.31,31.22 77.29,34.24", $e, 9.47),
        c("M 61.62,17.78 C 64.56,26.43 71.47,61.29 60.97,82.75", $e, 9.47)
    ]), l([
        81,
        36,
        67
    ]), 1, "ke", "\u3051", 0), jC = A7(ef, 9, l([
        c("M 39.2,21 C 39.2,21 35.2,39.37 20,51.35", $e, 10),
        c("M 35.2,35.38 L 80,35.38", $e, 10),
        c("M 58.8,38.97 C 58.8,38.97 57.2,70.12 33.2,80.5", $e, 10)
    ]), l([
        37,
        46,
        52
    ]), 1, "ke", "\u30B1", 0), RC = A7(ef, 7, l([
        c("M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97", $e, 9.47),
        c("M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85", $e, 9.47),
        c("M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23", $e, 9.47),
        c("M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12", $e, 9.47)
    ]), l([
        30,
        42,
        55,
        34
    ]), 1, "ki", "\u304D", 0), QC = A7(ef, 7, l([
        c("M 21.64,37.84 L 72.44,31.35", $e, 10),
        c("M 20,59.73 L 79,52.43", $e, 10),
        c("M 44.58,20 L 52.78,80", $e, 10)
    ]), l([
        52,
        60,
        61
    ]), 1, "ki", "\u30AD", 0), PC = A7(ef, 7, l([
        c("M 20,49.17 C 20,49.17 23.38,53.94 25.8,59.19", $e, 7),
        c("M 32.57,44.88 C 32.57,44.88 35.95,49.65 38.37,54.89", $e, 7),
        c("M 56.5,46.07 C 56.5,46.07 53.12,72.79 29.91,81.37", $e, 7),
        c("M 83.94,37.84 L 134.75,31.35", $e, 10),
        c("M 82.3,59.73 L 141.3,52.43", $e, 10),
        c("M 106.88,20 L 115.08,80", $e, 10)
    ]), l([
        12,
        12,
        47,
        52,
        60,
        61
    ]), 1, "kki", "\u30C3\u30AD", 0), VC = A7(ef, 10, l([
        c("M 32.45,27.06 C 38.11,30.47 56.01,18.26 66.26,24.68 72.94,28.87 64.28,33.19 61.89,36", $e, 9.47),
        c("M 30.78,66.21 C 34.95,77.97 60.4,79.19 68.58,74.56", $e, 9.47)
    ]), l([
        51,
        43
    ]), 1, "ko", "\u3053", 0), FC = A7(ef, 10, l([
        c("M 25.73,25 L 74,25 74,75", $e, 10),
        c("M 25,71.15 L 74,71.15", $e, 10)
    ]), l([
        99,
        49
    ]), 1, "ko", "\u30B3", 0), NC = A7(ef, 8, l([
        c("M 65.89,18.78 C 58.37,32.23 37.7,51.06 32.78,52.04 38.98,55.14 60.45,73.99 64.18,83.11", $e, 9.47)
    ]), l([
        93
    ]), 1, "ku", "\u304F", 0), JC = A7(ef, 8, l([
        c("M 47.06,20 C 47.06,20 40.44,36.83 25,50", $e, 10),
        c("M 44.85,29.51 L 75,29.51 C 75,29.51 73.53,63.17 36.03,80", $e, 10)
    ]), l([
        38,
        97
    ]), 1, "ku", "\u30AF", 0), _C = A7(ef, 71, l([
        c("M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97", $e, 9.47),
        c("M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85", $e, 9.47),
        c("M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23", $e, 9.47),
        c("M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12", $e, 9.47),
        c("M 92.78,56.64 C 98.35,59.29 125.25,44.95 128.64,48.53 134.07,54.28 125.51,61.36 123.61,64.75", $e, 7),
        c("M 114.24,42.78 C 114.24,47.06 116.78,55.36 118.59,58.11", $e, 7),
        c("M 97.81,46.03 C 100.39,48.09 113.29,76.39 113.02,82.73", $e, 7)
    ]), l([
        30,
        42,
        55,
        34,
        56,
        17,
        40
    ]), 1, "kya", "\u304D\u3083", 0), YC = A7(ef, 71, l([
        c("M 21.64,37.84 L 72.44,31.35", $e, 10),
        c("M 20,59.73 L 79,52.43", $e, 10),
        c("M 44.58,20 L 52.78,80", $e, 10),
        c("M 100,57.44 C 100,57.44 134.04,51.92 135.75,51.52 137.45,51.13 130.21,60.59 124.26,64.92", $e, 7),
        c("M 110.35,43.46 L 118.45,81.46", $e, 7)
    ]), l([
        52,
        60,
        61,
        55,
        39
    ]), 1, "kya", "\u30AD\u30E3", 0), XC = A7(ef, 73, l([
        c("M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97", $e, 9.47),
        c("M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85", $e, 9.47),
        c("M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23", $e, 9.47),
        c("M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12", $e, 9.47),
        c("M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81", $e, 7),
        c("M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78", $e, 7)
    ]), l([
        30,
        42,
        55,
        34,
        13,
        113
    ]), 1, "kyo", "\u304D\u3087", 0), nl = A7(ef, 73, l([
        c("M 28.64,37.84 L 79.44,31.35", $e, 10),
        c("M 27,59.73 L 86,52.43", $e, 10),
        c("M 51.58,20 L 59.78,80", $e, 10),
        c("M 110.52,45 L 144,45 144,83", $e, 7),
        c("M 111.57,62.7 L 142.95,62.7", $e, 7),
        c("M 110,80.4 L 143.48,80.4", $e, 7)
    ]), l([
        52,
        60,
        61,
        72,
        32,
        34
    ]), 1, "kyo", "\u30AD\u30E7", 0), rl = A7(ef, 72, l([
        c("M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97", $e, 9.47),
        c("M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85", $e, 9.47),
        c("M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23", $e, 9.47),
        c("M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12", $e, 9.47),
        c("M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07", $e, 7),
        c("M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34", $e, 7)
    ]), l([
        30,
        42,
        55,
        34,
        107,
        47
    ]), 1, "kyu", "\u304D\u3085", 0), el = A7(ef, 72, l([
        c("M 28.64,37.84 L 79.44,31.35", $e, 10),
        c("M 27,59.73 L 86,52.43", $e, 10),
        c("M 51.58,20 L 59.78,80", $e, 10),
        c("M 112.73,48.63 L 140.23,48.63 137.64,77.53", $e, 7),
        c("M 107.02,80.13 L 148.02,80.13", $e, 7)
    ]), l([
        52,
        60,
        61,
        57,
        42
    ]), 1, "kyu", "\u30AD\u30E5", 0), tl = A7(ef, 31, l([
        c("M 33.91,33.28 C 45.18,34.93 65.34,25.88 71,28", $e, 9.47),
        c("M 37.27,49.64 C 43.88,54.71 66.29,52.84 69.71,49.16", $e, 9.47),
        c("M 51.28,17.78 C 52.65,32.76 70.47,83 46,83 35,83 29.31,80.82 29.81,72.69 30.69,58.29 67.76,71.91 75,80", $e, 9.47)
    ]), l([
        38,
        34,
        147
    ]), 1, "ma", "\u307E", 0), al = A7(ef, 31, l([
        c("M 20,23 L 80,23 C 80,23 69.88,41.21 52.25,57.93", $e, 10),
        c("M 31.25,46.78 C 50,60.16 67.25,78 67.25,78", $e, 10)
    ]), l([
        105,
        48
    ]), 1, "ma", "\u30DE", 0), ul = A7(ef, 34, l([
        c("M 31.71,26.18 C 32.78,31.34 45.05,63.27 50.99,70.3", $e, 9.47),
        c("M 72.23,23.78 C 70.93,28.75 48.72,73.19 34.81,75.91 27.84,77.27 20.96,72.91 21.86,61.67 22.38,55.26 28.59,48.84 38.16,43.68 65.36,29 90.78,55.65 70.57,77.06", $e, 9.47)
    ]), l([
        50,
        185
    ]), 1, "me", "\u3081", 0), il = A7(ef, 34, l([
        c("M 68.21,20 C 68.21,20 59.63,63.08 23,80", $e, 10),
        c("M 33.13,36.92 C 33.13,36.92 56.12,45 76,65.38", $e, 10)
    ]), l([
        78,
        52
    ]), 1, "me", "\u30E1", 0), ol = A7(ef, 32, l([
        c("M 34.35,27.32 C 39.21,29.61 49.62,22.78 49.62,22.78 49.81,34.5 40.02,72.77 27.18,71.73 14.23,70.67 20.26,55.05 30.17,51.72 52.5,44.23 75.8,60.03 80.81,68.09", $e, 9.47),
        c("M 73.73,40.14 C 74.52,52.04 70.62,69.52 62.16,77.1", $e, 9.47)
    ]), l([
        160,
        41
    ]), 1, "mi", "\u307F", 0), cl = A7(ef, 32, l([
        c("M 28.02,20 C 28.02,20 49.88,21.52 71.74,26.84", $e, 10),
        c("M 31.03,42.78 C 31.03,42.78 49.88,45.06 68.72,51.14", $e, 10),
        c("M 25,69.37 C 25,69.37 49.12,72.41 74,80", $e, 10)
    ]), l([
        45,
        39,
        51
    ]), 1, "mi", "\u30DF", 0), fl = A7(ef, 35, l([
        c("M 51.62,18.79 C 49.38,34.17 29.38,79.57 45.48,81.79 59.18,83.68 63.85,74.52 66.96,67", $e, 9.47),
        c("M 36.13,27.06 C 46.65,34.87 56.03,32.53 59.28,28.4", $e, 9.47),
        c("M 32.79,48.36 C 37.53,51.62 51.33,57.09 59,50.59", $e, 9.47)
    ]), l([
        97,
        26,
        28
    ]), 1, "mo", "\u3082", 0), bl = A7(ef, 35, l([
        c("M 24.11,21 L 74.25,21", $e, 10),
        c("M 20,45.58 L 80,45.58", $e, 10),
        c("M 44.66,21 L 44.66,70.19 C 44.66,70.19 45.48,80 57.81,80 70.14,80 77.53,79.18 77.53,79.18", $e, 10)
    ]), l([
        51,
        60,
        87
    ]), 1, "mo", "\u30E2", 0), sl = A7(ef, 33, l([
        c("M 25.65,30.62 C 29.13,33.07 41.55,31.23 41.55,31.23", $e, 9.47),
        c("M 34.79,20.79 C 36.3,42.08 38.78,62.89 32.18,61.94 18.81,60.02 22.46,43.84 26.52,43.51 47.14,41.87 27.64,70.42 37.24,75.85 49.76,82.94 72.47,79.36 75.63,73.36 78.59,67.75 72.82,59.59 69.8,54.92", $e, 9.47),
        c("M 63.97,27.62 C 66.33,31.5 70.53,35.41 75.87,37.08", $e, 9.47)
    ]), l([
        17,
        169,
        16
    ]), 1, "mu", "\u3080", 0), Ml = A7(ef, 33, l([
        c("M 43.77,21 L 23,75.46 68.84,71.22", $e, 10),
        c("M 57.38,48.59 C 57.38,48.59 70.99,66.98 76,79", $e, 10)
    ]), l([
        105,
        36
    ]), 1, "mu", "\u30E0", 0), dl = A7(ef, 86, l([
        c("M 34.35,27.32 C 39.21,29.61 49.62,22.78 49.62,22.78 49.81,34.5 40.02,72.77 27.18,71.73 14.23,70.67 20.26,55.05 30.17,51.72 52.5,44.23 75.8,60.03 80.81,68.09", $e, 9.47),
        c("M 73.73,40.14 C 74.52,52.04 70.62,69.52 62.16,77.1", $e, 9.47),
        c("M 102,56.64 C 107.57,59.29 134.47,44.95 137.85,48.53 143.28,54.28 134.73,61.36 132.83,64.75", $e, 7),
        c("M 123.46,42.78 C 123.46,47.06 125.99,55.36 127.8,58.11", $e, 7),
        c("M 107.02,46.03 C 109.61,48.09 122.51,76.39 122.23,82.73", $e, 7)
    ]), l([
        160,
        41,
        56,
        17,
        40
    ]), 1, "mya", "\u307F\u3083", 0), Cl = A7(ef, 86, l([
        c("M 28.02,20 C 28.02,20 49.88,21.52 71.74,26.84", $e, 10),
        c("M 31.03,42.78 C 31.03,42.78 49.88,45.06 68.72,51.14", $e, 10),
        c("M 25,69.37 C 25,69.37 49.12,72.41 74,80", $e, 10),
        c("M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92", $e, 7),
        c("M 115.35,43.46 L 123.45,81.46", $e, 7)
    ]), l([
        45,
        39,
        51,
        55,
        39
    ]), 1, "mya", "\u30DF\u30E3", 0), ll = A7(ef, 88, l([
        c("M 34.35,27.32 C 39.21,29.61 49.62,22.78 49.62,22.78 49.81,34.5 40.02,72.77 27.18,71.73 14.23,70.67 20.26,55.05 30.17,51.72 52.5,44.23 75.8,60.03 80.81,68.09", $e, 9.47),
        c("M 73.73,40.14 C 74.52,52.04 70.62,69.52 62.16,77.1", $e, 9.47),
        c("M 120.93,43.15 C 122.8,44.07 131.77,41.31 131.77,41.31", $e, 7),
        c("M 117.01,32.5 C 119.44,38.93 121.94,72.25 108.52,76.13 94.09,80.3 90.36,74.66 97.58,67.75 104.86,60.77 130.25,69.72 135.32,75.28", $e, 7)
    ]), l([
        160,
        41,
        13,
        113
    ]), 1, "myo", "\u307F\u3087", 0), vl = A7(ef, 88, l([
        c("M 35.02,20 C 35.02,20 56.88,21.52 78.74,26.84", $e, 10),
        c("M 38.03,42.78 C 38.03,42.78 56.88,45.06 75.72,51.14", $e, 10),
        c("M 32,69.37 C 32,69.37 56.12,72.41 81,80", $e, 10),
        c("M 110.52,45 L 144,45 144,83", $e, 7),
        c("M 111.57,62.7 L 142.95,62.7", $e, 7),
        c("M 110,80.4 L 143.48,80.4", $e, 7)
    ]), l([
        45,
        39,
        51,
        72,
        32,
        34
    ]), 1, "myo", "\u30DF\u30E7", 0), gl = A7(ef, 87, l([
        c("M 34.35,27.32 C 39.21,29.61 49.62,22.78 49.62,22.78 49.81,34.5 40.02,72.77 27.18,71.73 14.23,70.67 20.26,55.05 30.17,51.72 52.5,44.23 75.8,60.03 80.81,68.09", $e, 9.47),
        c("M 73.73,40.14 C 74.52,52.04 70.62,69.52 62.16,77.1", $e, 9.47),
        c("M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07", $e, 7),
        c("M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34", $e, 7)
    ]), l([
        160,
        41,
        107,
        47
    ]), 1, "myu", "\u307F\u3085", 0), hl = A7(ef, 87, l([
        c("M 35.02,20 C 35.02,20 56.88,21.52 78.74,26.84", $e, 10),
        c("M 38.03,42.78 C 38.03,42.78 56.88,45.06 75.72,51.14", $e, 10),
        c("M 32,69.37 C 32,69.37 56.12,72.41 81,80", $e, 10),
        c("M 112.73,48.63 L 140.23,48.63 137.64,77.53", $e, 7),
        c("M 107.02,80.13 L 148.02,80.13", $e, 7)
    ]), l([
        45,
        39,
        51,
        57,
        42
    ]), 1, "myu", "\u30DF\u30E5", 0), pl = A7(ef, 46, l([
        c("M 46.56,21.78 C 41.81,45.37 21.78,79.42 21.78,79.42 21.78,79.42 38.82,49.54 40.92,49.39 54.53,48.46 53.95,78.25 60.89,78.24 73.35,78.22 74.69,59.42 77.71,54.81", $e, 9.47)
    ]), l([
        171
    ]), 1, "n", "\u3093", 0), Ll = A7(ef, 46, l([
        c("M 21.62,22 C 21.62,22 31.92,28.42 41.89,38.46", $e, 10),
        c("M 20,79 C 64.59,68.56 80,27.62 80,27.62", $e, 10)
    ]), l([
        27,
        82
    ]), 1, "n", "\u30F3", 0), wl = A7(ef, 21, l([
        c("M 26.4,29 C 33.69,33.08 51.96,28.68 56.26,27.39", $e, 9.47),
        c("M 44.13,17.78 C 39.6,28.49 28.03,53.65 21.78,65.99", $e, 9.47),
        c("M 69.01,33.62 C 72.08,37.54 78.28,41.56 78.28,41.56 77.1,42.94 74.98,42.92 73.35,47.03", $e, 9.47),
        c("M 57.55,41.54 C 58.19,58.01 65.66,83.67 48.1,82.97 39.92,82.64 38.52,75.76 41.07,70.9 47.37,58.94 71.18,69.36 77.19,73.65", $e, 9.47)
    ]), l([
        31,
        54,
        20,
        106
    ]), 1, "na", "\u306A", 0), Zl = A7(ef, 21, l([
        c("M 20,40.61 L 80,40.61", $e, 10),
        c("M 50.82,20 L 50.82,54.62 C 50.82,54.62 50.41,75.23 33.15,81", $e, 10)
    ]), l([
        60,
        69
    ]), 1, "na", "\u30CA", 0), ml = A7(ef, 24, l([
        c("M 36.13,19.79 C 34.3,30.36 31.39,75.46 32.3,80.57", $e, 9.47),
        c("M 21.14,34.56 C 29.15,35.05 37.16,32.83 37.16,32.83 L 18.79,69.72 C 18.79,69.72 48.99,27.67 66.84,26.14 79.76,25.04 75.54,77.01 62.13,77.15 52.14,77.25 46.81,69.53 52.71,62.29 58.36,55.36 77.07,67.42 81.21,75.41", $e, 9.47)
    ]), l([
        62,
        241
    ]), 1, "ne", "\u306D", 0), Sl = A7(ef, 24, l([
        c("M 47.6,20 L 47.6,26.4", $e, 10),
        c("M 25.2,29.6 L 70.8,29.6 C 70.8,29.6 48.4,58.4 22,68", $e, 10),
        c("M 47.6,54.4 L 47.6,80", $e, 10),
        c("M 59.6,58.4 C 59.6,58.4 69.2,62.4 78,69.6", $e, 10)
    ]), l([
        7,
        109,
        26,
        22
    ]), 1, "ne", "\u30CD", 0), $l = A7(ef, 22, l([
        c("M 29.65,21.78 C 22.67,33.23 20.35,71.25 25.8,79.09 26.48,74.06 31.38,64.46 34.81,61.13", $e, 9.47),
        c("M 47.68,30.43 C 56.82,27.16 64.05,21.31 76.42,31.6", $e, 9.47),
        c("M 47.96,66.61 C 56.17,76.84 66.62,78.19 76.03,74.95", $e, 9.47)
    ]), l([
        80,
        32,
        33
    ]), 1, "ni", "\u306B", 0), Dl = A7(ef, 22, l([
        c("M 25.33,29 L 72.83,29", $e, 10),
        c("M 17,71 L 82,71", $e, 10)
    ]), l([
        48,
        65
    ]), 1, "ni", "\u30CB", 0), yl = A7(ef, 25, l([
        c("M 47.6,30.6 C 48.44,55.92 35.33,74.66 24.57,71.83 13.89,69.01 20.33,30.78 51.56,26.11 79.15,21.98 89.15,58.35 68.42,73.96", $e, 9.47)
    ]), l([
        186
    ]), 1, "no", "\u306E", 0), zl = A7(ef, 25, l([
        c("M 73,20 C 73,20 65.07,59.74 27,80", $e, 10)
    ]), l([
        78
    ]), 1, "no", "\u30CE", 0), Kl = A7(ef, 23, l([
        c("M 26.95,24.06 C 29.55,38.39 36.5,64.32 43.39,73.06", $e, 9.47),
        c("M 63.81,19.79 C 53.12,37.9 43.07,79.51 31.24,79.86 24.98,80.04 19.06,76.96 19.86,67.96 20.46,61.22 21.36,52.36 31,47 56.13,33.04 81.32,54.08 73.15,72.58 67.1,86.29 57.35,79.58 59.42,71.68 62.34,60.59 73.03,65.6 80.76,80.28", $e, 9.47)
    ]), l([
        53,
        234
    ]), 1, "nu", "\u306C", 0), xl = A7(ef, 23, l([
        c("M 27.91,20 L 75.36,20 C 75.36,20 63.09,60.54 23,80", $e, 10),
        c("M 36.91,39.46 C 36.91,39.46 59.82,50.81 77,70.27", $e, 10)
    ]), l([
        130,
        51
    ]), 1, "nu", "\u30CC", 0), Hl = A7(ef, 80, l([
        c("M 39.65,21.78 C 32.67,33.23 30.35,71.25 35.8,79.09 36.48,74.06 41.38,64.46 44.81,61.13", $e, 9.47),
        c("M 57.68,30.43 C 66.82,27.16 74.05,21.31 86.42,31.6", $e, 9.47),
        c("M 57.96,66.61 C 66.17,76.84 76.62,78.19 86.03,74.95", $e, 9.47),
        c("M 102,56.64 C 107.57,59.29 134.47,44.95 137.85,48.53 143.28,54.28 134.73,61.36 132.83,64.75", $e, 7),
        c("M 123.46,42.78 C 123.46,47.06 125.99,55.36 127.8,58.11", $e, 7),
        c("M 107.02,46.03 C 109.61,48.09 122.51,76.39 122.23,82.73", $e, 7)
    ]), l([
        80,
        32,
        33,
        56,
        17,
        40
    ]), 1, "nya", "\u306B\u3083", 0), kl = A7(ef, 80, l([
        c("M 25.33,29 L 72.83,29", $e, 10),
        c("M 17,71 L 82,71", $e, 10),
        c("M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92", $e, 7),
        c("M 115.35,43.46 L 123.45,81.46", $e, 7)
    ]), l([
        48,
        65,
        55,
        39
    ]), 1, "nya", "\u30CB\u30E3", 0), Bl = A7(ef, 82, l([
        c("M 29.65,21.78 C 22.67,33.23 20.35,71.25 25.8,79.09 26.48,74.06 31.38,64.46 34.81,61.13", $e, 9.47),
        c("M 47.68,30.43 C 56.82,27.16 64.05,21.31 76.42,31.6", $e, 9.47),
        c("M 47.96,66.61 C 56.17,76.84 66.62,78.19 76.03,74.95", $e, 9.47),
        c("M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81", $e, 7),
        c("M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78", $e, 7)
    ]), l([
        80,
        32,
        33,
        13,
        113
    ]), 1, "nyo", "\u306B\u3087", 0), Ol = A7(ef, 82, l([
        c("M 33.82,35.4 L 81.32,35.4", $e, 10),
        c("M 25.49,77.4 L 90.49,77.4", $e, 10),
        c("M 110.52,45 L 144,45 144,83", $e, 7),
        c("M 111.57,62.7 L 142.95,62.7", $e, 7),
        c("M 110,80.4 L 143.48,80.4", $e, 7)
    ]), l([
        48,
        65,
        72,
        32,
        34
    ]), 1, "nyo", "\u30CB\u30E7", 0), Gl = A7(ef, 81, l([
        c("M 29.65,21.78 C 22.67,33.23 20.35,71.25 25.8,79.09 26.48,74.06 31.38,64.46 34.81,61.13", $e, 9.47),
        c("M 47.68,30.43 C 56.82,27.16 64.05,21.31 76.42,31.6", $e, 9.47),
        c("M 47.96,66.61 C 56.17,76.84 66.62,78.19 76.03,74.95", $e, 9.47),
        c("M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07", $e, 7),
        c("M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34", $e, 7)
    ]), l([
        80,
        32,
        33,
        107,
        47
    ]), 1, "nyu", "\u306B\u3085", 0), Wl = A7(ef, 81, l([
        c("M 33.82,35.4 L 81.32,35.4", $e, 10),
        c("M 25.49,77.4 L 90.49,77.4", $e, 10),
        c("M 112.73,48.63 L 140.23,48.63 137.64,77.53", $e, 7),
        c("M 107.02,80.13 L 148.02,80.13", $e, 7)
    ]), l([
        48,
        65,
        57,
        42
    ]), 1, "nyu", "\u30CB\u30E5", 0), ql = A7(ef, 5, l([
        c("M 28.5,27.7 C 35.33,32.09 53.46,27.03 53.46,27.03", $e, 9.47),
        c("M 43.14,17.78 C 39.77,50.22 41.81,91.53 24.64,80.9 13.47,73.98 21.01,57.96 53.23,46.51 77.52,37.88 82.35,69.46 65.48,81.95", $e, 9.47),
        c("M 69.36,21.27 C 74.34,23.68 80.52,25.86 80.16,32.59", $e, 9.47)
    ]), l([
        26,
        185,
        17
    ]), 1, "o", "\u304A", 0), Ul = A7(ef, 5, l([
        c("M 23.77,35.4 L 76,35.4", $e, 10),
        c("M 58.33,20 L 58.33,73.12 C 58.33,73.12 59.1,79.28 53.72,80.05 48.35,80.82 45.28,78.51 45.28,78.51", $e, 10),
        c("M 58.33,35.4 C 58.33,35.4 42.2,57.72 23,72.35", $e, 10)
    ]), l([
        53,
        72,
        52
    ]), 1, "o", "\u30AA", 0), Al = A7(ef, 66, l([
        c("M 23.13,25.16 C 28.12,33.04 11.34,82.92 20.65,87.48 25.8,89.99 28.7,77.05 32.07,74.53", $e, 9.47),
        c("M 47.85,38.2 C 55.99,40.06 74.35,35.17 78.77,35.41", $e, 9.47),
        c("M 66.91,23.78 C 67.53,39.64 77.69,86.82 58.54,85.39 49.24,84.69 42.94,81.76 43.9,74.69 45.71,61.34 67.34,69.55 78.15,79.08", $e, 9.47),
        c("M 85,11 C 88.87,11 92,14.13 92,18 92,21.87 88.87,25 85,25 81.13,25 78,21.87 78,18 78,14.13 81.13,11 85,11 Z M 85,11", $e, 5)
    ]), l([
        83,
        32,
        130,
        47
    ]), 1, "pa", "\u3071", 0), El = A7(ef, 66, l([
        c("M 36.71,28.52 C 36.71,28.52 34.43,55.81 20,74", $e, 10),
        c("M 59.49,27 C 59.49,27 74.68,46.71 80,74", $e, 10),
        c("M 78.47,13.32 C 82.34,13.32 85.47,16.46 85.47,20.32 85.47,24.19 82.34,27.32 78.47,27.32 74.61,27.32 71.47,24.19 71.47,20.32 71.47,16.46 74.61,13.32 78.47,13.32 Z M 78.47,13.32", $e, 5)
    ]), l([
        50,
        53,
        47
    ]), 1, "pa", "\u30D1", 0), Tl = A7(ef, 69, l([
        c("M 17.78,60.06 C 25.32,54.85 30.91,43.44 34.64,38.78 41.18,44.42 62.75,56.65 80.86,63.16", $e, 9.47),
        c("M 72,20 C 75.87,20 79,23.13 79,27 79,30.87 75.87,34 72,34 68.13,34 65,30.87 65,27 65,23.13 68.13,20 72,20 Z M 72,20", $e, 5)
    ]), l([
        81,
        47
    ]), 1, "pe", "\u307A", 0), Il = A7(ef, 69, l([
        c("M 17,55.49 C 17,55.49 35.46,31 40.27,31 45.09,31 82,71 82,71", $e, 10),
        c("M 64.77,15.22 C 68.63,15.22 71.77,18.36 71.77,22.22 71.77,26.09 68.63,29.22 64.77,29.22 60.9,29.22 57.77,26.09 57.77,22.22 57.77,18.36 60.9,15.22 64.77,15.22 Z M 64.77,15.22", $e, 5)
    ]), l([
        92,
        47
    ]), 1, "pe", "\u30DA", 0), jl = A7(ef, 67, l([
        c("M 13.78,36.93 C 21.52,35.69 30.52,32.36 37.95,26.78 30.7,38.87 20.01,80.75 41.09,81.05 67.78,81.43 64.67,35.07 64.67,35.07 66.07,38.57 72.31,46.5 76.79,49.7", $e, 9.47),
        c("M 81,17.04 C 84.87,17.04 88,20.18 88,24.04 88,27.91 84.87,31.04 81,31.04 77.13,31.04 74,27.91 74,24.04 74,20.18 77.13,17.04 81,17.04 Z M 81,17.04", $e, 5)
    ]), l([
        168,
        47
    ]), 1, "pi", "\u3074", 0), Rl = A7(ef, 67, l([
        c("M 27.15,50.86 C 27.15,50.86 49.58,48.43 71.18,35.43", $e, 10),
        c("M 26.32,20 C 26.32,20 18.85,71.17 26.32,77.67 33.8,84.17 77,77.67 77,77.67", $e, 10),
        c("M 81.92,10.83 C 85.79,10.83 88.92,13.96 88.92,17.83 88.92,21.69 85.79,24.83 81.92,24.83 78.06,24.83 74.92,21.69 74.92,17.83 74.92,13.96 78.06,10.83 81.92,10.83 Z M 81.92,10.83", $e, 5)
    ]), l([
        47,
        110,
        47
    ]), 1, "pi", "\u30D4", 0), Ql = A7(ef, 70, l([
        c("M 23.68,28.78 C 18.01,36.26 15.15,81.9 21.03,82.29 24.7,82.54 29.19,68.25 29.19,68.25", $e, 9.47),
        c("M 49.48,30.62 C 56.47,29.12 72.83,30.46 76.82,31.6", $e, 9.47),
        c("M 48.95,49.19 C 56,53.38 73.17,50.27 77.31,48.5", $e, 9.47),
        c("M 62.91,31.6 C 65.68,57.03 74.11,89.55 49.19,83.27 39.34,80.79 43.01,64.22 52.13,65.64 65.86,67.78 72.9,70.49 77.8,78.09", $e, 9.47),
        c("M 85,11 C 88.87,11 92,14.13 92,18 92,21.87 88.87,25 85,25 81.13,25 78,21.87 78,18 78,14.13 81.13,11 85,11 Z M 85,11", $e, 5)
    ]), l([
        72,
        28,
        29,
        120,
        47
    ]), 1, "po", "\u307D", 0), Pl = A7(ef, 70, l([
        c("M 24.09,35.78 L 76.64,35.78", $e, 10),
        c("M 50,21 L 50,76.32 C 50,76.32 49.64,78.79 46.35,80.11 43.07,81.44 38.32,78.6 38.32,78.6", $e, 10),
        c("M 33.95,52.07 C 33.95,52.07 32.49,61.17 23,72.53", $e, 10),
        c("M 65.32,52.07 C 65.32,52.07 68.97,63.44 77,72.53", $e, 10),
        c("M 69.4,9.64 C 73.27,9.64 76.4,12.77 76.4,16.64 76.4,20.51 73.27,23.64 69.4,23.64 65.54,23.64 62.4,20.51 62.4,16.64 62.4,12.77 65.54,9.64 69.4,9.64 Z M 69.4,9.64", $e, 5)
    ]), l([
        53,
        70,
        24,
        24,
        47
    ]), 1, "po", "\u30DD", 0), Vl = A7(ef, 68, l([
        c("M 44.09,19.78 C 45.89,23.85 48.42,26.98 50.73,28.5 L 46.37,30.78", $e, 9.47),
        c("M 46.58,45.21 C 58.43,50.96 57.51,79.75 47.2,80.88 41.54,81.51 38.7,74.66 38.7,74.66", $e, 9.47),
        c("M 30.4,49.39 C 29.36,54.79 25.55,64.17 18.78,68.02", $e, 9.47),
        c("M 70.99,45.55 C 76.87,54.76 82.64,67.33 80.49,69.2 77.39,71.9 72.78,65.61 71.47,64.91", $e, 9.47),
        c("M 75,15.04 C 78.87,15.04 82,18.18 82,22.04 82,25.91 78.87,29.04 75,29.04 71.13,29.04 68,25.91 68,22.04 68,18.18 71.13,15.04 75,15.04 Z M 75,15.04", $e, 5)
    ]), l([
        16,
        53,
        23,
        37,
        47
    ]), 1, "pu", "\u3077", 0), Fl = A7(ef, 68, l([
        c("M 17.63,30.92 L 71.63,30.92 C 71.63,30.92 68.21,67.2 28.28,85.92", $e, 10),
        c("M 81.92,10.83 C 85.79,10.83 88.92,13.96 88.92,17.83 88.92,21.69 85.79,24.83 81.92,24.83 78.06,24.83 74.92,21.69 74.92,17.83 74.92,13.96 78.06,10.83 81.92,10.83 Z M 81.92,10.83", $e, 5)
    ]), l([
        127,
        47
    ]), 1, "pu", "\u30D7", 0), Nl = A7(ef, 101, l([
        c("M 13.78,36.93 C 21.52,35.69 30.52,32.36 37.95,26.78 30.7,38.87 20.01,80.75 41.09,81.05 67.78,81.43 64.67,35.07 64.67,35.07 66.07,38.57 72.31,46.5 76.79,49.7", $e, 9.47),
        c("M 81,17.04 C 84.87,17.04 88,20.18 88,24.04 88,27.91 84.87,31.04 81,31.04 77.13,31.04 74,27.91 74,24.04 74,20.18 77.13,17.04 81,17.04 Z M 81,17.04", $e, 5),
        c("M 95,56.64 C 100.57,59.29 127.47,44.95 130.85,48.53 136.28,54.28 127.73,61.36 125.83,64.75", $e, 7),
        c("M 116.46,42.78 C 116.46,47.06 118.99,55.36 120.8,58.11", $e, 7),
        c("M 100.02,46.03 C 102.61,48.09 115.51,76.39 115.23,82.73", $e, 7)
    ]), l([
        168,
        47,
        56,
        17,
        40
    ]), 1, "pya", "\u3074\u3083", 0), Jl = A7(ef, 101, l([
        c("M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43", $e, 10),
        c("M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67", $e, 10),
        c("M 87.99,12.09 C 91.86,12.09 94.99,15.22 94.99,19.09 94.99,22.95 91.86,26.09 87.99,26.09 84.13,26.09 80.99,22.95 80.99,19.09 80.99,15.22 84.13,12.09 87.99,12.09 Z M 87.99,12.09", $e, 5),
        c("M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92", $e, 7),
        c("M 115.35,43.46 L 123.45,81.46", $e, 7)
    ]), l([
        47,
        110,
        47,
        55,
        39
    ]), 1, "pya", "\u30D4\u30E3", 0), _l = A7(ef, 103, l([
        c("M 13.78,36.93 C 21.52,35.69 30.52,32.36 37.95,26.78 30.7,38.87 20.01,80.75 41.09,81.05 67.78,81.43 64.67,35.07 64.67,35.07 66.07,38.57 72.31,46.5 76.79,49.7", $e, 9.47),
        c("M 81,17.04 C 84.87,17.04 88,20.18 88,24.04 88,27.91 84.87,31.04 81,31.04 77.13,31.04 74,27.91 74,24.04 74,20.18 77.13,17.04 81,17.04 Z M 81,17.04", $e, 5),
        c("M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81", $e, 7),
        c("M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78", $e, 7)
    ]), l([
        168,
        47,
        13,
        113
    ]), 1, "pyo", "\u3074\u3087", 0), Yl = A7(ef, 103, l([
        c("M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43", $e, 10),
        c("M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67", $e, 10),
        c("M 87.99,12.09 C 91.86,12.09 94.99,15.22 94.99,19.09 94.99,22.95 91.86,26.09 87.99,26.09 84.13,26.09 80.99,22.95 80.99,19.09 80.99,15.22 84.13,12.09 87.99,12.09 Z M 87.99,12.09", $e, 5),
        c("M 110.52,45 L 144,45 144,83", $e, 7),
        c("M 111.57,62.7 L 142.95,62.7", $e, 7),
        c("M 110,80.4 L 143.48,80.4", $e, 7)
    ]), l([
        47,
        110,
        47,
        72,
        32,
        34
    ]), 1, "pyo", "\u30D4\u30E7", 0), Xl = A7(ef, 102, l([
        c("M 13.78,36.93 C 21.52,35.69 30.52,32.36 37.95,26.78 30.7,38.87 20.01,80.75 41.09,81.05 67.78,81.43 64.67,35.07 64.67,35.07 66.07,38.57 72.31,46.5 76.79,49.7", $e, 9.47),
        c("M 81,17.04 C 84.87,17.04 88,20.18 88,24.04 88,27.91 84.87,31.04 81,31.04 77.13,31.04 74,27.91 74,24.04 74,20.18 77.13,17.04 81,17.04 Z M 81,17.04", $e, 5),
        c("M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07", $e, 7),
        c("M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34", $e, 7)
    ]), l([
        168,
        47,
        107,
        47
    ]), 1, "pyu", "\u3074\u3085", 0), nv = A7(ef, 102, l([
        c("M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43", $e, 10),
        c("M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67", $e, 10),
        c("M 87.99,12.09 C 91.86,12.09 94.99,15.22 94.99,19.09 94.99,22.95 91.86,26.09 87.99,26.09 84.13,26.09 80.99,22.95 80.99,19.09 80.99,15.22 84.13,12.09 87.99,12.09 Z M 87.99,12.09", $e, 5),
        c("M 112.73,48.63 L 140.23,48.63 137.64,77.53", $e, 7),
        c("M 107.02,80.13 L 148.02,80.13", $e, 7)
    ]), l([
        47,
        110,
        47,
        57,
        42
    ]), 1, "pyu", "\u30D4\u30E5", 0), rv = A7(ef, 39, l([
        c("M 43.84,19.78 C 46.8,23.94 53.73,26.94 58.23,28.54", $e, 9.47),
        c("M 40.5,33.55 C 34.87,42.94 32.78,62.75 32.78,62.75 32.78,62.75 47.43,40.69 61.57,51.49 74.94,61.71 62.61,82.07 48.43,80.9", $e, 9.47)
    ]), l([
        19,
        109
    ]), 1, "ra", "\u3089", 0), ev = A7(ef, 39, l([
        c("M 26,20 L 72.4,20", $e, 10),
        c("M 22,37.37 L 78,37.37 C 78,37.37 78.75,67.37 36.19,80", $e, 10)
    ]), l([
        47,
        120
    ]), 1, "ra", "\u30E9", 0), tv = A7(ef, 42, l([
        c("M 40.19,18.78 C 37.38,42.75 36.47,60.32 38.5,80.55", $e, 9.47),
        c("M 25.12,32 C 31.66,34.1 45.19,27.3 45.19,27.3 38.51,42.91 35.38,56.72 20.78,74.91 44.51,46.01 61.83,21.69 75.67,27.8 67.88,47.15 66.61,73.64 78.47,79.81", $e, 9.47)
    ]), l([
        63,
        207
    ]), 1, "re", "\u308C", 0), av = A7(ef, 42, l([
        c("M 35,20 L 35,80 C 35,80 59.92,75 81,50.77", $e, 10)
    ]), l([
        116
    ]), 1, "re", "\u30EC", 0), uv = A7(ef, 40, l([
        c("M 39.59,18.89 C 36.04,25.9 35.82,41.79 39.15,46.91", $e, 9.47),
        c("M 61.25,18.79 C 70.01,47.51 54.78,74.87 46.39,81.82", $e, 9.47)
    ]), l([
        30,
        69
    ]), 1, "ri", "\u308A", 0), iv = A7(ef, 40, l([
        c("M 29,21.54 L 29,55.38", $e, 10),
        c("M 70,20 L 70,43.85 C 70,43.85 69.23,76.15 43.7,80", $e, 10)
    ]), l([
        34,
        73
    ]), 1, "ri", "\u30EA", 0), ov = A7(ef, 43, l([
        c("M 33.14,19.87 C 49.26,24.67 61.89,19.78 61.89,19.78 54.39,26.63 38.48,42.79 26.78,54.29 26.78,54.29 59.6,24.16 69.21,39.16 79.73,55.6 63.36,75.45 46.31,79.7", $e, 9.47)
    ]), l([
        186
    ]), 1, "ro", "\u308D", 0), cv = A7(ef, 43, l([
        c("M 20,21 L 20,80", $e, 10),
        c("M 20,21 L 80,21 80,80", $e, 10),
        c("M 20.88,75.6 L 80,75.6", $e, 10)
    ]), l([
        59,
        120,
        59
    ]), 1, "ro", "\u30ED", 0), fv = A7(ef, 41, l([
        c("M 36.42,21.9 C 49.97,22.61 64.01,19.78 64.01,19.78 64.01,19.78 27.67,50.37 26.01,51.94 22.54,55.24 59.79,26.4 70.31,44.29 77.92,57.25 61.77,80.07 46.59,80.34 35,80.55 36.92,68.49 43.21,65.86 51.87,62.24 55.69,69.48 59.43,71.75", $e, 9.47)
    ]), l([
        218
    ]), 1, "ru", "\u308B", 0), bv = A7(ef, 41, l([
        c("M 33.75,22.82 C 33.75,22.82 37.5,73.55 20,78.5", $e, 10),
        c("M 56.67,22 L 56.67,76.44 C 56.67,76.44 75,71.9 85,52.93", $e, 10)
    ]), l([
        61,
        94
    ]), 1, "ru", "\u30EB", 0), sv = A7(ef, 89, l([
        c("M 49.59,18.89 C 46.04,25.9 45.82,41.79 49.15,46.91", $e, 9.47),
        c("M 71.25,18.79 C 80.01,47.51 64.78,74.87 56.39,81.82", $e, 9.47),
        c("M 95,56.64 C 100.57,59.29 127.47,44.95 130.85,48.53 136.28,54.28 127.73,61.36 125.83,64.75", $e, 7),
        c("M 116.46,42.78 C 116.46,47.06 118.99,55.36 120.8,58.11", $e, 7),
        c("M 100.02,46.03 C 102.61,48.09 115.51,76.39 115.23,82.73", $e, 7)
    ]), l([
        30,
        69,
        56,
        17,
        40
    ]), 1, "rya", "\u308A\u3083", 0), Mv = A7(ef, 89, l([
        c("M 36,21.54 L 36,55.38", $e, 10),
        c("M 77,20 L 77,43.85 C 77,43.85 76.23,76.15 50.7,80", $e, 10),
        c("M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92", $e, 7),
        c("M 115.35,43.46 L 123.45,81.46", $e, 7)
    ]), l([
        34,
        73,
        55,
        39
    ]), 1, "rya", "\u30EA\u30E3", 0), dv = A7(ef, 91, l([
        c("M 39.59,18.89 C 36.04,25.9 35.82,41.79 39.15,46.91", $e, 9.47),
        c("M 61.25,18.79 C 70.01,47.51 54.78,74.87 46.39,81.82", $e, 9.47),
        c("M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81", $e, 7),
        c("M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78", $e, 7)
    ]), l([
        30,
        69,
        13,
        113
    ]), 1, "ryo", "\u308A\u3087", 0), Cv = A7(ef, 91, l([
        c("M 36,21.54 L 36,55.38", $e, 10),
        c("M 77,20 L 77,43.85 C 77,43.85 76.23,76.15 50.7,80", $e, 10),
        c("M 110.52,45 L 144,45 144,83", $e, 7),
        c("M 111.57,62.7 L 142.95,62.7", $e, 7),
        c("M 110,80.4 L 143.48,80.4", $e, 7)
    ]), l([
        34,
        73,
        72,
        32,
        34
    ]), 1, "ryo", "\u30EA\u30E7", 0), lv = A7(ef, 90, l([
        c("M 39.59,18.89 C 36.04,25.9 35.82,41.79 39.15,46.91", $e, 9.47),
        c("M 61.25,18.79 C 70.01,47.51 54.78,74.87 46.39,81.82", $e, 9.47),
        c("M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07", $e, 7),
        c("M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34", $e, 7)
    ]), l([
        30,
        69,
        107,
        47
    ]), 1, "ryu", "\u308A\u3085", 0), vv = A7(ef, 90, l([
        c("M 36,21.54 L 36,55.38", $e, 10),
        c("M 77,20 L 77,43.85 C 77,43.85 76.23,76.15 50.7,80", $e, 10),
        c("M 112.73,48.63 L 140.23,48.63 137.64,77.53", $e, 7),
        c("M 107.02,80.13 L 148.02,80.13", $e, 7)
    ]), l([
        34,
        73,
        57,
        42
    ]), 1, "ryu", "\u30EA\u30E5", 0), gv = A7(ef, 11, l([
        c("M 25.78,34.46 C 33.37,38.49 69,36.15 74.08,33.2", $e, 9.47),
        c("M 47.99,17.78 C 47.99,21.8 60.65,47.48 63.88,54 64.63,55.52 55.22,61.42 55.22,61.42", $e, 9.47),
        c("M 31.92,67.95 C 34.87,77.86 47.45,83.64 60.84,82.84", $e, 9.47)
    ]), l([
        49,
        52,
        35
    ]), 1, "sa", "\u3055", 0), hv = A7(ef, 11, l([
        c("M 20,36.91 L 79.5,36.91", $e, 10),
        c("M 34.59,21.78 L 34.59,54.38", $e, 10),
        c("M 65.3,21 L 65.3,55.16 C 65.3,55.16 63.38,75.73 44.57,80", $e, 10)
    ]), l([
        60,
        34,
        69
    ]), 1, "sa", "\u30B5", 0), pv = A7(ef, 14, l([
        c("M 18.78,46.19 C 24.68,49.66 75.53,42.96 80.73,40.88", $e, 9.47),
        c("M 66.95,21.58 C 68.69,28.87 64.56,51.81 62.41,57.71", $e, 9.47),
        c("M 34.48,19.78 C 38.46,30.3 27.24,70.84 39.94,77.72 48.27,82.23 68.11,77.37 68.11,77.37", $e, 9.47)
    ]), l([
        63,
        37,
        89
    ]), 1, "se", "\u305B", 0), Lv = A7(ef, 14, l([
        c("M 21,43.89 L 79,35.2 C 79,35.2 70.05,51.49 59.67,59.09", $e, 10),
        c("M 38.9,20 L 38.19,72.49 C 38.19,72.49 38.9,85.16 76.49,78.28", $e, 10)
    ]), l([
        90,
        94
    ]), 1, "se", "\u30BB", 0), wv = A7(ef, 74, l([
        c("M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42", $e, 9.47),
        c("M 92.78,56.64 C 98.35,59.29 125.25,44.95 128.64,48.53 134.07,54.28 125.51,61.36 123.61,64.75", $e, 7),
        c("M 114.24,42.78 C 114.24,47.06 116.78,55.36 118.59,58.11", $e, 7),
        c("M 97.81,46.03 C 100.39,48.09 113.29,76.39 113.02,82.73", $e, 7)
    ]), l([
        111,
        56,
        17,
        40
    ]), 1, "sha", "\u3057\u3083", 0), Zv = A7(ef, 74, l([
        c("M 32.87,20 C 32.87,20 43.09,22.34 50.96,27.79", $e, 10),
        c("M 25,38.7 C 25,38.7 35.23,41.04 43.09,46.49", $e, 10),
        c("M 31.29,80 C 31.29,80 65.91,72.21 84,37.14", $e, 10),
        c("M 100,57.44 C 100,57.44 134.04,51.92 135.75,51.52 137.45,51.13 130.21,60.59 124.26,64.92", $e, 7),
        c("M 110.35,43.46 L 118.45,81.46", $e, 7)
    ]), l([
        20,
        20,
        70,
        55,
        39
    ]), 1, "sha", "\u30B7\u30E3", 0), mv = A7(ef, 12, l([
        c("M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42", $e, 9.47)
    ]), l([
        111
    ]), 1, "shi", "\u3057", 0), Sv = A7(ef, 12, l([
        c("M 32.87,20 C 32.87,20 43.09,22.34 50.96,27.79", $e, 10),
        c("M 25,38.7 C 25,38.7 35.23,41.04 43.09,46.49", $e, 10),
        c("M 31.29,80 C 31.29,80 65.91,72.21 84,37.14", $e, 10)
    ]), l([
        20,
        20,
        70
    ]), 1, "shi", "\u30B7", 0), $v = A7(ef, 76, l([
        c("M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42", $e, 9.47),
        c("M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81", $e, 7),
        c("M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78", $e, 7)
    ]), l([
        111,
        13,
        113
    ]), 1, "sho", "\u3057\u3087", 0), Dv = A7(ef, 76, l([
        c("M 39.87,20 C 39.87,20 50.09,22.34 57.96,27.79", $e, 10),
        c("M 32,38.7 C 32,38.7 42.23,41.04 50.09,46.49", $e, 10),
        c("M 38.29,80 C 38.29,80 72.91,72.21 91,37.14", $e, 10),
        c("M 110.52,45 L 144,45 144,83", $e, 7),
        c("M 111.57,62.7 L 142.95,62.7", $e, 7),
        c("M 110,80.4 L 143.48,80.4", $e, 7)
    ]), l([
        20,
        20,
        70,
        72,
        32,
        34
    ]), 1, "sho", "\u30B7\u30E7", 0), yv = A7(ef, 75, l([
        c("M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42", $e, 9.47),
        c("M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07", $e, 7),
        c("M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34", $e, 7)
    ]), l([
        111,
        107,
        47
    ]), 1, "shu", "\u3057\u3085", 0), zv = A7(ef, 75, l([
        c("M 39.87,20 C 39.87,20 50.09,22.34 57.96,27.79", $e, 10),
        c("M 32,38.7 C 32,38.7 42.23,41.04 50.09,46.49", $e, 10),
        c("M 38.29,80 C 38.29,80 72.91,72.21 91,37.14", $e, 10),
        c("M 112.73,48.63 L 140.23,48.63 137.64,77.53", $e, 7),
        c("M 107.02,80.13 L 148.02,80.13", $e, 7)
    ]), l([
        20,
        20,
        70,
        57,
        42
    ]), 1, "shu", "\u30B7\u30E5", 0), Kv = A7(ef, 15, l([
        c("M 38.01,17.78 C 44.31,23.61 64.91,18.71 64.91,18.98 64.91,18.98 39.66,36.29 27.78,47.31 51.44,41.14 62.09,44.1 72.34,45.11 53.34,55.2 41.51,70.92 53.06,81.69", $e, 9.47)
    ]), l([
        171
    ]), 1, "so", "\u305D", 0), xv = A7(ef, 15, l([
        c("M 26,26.97 C 26,26.97 34,35.53 38.67,46.71", $e, 10),
        c("M 74,25 C 74,25 68,61.18 35.33,75", $e, 10)
    ]), l([
        24,
        66
    ]), 1, "so", "\u30BD", 0), Hv = A7(ef, 13, l([
        c("M 22.78,27.69 C 29.68,32.52 73.2,29.36 78.1,27.55", $e, 9.47),
        c("M 55.98,16.78 C 55.21,24.27 63.56,60.21 46.95,61.15 41.95,61.42 36.79,55.86 38.69,50.05 41.84,40.41 58.24,40.5 57.78,53.41 57.43,63.23 58.5,76.46 47.72,83.19", $e, 9.47)
    ]), l([
        57,
        128
    ]), 1, "su", "\u3059", 0), kv = A7(ef, 13, l([
        c("M 25.18,23 L 66.65,23 C 66.65,23 56.28,60.57 18,77", $e, 10),
        c("M 53.49,53.91 C 53.49,53.91 68.64,64.09 81,76.22", $e, 10)
    ]), l([
        117,
        36
    ]), 1, "su", "\u30B9", 0), Bv = A7(ef, 16, l([
        c("M 26.53,35.58 C 35.03,40.2 60.03,37.28 65.03,35.82", $e, 9.47),
        c("M 49.28,18.78 C 44.53,26.33 30.53,69.65 23.78,81.09", $e, 9.47),
        c("M 51.78,53.34 C 55.78,55.53 70.68,48.07 76.53,52.37", $e, 9.47),
        c("M 48.78,75.49 C 54.78,79.87 66.03,83.28 77.03,79.63", $e, 9.47)
    ]), l([
        39,
        68,
        26,
        30
    ]), 1, "ta", "\u305F", 0), Ov = A7(ef, 16, l([
        c("M 46.11,20 C 46.11,20 41.26,37.86 26,49.29", $e, 10),
        c("M 45.07,28.21 L 73.5,28.21 C 73.5,28.21 71.77,64.29 32.93,80", $e, 10),
        c("M 43.68,46.07 C 53.74,50 65.53,60.71 65.53,60.71", $e, 10)
    ]), l([
        37,
        98,
        27
    ]), 1, "ta", "\u30BF", 0), Gv = A7(ef, 19, l([
        c("M 21.78,22.5 C 29.99,28.78 71.55,20.78 78.64,20.78 51.59,34.58 32.17,54.16 56.94,79.04", $e, 9.47)
    ]), l([
        136
    ]), 1, "te", "\u3066", 0), Wv = A7(ef, 19, l([
        c("M 27.5,21 L 71,21", $e, 10),
        c("M 20,42.09 L 80,42.09", $e, 10),
        c("M 51.5,44.73 C 51.5,44.73 51.12,69.96 31.62,79", $e, 10)
    ]), l([
        44,
        60,
        42
    ]), 1, "te", "\u30C6", 0), qv = A7(ef, 20, l([
        c("M 25.78,19.78 C 27.99,25.66 35.38,41.46 40.32,44.85", $e, 9.47),
        c("M 70.21,28.56 C 50.35,44.91 24.85,51.41 26.33,68.69 27.5,82.41 48.38,80.86 73.52,80.01", $e, 9.47)
    ]), l([
        31,
        116
    ]), 1, "to", "\u3068", 0), Uv = A7(ef, 20, l([
        c("M 40,20 L 40,80", $e, 10),
        c("M 42.57,44.22 C 42.57,44.22 56.13,46.75 73,53.98", $e, 10)
    ]), l([
        60,
        33
    ]), 1, "to", "\u30C8", 0), Av = A7(ef, 18, l([
        c("M 21.78,38.74 C 30.41,46.04 67.51,19.79 75.18,36.4 84.42,56.4 56.84,70.78 43.9,70.52", $e, 9.47)
    ]), l([
        112
    ]), 1, "tsu", "\u3064", 0), Ev = A7(ef, 18, l([
        c("M 22,34.41 C 22,34.41 27.15,41.54 30.82,49.37", $e, 10),
        c("M 41.11,28 C 41.11,28 46.26,35.12 49.93,42.96", $e, 10),
        c("M 77.5,29.78 C 77.5,29.78 72.35,69.68 37.07,82.5", $e, 10)
    ]), l([
        18,
        18,
        70
    ]), 1, "tsu", "\u30C4", 0), Tv = A7(ef, 3, l([
        c("M 43.89,16.78 C 50.22,19.5 55.18,20.76 56.94,23.52", $e, 9.47),
        c("M 34.78,43.76 C 43.52,31.89 65.39,33.6 65.56,48.69 65.7,60.69 59,68.69 49.09,82.64", $e, 9.47)
    ]), l([
        16,
        80
    ]), 1, "u", "\u3046", 0), Iv = A7(ef, 3, l([
        c("M 52.19,17 L 52.19,28.18", $e, 10),
        c("M 25,32.17 L 25,51.34", $e, 10),
        c("M 25.81,31.77 L 81,31.77 C 81,31.77 81.81,70.92 42.86,84.5", $e, 10)
    ]), l([
        12,
        20,
        125
    ]), 1, "u", "\u30A6", 0), jv = A7(ef, 44, l([
        c("M 41.28,20.78 C 41.41,33.41 38.62,61.69 38.7,78.57", $e, 9.47),
        c("M 26.16,34.93 C 30.9,34.73 39.53,38.29 39.53,38.29 L 20.78,73.88 C 20.78,73.88 48.25,29.14 68.51,29.73 84.53,30.2 83.02,74.16 66.51,79.04", $e, 9.47)
    ]), l([
        59,
        181
    ]), 1, "wa", "\u308F", 0), Rv = A7(ef, 44, l([
        c("M 25,20.89 L 25,44.31", $e, 10),
        c("M 25,20.5 L 74.51,20.5 C 74.51,20.5 76.81,70.07 36.13,81", $e, 10)
    ]), l([
        24,
        127
    ]), 1, "wa", "\u30EF", 0), Qv = A7(ef, 9999, l([
        c("M 20.71,25 L 79.64,25 C 79.64,25 72.96,40.45 57.25,51.27", $e, 10),
        c("M 44,42.39 L 44,73.3", $e, 10),
        c("M 19,76 C 22.57,76 79,76 79,76", $e, 10)
    ]), l([
        94,
        32,
        60
    ]), 1, "we", "\u30F1", 0), Pv = A7(ef, 9999, l([
        c("M 22.27,31.34 L 78.59,31.34", $e, 10),
        c("M 35.07,33.47 L 35.07,63.27", $e, 10),
        c("M 18,65.82 L 82,65.82", $e, 10),
        c("M 61.52,19 L 61.52,82", $e, 10)
    ]), l([
        57,
        30,
        64,
        64
    ]), 1, "wi", "\u30F0", 0), Vv = A7(ef, 45, l([
        c("M 33.43,31.3 C 39.64,31.98 57.86,27.66 57.86,27.66", $e, 9.47),
        c("M 51.42,18.78 C 37.07,46.85 41.88,38.29 34.76,49.27 39.46,46.06 39.28,44.21 46.31,43.81 52.05,43.48 59.32,50.69 58.97,58.14", $e, 9.47),
        c("M 65.63,39.49 C 60.52,42.67 26.2,67.74 32.57,76.34 38.18,83.91 67.98,78.39 67.98,78.39", $e, 9.47)
    ]), l([
        25,
        69,
        89
    ]), 1, "wo", "\u3092", 0), Fv = A7(ef, 45, l([
        c("M 23,21 L 75.01,21", $e, 10),
        c("M 26.2,45 L 71.01,45", $e, 10),
        c("M 75.01,21 C 75.01,21 77.41,66.6 39.8,81", $e, 10)
    ]), l([
        53,
        46,
        74
    ]), 1, "wo", "\u30F2", 0), Nv = A7(ef, 36, l([
        c("M 18.78,40.92 C 27.9,44.97 71.95,23.09 77.5,28.55 86.4,37.33 72.39,48.12 69.27,53.29", $e, 9.47),
        c("M 53.92,19.78 C 53.92,26.3 58.08,38.97 61.04,43.17", $e, 9.47),
        c("M 27.01,24.73 C 31.24,27.88 52.37,71.06 51.92,80.73", $e, 9.47)
    ]), l([
        90,
        26,
        62
    ]), 1, "ya", "\u3084", 0), Jv = A7(ef, 36, l([
        c("M 37.39,20 L 50.21,80", $e, 10),
        c("M 21,42.06 C 21,42.06 74.9,33.35 77.6,32.72 80.29,32.1 68.84,47.04 59.41,53.88", $e, 10)
    ]), l([
        62,
        86
    ]), 1, "ya", "\u30E4", 0), _v = A7(ef, 38, l([
        c("M 57.72,32.5 C 60.09,33.69 71.44,30.14 71.44,30.14", $e, 9.47),
        c("M 52.75,18.78 C 55.83,27.06 59,70 42,75 23.73,80.37 19.01,73.11 28.15,64.2 37.37,55.21 69.52,66.75 75.94,73.9", $e, 9.47)
    ]), l([
        17,
        170
    ]), 1, "yo", "\u3088", 0), Yv = A7(ef, 38, l([
        c("M 23.82,20 L 76,20 76,80", $e, 10),
        c("M 25.45,47.95 L 74.37,47.95", $e, 10),
        c("M 23,75.89 L 75.18,75.89", $e, 10)
    ]), l([
        113,
        50,
        52
    ]), 1, "yo", "\u30E8", 0), Xv = A7(ef, 37, l([
        c("M 22.79,32.71 C 28.77,41.7 27.38,55.36 27.38,55.36 30.56,31.39 76.28,13.43 77.69,39.57 78.74,58.99 48.98,71.13 40.07,60.13", $e, 9.47),
        c("M 51.01,18.79 C 59.54,42.49 57.79,72.61 51.88,81.12", $e, 9.47)
    ]), l([
        148,
        65
    ]), 1, "yu", "\u3086", 0), ng = A7(ef, 37, l([
        c("M 27.63,27 L 69.23,27 65.3,69.66", $e, 10),
        c("M 19,73.5 L 81,73.5", $e, 10)
    ]), l([
        85,
        62
    ]), 1, "yu", "\u30E6", 0), rg = A7(ef, 52, l([
        c("M 25.78,34.46 C 33.37,38.49 69,36.15 74.08,33.2", $e, 9.47),
        c("M 47.99,17.78 C 47.99,21.8 60.65,47.48 63.88,54 64.63,55.52 55.22,61.42 55.22,61.42", $e, 9.47),
        c("M 31.92,67.95 C 34.87,77.86 47.45,83.64 60.84,82.84", $e, 9.47),
        c("M 77.31,16 C 77.31,16 79.98,16 82.64,19 85.31,22 85.31,25 85.31,25", Se("M 75.13,15.06 C 74.83,15.35 74.99,15.53 76.27,16.3 78.68,17.76 81.7,21.22 83.95,25.13 84.8,26.59 85.52,27.16 86.31,26.96 87.95,26.56 87.48,21.6 85.57,19.32 84.69,18.26 81.52,16.67 78.37,15.7 75.69,14.89 75.37,14.82 75.13,15.06 Z M 75.13,15.06"), 5),
        c("M 82.31,10 C 82.31,10 84.98,10 87.64,13 90.31,16 90.31,19 90.31,19", Se("M 80.13,9.06 C 79.83,9.35 79.99,9.53 81.27,10.3 83.68,11.76 86.7,15.22 88.95,19.13 89.8,20.59 90.52,21.16 91.31,20.96 92.95,20.56 92.48,15.6 90.57,13.32 89.69,12.26 86.52,10.67 83.37,9.7 80.69,8.89 80.37,8.82 80.13,9.06 Z M 80.13,9.06"), 5)
    ]), l([
        49,
        52,
        35,
        14,
        14
    ]), 1, "za", "\u3056", 0), eg = A7(ef, 52, l([
        c("M 16.2,41.71 L 75.7,41.71", $e, 10),
        c("M 30.79,26.57 L 30.79,59.18", $e, 10),
        c("M 61.5,25.8 L 61.5,59.95 C 61.5,59.95 59.58,80.53 40.77,84.8", $e, 10),
        c("M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06", Se("M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12"), 5),
        c("M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06", Se("M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12"), 5)
    ]), l([
        60,
        34,
        69,
        14,
        14
    ]), 1, "za", "\u30B6", 0), tg = A7(ef, 55, l([
        c("M 18.78,46.19 C 24.68,49.66 75.53,42.96 80.73,40.88", $e, 9.47),
        c("M 66.95,21.58 C 68.69,28.87 64.56,51.81 62.41,57.71", $e, 9.47),
        c("M 34.48,19.78 C 38.46,30.3 27.24,70.84 39.94,77.72 48.27,82.23 68.11,77.37 68.11,77.37", $e, 9.47),
        c("M 77.31,15 C 77.31,15 79.98,15 82.64,18 85.31,21 85.31,24 85.31,24", Se("M 75.13,14.06 C 74.83,14.35 74.99,14.53 76.27,15.3 78.68,16.76 81.7,20.22 83.95,24.13 84.8,25.59 85.52,26.16 86.31,25.96 87.95,25.56 87.48,20.6 85.57,18.32 84.69,17.26 81.52,15.67 78.37,14.7 75.69,13.89 75.37,13.82 75.13,14.06 Z M 75.13,14.06"), 5),
        c("M 82.31,9 C 82.31,9 84.98,9 87.64,12 90.31,15 90.31,18 90.31,18", Se("M 80.13,8.06 C 79.83,8.35 79.99,8.53 81.27,9.3 83.68,10.76 86.7,14.22 88.95,18.13 89.8,19.59 90.52,20.16 91.31,19.96 92.95,19.56 92.48,14.6 90.57,12.32 89.69,11.26 86.52,9.67 83.37,8.7 80.69,7.89 80.37,7.82 80.13,8.06 Z M 80.13,8.06"), 5)
    ]), l([
        63,
        37,
        89,
        14,
        14
    ]), 1, "ze", "\u305C", 0), ag = A7(ef, 55, l([
        c("M 21,43.89 L 79,35.2 C 79,35.2 70.05,51.49 59.67,59.09", $e, 10),
        c("M 38.9,20 L 38.19,72.49 C 38.19,72.49 38.9,85.16 76.49,78.28", $e, 10),
        c("M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06", Se("M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12"), 5),
        c("M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06", Se("M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12"), 5)
    ]), l([
        90,
        94,
        14,
        14
    ]), 1, "ze", "\u30BC", 0), ug = A7(ef, 53, l([
        c("M 68.61,20 C 47.01,28.33 26.23,28.33 26.23,28.33", $e, 10),
        c("M 20,47.08 L 79,47.08", $e, 10),
        c("M 50.33,27.5 L 50.33,49.17 C 50.33,49.17 49.5,72.5 32.05,80", $e, 10),
        c("M 72.31,29.06 C 72.31,29.06 74.98,29.06 77.64,32.06 80.31,35.06 80.31,38.06 80.31,38.06", Se("M 70.13,28.12 C 69.83,28.41 69.99,28.59 71.27,29.36 73.68,30.82 76.7,34.28 78.95,38.19 79.8,39.65 80.52,40.22 81.31,40.02 82.95,39.63 82.48,34.66 80.57,32.38 79.69,31.33 76.52,29.74 73.37,28.76 70.69,27.95 70.37,27.88 70.13,28.12 Z M 70.13,28.12"), 5),
        c("M 77.31,23.06 C 77.31,23.06 79.98,23.06 82.64,26.06 85.31,29.06 85.31,32.06 85.31,32.06", Se("M 75.13,22.12 C 74.83,22.41 74.99,22.59 76.27,23.36 78.68,24.82 81.7,28.28 83.95,32.19 84.8,33.65 85.52,34.22 86.31,34.02 87.95,33.63 87.48,28.66 85.57,26.38 84.69,25.33 81.52,23.74 78.37,22.76 75.69,21.95 75.37,21.88 75.13,22.12 Z M 75.13,22.12"), 5)
    ]), l([
        44,
        60,
        60,
        14,
        14
    ]), 1, "zi", "\u30C2", 0), ig = A7(ef, 56, l([
        c("M 38.01,17.78 C 44.31,23.61 64.91,18.71 64.91,18.98 64.91,18.98 39.66,36.29 27.78,47.31 51.44,41.14 62.09,44.1 72.34,45.11 53.34,55.2 41.51,70.92 53.06,81.69", $e, 9.47),
        c("M 77.31,15 C 77.31,15 79.98,15 82.64,18 85.31,21 85.31,24 85.31,24", Se("M 75.13,14.06 C 74.83,14.35 74.99,14.53 76.27,15.3 78.68,16.76 81.7,20.22 83.95,24.13 84.8,25.59 85.52,26.16 86.31,25.96 87.95,25.56 87.48,20.6 85.57,18.32 84.69,17.26 81.52,15.67 78.37,14.7 75.69,13.89 75.37,13.82 75.13,14.06 Z M 75.13,14.06"), 5),
        c("M 82.31,9 C 82.31,9 84.98,9 87.64,12 90.31,15 90.31,18 90.31,18", Se("M 80.13,8.06 C 79.83,8.35 79.99,8.53 81.27,9.3 83.68,10.76 86.7,14.22 88.95,18.13 89.8,19.59 90.52,20.16 91.31,19.96 92.95,19.56 92.48,14.6 90.57,12.32 89.69,11.26 86.52,9.67 83.37,8.7 80.69,7.89 80.37,7.82 80.13,8.06 Z M 80.13,8.06"), 5)
    ]), l([
        171,
        14,
        14
    ]), 1, "zo", "\u305E", 0), og = A7(ef, 56, l([
        c("M 28.21,35.31 C 28.21,35.31 36.21,43.87 40.88,55.05", $e, 10),
        c("M 76.21,33.34 C 76.21,33.34 70.21,69.52 37.55,83.34", $e, 10),
        c("M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06", Se("M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12"), 5),
        c("M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06", Se("M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12"), 5)
    ]), l([
        24,
        66,
        14,
        14
    ]), 1, "zo", "\u30BE", 0), cg = A7(ef, 54, l([
        c("M 22.78,32.69 C 29.68,37.52 73.2,34.36 78.1,32.55", $e, 9.47),
        c("M 55.98,21.78 C 55.21,29.27 63.56,65.21 46.95,66.15 41.95,66.42 36.79,60.86 38.69,55.05 41.84,45.41 58.24,45.5 57.78,58.41 57.43,68.23 58.5,81.46 47.72,88.19", $e, 9.47),
        c("M 77.31,15 C 77.31,15 79.98,15 82.64,18 85.31,21 85.31,24 85.31,24", Se("M 75.13,14.06 C 74.83,14.35 74.99,14.53 76.27,15.3 78.68,16.76 81.7,20.22 83.95,24.13 84.8,25.59 85.52,26.16 86.31,25.96 87.95,25.56 87.48,20.6 85.57,18.32 84.69,17.26 81.52,15.67 78.37,14.7 75.69,13.89 75.37,13.82 75.13,14.06 Z M 75.13,14.06"), 5),
        c("M 82.31,9 C 82.31,9 84.98,9 87.64,12 90.31,15 90.31,18 90.31,18", Se("M 80.13,8.06 C 79.83,8.35 79.99,8.53 81.27,9.3 83.68,10.76 86.7,14.22 88.95,18.13 89.8,19.59 90.52,20.16 91.31,19.96 92.95,19.56 92.48,14.6 90.57,12.32 89.69,11.26 86.52,9.67 83.37,8.7 80.69,7.89 80.37,7.82 80.13,8.06 Z M 80.13,8.06"), 5)
    ]), l([
        57,
        128,
        14,
        14
    ]), 1, "zu", "\u305A", 0), fg = A7(ef, 54, l([
        c("M 25.18,23 L 66.65,23 C 66.65,23 56.28,60.57 18,77", $e, 10),
        c("M 53.49,53.91 C 53.49,53.91 68.64,64.09 81,76.22", $e, 10),
        c("M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06", Se("M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12"), 5),
        c("M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06", Se("M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12"), 5)
    ]), l([
        117,
        36,
        14,
        14
    ]), 1, "zu", "\u30BA", 0), bg = A7(ef, 58, l([
        c("M 21.78,38.74 C 30.41,46.04 67.51,19.79 75.18,36.4 84.42,56.4 56.84,70.78 43.9,70.52", $e, 9.47),
        c("M 78.31,17 C 78.31,17 80.98,17 83.64,20 86.31,23 86.31,26 86.31,26", Se("M 76.13,16.06 C 75.83,16.35 75.99,16.53 77.27,17.3 79.68,18.76 82.7,22.22 84.95,26.13 85.8,27.59 86.52,28.16 87.31,27.96 88.95,27.56 88.48,22.6 86.57,20.32 85.69,19.26 82.52,17.67 79.37,16.7 76.69,15.89 76.37,15.82 76.13,16.06 Z M 76.13,16.06"), 5),
        c("M 83.31,11 C 83.31,11 85.98,11 88.64,14 91.31,17 91.31,20 91.31,20", Se("M 81.13,10.06 C 80.83,10.35 80.99,10.53 82.27,11.3 84.68,12.76 87.7,16.22 89.95,20.13 90.8,21.59 91.52,22.16 92.31,21.96 93.95,21.56 93.48,16.6 91.57,14.32 90.69,13.26 87.52,11.67 84.37,10.7 81.69,9.89 81.37,9.82 81.13,10.06 Z M 81.13,10.06"), 5)
    ]), l([
        112,
        14,
        14
    ]), 1, "zu", "\u3065", 0), sg = A7(ef, 58, l([
        c("M 25.23,39.41 C 25.23,39.41 30.38,46.54 34.06,54.37", $e, 10),
        c("M 44.35,33 C 44.35,33 49.49,40.12 53.17,47.96", $e, 10),
        c("M 80.73,34.78 C 80.73,34.78 75.59,74.68 40.3,87.5", $e, 10),
        c("M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06", Se("M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12"), 5),
        c("M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06", Se("M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12"), 5)
    ]), l([
        18,
        18,
        70,
        14,
        14
    ]), 1, "zu", "\u30C5", 0), Mg = uu(l([
        o("\u3042", bd),
        o("\u3044", SC),
        o("\u3046", Tv),
        o("\u3048", jd),
        o("\u304A", ql),
        o("\u304B", EC),
        o("\u304D", RC),
        o("\u304F", NC),
        o("\u3051", IC),
        o("\u3053", VC),
        o("\u3055", gv),
        o("\u3057", mv),
        o("\u3059", Hv),
        o("\u305B", pv),
        o("\u305D", Kv),
        o("\u305F", Bv),
        o("\u3061", xd),
        o("\u3064", Av),
        o("\u3066", Gv),
        o("\u3068", qv),
        o("\u306A", wl),
        o("\u306B", $l),
        o("\u306C", Kl),
        o("\u306D", ml),
        o("\u306E", yl),
        o("\u306F", bC),
        o("\u3072", CC),
        o("\u3075", Pd),
        o("\u3078", MC),
        o("\u307B", vC),
        o("\u307E", tl),
        o("\u307F", ol),
        o("\u3080", sl),
        o("\u3081", ul),
        o("\u3082", fl),
        o("\u3084", Nv),
        o("\u3086", Xv),
        o("\u3088", _v),
        o("\u3089", rv),
        o("\u308A", uv),
        o("\u308B", fv),
        o("\u308C", tv),
        o("\u308D", ov),
        o("\u304C", Fd),
        o("\u304E", Yd),
        o("\u3050", eC),
        o("\u3052", Jd),
        o("\u3054", nC),
        o("\u3056", rg),
        o("\u3058", xC),
        o("\u305A", cg),
        o("\u305C", tg),
        o("\u305E", ig),
        o("\u3060", Wd),
        o("\u3062", Id),
        o("\u3065", bg),
        o("\u3067", Ud),
        o("\u3069", Ed),
        o("\u3070", Md),
        o("\u3073", vd),
        o("\u3076", Ld),
        o("\u3079", Cd),
        o("\u307C", hd),
        o("\u3071", Al),
        o("\u3074", jl),
        o("\u3077", Vl),
        o("\u307A", Tl),
        o("\u307D", Ql),
        o("\u308F", jv),
        o("\u3092", Vv),
        o("\u304D\u3083", _C),
        o("\u304D\u3085", rl),
        o("\u304D\u3087", XC),
        o("\u3057\u3083", wv),
        o("\u3057\u3085", yv),
        o("\u3057\u3087", $v),
        o("\u3061\u3083", zd),
        o("\u3061\u3085", Od),
        o("\u3061\u3087", kd),
        o("\u306B\u3083", Hl),
        o("\u306B\u3085", Gl),
        o("\u306B\u3087", Bl),
        o("\u3072\u3083", hC),
        o("\u3072\u3085", ZC),
        o("\u3072\u3087", LC),
        o("\u307F\u3083", dl),
        o("\u307F\u3085", gl),
        o("\u307F\u3087", ll),
        o("\u308A\u3083", sv),
        o("\u308A\u3085", lv),
        o("\u308A\u3087", dv),
        o("\u304E\u3083", aC),
        o("\u304E\u3085", cC),
        o("\u304E\u3087", iC),
        o("\u3058\u3083", DC),
        o("\u3058\u3085", WC),
        o("\u3058\u3087", kC),
        o("\u3062\u3083", zC),
        o("\u3062\u3085", UC),
        o("\u3062\u3087", OC),
        o("\u3073\u3083", Zd),
        o("\u3073\u3085", Dd),
        o("\u3073\u3087", Sd),
        o("\u3074\u3083", Nl),
        o("\u3074\u3085", Xl),
        o("\u3074\u3087", _l),
        o("\u3093", pl),
        o("\u30A2", sd),
        o("\u30A4", $C),
        o("\u30A6", Iv),
        o("\u30A8", Rd),
        o("\u30AA", Ul),
        o("\u30AB", TC),
        o("\u30AD", QC),
        o("\u30AF", JC),
        o("\u30B1", jC),
        o("\u30B3", FC),
        o("\u30B5", hv),
        o("\u30B7", Sv),
        o("\u30B9", kv),
        o("\u30BB", Lv),
        o("\u30BD", xv),
        o("\u30BF", Ov),
        o("\u30C1", Hd),
        o("\u30C4", Ev),
        o("\u30C6", Wv),
        o("\u30C8", Uv),
        o("\u30CA", Zl),
        o("\u30CB", Dl),
        o("\u30CC", xl),
        o("\u30CD", Sl),
        o("\u30CE", zl),
        o("\u30CF", sC),
        o("\u30D2", lC),
        o("\u30D5", Vd),
        o("\u30D8", dC),
        o("\u30DB", gC),
        o("\u30DE", al),
        o("\u30DF", cl),
        o("\u30E0", Ml),
        o("\u30E1", il),
        o("\u30E2", bl),
        o("\u30E4", Jv),
        o("\u30E6", ng),
        o("\u30E8", Yv),
        o("\u30E9", ev),
        o("\u30EA", iv),
        o("\u30EB", bv),
        o("\u30EC", av),
        o("\u30ED", cv),
        o("\u30EF", Rv),
        o("\u30F0", Pv),
        o("\u30F1", Qv),
        o("\u30F2", Fv),
        o("\u30F3", Ll),
        o("\u30AC", Nd),
        o("\u30AE", Xd),
        o("\u30B0", tC),
        o("\u30B2", _d),
        o("\u30B4", rC),
        o("\u30B6", eg),
        o("\u30B8", HC),
        o("\u30BA", fg),
        o("\u30BC", ag),
        o("\u30BE", og),
        o("\u30C0", qd),
        o("\u30C2", ug),
        o("\u30C5", sg),
        o("\u30C7", Ad),
        o("\u30C9", Td),
        o("\u30D0", dd),
        o("\u30D3", gd),
        o("\u30D6", wd),
        o("\u30D9", ld),
        o("\u30DC", pd),
        o("\u30D1", El),
        o("\u30D4", Rl),
        o("\u30D7", Fl),
        o("\u30DA", Il),
        o("\u30DD", Pl),
        o("\u30AD\u30E3", YC),
        o("\u30AD\u30E5", el),
        o("\u30AD\u30E7", nl),
        o("\u30B7\u30E3", Zv),
        o("\u30B7\u30E5", zv),
        o("\u30B7\u30E7", Dv),
        o("\u30C1\u30E3", Kd),
        o("\u30C1\u30E5", Gd),
        o("\u30C1\u30E7", Bd),
        o("\u30CB\u30E3", kl),
        o("\u30CB\u30E5", Wl),
        o("\u30CB\u30E7", Ol),
        o("\u30D2\u30E3", pC),
        o("\u30D2\u30E5", mC),
        o("\u30D2\u30E7", wC),
        o("\u30DF\u30E3", Cl),
        o("\u30DF\u30E5", hl),
        o("\u30DF\u30E7", vl),
        o("\u30EA\u30E3", Mv),
        o("\u30EA\u30E5", vv),
        o("\u30EA\u30E7", Cv),
        o("\u30AE\u30E3", uC),
        o("\u30AE\u30E5", fC),
        o("\u30AE\u30E7", oC),
        o("\u30B8\u30E3", yC),
        o("\u30B8\u30E5", qC),
        o("\u30B8\u30E7", BC),
        o("\u30C2\u30E3", KC),
        o("\u30C2\u30E5", AC),
        o("\u30C2\u30E7", GC),
        o("\u30D3\u30E3", md),
        o("\u30D3\u30E5", yd),
        o("\u30D3\u30E7", $d),
        o("\u30D4\u30E3", Jl),
        o("\u30D4\u30E5", nv),
        o("\u30D4\u30E7", Yl),
        o("\u30C3\u30AD", PC)
    ])), dg = function(n) {
        return A2(Qu, tf, A2(zu, n, Mg));
    }, Cg = function(n) {
        n: for(;;){
            if (!n.b) return M;
            if (!n.b.b) break n;
            switch(n.b.a){
                case "\u3083":
                    var r = n.b.b;
                    return A2(se, dg(n.a + "\u3083"), Cg(r));
                case "\u3085":
                    return r = n.b.b, A2(se, dg(n.a + "\u3085"), Cg(r));
                case "\u3087":
                    return r = n.b.b, A2(se, dg(n.a + "\u3087"), Cg(r));
                case "\u30E3":
                    return r = n.b.b, A2(se, dg(n.a + "\u30E3"), Cg(r));
                case "\u30E5":
                    return r = n.b.b, A2(se, dg(n.a + "\u30E5"), Cg(r));
                case "\u30E7":
                    return r = n.b.b, A2(se, dg(n.a + "\u30E7"), Cg(r));
                default:
                    switch(n.a){
                        case "\u30C3":
                            var e = n.b;
                            return r = e.b, A2(se, dg("\u30C3" + e.a), Cg(r));
                        case "\u3063":
                            var t = n.b;
                            return r = t.b, A2(se, dg("\u3063" + t.a), Cg(r));
                        default:
                            break n;
                    }
            }
        }
        return r = n.b, A2(se, dg(n.a), Cg(r));
    }, lg = function(n) {
        return Cg(A2(xe, "", n));
    }, vg = F2(function(n, r) {
        return b(r, {
            bq: $e,
            bu: !0,
            bv: lg(n),
            bV: 0
        });
    }), gg = function(n) {
        var r = n.bY;
        return r.$ ? n : b(n, {
            bw: A2(vg, r.a.cH, n.bw)
        });
    }, hg = F2(function(n, r) {
        return b(r, {
            dc: Se(n)
        });
    }), pg = F2(function(n, r) {
        return A2(Qu, r, A2(Vo, function(n) {
            return Se(b(r, {
                dM: A2(se, n, r.dM)
            }));
        }, n));
    }), Lg = {
        $: 16
    }, wg = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Zg = function(n) {
        var r;
        return 7 === n.by ? (r = wg(Lg), A2(qs, 3e3, r)) : xu;
    }, mg = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, a = A2(Qu, 0, A2(Vo, function(n) {
                    return Se(n.cp);
                }, r.bY)), u = e(t, a);
                return c(A2(DM, A3(od, Se(t), a, r.ct), b(r, {
                    ct: A2(hg, t, r.ct)
                })), Xt(A2(ud, r, u)), zc);
            case 2:
                return c(b(r, {
                    ct: A2(pg, r.ct.dc, r.ct)
                }), xu, zc);
            default:
                var i = A2(fd, Ei, gg(function(n) {
                    var r = n.ds, e = A2(TM, n.bY, n.cK.cI);
                    if (e.$) return EM(b(n, {
                        by: 7
                    }));
                    var t = e.a, a = t.cw;
                    if (a.$) {
                        var u = A6(_M, Ob(n), n.c4.c7, 10, 10, gf(n.cK.dw), t.cG);
                        return b(n, {
                            by: 5,
                            bG: u,
                            bY: e,
                            cG: t.cG,
                            ds: b(r, {
                                c3: A2(Xf, gf(n.cK.dw), u)
                            })
                        });
                    }
                    var i = a.a;
                    return b(n, {
                        by: 5,
                        bG: i,
                        bY: e,
                        cG: t.cG,
                        ds: b(r, {
                            c3: A2(Xf, gf(n.cK.dw), i)
                        })
                    });
                }(function(n) {
                    var r;
                    return b(n, {
                        bx: M,
                        bH: M,
                        b7: M,
                        ct: (r = n.ct, b(r, {
                            dc: $e,
                            dM: M
                        }))
                    });
                }(r))));
                return c(i, Xt(l([
                    id(i),
                    Zg(i)
                ])), zc);
        }
    }), Sg = {
        $: 3
    }, $g = {
        $: 4
    }, Dg = {
        $: 1
    }, yg = function(n) {
        return A2(Qu, !1, A2(Vo, function(r) {
            return Se(e(n.ct.dc, Se(r.cp)));
        }, n.bY));
    }, zg = function(n) {
        return "../Audio/KanaSounds/" + ze(n) + ".mp3";
    }, Kg = F2(function(n, r) {
        return n.de.bd ? Ps(Fs(A3(Di, ze(r), zg(r), 1))) : xu;
    }), xg = F2(function(n, r) {
        var e = r.bw;
        if (!r.de.bd || yg(r)) return xu;
        var t = c(n, Zs(r.bN), e.cc);
        if (!t.a.$ && t.b && t.c) {
            var a = A2(rf, t.a.a, e.bv);
            return a.$ ? xu : A2(Kg, r, a.a.bB);
        }
        return xu;
    }), Hg = function(n) {
        return "../Audio/ImageSounds/" + ze(n) + ".mp3";
    }, kg = function(n) {
        return Fs(A3(Di, ze(n), Hg(n), 2));
    }, Bg = function(n) {
        return 20 * n;
    }, Og = F3(function(n, r, e) {
        return A2(Qu, 0, A2(Vo, function(n) {
            return Se(A2(HM, Vc(A2(Ya, n, r.$7)), r.bZ + e));
        }, A2(zu, n, Pc)));
    }), Gg = V, Wg = F2(function(n, r) {
        var t = function(n) {
            return A2(Et, function(n) {
                return A2(zu, n, Pc);
            }, Yc(n));
        }(r.cD);
        if (t.b) {
            if (t.b.b) {
                if (t.b.b.b) return !1;
                var a = o(t.a, t.b.a);
                return !a.a.$ && !a.b.$ && (0 > u(r.bZ, Vc(A2(Ya, a.a.a, r.$7))) ? A2(Bt, n, r.cD) : A2(Gg, n, r.cD));
            }
            return e(r.cD, n);
        }
        return !1;
    }), qg = F3(function(n, r, e) {
        return A2(Wg, n, e) ? 1 === Zt(e.cD) || A2(Gg, n, e.cD) ? b(e, {
            bZ: e.bZ + r
        }) : b(e, {
            bZ: A3(Og, n, e, r)
        }) : e;
    }), Ug = F3(function(n, r, t) {
        return A2(qe, F2(function(t, a) {
            return e(t, n) ? r(a) : a;
        }), t);
    }), Ag = F3(function(n, r, e) {
        return b(e, {
            bv: A3(Ug, e.bV, A2(qg, n, r), e.bv)
        });
    }), Eg = F3(function(n, r, e) {
        return b(e, {
            bw: A3(Ag, r, Bg(n), e.bw)
        });
    }), Tg = function(n) {
        return A2(Vo, function(r) {
            return Se(0 > u(r, Be(n.bv)));
        }, n.bq);
    }, Ig = function(n) {
        return A2(qs, 1500, n);
    }, jg = function(n) {
        var r;
        return r = af(n.bw), A3(ke, F2(function(n, e) {
            var t = e.a, a = e.b;
            return u(r.bZ, t + n) > -1 ? o(t + n, a + 1) : o(t + n, a);
        }), o(0, 0), r.$7).b;
    }, Rg = F2(function(n, r) {
        return Xt(A2(Et, function(n) {
            return A2(qs, 1e3 * n, r);
        }, A2(We, 1, n)));
    }), Qg = F2(function(n, r) {
        return b(r, {
            bq: Se(n)
        });
    }), Pg = F2(function(n, r) {
        return b(r, {
            bw: A2(Qg, n, r.bw)
        });
    }), Vg = function(n) {
        return b(n, {
            bv: A3(Ug, n.bV, function(n) {
                return b(n, {
                    dn: n.dn + 1
                });
            }, n.bv)
        });
    }, Fg = F2(function(n, r) {
        switch(n.$){
            case 3:
                var e = function(n) {
                    return n.bw.cc && !n.cA ? b(n, {
                        by: 6
                    }) : n;
                }(function(n) {
                    var r, e = af(n.bw), t = e.dn, a = u(e.bZ, Vc(e.$7)) > -1, i = Be(e.dp);
                    return u(t, i) > -1 && a ? b(n, {
                        bw: (r = n.bw, 0 > u(r.bV, Be(r.bv) - 1) ? b(r, {
                            bV: r.bV + 1
                        }) : b(r, {
                            cc: !0
                        }))
                    }) : 0 > u(t, i) ? b(n, {
                        bw: Vg(n.bw)
                    }) : n;
                }(r));
                return c(e, e.bw.cc && !e.cA ? function(n) {
                    return A2(qs, 1e3, n);
                }(As(Dg)) : xu, zc);
            case 0:
                var t = A3(Eg, n.a, n.b, r), a = jg(t) - jg(r);
                return c(t, a > 0 ? A2(Rg, a, As(Sg)) : xu, zc);
            case 1:
                return c(A2(Pg, 0, r), Xt(l([
                    A2(xg, Se(0), r),
                    Ig(As($g))
                ])), zc);
            case 4:
                var i = b(s = r.bw, {
                    bq: A2(Vo, function(n) {
                        return Se(n + 1);
                    }, s.bq)
                });
                return c(b(r, {
                    bw: i
                }), (f = Tg(i)).$ ? xu : f.a ? Xt(l([
                    A2(xg, i.bq, r),
                    Ig(As($g))
                ])) : (o = r).de.bd ? Ps(kg(A2(Qu, 0, A2(Vo, function(n) {
                    return Se(n.cp);
                }, o.bY)))) : xu, zc);
            default:
                return c(function(n) {
                    var r;
                    return n.bY.$ ? n : b(n, {
                        bw: (r = n.bw, b(r, {
                            bu: !1,
                            cc: !1
                        }))
                    });
                }(function(n) {
                    var r;
                    return b(n, {
                        ct: (r = n.ct, b(r, {
                            bT: r.bT + 1
                        }))
                    });
                }(r)), xu, zc);
        }
        var o, f, s;
    }), Ng = {
        $: 0
    }, Jg = {
        $: 2
    }, _g = F2(function(n, r) {
        return ma(A2(Et, n, r));
    }), Yg = function(n) {
        return Wi(A3(Di, ze(n), zg(n), 1));
    }, Xg = function(n) {
        return Wi(A3(Di, ze(n), Hg(n), 2));
    }, nh = F2(function(n, r) {
        if (0 > n) return r;
        var e = A2(Fa, n, r);
        if (e.b) {
            var t = e.b;
            return s(A2(Ya, n, r), t);
        }
        return r;
    }), rh = F3(function(n, r, e) {
        for(;;){
            if (Zs(r)) return e;
            var t = A2(Qi, 0, Be(r) - 1), a = A2(Co, t, n), u = a.a, i = a.b, o = A2(nh, u, r), c = A2(rf, u, r);
            if (c.$) return M;
            n = i, r = o, e = A2(se, c.a, e);
        }
    }), eh = F2(function(n, r) {
        return A3(rh, n, r, M);
    }), th = F2(function(n, r) {
        return b(r, {
            cI: A2(eh, n, r.cI)
        });
    }), ah = F2(function(n, r) {
        return b(r, {
            cK: A2(th, n, r.cK)
        });
    }), uh = F2(function(n, r) {
        return !A2(Wu, A2(ri, Ts, n), r);
    }), ih = F2(function(n, r) {
        return !A2(zu, n, r).$;
    }), oh = F2(function(n, r) {
        return A2(uh, function(n) {
            return A2(ih, n, r);
        }, A2(Et, function(n) {
            return ze(n.bB);
        }, A2(_g, function(n) {
            return lg(n.cH);
        }, n.cK.cI)));
    }), ch = F2(function(n, r) {
        return A2(uh, function(n) {
            return A2(ih, n, r);
        }, A2(Et, function(n) {
            return ze(n.cp);
        }, n.cK.cI));
    }), fh = F6(function(n, r, e, t, a, u) {
        return {
            bM: n,
            b2: r,
            cp: e,
            cw: t,
            cG: u,
            cH: a
        };
    }), bh = function(n) {
        return {
            $: 4,
            b: n
        };
    }, sh = F2(function(n, r) {
        return A2(gb, r, zb(l([
            n
        ])));
    }), Mh = F4(function(n, r, e, t) {
        return A3(Lf, F2(function(n, e) {
            var t = e.b, a = ts(e.a);
            return o(a.b, A3(r, a.a, n, t));
        }), o(n, e), t).b;
    }), dh = F3(function(n, r, e) {
        return A4(Mh, n, F3(function(n, e, t) {
            return A2(sh, A2(r, n, e), t);
        }), Ye, e);
    }), Ch = F3(function(n, r, e) {
        return A3(Lf, F2(function(n, e) {
            var t = e.b, a = A2(Co, Pi, e.a).b;
            return o(a, A2(sh, A3(dh, a, r, n), t));
        }), o(n, Ye), e).b;
    }), lh = F4(function(n, r, e, t) {
        return A2(cb, F2(function(r, a) {
            var u = a.a, i = a.b;
            return n(o(e, r)) ? A4(Pb, u, i, o(e, r), t) : $e;
        }), r);
    }), vh = F3(function(n, r, e) {
        return A2(cb, F2(function(e, t) {
            return A4(lh, n, t, e, r);
        }), e);
    }), gh = F4(function(n, r, e, t) {
        var a = A2(Vi, bh(bh(gu)), t);
        if (a.$) return Ye;
        var u = a.a;
        return A3(vh, r, e, A3(Ch, n, F2(function(n, r) {
            return o(n, Se(r));
        }), u));
    }), hh = F4(function(n, r, e, t) {
        return A2(Vo, function(t) {
            return Se(A4(gh, n, r, e, t));
        }, t);
    }), ph = F3(function(n, r, e) {
        var t = uu(A2(Et, function(n) {
            return o(n.bR, n.cE);
        }, e.cG));
        return A6(fh, e.bM, e.b2, e.cp, A4(hh, n, r, t, e.cw), e.cH, t);
    }), Lh = F2(function(n, r) {
        var e = function(n) {
            var r = A2(Vi, Eo(Eo(lu)), n);
            if (r.$) return zb(M);
            var e = r.a;
            return zb(A3(ke, F2(function(n, r) {
                return s(r, l([
                    zb(n)
                ]));
            }), M, e));
        }(r.dw);
        return {
            b3: r.b3,
            cp: r.cp,
            cI: A2(Et, A2(ph, n, gf(e)), r.cI),
            cU: r.cU,
            cX: r.cX,
            c$: r.c$,
            du: r.du,
            dw: e,
            dE: r.dE
        };
    }), wh = F2(function(n, r) {
        return b(r, {
            da: A8(pi, 0, 0, 0, !1, !1, !1, 0, n)
        });
    }), Zh = F2(function(n, r) {
        return A2(wh, r.da.cn, function(n) {
            return b(n, {
                ct: oi
            });
        }(b(r, {
            by: 3,
            cK: A2(Lh, r.c4.c7, n)
        })));
    }), mh = F2(function(n, r) {
        var e, t, a = r.bC;
        switch(n.$){
            case 0:
                return c(r, A2(Po, r.cW, n.a), zc);
            case 1:
                var u = n.a;
                if (u.$) return c(function(n) {
                    return b(n, {
                        cQ: b(n.cQ, {
                            b4: 0
                        })
                    });
                }(b(r, {
                    by: 0
                })), xu, zc);
                var i = u.a;
                return c(gg(function(n) {
                    var r = n.ds, e = n.cK.cI;
                    if (e.b && e.b.b && e.b.b.b && e.b.b.b.b && !e.b.b.b.b.b) {
                        var t = e.a, a = t.cw;
                        if (a.$) {
                            var u = A6(_M, Ob(n), n.c4.c7, 10, 10, gf(n.cK.dw), t.cG);
                            return b(n, {
                                bG: u,
                                bY: Se(t),
                                cG: t.cG,
                                ds: b(r, {
                                    c3: A2(Xf, gf(n.cK.dw), u)
                                })
                            });
                        }
                        var i = a.a;
                        return b(n, {
                            bG: i,
                            bY: Se(t),
                            cG: t.cG,
                            ds: b(r, {
                                c3: A2(Xf, gf(n.cK.dw), i)
                            })
                        });
                    }
                    return n;
                }(A2(ah, r.c4.cJ, A2(Zh, i, r)))), function(n) {
                    return A2(qs, 750, n);
                }(ki(Jg)), $i(l([
                    (t = A2(Et, function(n) {
                        return n.cp;
                    }, i.cI), $i(A2(Et, Xg, t))),
                    (e = A2(Et, function(n) {
                        return n.bB;
                    }, A2(_g, function(n) {
                        return lg(n.cH);
                    }, i.cI)), $i(A2(Et, Yg, e)))
                ])));
            case 2:
                var o = function(n) {
                    var r = n.bC;
                    return A2(ch, n, r.dK) && A2(oh, n, r.cF);
                }(r);
                return c(o ? function(n) {
                    var r, e = n.cQ;
                    return b(n, {
                        cQ: b(e, {
                            cM: (r = e.cM, b(r, {
                                aO: 0
                            }))
                        })
                    });
                }(b(r, {
                    by: 4
                })) : r, o ? xu : function(n) {
                    return A2(qs, 500, n);
                }(ki(Jg)), zc);
            default:
                var f = n.a, s = n.b, M = n.c;
                if (M.$) return c(r, xu, zc);
                var d = M.a;
                switch(f){
                    case 0:
                        return c(b(r, {
                            bC: b(a, {
                                dj: A3(Ha, s, Uc({
                                    c2: Ng,
                                    di: d
                                }), a.dj)
                            })
                        }), xu, zc);
                    case 1:
                        return c(b(r, {
                            bC: b(a, {
                                cF: A3(Ha, s, Uc({
                                    c2: Ng,
                                    di: d
                                }), a.cF)
                            })
                        }), xu, zc);
                    default:
                        return c(b(r, {
                            bC: b(a, {
                                dK: A3(Ha, s, Uc({
                                    c2: Ng,
                                    di: d
                                }), a.dK)
                            })
                        }), xu, zc);
                }
        }
    }), Sh = F2(function(n, r) {
        var e = r.de;
        switch(n){
            case 0:
                return e.a8;
            case 1:
                return e.aQ;
            case 2:
                return e.bd;
            default:
                return e.aF;
        }
    }), $h = function(n) {
        return n ? 1 : 0;
    }, Dh = F3(function(n, r, e) {
        return Bc(A2(ye, 0, ba(l([
            o(Hc, va(n)),
            o(r, ia(e))
        ]))));
    }), yh = F2(function(n, r) {
        switch(r){
            case 0:
                return A3(Dh, "saveSoundEffectsEnabled", "soundEffectsEnabled", $h(n));
            case 1:
                return A3(Dh, "saveMusicEnabled", "musicEnabled", $h(n));
            case 2:
                return A3(Dh, "saveTextAudioEnabled", "textAudioEnabled", $h(n));
            default:
                return A3(Dh, "saveHintsEnabled", "hintsEnabled", $h(n));
        }
    }), zh = F2(function(n, r) {
        switch(n){
            case 0:
                return function(n) {
                    var r;
                    return b(n, {
                        de: (r = n.de, b(r, {
                            a8: !r.a8
                        }))
                    });
                }(r);
            case 1:
                return function(n) {
                    var r;
                    return b(n, {
                        de: (r = n.de, b(r, {
                            aQ: !r.aQ
                        }))
                    });
                }(r);
            case 2:
                return function(n) {
                    var r;
                    return b(n, {
                        de: (r = n.de, b(r, {
                            bd: !r.bd
                        }))
                    });
                }(r);
            default:
                return function(n) {
                    var r;
                    return b(n, {
                        de: (r = n.de, b(r, {
                            aF: !r.aF
                        }))
                    });
                }(r);
        }
    }), Kh = F2(function(n, r) {
        var e = n.a8, t = n.bd, a = n.aQ;
        return b(r, {
            de: b(r.de, {
                aF: A2(Qu, r.de.aF, n.aF),
                aQ: A2(Qu, r.de.aQ, a),
                a8: A2(Qu, r.de.a8, e),
                bd: A2(Qu, r.de.bd, t)
            })
        });
    }), xh = F2(function(n, r) {
        return b(r, {
            da: b(r.da, {
                cn: zt(n)
            })
        });
    }), Hh = F2(function(n, r) {
        switch(n.$){
            case 0:
                return c(A2(xh, n.a, r), xu, zc);
            case 1:
                return c(A2(Kh, n.a, r), xu, zc);
            default:
                var e = n.a, t = A2(zh, e, r);
                return c(t, A2(yh, A2(Sh, e, t), e), zc);
        }
    }), kh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Bh = {
        $: 3
    }, Oh = function(n) {
        return b(n, {
            cQ: b(n.cQ, {
                b_: 1
            })
        });
    }, Gh = function(n) {
        return b(n, {
            cQ: b(n.cQ, {
                b4: 1
            })
        });
    }, Wh = function(n) {
        var r, e = n.cQ;
        return b(n, {
            cQ: b(e, {
                cM: (r = e.cM, b(r, {
                    aO: 1
                }))
            })
        });
    }, qh = function(n) {
        return A2(qs, 350, n);
    }, Uh = function(n) {
        return b(n, {
            cQ: b(n.cQ, {
                dH: 1
            })
        });
    }, Ah = F2(function(n, r) {
        return b(r, {
            cr: n
        });
    }), Eh = F2(function(n, r) {
        var e = r.cQ;
        return b(r, {
            cQ: b(e, {
                cM: A2(Ah, n, e.cM)
            })
        });
    }), Th = F2(function(n, r) {
        switch(n.$){
            case 0:
                return c(function(n) {
                    var r;
                    return b(n, {
                        cQ: b(n.cQ, {
                            df: (r = n.cQ.df, r ? 0 : 1)
                        })
                    });
                }(r), xu, zc);
            case 10:
                return c(A2(Eh, (a = r.cQ.cM).cr > 0 ? a.cr - 1 : 3, r), xu, zc);
            case 9:
                return c(A2(Eh, function(n) {
                    return 3 > n.cr ? n.cr + 1 : 0;
                }(r.cQ.cM), r), xu, zc);
            case 8:
                return c(r, Ps(kg(n.a)), zc);
            case 4:
                return c(Uh(r), qh(ki(kh(r.cK.cp + 1))), zc);
            case 1:
                var e = n.a;
                return c(Gh(r), qh(ki(kh(e))), zc);
            case 2:
                return c(Wh(r), qh(wg(Bh)), zc);
            case 3:
                return c(ms(A2(Eh, 0, b(r, {
                    by: 5
                }))), Zs(r.ds.c3) && r.cK.cU > 0 ? oM(iM(1)) : xu, zc);
            case 5:
                return c(Oh(r), qh(ki(kh(r.cK.cp))), zc);
            case 7:
                return c(A2(Eh, n.a, r), xu, zc);
            case 6:
            case 11:
                return c(function(n) {
                    return b(n, {
                        cQ: b(n.cQ, {
                            df: 1
                        })
                    });
                }(r), xu, zc);
            case 12:
                return c(Wh(r), xu, zc);
            case 15:
                return c(Uh(r), xu, zc);
            case 13:
                return c(Oh(r), xu, zc);
            case 14:
                return c(Gh(r), xu, zc);
            default:
                return c(function(n) {
                    return b(n, {
                        cQ: b(n.cQ, {
                            dH: 0
                        })
                    });
                }(function(n) {
                    return b(n, {
                        cQ: b(n.cQ, {
                            cL: 1
                        })
                    });
                }(r)), xc(A2(ye, 0, function(n) {
                    var r = n.a, e = n.b;
                    return ba(l([
                        o(Hc, va("saveScoreByLevelID")),
                        o(ze(r), ia(e))
                    ]));
                }(o((t = r).cK.cp, t.da.cf)))), zc);
        }
        var t, a;
    }), Ih = F2(function(n, r) {
        return b(r, {
            c4: b(r.c4, {
                cs: vi(n)
            })
        });
    }), jh = F2(function(n, r) {
        return b(r, {
            c4: b(r.c4, {
                cJ: vi(n)
            })
        });
    }), Rh = F2(function(n, r) {
        return b(r, {
            c4: b(r.c4, {
                c7: vi(n)
            })
        });
    }), Qh = F2(function(n, r) {
        return b(r, {
            c4: b(r.c4, {
                a5: vi(n)
            })
        });
    }), Ph = F3(function(n, r, e) {
        switch(n.$){
            case 0:
                return c(A2(jh, r, e), xu, zc);
            case 1:
                var t = n.a;
                return c(A2(Rh, r, e), t, zc);
            case 2:
                return c(A2(Qh, r, e), xu, zc);
            default:
                return c(A2(Ih, r, e), xu, zc);
        }
    }), Vh = F3(function(n, r, t) {
        return e(n, r) || !t(r);
    }), Fh = F4(function(n, r, e, t) {
        var a = A2(Co, A2(Qi, 0, Tf(t) - 1), n), u = a.a, i = a.b, c = A2(Co, A2(Qi, 0, Tf(t) - 1), i), f = c.a, b = c.b;
        return A3(Vh, e, o(u, f), r) ? A4(Fh, b, r, e, t) : o(o(u, f), b);
    }), Nh = F2(function(n, r) {
        return Zs(Ef(A2(_f, n, r))) ? A2(_f, n, r) : r;
    }), Jh = F4(function(n, r, e, t) {
        for(;;){
            var a = A3(Zf, F3(function(n, t) {
                var a = t.a, u = A4(Fh, t.b, e, n, a), i = u.a, c = u.b;
                return e(n) ? o(A2(Nh, o(n, i), a), c) : o(a, r);
            }), o(t, r), t).a;
            if (Be(A2(Xf, e, a)) > 0) return a;
            if (n >= 25) return a;
            n += 1, t = a;
        }
    }), _h = F3(function(n, r, e) {
        return A4(Jh, 0, n, r, e);
    }), Yh = F2(function(n, r) {
        var e = r.ds, t = A3(_h, n, gf(r.cK.dw), r.bG);
        return b(r, {
            bG: t,
            ds: b(e, {
                c3: A2(Xf, gf(r.cK.dw), t)
            })
        });
    }), Xh = F2(function(n, r) {
        var e, t = r.a5, a = r.c4;
        switch(n){
            case 4:
                return c(b(r, {
                    a5: b(t, {
                        dh: 3
                    })
                }), oM(iM(1)), zc);
            case 1:
                return c(b(r, {
                    a5: b(t, {
                        dh: 0
                    })
                }), (e = iM(2), A2(qs, 750, e)), zc);
            case 2:
                return c(A2(Yh, a.a5, r), function(n) {
                    return A2(qs, 10, n);
                }(iM(3)), zc);
            case 3:
                return c(b(r, {
                    a5: b(t, {
                        dh: 1
                    })
                }), function(n) {
                    return A2(qs, 1750, n);
                }(iM(0)), zc);
            default:
                return c(function(n) {
                    return b(n, {
                        a5: b(n.a5, {
                            dh: 2
                        })
                    });
                }(r), A2(po, Ii(ji), Pi), zc);
        }
    }), np = {
        $: 2
    }, rp = function(n) {
        return A2(qs, 500, n);
    }, ep = function(n) {
        return n.de.a8 && !e(n.ds.cy, $e) ? Ns(xi) : xu;
    }, tp = {
        $: 1
    }, ap = function(n) {
        return A2(qs, 500, n);
    }, up = function(n) {
        var r;
        return e(n.ds.dr, $e) ? e(n.ds.cy, $e) ? xu : (r = fc(tp), A2(qs, 1e3, r)) : ap(Qc(0));
    }, ip = F2(function(n, r) {
        var e = r.ds, t = r.cx.cR;
        if (t.$) return b(r, {
            ds: b(e, {
                cd: Se(n),
                db: $e
            })
        });
        var a = t.a, i = a.b;
        return 1 > u(Vb(a.a), 3) && 1 > u(Vb(i), 3) ? b(r, {
            ds: b(e, {
                cd: Se(n),
                db: $e
            })
        }) : r;
    }), op = function(n) {
        return b(n, {
            cA: !0,
            cC: !1
        });
    }, cp = function(n) {
        return o(n.a - 1, n.b);
    }, fp = function(n) {
        return o(n.a, n.b - 1);
    }, bp = F2(function(n, r) {
        return A2(Ss, r, l([
            fp(n),
            Gf(n),
            cp(n),
            $f(n)
        ]));
    }), sp = function(n) {
        return b(n, {
            ds: b(n.ds, {
                cd: $e,
                db: $e
            })
        });
    }, Mp = F3(function(n, r, e) {
        return b(e, {
            ds: b(e.ds, {
                cy: Se(o(n, r))
            })
        });
    }), dp = F3(function(n, r, e) {
        return b(e, {
            ds: b(e.ds, {
                dr: Se(o(n, r))
            })
        });
    }), Cp = F3(function(n, r, e) {
        var t = c(A2(vf, r, e.cK.dw) && A2(vf, n, e.cK.dw), A2(bp, r, n), A2($s, o(r, n), e.ds.c3));
        n: for(;;){
            if (t.a) {
                if (t.b) return op(A3(t.c ? dp : Mp, r, n, sp(e)));
                if (t.c) break n;
                return A2(ip, n, e);
            }
            break n;
        }
        return sp(e);
    }), lp = F2(function(n, r) {
        var e = o(r.ds.cd, r.ds.db);
        return e.a.$ ? 1 === e.b.$ ? A2(ip, n, r) : sp(r) : 1 === e.b.$ ? A3(Cp, n, e.a.a, r) : A2(ip, n, r);
    }), vp = F3(function(n, r, e) {
        var t = e.ds, a = e.cx.cS;
        if (a.$) return e;
        var u = a.a, i = o(u, r(u));
        return A2(n, 25, e.cx) && A2($s, i, e.ds.c3) ? op(b(e, {
            ds: b(t, {
                dr: Se(i)
            })
        })) : A2(n, 3, e.cx) ? op(b(e, {
            ds: b(t, {
                cz: Se(i)
            })
        })) : e;
    }), gp = F2(function(n, r) {
        var e = r.cR;
        if (e.$) return !1;
        var t = e.a, a = t.a, i = t.b;
        return u(Vb(i), Vb(a)) > 0 && u(i, n) > 0;
    }), hp = F2(function(n, r) {
        var e = r.cR;
        if (e.$) return !1;
        var t = e.a, a = t.a, i = t.b;
        return u(Vb(a), Vb(i)) > 0 && 0 > a && u(Vb(a), n) > 0;
    }), pp = F2(function(n, r) {
        var e = r.cR;
        if (e.$) return !1;
        var t = e.a, a = t.a, i = t.b;
        return u(Vb(a), Vb(i)) > 0 && u(a, n) > 0;
    }), Lp = F2(function(n, r) {
        var e = r.cR;
        if (e.$) return !1;
        var t = e.a, a = t.a, i = t.b;
        return u(Vb(i), Vb(a)) > 0 && 0 > i && u(Vb(i), n) > 0;
    }), wp = function(n) {
        return A3(vp, pp, Gf, A3(vp, hp, fp, A3(vp, gp, $f, A3(vp, Lp, cp, n))));
    }, Zp = F2(function(n, r) {
        return b(r, {
            cx: b(r.cx, {
                cB: n
            })
        });
    }), mp = F2(function(n, r) {
        var e, t = n.a;
        return e = A2(Vo, Cf(n.b), A2(Cf, t, r)), !lf(e);
    }), Sp = F2(function(n, r) {
        var e = n.b;
        return A2(mp, n.a, r.cK.dw) || A2(mp, e, r.cK.dw);
    }), $p = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Dp = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yp = F2(function(n, r) {
        return {
            M: r.M,
            ak: A2(se, r.Q, r.ak),
            Q: n
        };
    }), zp = F2(function(n, r) {
        var e = n.b, t = o(n.a, r);
        switch(t.a){
            case 0:
                return Dp(e);
            case 1:
                switch(t.b.$){
                    case 1:
                        return $p({
                            M: t.b.a,
                            ak: M,
                            Q: e
                        });
                    case 2:
                        return $p(A2(yp, e, t.b.a));
                    default:
                        return Dp(e);
                }
            default:
                return 2 === t.b.$ ? {
                    $: 3,
                    a: A2(yp, e, t.b.a)
                } : {
                    $: 4,
                    a: e
                };
        }
    }), Kp = function(n) {
        return 3 === n.$ ? Se(n.a.Q.bm - n.a.M.bm) : $e;
    }, xp = F2(function(n, r) {
        return A2(Yt, n, A2(Yt, qc(r), Qu(!1)));
    }), Hp = function(n) {
        return A2(xp, Kp, function(r) {
            return u(r, n) > -1;
        });
    }, kp = function(n) {
        return 3 === n.$ ? Se(n.a.Q.bl - n.a.M.bl) : $e;
    }, Bp = function(n) {
        return A2(xp, kp, function(r) {
            return 1 > u(r, -n);
        });
    }, Op = function(n) {
        return A2(xp, kp, function(r) {
            return u(r, n) > -1;
        });
    }, Gp = function(n) {
        return A2(xp, Kp, function(r) {
            return 1 > u(r, -n);
        });
    }, Wp = F3(function(n, r, e) {
        return A2(Hp, 25, e) ? Se(o(o(n, r), o(n + 1, r))) : A2(Gp, 25, e) ? Se(o(o(n, r), o(n - 1, r))) : A2(Bp, 25, e) ? Se(o(o(n, r - 1), o(n, r))) : A2(Op, 25, e) ? Se(o(o(n, r + 1), o(n, r))) : $e;
    }), qp = F4(function(n, r, e, t) {
        var a = t.ds;
        return 4 === A2(zp, e, t.cg).$ ? A2(lp, o(n, r), t) : A2(Qu, t, A2(Vo, function(n) {
            return Se(A2(Sp, n, t) ? t : b(t, A2($s, n, t.ds.c3) ? {
                cg: ai,
                ds: b(a, {
                    dr: Se(n)
                })
            } : {
                cg: ai,
                ds: b(a, {
                    cy: Se(n)
                })
            }));
        }, A3(Wp, n, r, A2(zp, e, t.cg))));
    }), Up = F3(function(n, r, e) {
        var t = e.cx, a = e.ds, i = t.cT;
        if (i.$) return e;
        var c = i.a, f = c.a, s = c.b;
        return b(e, {
            cx: b(t, {
                cR: Se(o(n - f, r - s))
            }),
            ds: b(a, {
                cd: u(Vb(n - f), 3) > 0 || u(Vb(r - s), 3) > 0 ? $e : a.cd
            })
        });
    }), Ap = F4(function(n, r, e, t) {
        return b(t, {
            cx: b(t.cx, {
                cB: !0,
                cR: Se(o(0, 0)),
                cS: Se(n),
                cT: Se(o(r, e))
            })
        });
    }), Ep = function(n) {
        var r;
        return e(n.ds.dr, $e) ? n : b(n, {
            cK: (r = n.cK, b(r, {
                cU: r.cU - 1
            }))
        });
    }, Tp = F2(function(n, r) {
        var t = r.ds, a = r.cx;
        switch(n.$){
            case 0:
                return c(i = Kc(Ep(A2(lp, n.a, r))), Xt(l([
                    up(i),
                    ep(i)
                ])), zc);
            case 1:
                return c(b(r, {
                    cx: b(a, {
                        cR: $e
                    }),
                    cA: !1,
                    ds: b(t, {
                        cy: $e
                    })
                }), xu, zc);
            case 2:
                return c(b(r, {
                    cA: !1,
                    ds: b(t, {
                        cz: $e
                    })
                }), xu, zc);
            case 3:
                return c(b(r, {
                    cg: A2(zp, n.a, r.cg)
                }), xu, zc);
            case 4:
                var i;
                return c(i = Ep(A4(qp, n.a, n.b, n.c, r)), up(i), zc);
            case 5:
                return c(A4(Ap, n.a, n.b, n.c, r), xu, zc);
            case 6:
                var o = Ep(function(n) {
                    var r = function(n) {
                        switch(n){
                            case 0:
                                return 42;
                            case 1:
                                return 48;
                            case 2:
                                return 50;
                            default:
                                return 60;
                        }
                    }(n.b$.bP);
                    return A2(Qu, n, A2(Vo, function(e) {
                        var t = e.b;
                        return u(Vb(e.a), r) > -1 || u(Vb(t), r) > -1 ? Se(A2(Zp, !1, wp(n))) : Se(n);
                    }, n.cx.cR));
                }(A3(Up, n.a, n.b, A2(Zp, !0, r))));
                return c(o, e(o.ds.dr, $e) ? e(o.ds.cz, $e) ? xu : rp(fc(np)) : ap(Qc(0)), zc);
            default:
                var f = Ep(wp(A3(Up, n.a, n.b, A2(Zp, !1, r))));
                return c(f, function(n) {
                    var r = n.ds;
                    return e(r.cz, $e) ? e(r.dr, $e) ? xu : ap(Qc(0)) : rp(fc(np));
                }(f), zc);
        }
    }), Ip = F2(function(n, r) {
        switch(n){
            case 4:
                return c(b(r, {
                    bw: b(r.bw, {
                        cc: !0
                    }),
                    by: 6
                }), A2(xg, Se(0), r), zc);
            case 3:
                return c(A2(DM, 4e3, r), rM(Es), zc);
            case 0:
                return c(Os(r), xu, zc);
            case 1:
                var e = EM(b(r, {
                    by: 7
                }));
                return c(e, Xt(l([
                    id(e),
                    Zg(e)
                ])), zc);
            default:
                var t = af(r.bw), a = u(t.bZ, A2(Qu, 0, A2(Vo, function(n) {
                    return Se(Vc(A2(Ya, n, t.$7)));
                }, A2(zu, A3(mt, 0, 1, t.cD), Pc)))) > -1 ? A3(mt, 1, 1, t.cD) : A3(mt, 0, 1, t.cD);
                return c(r, A2(qs, 1, As(A2(Us, 25, a))), zc);
        }
    }), jp = F2(function(n, r) {
        return n ? b(r, {
            bx: M,
            bH: M,
            b7: M
        }) : r;
    }), Rp = F2(function(n, r) {
        return n - r;
    }), Qp = F2(function(n, r) {
        return !r.cA && u(A2(Rp, n, r.cq), 3e3) > 0;
    }), Pp = F2(function(n, r) {
        if (1 === n.$) {
            var e = n.a;
            return c(b(r, {
                bX: e,
                cq: e
            }), xu, zc);
        }
        var t = n.a;
        return c(A2(jp, A2(Qp, t, r), b(r, {
            bX: t,
            cC: A2(Qp, t, r)
        })), xu, zc);
    }), Vp = F3(function(n, r, e) {
        switch(r.$){
            case 0:
                var t = r.a;
                return c(Kc(e), Xt(l([
                    kc(t),
                    Oc
                ])), zc);
            case 1:
                return c(Kc(e), xu, zc);
            case 2:
                return c($M(function(n) {
                    var r = n.da;
                    return b(n, {
                        da: b(r, {
                            br: u(r.cf, n.cK.c$) > -1,
                            bs: r.bt && u(r.cf, n.cK.du) > -1,
                            bt: r.br && u(r.cf, n.cK.dE) > -1
                        })
                    });
                }(e)), xu, zc);
            case 8:
                return A2(xM, r.a, e);
            case 14:
                return A2(Pp, r.a, e);
            case 13:
                return A2(AM, r.a, e);
            case 12:
                return A2(Hh, r.a, e);
            case 11:
                return A2(Rc, r.a, e);
            case 10:
                return A2(mh, r.a, e);
            case 9:
                return A2(Tp, r.a, e);
            case 7:
                return A2(Fg, r.a, e);
            case 6:
                return A2(mg, r.a, e);
            case 3:
                return A2(Th, r.a, e);
            case 4:
                return A2(Xh, r.a, e);
            case 5:
                return A3(Ph, r.a, r.b, e);
            case 15:
                return A2(WM, r.a, e);
            default:
                return A2(Ip, r.a, e);
        }
    }), Fp = vr("class"), Np = Fp("animatedScore"), Jp = function(n) {
        return "rgb(" + ze(n.c6) + ", " + ze(n.ch) + ", " + ze(n.bE) + ")";
    }, _p = function(n) {
        return n.b ? Jp(gs(n.a.bQ)) : "";
    }, Yp = F2(function(n, r) {
        return Be(A2(Wa, function(n) {
            return e(n.aw.b, r);
        }, n));
    }), Xp = F2(function(n, r) {
        return Be(A2(Wa, function(n) {
            return e(n.aw.a, r);
        }, n));
    }), nL = function(n) {
        return A2(Qu, o(0, 0), A2(Vo, function(n) {
            return Se(n.aw);
        }, nf(A2(Wa, function(r) {
            var e = r.aw, t = e.b;
            return A2(Xp, n, e.a) >= 3 && A2(Yp, n, t) >= 3;
        }, n))));
    }, rL = F2(function(n, r) {
        return e(n.aw.b, r.aw.b);
    }), eL = F2(function(n, r) {
        return e(n.aw.a, r.aw.a);
    }), tL = function(n) {
        if (n.b && n.b.b && n.b.b.b && n.b.b.b.b && n.b.b.b.b.b && !n.b.b.b.b.b.b) {
            var r = n.a, e = n.b, t = e.a, a = e.b, u = a.a, i = a.b, o = i.a, c = i.b.a;
            return A2(eL, r, t) && A2(eL, t, u) && A2(eL, u, o) && A2(eL, o, c) || A2(rL, r, t) && A2(rL, t, u) && A2(rL, u, o) && A2(rL, o, c);
        }
        return !1;
    }, aL = vr("fill"), uL = F2(function(n, r) {
        return ze(A2(yM, n, r));
    }), iL = fr("http://www.w3.org/2000/svg"), oL = iL("svg"), cL = vr("x"), fL = cL("50%"), bL = vr("y"), sL = bL("50%"), ML = "middle", dL = vr("dominant-baseline"), CL = dL(ML), lL = vr("text-anchor"), vL = lL(ML), gL = aL("rgb(0, 0, 0)"), hL = or, pL = hL, LL = iL("text"), wL = F2(function(n, r) {
        var e, t;
        return A2(oL, A2(se, Np, (e = function(n) {
            n: for(;;){
                if (n.b && n.b.b && n.b.b.b) {
                    if (n.b.b.b.b) {
                        if (n.b.b.b.b.b) {
                            if (n.b.b.b.b.b.b) {
                                if (n.b.b.b.b.b.b.b) break n;
                                return nL(n);
                            }
                            var r = n.b.b.a;
                            return tL(n) ? r.aw : nL(n);
                        }
                        return n.b.b.a.aw;
                    }
                    return n.b.a.aw;
                }
                break n;
            }
            return o(0, 0);
        }(n), t = e.b, l([
            Fp("row" + ze(e.a)),
            Fp("column" + ze(t))
        ]))), l([
            A2(LL, l([
                fL,
                sL,
                vL,
                CL,
                gL,
                aL(_p(n))
            ]), l([
                pL(A2(uL, n, r))
            ]))
        ]));
    }), ZL = F2(function(n, r) {
        return s(r, l([
            n
        ]));
    }), mL = F3(function(n, r, e) {
        return n ? A2(ZL, r, e) : e;
    }), SL = F2(function(n, r) {
        return A2(Ss, n, r);
    }), $L = F2(function(n, r) {
        return A2(lr, n, va(r));
    }), DL = $L("id"), yL = function(n) {
        return sr(Zr(n));
    }, zL = F2(function(n, r) {
        return A3(yL, "div", n, r);
    }), KL = F2(function(n, r) {
        var e = n.bx;
        return A3(mL, A2(SL, n.by, l([
            5,
            6
        ])), A2(zL, l([
            DL("animatedScores")
        ]), A2(Et, function(n) {
            var r = n.a, e = n.b;
            return o(function(n) {
                return A2(Ke, "", A2(Et, function(n) {
                    return function(n) {
                        var r = n.b;
                        return s(ze(n.a), ze(r));
                    }(n.aw);
                }, n));
            }(r), A2(wL, r, e));
        }, e)), r);
    }), xL = {
        $: 2
    }, HL = {
        $: 0
    }, kL = Fp("background-image"), BL = br("div"), OL = dr, GL = F2(function(n, r) {
        return A2(OL, n, {
            $: 0,
            a: r
        });
    }), WL = function(n) {
        return A2(GL, "click", gt(n));
    }, qL = hL, UL = F3(function(n, r, e) {
        return A3(mL, A2(SL, r.by, l([
            5,
            6
        ])), A2(BL, l([
            DL("hint-button"),
            WL(n)
        ]), l([
            qL("\uD83E\uDD14")
        ])), e);
    }), AL = br("img"), EL = iL("circle"), TL = vr("cx"), IL = vr("cy"), jL = vr("d"), RL = iL("defs"), QL = vr("dx"), PL = vr("dy"), VL = iL("feComposite"), FL = iL("feFlood"), NL = iL("feGaussianBlur"), JL = iL("feOffset"), _L = vr("fill-rule"), YL = iL("filter"), XL = vr("filter"), nw = vr("filterUnits"), rw = vr("flood-color"), ew = vr("flood-opacity"), tw = iL("g"), aw = vr("height"), uw = vr("id"), iw = vr("in2"), ow = vr("in"), cw = function(n) {
        return A2(GL, "click", gt(n));
    }, fw = vr("operator"), bw = iL("path"), sw = vr("r"), Mw = vr("result"), dw = vr("stdDeviation"), Cw = vr("stroke"), lw = vr("stroke-linecap"), vw = vr("stroke-linejoin"), gw = vr("stroke-miterlimit"), hw = vr("stroke-width"), pw = vr("viewBox"), Lw = vr("width"), ww = F3(function(n, r, e) {
        return A3(mL, A2(SL, r.by, l([
            5,
            6
        ])), function(n) {
            return A2(oL, l([
                uw("settings-button"),
                pw("0 0 100 100"),
                Lw("75"),
                aw("75"),
                cw(n)
            ]), l([
                A2(RL, M, l([
                    A2(YL, l([
                        uw("canvasGearOpenMenu2-shadow-outer"),
                        nw("objectBoundingBox")
                    ]), l([
                        A2(NL, l([
                            dw("2.5")
                        ]), M),
                        A2(JL, l([
                            QL("2"),
                            PL("2"),
                            Mw("blur")
                        ]), M),
                        A2(FL, l([
                            rw("rgb(85, 85, 85)"),
                            ew("0.7")
                        ]), M),
                        A2(VL, l([
                            iw("blur"),
                            fw("in"),
                            Mw("colorShadow")
                        ]), M),
                        A2(VL, l([
                            ow("SourceGraphic"),
                            iw("colorShadow"),
                            fw("over")
                        ]), M)
                    ]))
                ])),
                A2(tw, l([
                    uw("canvasGearOpenMenu2-group4"),
                    XL("url(#canvasGearOpenMenu2-shadow-outer)")
                ]), l([
                    A2(EL, l([
                        uw("canvasGearOpenMenu2-oval"),
                        Cw("rgb(85, 85, 85)"),
                        hw("3"),
                        gw("10"),
                        aL("rgb(225, 225, 225)"),
                        TL("50"),
                        IL("50"),
                        sw("45")
                    ]), M),
                    A2(bw, l([
                        uw("canvasGearOpenMenu2-bezier2"),
                        _L("evenodd"),
                        Cw("rgb(85, 85, 85)"),
                        hw("2"),
                        lw("round"),
                        vw("round"),
                        gw("1.41"),
                        aL("rgb(170, 170, 170)"),
                        jL("M 54.17,14.35 C 50.84,13.9 47.47,13.9 44.15,14.35 L 40.81,20.67 C 37.16,21.67 33.73,23.32 30.67,25.54 L 23.63,24.2 C 21.2,26.51 19.1,29.14 17.38,32.02 L 20.25,38.56 C 18.77,42.03 17.92,45.74 17.75,49.51 L 12.32,54.16 C 12.61,57.5 13.36,60.77 14.54,63.9 L 21.47,65.75 C 23.26,69.07 25.63,72.04 28.48,74.52 L 28.74,81.66 C 31.54,83.51 34.58,84.97 37.77,86 L 43.53,81.75 C 47.25,82.43 51.06,82.43 54.78,81.75 L 60.54,86 C 63.74,84.97 66.77,83.51 69.57,81.66 L 69.83,74.52 C 72.68,72.04 75.06,69.07 76.85,65.75 L 83.77,63.9 C 84.95,60.77 85.7,57.5 86,54.16 L 80.57,49.51 C 80.4,45.74 79.55,42.03 78.06,38.56 L 80.93,32.02 C 79.22,29.14 77.11,26.51 74.69,24.2 L 67.65,25.54 C 64.59,23.32 61.15,21.67 57.51,20.67 L 54.17,14.35 Z M 49.16,30.62 C 60.38,30.62 69.49,39.71 69.49,50.9 69.49,62.09 60.38,71.18 49.16,71.18 37.94,71.18 28.83,62.09 28.83,50.9 28.83,39.71 37.94,30.62 49.16,30.62 Z M 49.16,30.62")
                    ]), M)
                ]))
            ]));
        }(n), e);
    }), Zw = F2(function(n, r) {
        return A3(mL, A2(SL, n.by, l([
            2,
            3,
            4,
            5,
            6,
            7
        ])), A2(BL, l([
            kL
        ]), A3(UL, qM(xL), n, A3(ww, wg(HL), n, l([
            A2(AL, l([
                A2($L, "src", mr("../Images/Backdrops/Spring.svg"))
            ]), M)
        ])))), r);
    }), mw = vr("style"), Sw = F2(function(n, r) {
        return A2(SL, n, l([
            3,
            0,
            1
        ])) ? A2(se, Fp("active"), r) : 4 === n ? A2(se, mw("transition-delay: 250ms; transition-timing-function: ease-in;"), r) : r;
    }), $w = iL("clipPath"), Dw = vr("clip-path"), yw = vr("gradientUnits"), zw = iL("linearGradient"), Kw = vr("offset"), xw = iL("stop"), Hw = vr("stop-color"), kw = vr("stop-opacity"), Bw = vr("x1"), Ow = vr("x2"), Gw = vr("y1"), Ww = vr("y2"), qw = A2(RL, M, l([
        A2(YL, l([
            uw("shuffleDrawing-levelCompleteOuterShadow-outer"),
            nw("objectBoundingBox")
        ]), l([
            A2(NL, l([
                dw("2.5")
            ]), M),
            A2(JL, l([
                QL("0"),
                PL("3"),
                Mw("blur")
            ]), M),
            A2(FL, l([
                rw("rgb(85, 85, 85)"),
                ew("1")
            ]), M),
            A2(VL, l([
                iw("blur"),
                fw("in"),
                Mw("colorShadow")
            ]), M),
            A2(VL, l([
                ow("SourceGraphic"),
                iw("colorShadow"),
                fw("over")
            ]), M)
        ])),
        A2(zw, l([
            uw("shuffleDrawing-lightStripeGradiantBottom-rectangle4"),
            Bw("187.5"),
            Gw("97"),
            Ow("187.5"),
            Ww("100"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(49, 104, 90)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0"),
                Hw("rgb(70, 146, 129)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.5"),
                Hw("rgb(92, 188, 168)"),
                kw("1")
            ]), M)
        ])),
        A2(zw, l([
            uw("shuffleDrawing-lightStripeGradiantTop-rectangle6"),
            Bw("187.5"),
            Gw("-2.5"),
            Ow("187.5"),
            Ww("97.5"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0.94"),
                Hw("rgb(92, 188, 168)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(70, 146, 129)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(49, 104, 90)"),
                kw("1")
            ]), M)
        ])),
        A2(zw, l([
            uw("shuffleDrawing-darkStripeGradiantBottom-bottomShade"),
            Bw("187.5"),
            Gw("97"),
            Ow("187.5"),
            Ww("100"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(49, 104, 90)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0"),
                Hw("rgb(60, 126, 109)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.5"),
                Hw("rgb(71, 148, 129)"),
                kw("1")
            ]), M)
        ])),
        A2(zw, l([
            uw("shuffleDrawing-darkStripeGradiantTop-topShade"),
            Bw("187.5"),
            Gw("-3"),
            Ow("187.5"),
            Ww("97"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0.93"),
                Hw("rgb(71, 148, 129)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(60, 126, 109)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(49, 104, 90)"),
                kw("1")
            ]), M)
        ])),
        A2(zw, l([
            uw("shuffleDrawing-highlight-rectangle2"),
            Bw("187.5"),
            Gw("6"),
            Ow("187.5"),
            Ww("24"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(251, 251, 248)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.25"),
                Hw("rgb(126, 126, 124)"),
                kw("0.5")
            ]), M),
            A2(xw, l([
                Kw("0.58"),
                Hw("rgb(0, 0, 0)"),
                kw("0")
            ]), M)
        ])),
        A2(zw, l([
            uw("shuffleDrawing-reverseHighlight-rectangle3"),
            Bw("187.5"),
            Gw("-0"),
            Ow("187.5"),
            Ww("6"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(0, 0, 0)"),
                kw("0")
            ]), M),
            A2(xw, l([
                Kw("0.43"),
                Hw("rgb(126, 126, 124)"),
                kw("0.5")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(251, 251, 248)"),
                kw("1")
            ]), M)
        ])),
        A2(YL, l([
            uw("shuffleDrawing-levelCompleteInnerShadow-outer"),
            nw("objectBoundingBox")
        ]), l([
            A2(NL, l([
                dw("1")
            ]), M),
            A2(JL, l([
                QL("0"),
                PL("1"),
                Mw("blur")
            ]), M),
            A2(FL, l([
                rw("rgb(85, 85, 85)"),
                ew("1")
            ]), M),
            A2(VL, l([
                iw("blur"),
                fw("in"),
                Mw("colorShadow")
            ]), M),
            A2(VL, l([
                ow("SourceGraphic"),
                iw("colorShadow"),
                fw("over")
            ]), M)
        ])),
        A2(zw, l([
            uw("shuffleDrawing-gradient3-beigeStipeShadow"),
            Bw("187.5"),
            Gw("86.5"),
            Ow("187.5"),
            Ww("89.63"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(252, 246, 213)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.68"),
                Hw("rgb(211, 208, 192)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(170, 170, 170)"),
                kw("1")
            ]), M)
        ]))
    ])), Uw = vr("opacity"), Aw = iL("rect"), Ew = vr("transform"), Tw = uw("boardItemsContainer"), Iw = y, jw = F2(function(n, r) {
        var e = r.d, t = function(r) {
            return r.$ ? nt(A2(Iw, n, r.a)) : it(A2(Iw, t, r.a));
        };
        return A4(Ve, r.a, r.b, A2(Iw, t, r.c), A2(Iw, n, e));
    }), Rw = F2(function(n, r) {
        return A2(jw, jw(n), r);
    }), Qw = Fp("board-item"), Pw = F4(function(n, r, e, t) {
        return {
            aE: t,
            bk: e,
            bl: n,
            bm: r
        };
    }), Vw = A4(Pw, 0, 0, "200", "200"), Fw = F2(function(n, r) {
        return ta(255 * (n / 255 * (1 - r) + r));
    }), Nw = F2(function(n, r) {
        return {
            bE: A2(Fw, n.bE, r),
            ch: A2(Fw, n.ch, r),
            c6: A2(Fw, n.c6, r)
        };
    }), Jw = function(n) {
        return A2(Nw, n, .2);
    }, _w = function(n) {
        return A2(Nw, n, .5);
    }, Yw = vr("fx"), Xw = vr("fy"), nZ = function(n) {
        return Hw(Jp(n));
    }, rZ = {
        bE: 255,
        ch: 255,
        c6: 255
    }, eZ = function(n) {
        return n(Jp(rZ));
    }, tZ = iL("radialGradient"), aZ = F2(function(n, r) {
        var e;
        return o(r.cp, A2(oL, n, l([
            (e = gs(r.bQ), A2(RL, M, l([
                A2(YL, l([
                    uw("canvasBombDrawing-shadowCirlce-outer"),
                    nw("objectBoundingBox")
                ]), l([
                    A2(NL, l([
                        dw("1.5")
                    ]), M),
                    A2(JL, l([
                        QL("2"),
                        PL("2"),
                        Mw("blur")
                    ]), M),
                    A2(FL, l([
                        rw("rgb(85, 85, 85)"),
                        ew("1")
                    ]), M),
                    A2(VL, l([
                        iw("blur"),
                        fw("in"),
                        Mw("colorShadow")
                    ]), M),
                    A2(VL, l([
                        ow("SourceGraphic"),
                        iw("colorShadow"),
                        fw("over")
                    ]), M)
                ])),
                A2(tZ, l([
                    uw("canvasBombDrawing-bombGradient-bombBackground"),
                    TL("77.1"),
                    IL("80.21"),
                    sw("104.69"),
                    Yw("77.07"),
                    Xw("122.58"),
                    yw("userSpaceOnUse")
                ]), l([
                    A2(xw, l([
                        Kw("0.043"),
                        nZ(Jw(e)),
                        kw("1")
                    ]), M),
                    A2(xw, l([
                        Kw("1"),
                        nZ(_w(e)),
                        kw("1")
                    ]), M)
                ])),
                A2(zw, l([
                    uw("canvasBombDrawing-gradient4-highlight"),
                    Bw("60.73"),
                    Gw("27.32"),
                    Ow("79.14"),
                    Ww("94.07"),
                    yw("userSpaceOnUse")
                ]), l([
                    A2(xw, l([
                        Kw("0"),
                        eZ(Hw),
                        kw("1")
                    ]), M),
                    A2(xw, l([
                        Kw("0.47"),
                        eZ(Hw),
                        kw("0.5")
                    ]), M),
                    A2(xw, l([
                        Kw("1"),
                        eZ(Hw),
                        kw("0")
                    ]), M)
                ])),
                A2(YL, l([
                    uw("canvasBombDrawing-bombShadow-outer"),
                    nw("objectBoundingBox")
                ]), l([
                    A2(NL, l([
                        dw("1")
                    ]), M),
                    A2(JL, l([
                        QL("0"),
                        PL("2"),
                        Mw("blur")
                    ]), M),
                    A2(FL, l([
                        rw("rgb(0, 0, 0)"),
                        ew("0.8")
                    ]), M),
                    A2(VL, l([
                        iw("blur"),
                        fw("in"),
                        Mw("colorShadow")
                    ]), M),
                    A2(VL, l([
                        ow("SourceGraphic"),
                        iw("colorShadow"),
                        fw("over")
                    ]), M)
                ]))
            ]))),
            A2(tw, l([
                uw("canvasBombDrawing-bomb")
            ]), l([
                A2(tw, l([
                    uw("canvasBombDrawing-background"),
                    XL("url(#canvasBombDrawing-shadowCirlce-outer)")
                ]), l([
                    A2(bw, l([
                        uw("canvasBombDrawing-bombBackground"),
                        Cw("none"),
                        aL("url(#canvasBombDrawing-bombGradient-bombBackground)"),
                        jL("M 133.1,80.21 C 133.1,111.69 108.03,137.21 77.1,137.21 46.18,137.21 21.1,111.69 21.1,80.21 21.1,48.73 46.18,23.21 77.1,23.21 108.03,23.21 133.1,48.73 133.1,80.21 Z M 133.1,80.21")
                    ]), M),
                    A2(bw, l([
                        uw("canvasBombDrawing-highlight"),
                        _L("evenodd"),
                        Cw("none"),
                        aL("url(#canvasBombDrawing-gradient4-highlight)"),
                        jL("M 77.1,26.44 C 107.55,26.44 125.71,55.19 125.71,74 125.71,92.82 107.55,73.76 77.1,73.76 46.65,73.76 28.5,92.82 28.5,74 28.5,55.19 46.65,26.44 77.1,26.44 Z M 77.1,26.44")
                    ]), M)
                ])),
                A2(tw, l([
                    uw("canvasBombDrawing-groupFuse"),
                    XL("url(#canvasBombDrawing-bombShadow-outer)"),
                    Ew("translate(16.64, 38.77) rotate(-36.26)")
                ]), l([
                    A2(bw, l([
                        uw("canvasBombDrawing-fuseBase"),
                        Cw("none"),
                        aL("rgb(158, 161, 179)"),
                        jL("M 47.72,21.38 C 47.72,29.32 36.59,35.76 22.86,35.76 9.13,35.76 -2,29.32 -2,21.38 -2,13.44 9.13,7 22.86,7 36.59,7 47.72,13.44 47.72,21.38 Z M 47.72,21.38")
                    ]), M),
                    A2(bw, l([
                        uw("canvasBombDrawing-fuseShadow"),
                        Cw("none"),
                        aL("rgb(69, 76, 104)"),
                        jL("M 47.49,22.28 C 47.49,26.07 47.49,29.19 47.49,29.19 47.49,29.27 47.49,29.37 47.49,29.37 47.49,37.66 36.48,44.39 22.91,44.39 9.33,44.39 -1.67,37.66 -1.67,29.37 -1.67,29.37 -1.67,29.27 -1.67,29.19 -1.67,29.17 -1.67,24.46 -1.67,22.28 L -1.55,22.28 C -0.65,30.08 9.98,36.23 22.97,36.23 35.95,36.23 46.58,30.08 47.48,22.28 L 47.49,22.28 Z M 47.49,22.28")
                    ]), M),
                    A2(bw, l([
                        uw("canvasBombDrawing-baseHighlight"),
                        Uw("0.8"),
                        Cw("none"),
                        eZ(aL),
                        jL("M 40.04,1 C 44.96,7.7 40.07,19.64 29.12,27.67 18.17,35.7 5.32,36.77 0.4,30.08 0.26,29.88 0.13,29.68 -0,29.48 5.43,35.05 17.51,33.68 27.87,26.07 38.5,18.28 43.42,6.79 39.19,0 39.5,0.31 39.78,0.65 40.04,1 Z M 40.04,1"),
                        Ew("translate(15.75, -3.17) rotate(36.26)")
                    ]), M),
                    A2(bw, l([
                        uw("canvasBombDrawing-fuseString"),
                        eZ(Cw),
                        hw("10"),
                        lw("round"),
                        vw("round"),
                        gw("10"),
                        aL("none"),
                        jL("M 6.26,23.31 C 6.26,23.31 -5.06,13.92 3.14,3.1"),
                        Ew("translate(29.94, -8.12) rotate(36.26)")
                    ]), M)
                ]))
            ]))
        ])));
    }), uZ = F2(function(n, r) {
        return ta(n / 255 * (1 - r) * 255);
    }), iZ = F2(function(n, r) {
        return {
            bE: A2(uZ, n.bE, r),
            ch: A2(uZ, n.ch, r),
            c6: A2(uZ, n.c6, r)
        };
    }), oZ = function(n) {
        return A2(iZ, n, .5);
    }, cZ = F2(function(n, r) {
        return {
            bE: ta((n.bE + r.bE) / 2),
            ch: ta((n.ch + r.ch) / 2),
            c6: ta((n.c6 + r.c6) / 2)
        };
    }), fZ = function(n) {
        return A2(Nw, n, .3);
    }, bZ = function(n) {
        return nZ(fZ(n));
    }, sZ = vr("k2"), MZ = vr("k3"), dZ = function(n) {
        return A2(Nw, n, .7);
    }, CZ = function(n) {
        return A2(iZ, n, .1);
    }, lZ = function(n) {
        return nZ(CZ(n));
    }, vZ = function(n) {
        return l([
            A2(zw, l([
                uw("diamondWithKana-diamondGradient-outerDiamond"),
                Bw("100"),
                Gw("5"),
                Ow("100"),
                Ww("195"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.5"),
                    Hw(Jp(A2(cZ, fZ(n), CZ(n)))),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    lZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("diamondWithKana-innerSquareGradient-innerDiamond"),
                Bw("99"),
                Gw("14"),
                Ow("99"),
                Ww("184"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.5"),
                    Hw(Jp(A2(cZ, fZ(n), n))),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    nZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(YL, l([
                uw("diamondWithKana-shadow2-outer"),
                nw("objectBoundingBox")
            ]), l([
                A2(NL, l([
                    dw("2")
                ]), M),
                A2(JL, l([
                    QL("1"),
                    PL("1"),
                    Mw("blur")
                ]), M),
                A2(FL, l([
                    rw(Jp(CZ(n))),
                    ew("1")
                ]), M),
                A2(VL, l([
                    iw("blur"),
                    fw("in"),
                    Mw("colorShadow")
                ]), M),
                A2(VL, l([
                    ow("SourceGraphic"),
                    iw("colorShadow"),
                    fw("over")
                ]), M)
            ])),
            A2(zw, l([
                uw("diamondWithKana-squareBottomHighlight-outerDiamond2"),
                Bw("100"),
                Gw("5"),
                Ow("100"),
                Ww("195"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.44"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("diamondWithKana-diamondHighlightGradientReversed-bottom"),
                Bw("101.18"),
                Gw("136.66"),
                Ow("101.18"),
                Ww("186.71"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.26"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("diamondWithKana-diamondHighlightGradient-top"),
                Bw("99"),
                Gw("14"),
                Ow("99"),
                Ww("96"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.32"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ])),
            A2(zw, l([
                uw("diamondWithKana-innerSquareGradiant-bezier2"),
                Bw("100"),
                Gw("25"),
                Ow("100"),
                Ww("175"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.19"),
                    Hw(Jp(A2(cZ, fZ(n), dZ(n)))),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    nZ(dZ(n)),
                    kw("1")
                ]), M)
            ])),
            A2(YL, l([
                uw("diamondWithKana-shadow3-inner"),
                nw("objectBoundingBox")
            ]), l([
                A2(NL, l([
                    ow("SourceAlpha"),
                    dw("1"),
                    Mw("blur")
                ]), M),
                A2(JL, l([
                    QL("0"),
                    PL("6")
                ]), M),
                A2(VL, l([
                    iw("SourceAlpha"),
                    fw("arithmetic"),
                    sZ("-1.15"),
                    MZ("1.15"),
                    Mw("shadowDiff")
                ]), M),
                A2(FL, l([
                    rw(Jp(n)),
                    ew("1")
                ]), M),
                A2(VL, l([
                    iw("shadowDiff"),
                    fw("in")
                ]), M),
                A2(VL, l([
                    iw("SourceGraphic"),
                    fw("over")
                ]), M)
            ])),
            A2(zw, l([
                uw("diamondWithKana-diamondInnerHighlightGradientReversed-bezier4"),
                Bw("99.68"),
                Gw("117.66"),
                Ow("99.68"),
                Ww("167.71"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.58"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("0.82"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("diamondWithKana-diamondInnerHighlight-bezier"),
                Bw("99.68"),
                Gw("87.04"),
                Ow("99.68"),
                Ww("37"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.54"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("0.85"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ]))
        ]);
    }, gZ = vr("font-family"), hZ = vr("font-size"), pZ = vr("font-weight"), LZ = function(n) {
        return A2(iZ, n, .5);
    }, wZ = F2(function(n, r) {
        return A2(fr, n, Zr(r));
    }), ZZ = wZ("http://www.w3.org/2000/svg"), mZ = iL("tspan"), SZ = F2(function(n, r) {
        return A2(tw, l([
            uw("diamondWithKana-groupInnerDiamond")
        ]), l([
            A2(bw, l([
                uw("diamondWithKana-bezier2"),
                _L("evenodd"),
                Cw("none"),
                aL("url(#diamondWithKana-innerSquareGradiant-bezier2)"),
                XL("url(#diamondWithKana-shadow3-inner)"),
                jL("M 100,25 C 125,25 175,75 175,100 175,125 125,175 100,175 75,175 25,125 25,100 25,75 75,25 100,25 Z M 100,25")
            ]), M),
            A2(tw, l([
                uw("diamondWithKana-highlights")
            ]), l([
                A2(bw, l([
                    uw("diamondWithKana-bezier4"),
                    _L("evenodd"),
                    Cw("none"),
                    aL("url(#diamondWithKana-diamondInnerHighlightGradientReversed-bezier4)"),
                    jL("M 99.68,117.66 C 115.12,117.66 146,125 146,133.34 146,141.68 115.12,167.71 99.68,167.71 84.24,167.71 53.37,141.68 53.37,133.34 53.37,125 84.24,117.66 99.68,117.66 Z M 99.68,117.66")
                ]), M),
                A2(bw, l([
                    uw("diamondWithKana-bezier"),
                    _L("evenodd"),
                    Cw("none"),
                    aL("url(#diamondWithKana-diamondInnerHighlight-bezier)"),
                    jL("M 99.68,87.04 C 115.12,87.04 146,79.7 146,71.36 146,63.02 115.12,37 99.68,37 84.24,37 53.37,63.02 53.37,71.36 53.37,79.7 84.24,87.04 99.68,87.04 Z M 99.68,87.04")
                ]), M)
            ])),
            A3(ZZ, "text", l([
                aL(Jp(LZ(r))),
                gZ("Helvetica-Bold, Helvetica, sans-serif"),
                pZ("bold"),
                hZ("95"),
                cL("54"),
                bL("47"),
                lL("middle")
            ]), l([
                A2(mZ, l([
                    cL("50%"),
                    bL("70%")
                ]), l([
                    pL(n)
                ]))
            ]))
        ]));
    }), $Z = F3(function(n, r, e) {
        var t = e.bQ;
        return o(e.cp, A2(oL, r, l([
            A2(RL, M, vZ(gs(t))),
            A2(tw, l([
                uw("diamondWithKana-group")
            ]), l([
                A2(tw, l([
                    uw("diamondWithKana-group2")
                ]), l([
                    A2(tw, l([
                        uw("diamondWithKana-group3"),
                        Ew("")
                    ]), l([
                        A2(tw, l([
                            uw("diamondWithKana-group4")
                        ]), l([
                            A2(bw, l([
                                uw("diamondWithKana-diamondShadow"),
                                _L("evenodd"),
                                Cw("none"),
                                aL(Jp(oZ(gs(t)))),
                                jL("M 102,7 C 133.67,7 197,70.33 197,102 197,133.67 133.67,197 102,197 70.33,197 7,133.67 7,102 7,70.33 70.33,7 102,7 Z M 102,7")
                            ]), M),
                            A2(bw, l([
                                uw("diamondWithKana-outerDiamond"),
                                _L("evenodd"),
                                Cw("none"),
                                aL("url(#diamondWithKana-diamondGradient-outerDiamond)"),
                                jL("M 100,5 C 131.67,5 195,68.33 195,100 195,131.67 131.67,195 100,195 68.33,195 5,131.67 5,100 5,68.33 68.33,5 100,5 Z M 100,5")
                            ]), M),
                            A2(bw, l([
                                uw("diamondWithKana-innerDiamond"),
                                _L("evenodd"),
                                Cw("none"),
                                aL("url(#diamondWithKana-innerSquareGradient-innerDiamond)"),
                                XL("url(#diamondWithKana-shadow2-outer)"),
                                jL("M 99,14 C 127.33,14 184,70.67 184,99 184,127.33 127.33,184 99,184 70.67,184 14,127.33 14,99 14,70.67 70.67,14 99,14 Z M 99,14")
                            ]), M),
                            A2(tw, l([
                                uw("diamondWithKana-groupHighlights")
                            ]), l([
                                A2(bw, l([
                                    uw("diamondWithKana-outerDiamond2"),
                                    _L("evenodd"),
                                    Cw("none"),
                                    aL("url(#diamondWithKana-squareBottomHighlight-outerDiamond2)"),
                                    jL("M 100,5 C 131.67,5 195,68.33 195,100 195,131.67 131.67,195 100,195 68.33,195 5,131.67 5,100 5,68.33 68.33,5 100,5 Z M 100,5")
                                ]), M),
                                A2(bw, l([
                                    uw("diamondWithKana-bottom"),
                                    Uw("0.4"),
                                    _L("evenodd"),
                                    Cw("none"),
                                    aL("url(#diamondWithKana-diamondHighlightGradientReversed-bottom)"),
                                    jL("M 101.18,136.66 C 116.79,136.66 148,144 148,152.34 148,160.68 116.79,186.71 101.18,186.71 85.58,186.71 54.37,160.68 54.37,152.34 54.37,144 85.58,136.66 101.18,136.66 Z M 101.18,136.66")
                                ]), M),
                                A2(bw, l([
                                    uw("diamondWithKana-top"),
                                    _L("evenodd"),
                                    Cw("none"),
                                    aL("url(#diamondWithKana-diamondHighlightGradient-top)"),
                                    jL("M 99,14 C 125.68,14 165,51.61 165,70.41 165,89.21 125.68,96 99,96 72.32,96 33,89.21 33,70.41 33,51.61 72.32,14 99,14 Z M 99,14")
                                ]), M)
                            ]))
                        ]))
                    ]))
                ])),
                n.$ ? pL("") : A2(SZ, n.a, gs(t))
            ]))
        ])));
    }), DZ = A2(RL, M, l([
        A2(YL, l([
            uw("canvas3-shadowCirlce-outer"),
            nw("objectBoundingBox")
        ]), l([
            A2(NL, l([
                dw("1.5")
            ]), M),
            A2(JL, l([
                QL("2"),
                PL("2"),
                Mw("blur")
            ]), M),
            A2(FL, l([
                rw("rgb(85, 85, 85)"),
                ew("1")
            ]), M),
            A2(VL, l([
                iw("blur"),
                fw("in"),
                Mw("colorShadow")
            ]), M),
            A2(VL, l([
                ow("SourceGraphic"),
                iw("colorShadow"),
                fw("over")
            ]), M)
        ])),
        A2(zw, l([
            uw("canvas3-gradientGreen-ovalGreen"),
            Bw("157.55"),
            Gw("44.43"),
            Ow("42.45"),
            Ww("155.57"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0.04"),
                Hw("rgb(47, 225, 0)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.25"),
                Hw("rgb(24, 112, 0)"),
                kw("0.5")
            ]), M),
            A2(xw, l([
                Kw("0.42"),
                Hw("rgb(0, 0, 0)"),
                kw("0")
            ]), M)
        ])),
        A2(zw, l([
            uw("canvas3-gradientBlue-ovalBlue"),
            Bw("47.51"),
            Gw("39.62"),
            Ow("152.49"),
            Ww("160.38"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0.07"),
                Hw("rgb(0, 21, 255)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.35"),
                Hw("rgb(0, 11, 128)"),
                kw("0.5")
            ]), M),
            A2(xw, l([
                Kw("0.78"),
                Hw("rgb(0, 0, 0)"),
                kw("0")
            ]), M)
        ])),
        A2(zw, l([
            uw("canvas3-gradientYellow-ovalYellow"),
            Bw("174.71"),
            Gw("128.68"),
            Ow("25.29"),
            Ww("71.32"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0.03"),
                Hw("rgb(255, 240, 55)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.22"),
                Hw("rgb(128, 120, 27)"),
                kw("0.5")
            ]), M),
            A2(xw, l([
                Kw("0.38"),
                Hw("rgb(0, 0, 0)"),
                kw("0")
            ]), M)
        ])),
        A2(zw, l([
            uw("canvas3-gradientRed-ovalRed"),
            Bw("113.89"),
            Gw("178.8"),
            Ow("86.11"),
            Ww("21.2"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0.1"),
                Hw("rgb(229, 0, 0)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.45"),
                Hw("rgb(114, 0, 0)"),
                kw("0.5")
            ]), M),
            A2(xw, l([
                Kw("0.57"),
                Hw("rgb(0, 0, 0)"),
                kw("0")
            ]), M)
        ])),
        A2(zw, l([
            uw("canvas3-gradientPurple-ovalPurple"),
            Bw("20.11"),
            Gw("104.19"),
            Ow("179.89"),
            Ww("95.81"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0.07"),
                Hw("rgb(196, 93, 255)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.3"),
                Hw("rgb(98, 47, 128)"),
                kw("0.5")
            ]), M),
            A2(xw, l([
                Kw("0.44"),
                Hw("rgb(0, 0, 0)"),
                kw("0")
            ]), M)
        ])),
        A2(zw, l([
            uw("canvas3-gradient4-bezier"),
            Bw("76.61"),
            Gw("25.76"),
            Ow("102.91"),
            Ww("119.44"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                eZ(Hw),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.47"),
                eZ(Hw),
                kw("0.5")
            ]), M),
            A2(xw, l([
                Kw("1"),
                eZ(Hw),
                kw("0")
            ]), M)
        ])),
        A2(YL, l([
            uw("canvas3-kanjiShadow-outer"),
            nw("objectBoundingBox")
        ]), l([
            A2(NL, l([
                dw("1.5")
            ]), M),
            A2(JL, l([
                QL("1"),
                PL("1"),
                Mw("blur")
            ]), M),
            A2(FL, l([
                rw("rgb(0, 0, 0)"),
                ew("1")
            ]), M),
            A2(VL, l([
                iw("blur"),
                fw("in"),
                Mw("colorShadow")
            ]), M),
            A2(VL, l([
                ow("SourceGraphic"),
                iw("colorShadow"),
                fw("over")
            ]), M)
        ]))
    ])), yZ = F2(function(n, r) {
        return A2(tw, l([
            uw("hexagonWithKana-group")
        ]), l([
            A2(bw, l([
                uw("hexagonWithKana-innerHexagon"),
                _L("evenodd"),
                Cw("none"),
                aL("url(#hexagonWithKana-innerSquareGradiant-innerHexagon)"),
                XL("url(#hexagonWithKana-shadow3-inner)"),
                jL("M 168,99.93 C 168,103.38 167.11,106.78 165.43,109.77 L 140.96,153.16 C 137.54,159.23 131.16,163 124.32,163 L 75.39,163 C 68.55,163 62.17,159.23 58.75,153.16 L 34.29,109.77 C 32.6,106.78 31.71,103.38 31.71,99.93 31.71,96.48 32.6,93.07 34.29,90.08 L 58.75,46.69 C 62.17,40.62 68.55,36.85 75.39,36.85 L 124.32,36.85 C 131.16,36.85 137.54,40.62 140.96,46.69 L 165.43,90.08 C 167.11,93.07 168,96.48 168,99.93 Z M 168,99.93")
            ]), M),
            A2(tw, l([
                uw("hexagonWithKana-highlights")
            ]), l([
                A2(bw, l([
                    uw("hexagonWithKana-bezier3"),
                    _L("evenodd"),
                    Cw("none"),
                    aL("url(#hexagonWithKana-hexagonBottomInnerHighlightGradient-bezier3)"),
                    jL("M 168,99.93 C 168,103.38 167.11,106.78 165.42,109.77 L 140.96,153.16 C 137.54,159.23 131.16,163 124.32,163 L 75.39,163 C 68.55,163 62.17,159.23 58.75,153.16 L 34.28,109.77 C 32.6,106.78 31.71,103.38 31.71,99.93 31.71,96.48 32.6,93.07 34.28,90.08 L 58.75,46.69 C 62.17,40.62 68.55,36.85 75.39,36.85 L 124.32,36.85 C 131.16,36.85 137.54,40.62 140.96,46.69 L 165.42,90.08 C 167.11,93.07 168,96.48 168,99.93 Z M 168,99.93")
                ]), M),
                A2(bw, l([
                    uw("hexagonWithKana-bezier"),
                    Uw("0.9"),
                    _L("evenodd"),
                    Cw("none"),
                    aL("url(#hexagonWithKana-hexagonInnerHighlight-bezier)"),
                    jL("M 163.56,102.23 C 163.56,105.44 162.73,108.61 161.16,111.39 L 138.4,151.76 C 135.21,157.41 129.28,160.92 122.91,160.92 L 77.39,160.92 C 71.02,160.92 65.08,157.41 61.9,151.76 L 39.14,111.39 C 37.57,108.61 36.74,105.44 36.74,102.23 36.74,99.02 37.57,95.86 39.14,93.08 L 61.9,52.7 C 65.08,47.06 71.02,43.55 77.39,43.55 L 122.91,43.55 C 129.28,43.55 135.21,47.06 138.4,52.7 L 161.16,93.08 C 162.73,95.86 163.56,99.02 163.56,102.23 Z M 163.56,102.23")
                ]), M)
            ])),
            A3(ZZ, "text", l([
                aL(Jp(LZ(r))),
                gZ("Helvetica-Bold, Helvetica, sans-serif"),
                pZ("bold"),
                hZ("95"),
                cL("52"),
                bL("36"),
                lL("middle")
            ]), l([
                A2(mZ, l([
                    cL("50%"),
                    bL("70%")
                ]), l([
                    pL(n)
                ]))
            ]))
        ]));
    }), zZ = F3(function(n, r, e) {
        var t = e.bQ;
        return o(e.cp, A2(oL, r, l([
            A2(RL, M, l([
                A2(zw, l([
                    uw("hexagonWithKana-innerSquareGradient-bezier4"),
                    Bw("101.08"),
                    Gw("25.3"),
                    Ow("101.08"),
                    Ww("174.46"),
                    yw("userSpaceOnUse")
                ]), l([
                    A2(xw, l([
                        Kw("0"),
                        bZ(gs(t)),
                        kw("1")
                    ]), M),
                    A2(xw, l([
                        Kw("1"),
                        lZ(gs(t)),
                        kw("1")
                    ]), M)
                ])),
                A2(YL, l([
                    uw("hexagonWithKana-shadow2-outer"),
                    nw("objectBoundingBox")
                ]), l([
                    A2(NL, l([
                        dw("2")
                    ]), M),
                    A2(JL, l([
                        QL("1"),
                        PL("1"),
                        Mw("blur")
                    ]), M),
                    A2(FL, l([
                        rw(Jp(CZ(gs(t)))),
                        ew("1")
                    ]), M),
                    A2(VL, l([
                        iw("blur"),
                        fw("in"),
                        Mw("colorShadow")
                    ]), M),
                    A2(VL, l([
                        ow("SourceGraphic"),
                        iw("colorShadow"),
                        fw("over")
                    ]), M)
                ])),
                A2(zw, l([
                    uw("hexagonWithKana-squareBottomHighlight-bezier5"),
                    Bw("100.6"),
                    Gw("16.71"),
                    Ow("100.6"),
                    Ww("184"),
                    yw("userSpaceOnUse")
                ]), l([
                    A2(xw, l([
                        Kw("0.44"),
                        eZ(Hw),
                        kw("0")
                    ]), M),
                    A2(xw, l([
                        Kw("1"),
                        eZ(Hw),
                        kw("0.5")
                    ]), M),
                    A2(xw, l([
                        Kw("1"),
                        eZ(Hw),
                        kw("1")
                    ]), M)
                ])),
                A2(zw, l([
                    uw("hexagonWithKana-hexagonBottomHighlightGradient-bezier7"),
                    Bw("65.05"),
                    Gw("38.36"),
                    Ow("142.16"),
                    Ww("171.92"),
                    yw("userSpaceOnUse")
                ]), l([
                    A2(xw, l([
                        Kw("0.79"),
                        eZ(Hw),
                        kw("0")
                    ]), M),
                    A2(xw, l([
                        Kw("1"),
                        eZ(Hw),
                        kw("0.5")
                    ]), M),
                    A2(xw, l([
                        Kw("1"),
                        eZ(Hw),
                        kw("1")
                    ]), M)
                ])),
                A2(zw, l([
                    uw("hexagonWithKana-hexagonHighlightGradient-bezier8"),
                    Bw("100.6"),
                    Gw("24.71"),
                    Ow("100.6"),
                    Ww("164.42"),
                    yw("userSpaceOnUse")
                ]), l([
                    A2(xw, l([
                        Kw("0"),
                        eZ(Hw),
                        kw("1")
                    ]), M),
                    A2(xw, l([
                        Kw("0.23"),
                        eZ(Hw),
                        kw("0.5")
                    ]), M),
                    A2(xw, l([
                        Kw("0.53"),
                        eZ(Hw),
                        kw("0")
                    ]), M)
                ])),
                A2(zw, l([
                    uw("hexagonWithKana-innerSquareGradiant-innerHexagon"),
                    Bw("99.86"),
                    Gw("36.85"),
                    Ow("99.86"),
                    Ww("163"),
                    yw("userSpaceOnUse")
                ]), l([
                    A2(xw, l([
                        Kw("0"),
                        bZ(gs(t)),
                        kw("1")
                    ]), M),
                    A2(xw, l([
                        Kw("0.19"),
                        Hw(Jp(A2(cZ, fZ(gs(t)), dZ(gs(t))))),
                        kw("1")
                    ]), M),
                    A2(xw, l([
                        Kw("1"),
                        nZ(dZ(gs(t))),
                        kw("1")
                    ]), M)
                ])),
                A2(YL, l([
                    uw("hexagonWithKana-shadow3-inner"),
                    nw("objectBoundingBox")
                ]), l([
                    A2(NL, l([
                        ow("SourceAlpha"),
                        dw("1"),
                        Mw("blur")
                    ]), M),
                    A2(JL, l([
                        QL("0"),
                        PL("6")
                    ]), M),
                    A2(VL, l([
                        iw("SourceAlpha"),
                        fw("arithmetic"),
                        sZ("-1.15"),
                        MZ("1.15"),
                        Mw("shadowDiff")
                    ]), M),
                    A2(FL, l([
                        rw(Jp(gs(t))),
                        ew("1")
                    ]), M),
                    A2(VL, l([
                        iw("shadowDiff"),
                        fw("in")
                    ]), M),
                    A2(VL, l([
                        iw("SourceGraphic"),
                        fw("over")
                    ]), M)
                ])),
                A2(zw, l([
                    uw("hexagonWithKana-hexagonBottomInnerHighlightGradient-bezier3"),
                    Bw("65.17"),
                    Gw("39.85"),
                    Ow("134.54"),
                    Ww("160"),
                    yw("userSpaceOnUse")
                ]), l([
                    A2(xw, l([
                        Kw("0.74"),
                        eZ(Hw),
                        kw("0")
                    ]), M),
                    A2(xw, l([
                        Kw("0.97"),
                        eZ(Hw),
                        kw("0.5")
                    ]), M),
                    A2(xw, l([
                        Kw("1"),
                        eZ(Hw),
                        kw("1")
                    ]), M)
                ])),
                A2(zw, l([
                    uw("hexagonWithKana-hexagonInnerHighlight-bezier"),
                    Bw("100.15"),
                    Gw("43.55"),
                    Ow("100.15"),
                    Ww("160.92"),
                    yw("userSpaceOnUse")
                ]), l([
                    A2(xw, l([
                        Kw("0"),
                        eZ(Hw),
                        kw("1")
                    ]), M),
                    A2(xw, l([
                        Kw("0.22"),
                        eZ(Hw),
                        kw("0.5")
                    ]), M),
                    A2(xw, l([
                        Kw("0.45"),
                        eZ(Hw),
                        kw("0")
                    ]), M)
                ]))
            ])),
            A2(tw, l([
                uw("hexagonWithKana-group2")
            ]), l([
                A2(tw, l([
                    uw("hexagonWithKana-group3")
                ]), l([
                    A2(tw, l([
                        uw("hexagonWithKana-group4"),
                        Ew("")
                    ]), l([
                        A2(tw, l([
                            uw("hexagonWithKana-group5")
                        ]), l([
                            A2(bw, l([
                                uw("hexagonWithKana-bezier6"),
                                _L("evenodd"),
                                Cw("none"),
                                aL(Jp(oZ(gs(t)))),
                                jL("M 195.2,102.35 C 195.2,106.93 193.99,111.44 191.7,115.4 L 158.46,172.95 C 153.81,181 145.14,186 135.84,186 L 69.36,186 C 60.06,186 51.39,181 46.74,172.95 L 13.5,115.4 C 11.21,111.44 10,106.93 10,102.35 10,97.78 11.21,93.26 13.5,89.3 L 46.74,31.76 C 51.39,23.71 60.06,18.71 69.36,18.71 L 135.84,18.71 C 145.14,18.71 153.81,23.71 158.46,31.76 L 191.7,89.3 C 193.99,93.26 195.2,97.78 195.2,102.35 Z M 195.2,102.35")
                            ]), M),
                            A2(bw, l([
                                uw("hexagonWithKana-bezier2"),
                                _L("evenodd"),
                                Cw("none"),
                                aL(Jp(gs(t))),
                                jL("M 193.2,100.35 C 193.2,104.93 191.99,109.44 189.7,113.4 L 156.46,170.95 C 151.81,179 143.14,184 133.84,184 L 67.36,184 C 58.06,184 49.39,179 44.74,170.95 L 11.5,113.4 C 9.21,109.44 8,104.93 8,100.35 8,95.78 9.21,91.26 11.5,87.3 L 44.74,29.76 C 49.39,21.71 58.06,16.71 67.36,16.71 L 133.84,16.71 C 143.14,16.71 151.81,21.71 156.46,29.76 L 189.7,87.3 C 191.99,91.26 193.2,95.78 193.2,100.35 Z M 193.2,100.35")
                            ]), M),
                            A2(bw, l([
                                uw("hexagonWithKana-bezier4"),
                                _L("evenodd"),
                                Cw("none"),
                                aL("url(#hexagonWithKana-innerSquareGradient-bezier4)"),
                                XL("url(#hexagonWithKana-shadow2-outer)"),
                                jL("M 183.67,99.88 C 183.67,103.96 182.59,107.98 180.55,111.51 L 150.9,162.82 C 146.75,170 139.02,174.46 130.72,174.46 L 71.43,174.46 C 63.14,174.46 55.41,170 51.26,162.82 L 21.61,111.51 C 19.57,107.98 18.49,103.96 18.49,99.88 18.49,95.8 19.57,91.77 21.61,88.24 L 51.26,36.93 C 55.41,29.76 63.14,25.3 71.43,25.3 L 130.72,25.3 C 139.02,25.3 146.75,29.76 150.9,36.93 L 180.55,88.24 C 182.59,91.77 183.67,95.8 183.67,99.88 Z M 183.67,99.88")
                            ]), M),
                            A2(tw, l([
                                uw("hexagonWithKana-group6")
                            ]), l([
                                A2(bw, l([
                                    uw("hexagonWithKana-bezier5"),
                                    _L("evenodd"),
                                    Cw("none"),
                                    aL("url(#hexagonWithKana-squareBottomHighlight-bezier5)"),
                                    jL("M 193.2,100.35 C 193.2,104.93 191.99,109.44 189.7,113.4 L 156.46,170.95 C 151.81,179 143.14,184 133.84,184 L 67.36,184 C 58.06,184 49.39,179 44.74,170.95 L 11.5,113.4 C 9.21,109.44 8,104.93 8,100.35 8,95.78 9.21,91.26 11.5,87.3 L 44.74,29.76 C 49.39,21.71 58.06,16.71 67.36,16.71 L 133.84,16.71 C 143.14,16.71 151.81,21.71 156.46,29.76 L 189.7,87.3 C 191.99,91.26 193.2,95.78 193.2,100.35 Z M 193.2,100.35")
                                ]), M),
                                A2(bw, l([
                                    uw("hexagonWithKana-bezier7"),
                                    _L("evenodd"),
                                    Cw("none"),
                                    aL("url(#hexagonWithKana-hexagonBottomHighlightGradient-bezier7)"),
                                    jL("M 180.2,105.14 C 180.2,108.96 179.2,112.73 177.31,116.04 L 149.81,164.1 C 145.96,170.82 138.79,175 131.1,175 L 76.1,175 C 68.41,175 61.24,170.82 57.39,164.1 L 29.89,116.04 C 28,112.73 27,108.96 27,105.14 27,101.32 28,97.55 29.89,94.24 L 57.39,46.19 C 61.24,39.46 68.41,35.29 76.1,35.29 L 131.1,35.29 C 138.79,35.29 145.96,39.46 149.81,46.19 L 177.31,94.24 C 179.2,97.55 180.2,101.32 180.2,105.14 Z M 180.2,105.14")
                                ]), M),
                                A2(bw, l([
                                    uw("hexagonWithKana-bezier8"),
                                    Uw("0.9"),
                                    _L("evenodd"),
                                    Cw("none"),
                                    aL("url(#hexagonWithKana-hexagonHighlightGradient-bezier8)"),
                                    jL("M 177.2,94.56 C 177.2,98.39 176.2,102.16 174.31,105.46 L 146.81,153.52 C 142.96,160.25 135.79,164.42 128.1,164.42 L 73.1,164.42 C 65.41,164.42 58.24,160.25 54.39,153.52 L 26.89,105.46 C 25,102.16 24,98.39 24,94.56 24,90.74 25,86.97 26.89,83.66 L 54.39,35.61 C 58.24,28.88 65.41,24.71 73.1,24.71 L 128.1,24.71 C 135.79,24.71 142.96,28.88 146.81,35.61 L 174.31,83.66 C 176.2,86.97 177.2,90.74 177.2,94.56 Z M 177.2,94.56")
                                ]), M)
                            ]))
                        ]))
                    ]))
                ])),
                n.$ ? pL("") : A2(yZ, n.a, gs(t))
            ]))
        ])));
    }), KZ = function(n) {
        return l([
            A2(zw, l([
                uw("ovalWithKana-squareGradient-outerOval"),
                Bw("100"),
                Gw("10"),
                Ow("100"),
                Ww("190"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    lZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("ovalWithKana-innerSquareGradient-innerOval4"),
                Bw("100.16"),
                Gw("20.39"),
                Ow("100.16"),
                Ww("179.22"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.5"),
                    Hw(Jp(A2(cZ, fZ(n), n))),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    nZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(YL, l([
                uw("ovalWithKana-shadow2-outer"),
                nw("objectBoundingBox")
            ]), l([
                A2(NL, l([
                    dw("2")
                ]), M),
                A2(JL, l([
                    QL("1"),
                    PL("1"),
                    Mw("blur")
                ]), M),
                A2(FL, l([
                    rw(Jp(CZ(n))),
                    ew("1")
                ]), M),
                A2(VL, l([
                    iw("blur"),
                    fw("in"),
                    Mw("colorShadow")
                ]), M),
                A2(VL, l([
                    ow("SourceGraphic"),
                    iw("colorShadow"),
                    fw("over")
                ]), M)
            ])),
            A2(zw, l([
                uw("ovalWithKana-squareBottomHighlight-outerOval2"),
                Bw("100"),
                Gw("10"),
                Ow("100"),
                Ww("190"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.44"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("ovalWithKana-ovalBottomHighlightGradient-bottomRight"),
                Bw("89.86"),
                Gw("72.46"),
                Ow("142.17"),
                Ww("163.07"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.82"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("ovalWithKana-ovalHighlightGradient-top"),
                Bw("100.89"),
                Gw("21.21"),
                Ow("100.89"),
                Ww("126.93"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.36"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ])),
            A2(zw, l([
                uw("ovalWithKana-innerSquareGradiant-innerOval"),
                Bw("101.65"),
                Gw("25"),
                Ow("101.65"),
                Ww("169.23"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.19"),
                    Hw(Jp(A2(cZ, fZ(n), dZ(n)))),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    nZ(dZ(n)),
                    kw("1")
                ]), M)
            ])),
            A2(YL, l([
                uw("ovalWithKana-shadow3-inner"),
                nw("objectBoundingBox")
            ]), l([
                A2(NL, l([
                    ow("SourceAlpha"),
                    dw("1"),
                    Mw("blur")
                ]), M),
                A2(JL, l([
                    QL("0"),
                    PL("6")
                ]), M),
                A2(VL, l([
                    iw("SourceAlpha"),
                    fw("arithmetic"),
                    sZ("-1.15"),
                    MZ("1.15"),
                    Mw("shadowDiff")
                ]), M),
                A2(FL, l([
                    rw(Jp(n)),
                    ew("1")
                ]), M),
                A2(VL, l([
                    iw("shadowDiff"),
                    fw("in")
                ]), M),
                A2(VL, l([
                    iw("SourceGraphic"),
                    fw("over")
                ]), M)
            ])),
            A2(zw, l([
                uw("ovalWithKana-ovalInnerHighlight-innerOval2"),
                Bw("100.92"),
                Gw("42.4"),
                Ow("100.92"),
                Ww("128.24"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.26"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ])),
            A2(zw, l([
                uw("ovalWithKana-ovalBottomInnerHighlightGradient2-innerOval3"),
                Bw("49.24"),
                Gw("44.6"),
                Ow("154.18"),
                Ww("149.54"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.73"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("0.93"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ]))
        ]);
    }, xZ = F2(function(n, r) {
        return A2(tw, l([
            uw("ovalWithKana-group")
        ]), l([
            A2(bw, l([
                uw("ovalWithKana-innerOval"),
                Cw("none"),
                aL("url(#ovalWithKana-innerSquareGradiant-innerOval)"),
                XL("url(#ovalWithKana-shadow3-inner)"),
                jL("M 173.41,96.26 C 173.41,139.86 144.28,169.23 102.07,169.23 59.86,169.23 29.89,139.86 29.89,96.26 29.89,52.66 59.86,25 102.07,25 144.28,25 173.41,52.66 173.41,96.26 Z M 173.41,96.26")
            ]), M),
            A2(tw, l([
                uw("ovalWithKana-highlights")
            ]), l([
                A2(bw, l([
                    uw("ovalWithKana-innerOval2"),
                    Cw("none"),
                    aL("url(#ovalWithKana-ovalInnerHighlight-innerOval2)"),
                    jL("M 157.76,84.81 C 157.76,110.76 134.69,128.24 101.26,128.24 67.82,128.24 44.08,110.76 44.08,84.81 44.08,58.86 67.82,42.4 101.26,42.4 134.69,42.4 157.76,58.86 157.76,84.81 Z M 157.76,84.81")
                ]), M),
                A2(bw, l([
                    uw("ovalWithKana-innerOval3"),
                    Cw("none"),
                    aL("url(#ovalWithKana-ovalBottomInnerHighlightGradient2-innerOval3)"),
                    jL("M 174,96.64 C 174,140.47 144.58,170 101.93,170 59.28,170 29,140.47 29,96.64 29,52.81 59.28,25 101.93,25 144.58,25 174,52.81 174,96.64 Z M 174,96.64")
                ]), M)
            ])),
            A3(ZZ, "text", l([
                aL(Jp(LZ(r))),
                gZ("ArialMT, Arial, 'Helvetica Neue', Helvetica, sans-serif"),
                hZ("95"),
                cL("53"),
                bL("36"),
                lL("middle")
            ]), l([
                A2(mZ, l([
                    cL("50%"),
                    bL("70%")
                ]), l([
                    pL(n)
                ]))
            ]))
        ]));
    }), HZ = F3(function(n, r, e) {
        var t = e.bQ;
        return o(e.cp, A2(oL, r, l([
            A2(RL, M, KZ(gs(t))),
            A2(tw, l([
                uw("ovalWithKana-group2")
            ]), l([
                A2(tw, l([
                    uw("ovalWithKana-group3")
                ]), l([
                    A2(tw, l([
                        uw("ovalWithKana-group4"),
                        Ew("")
                    ]), l([
                        A2(tw, l([
                            uw("ovalWithKana-group5")
                        ]), l([
                            A2(bw, l([
                                uw("ovalWithKana-ovalShadow"),
                                Cw("none"),
                                aL(Jp(oZ(gs(t)))),
                                jL("M 192,100.93 C 192,155.35 155.47,192 102.53,192 49.59,192 12,155.35 12,100.93 12,46.52 49.59,12 102.53,12 155.47,12 192,46.52 192,100.93 Z M 192,100.93")
                            ]), M),
                            A2(bw, l([
                                uw("ovalWithKana-outerOval"),
                                Cw("none"),
                                aL("url(#ovalWithKana-squareGradient-outerOval)"),
                                jL("M 190,98.93 C 190,153.35 153.47,190 100.53,190 47.59,190 10,153.35 10,98.93 10,44.52 47.59,10 100.53,10 153.47,10 190,44.52 190,98.93 Z M 190,98.93")
                            ]), M),
                            A2(bw, l([
                                uw("ovalWithKana-innerOval4"),
                                Cw("none"),
                                aL("url(#ovalWithKana-innerSquareGradient-innerOval4)"),
                                XL("url(#ovalWithKana-shadow2-outer)"),
                                jL("M 179.57,98.87 C 179.57,146.88 147.34,179.22 100.63,179.22 53.91,179.22 20.74,146.88 20.74,98.87 20.74,50.86 53.91,20.39 100.63,20.39 147.34,20.39 179.57,50.86 179.57,98.87 Z M 179.57,98.87")
                            ]), M),
                            A2(tw, l([
                                uw("ovalWithKana-groupHighlights")
                            ]), l([
                                A2(bw, l([
                                    uw("ovalWithKana-outerOval2"),
                                    Cw("none"),
                                    aL("url(#ovalWithKana-squareBottomHighlight-outerOval2)"),
                                    jL("M 190,98.93 C 190,153.35 153.47,190 100.53,190 47.59,190 10,153.35 10,98.93 10,44.52 47.59,10 100.53,10 153.47,10 190,44.52 190,98.93 Z M 190,98.93")
                                ]), M),
                                A2(bw, l([
                                    uw("ovalWithKana-bottomRight"),
                                    Cw("none"),
                                    aL("url(#ovalWithKana-ovalBottomHighlightGradient-bottomRight)"),
                                    jL("M 167.39,117.34 C 167.39,148.33 146.44,169.21 116.09,169.21 85.73,169.21 64.18,148.33 64.18,117.34 64.18,86.34 85.73,66.67 116.09,66.67 146.44,66.67 167.39,86.34 167.39,117.34 Z M 167.39,117.34")
                                ]), M),
                                A2(bw, l([
                                    uw("ovalWithKana-top"),
                                    Uw("0.9"),
                                    Cw("none"),
                                    aL("url(#ovalWithKana-ovalHighlightGradient-top)"),
                                    jL("M 167.39,73.45 C 167.39,105.4 140.4,126.93 101.28,126.93 62.16,126.93 34.39,105.4 34.39,73.45 34.39,41.49 62.16,21.21 101.28,21.21 140.4,21.21 167.39,41.49 167.39,73.45 Z M 167.39,73.45")
                                ]), M)
                            ]))
                        ]))
                    ]))
                ])),
                n.$ ? A2(tw, M, M) : A2(xZ, n.a, gs(t))
            ]))
        ])));
    }), kZ = F3(function(n, r, e) {
        return r(e.aw) ? A2(dt, 1, Gs(n(e))) : Ye;
    }), BZ = function(n) {
        return A2(RL, M, l([
            A2(zw, l([
                uw("squareWithKana-squareGradient-outerSquare"),
                Bw("98"),
                Gw("8"),
                Ow("98"),
                Ww("188"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    lZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("squareWithKana-innerSquareGradient-innerSquare"),
                Bw("97.51"),
                Gw("14.81"),
                Ow("97.51"),
                Ww("176.32"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    nZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(YL, l([
                uw("squareWithKana-shadow2-outer"),
                nw("objectBoundingBox")
            ]), l([
                A2(NL, l([
                    dw("2")
                ]), M),
                A2(JL, l([
                    QL("1"),
                    PL("1"),
                    Mw("blur")
                ]), M),
                A2(FL, l([
                    rw(Jp(CZ(n))),
                    ew("1")
                ]), M),
                A2(VL, l([
                    iw("blur"),
                    fw("in"),
                    Mw("colorShadow")
                ]), M),
                A2(VL, l([
                    ow("SourceGraphic"),
                    iw("colorShadow"),
                    fw("over")
                ]), M)
            ])),
            A2(zw, l([
                uw("squareWithKana-squareBottomHighlight-bottomHighligh"),
                Bw("98"),
                Gw("8"),
                Ow("98"),
                Ww("188"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.44"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("squareWithKana-squareHighlightCorner-bottomRight2"),
                Bw("49.24"),
                Gw("11.96"),
                Ow("145.78"),
                Ww("179.17"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.92"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("squareWithKana-squareHighlightGradient-top"),
                Bw("97.51"),
                Gw("14.81"),
                Ow("97.51"),
                Ww("90.7"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.24"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ])),
            A2(zw, l([
                uw("squareWithKana-innerSquareGradiant-rectangle3"),
                Bw("100.5"),
                Gw("33"),
                Ow("100.5"),
                Ww("168"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    Hw(Jp(fZ(n))),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.19"),
                    Hw(Jp(A2(cZ, fZ(n), dZ(n)))),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    Hw(Jp(dZ(n))),
                    kw("1")
                ]), M)
            ])),
            A2(YL, l([
                uw("squareWithKana-shadow3-inner"),
                nw("objectBoundingBox")
            ]), l([
                A2(NL, l([
                    ow("SourceAlpha"),
                    dw("1"),
                    Mw("blur")
                ]), M),
                A2(JL, l([
                    QL("0"),
                    PL("6")
                ]), M),
                A2(VL, l([
                    iw("SourceAlpha"),
                    fw("arithmetic"),
                    sZ("-1.15"),
                    MZ("1.15"),
                    Mw("shadowDiff")
                ]), M),
                A2(FL, l([
                    rw(Jp(n)),
                    ew("1")
                ]), M),
                A2(VL, l([
                    iw("shadowDiff"),
                    fw("in")
                ]), M),
                A2(VL, l([
                    iw("SourceGraphic"),
                    fw("over")
                ]), M)
            ])),
            A2(zw, l([
                uw("squareWithKana-innerSquareHighlight-topLeft"),
                Bw("40"),
                Gw("43"),
                Ow("63.41"),
                Ww("64.26"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.63"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ])),
            A2(zw, l([
                uw("squareWithKana-innerSquareHighlight-bottomRight"),
                Bw("162"),
                Gw("164"),
                Ow("138.59"),
                Ww("142.74"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.63"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ])),
            A2(zw, l([
                uw("squareWithKana-innerSquareHighlightSmall-topRight"),
                Bw("162"),
                Gw("43"),
                Ow("138.59"),
                Ww("64.26"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ]))
        ]));
    }, OZ = F2(function(n, r) {
        return A2(tw, M, l([
            A2(bw, l([
                Cw("none"),
                aL("url(#squareWithKana-innerSquareGradiant-rectangle3)"),
                XL("url(#squareWithKana-shadow3-inner)"),
                jL("M 55.93,33 L 145.07,33 C 151.67,33 154.97,33 157.95,33.98 L 158.53,34.12 C 162.41,35.54 165.46,38.59 166.88,42.47 168,46.03 168,49.33 168,55.93 L 168,145.07 C 168,151.67 168,154.97 167.02,157.95 L 166.88,158.53 C 165.46,162.41 162.41,165.46 158.53,166.88 154.97,168 151.67,168 145.07,168 L 55.93,168 C 49.33,168 46.03,168 43.05,167.02 L 42.47,166.88 C 38.59,165.46 35.54,162.41 34.12,158.53 33,154.97 33,151.67 33,145.07 L 33,55.93 C 33,49.33 33,46.03 33.98,43.05 L 34.12,42.47 C 35.54,38.59 38.59,35.54 42.47,34.12 46.03,33 49.33,33 55.93,33 Z M 55.93,33")
            ]), M),
            A2(tw, M, l([
                A2(bw, l([
                    Cw("none"),
                    aL("url(#squareWithKana-innerSquareHighlight-topLeft)"),
                    jL("M 70.57,43 L 79.43,43 C 88.23,43 92.63,43 96.6,44.31 L 97.37,44.5 C 102.54,46.38 106.62,50.46 108.5,55.63 110,60.37 110,64.77 110,73.57 L 110,82.43 C 110,91.23 110,95.63 108.69,99.6 L 108.5,100.37 C 106.62,105.54 102.54,109.62 97.37,111.5 92.63,113 88.23,113 79.43,113 L 70.57,113 C 61.77,113 57.37,113 53.4,111.69 L 52.63,111.5 C 47.46,109.62 43.38,105.54 41.5,100.37 40,95.63 40,91.23 40,82.43 L 40,73.57 C 40,64.77 40,60.37 41.31,56.4 L 41.5,55.63 C 43.38,50.46 47.46,46.38 52.63,44.5 57.37,43 61.77,43 70.57,43 Z M 70.57,43")
                ]), M),
                A2(bw, l([
                    Cw("none"),
                    aL("url(#squareWithKana-innerSquareHighlight-bottomRight)"),
                    jL("M 122.57,94 L 131.43,94 C 140.23,94 144.63,94 148.6,95.31 L 149.37,95.5 C 154.54,97.38 158.62,101.46 160.5,106.63 162,111.37 162,115.77 162,124.58 L 162,133.43 C 162,142.23 162,146.64 160.69,150.6 L 160.5,151.37 C 158.62,156.55 154.54,160.62 149.37,162.5 144.63,164 140.23,164 131.43,164 L 122.57,164 C 113.77,164 109.37,164 105.4,162.69 L 104.63,162.5 C 99.46,160.62 95.38,156.55 93.5,151.37 92,146.64 92,142.23 92,133.43 L 92,124.58 C 92,115.77 92,111.37 93.31,107.4 L 93.5,106.63 C 95.38,101.46 99.46,97.38 104.63,95.5 109.37,94 113.77,94 122.57,94 Z M 122.57,94")
                ]), M),
                A2(bw, l([
                    Cw("none"),
                    aL("url(#squareWithKana-innerSquareHighlightSmall-topRight)"),
                    jL("M 122.57,43 L 131.43,43 C 140.23,43 144.63,43 148.6,44.31 L 149.37,44.5 C 154.54,46.38 158.62,50.46 160.5,55.63 162,60.37 162,64.77 162,73.57 L 162,82.43 C 162,91.23 162,95.63 160.69,99.6 L 160.5,100.37 C 158.62,105.54 154.54,109.62 149.37,111.5 144.63,113 140.23,113 131.43,113 L 122.57,113 C 113.77,113 109.37,113 105.4,111.69 L 104.63,111.5 C 99.46,109.62 95.38,105.54 93.5,100.37 92,95.63 92,91.23 92,82.43 L 92,73.57 C 92,64.77 92,60.37 93.31,56.4 L 93.5,55.63 C 95.38,50.46 99.46,46.38 104.63,44.5 109.37,43 113.77,43 122.57,43 Z M 122.57,43")
                ]), M)
            ])),
            A3(ZZ, "text", l([
                aL(Jp(LZ(r))),
                gZ("Helvetica-Bold, Helvetica, sans-serif"),
                pZ("bold"),
                hZ("95"),
                cL("53"),
                bL("46"),
                lL("middle")
            ]), l([
                A2(mZ, l([
                    cL("50%"),
                    bL("70%")
                ]), l([
                    pL(n)
                ]))
            ]))
        ]));
    }), GZ = vr("rx"), WZ = F3(function(n, r, e) {
        var t = e.bQ;
        return o(e.cp, A2(oL, r, l([
            BZ(gs(t)),
            A2(tw, M, l([
                A2(tw, M, l([
                    A2(tw, M, l([
                        A2(tw, M, l([
                            A2(Aw, l([
                                Cw("none"),
                                aL(Jp(LZ(gs(t)))),
                                cL("10"),
                                bL("10"),
                                Lw("180"),
                                aw("180"),
                                GZ("40")
                            ]), M),
                            A2(Aw, l([
                                Cw("none"),
                                aL("url(#squareWithKana-squareGradient-outerSquare)"),
                                cL("8"),
                                bL("8"),
                                Lw("180"),
                                aw("180"),
                                GZ("40")
                            ]), M),
                            A2(tw, M, l([
                                A2(bw, l([
                                    Cw("none"),
                                    aL("url(#squareWithKana-innerSquareGradient-innerSquare)"),
                                    XL("url(#squareWithKana-shadow2-outer)"),
                                    jL("M 75.28,14.81 L 119.75,14.81 C 136.88,14.81 145.45,14.81 153.17,17.36 L 154.67,17.73 C 164.73,21.39 172.66,29.32 176.33,39.39 179.24,48.61 179.24,57.17 179.24,74.3 L 179.24,116.83 C 179.24,133.96 179.24,142.53 176.69,150.25 L 176.33,151.75 C 172.66,161.81 164.73,169.74 154.67,173.41 145.45,176.32 136.88,176.32 119.75,176.32 L 75.28,176.32 C 58.15,176.32 49.58,176.32 41.86,173.78 L 40.36,173.41 C 30.29,169.74 22.36,161.81 18.7,151.75 15.78,142.53 15.78,133.96 15.78,116.83 L 15.78,74.3 C 15.78,57.17 15.78,48.61 18.33,40.88 L 18.7,39.39 C 22.36,29.32 30.29,21.39 40.36,17.73 49.58,14.81 58.15,14.81 75.28,14.81 Z M 75.28,14.81")
                                ]), M),
                                A2(tw, M, l([
                                    A2(Aw, l([
                                        Uw("0.8"),
                                        Cw("none"),
                                        aL("url(#squareWithKana-squareBottomHighlight-bottomHighligh)"),
                                        cL("8"),
                                        bL("8"),
                                        Lw("180"),
                                        aw("180"),
                                        GZ("40")
                                    ]), M),
                                    A2(bw, l([
                                        Cw("none"),
                                        aL("url(#squareWithKana-squareHighlightCorner-bottomRight2)"),
                                        jL("M 75.28,14.81 L 119.75,14.81 C 136.88,14.81 145.45,14.81 153.17,17.36 L 154.67,17.73 C 164.73,21.39 172.66,29.32 176.33,39.39 179.24,48.61 179.24,57.17 179.24,74.3 L 179.24,116.83 C 179.24,133.96 179.24,142.53 176.69,150.25 L 176.33,151.75 C 172.66,161.81 164.73,169.74 154.67,173.41 145.45,176.32 136.88,176.32 119.75,176.32 L 75.28,176.32 C 58.15,176.32 49.58,176.32 41.86,173.78 L 40.36,173.41 C 30.29,169.74 22.36,161.81 18.7,151.75 15.78,142.53 15.78,133.96 15.78,116.83 L 15.78,74.3 C 15.78,57.17 15.78,48.61 18.33,40.88 L 18.7,39.39 C 22.36,29.32 30.29,21.39 40.36,17.73 49.58,14.81 58.15,14.81 75.28,14.81 Z M 75.28,14.81")
                                    ]), M),
                                    A2(bw, l([
                                        Cw("none"),
                                        aL("url(#squareWithKana-squareHighlightGradient-top)"),
                                        jL("M 65.58,14.81 L 119.75,14.81 C 138.65,14.81 147,14.81 154.53,17.3 L 155.99,17.65 C 169.95,22.73 179.24,36 179.24,50.86 179.24,52.76 179.24,52.76 179.24,52.76 L 179.24,52.76 179.24,52.76 179.24,54.65 C 179.24,69.51 169.95,82.78 155.99,87.86 147,90.7 138.65,90.7 121.95,90.7 L 75.28,90.7 C 56.38,90.7 48.02,90.7 40.49,88.22 L 39.03,87.86 C 25.08,82.78 15.78,69.51 15.78,54.65 15.78,52.76 15.78,52.76 15.78,52.76 L 15.78,52.76 15.78,52.76 15.78,50.86 C 15.78,36 25.08,22.73 39.03,17.65 48.02,14.81 56.38,14.81 73.08,14.81 L 75.28,14.81 65.58,14.81 Z M 65.58,14.81")
                                    ]), M)
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                n.$ ? pL("") : A2(OZ, n.a, gs(t))
            ]))
        ])));
    }), qZ = function(n) {
        return l([
            A2(zw, l([
                uw("diamondGradient-outerDiamond"),
                Bw("100"),
                Gw("5"),
                Ow("100"),
                Ww("195"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    nZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("squareBottomHighlight-outerDiamond2"),
                Bw("100"),
                Gw("5"),
                Ow("100"),
                Ww("195"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.44"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("diamondHighlightGradientReversed-bottom"),
                Bw("101.18"),
                Gw("136.66"),
                Ow("101.18"),
                Ww("186.71"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.26"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("diamondHighlightGradient-top"),
                Bw("99"),
                Gw("14"),
                Ow("99"),
                Ww("96"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.32"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ]))
        ]);
    }, UZ = function(n) {
        return A2(iZ, n, .4);
    }, AZ = F3(function(n, r, e) {
        return o(e, A2(oL, n, l([
            A2(RL, M, qZ(r)),
            A2(tw, l([
                uw("canvasDiamondHorizontalStripedDrawing-group")
            ]), l([
                A2(bw, l([
                    uw("canvasDiamondHorizontalStripedDrawing-diamondShadow"),
                    _L("evenodd"),
                    Cw("none"),
                    aL(Jp(oZ(r))),
                    jL("M 102,7 C 133.67,7 197,70.33 197,102 197,133.67 133.67,197 102,197 70.33,197 7,133.67 7,102 7,70.33 70.33,7 102,7 Z M 102,7")
                ]), M),
                A2(bw, l([
                    uw("canvasDiamondHorizontalStripedDrawing-outerDiamond"),
                    _L("evenodd"),
                    Cw("none"),
                    aL("url(#diamondGradient-outerDiamond)"),
                    jL("M 100,5 C 131.67,5 195,68.33 195,100 195,131.67 131.67,195 100,195 68.33,195 5,131.67 5,100 5,68.33 68.33,5 100,5 Z M 100,5")
                ]), M),
                A2(bw, l([
                    uw("canvasDiamondHorizontalStripedDrawing-bezier"),
                    Cw("none"),
                    aL(Jp(UZ(r))),
                    jL("M 168.19,50 L 31.81,50 C 38.05,42.93 44.97,36.1 52.08,30 L 147.92,30 C 155.03,36.1 161.95,42.93 168.19,50 Z M 193.31,90 L 6.69,90 C 8.6,83.82 12.03,77 16.52,70 L 183.48,70 C 187.97,77 191.4,83.82 193.31,90 Z M 193.31,110 C 191.4,116.18 187.97,123 183.48,130 L 16.52,130 C 12.03,123 8.6,116.18 6.69,110 L 193.31,110 Z M 168.19,150 C 161.95,157.07 155.03,163.9 147.92,170 L 52.08,170 C 44.97,163.9 38.05,157.07 31.81,150 L 168.19,150 Z M 168.19,150")
                ]), M),
                A2(tw, l([
                    uw("canvasDiamondHorizontalStripedDrawing-groupHighlights")
                ]), l([
                    A2(bw, l([
                        uw("canvasDiamondHorizontalStripedDrawing-outerDiamond2"),
                        _L("evenodd"),
                        Cw("none"),
                        aL("url(#squareBottomHighlight-outerDiamond2)"),
                        jL("M 100,5 C 131.67,5 195,68.33 195,100 195,131.67 131.67,195 100,195 68.33,195 5,131.67 5,100 5,68.33 68.33,5 100,5 Z M 100,5")
                    ]), M),
                    A2(bw, l([
                        uw("canvasDiamondHorizontalStripedDrawing-bottom"),
                        _L("evenodd"),
                        Cw("none"),
                        aL("url(#diamondHighlightGradientReversed-bottom)"),
                        jL("M 101.18,136.66 C 116.79,136.66 148,144 148,152.34 148,160.68 116.79,186.71 101.18,186.71 85.58,186.71 54.37,160.68 54.37,152.34 54.37,144 85.58,136.66 101.18,136.66 Z M 101.18,136.66")
                    ]), M),
                    A2(bw, l([
                        uw("canvasDiamondHorizontalStripedDrawing-top"),
                        _L("evenodd"),
                        Cw("none"),
                        aL("url(#diamondHighlightGradient-top)"),
                        jL("M 99,14 C 125.68,14 165,51.61 165,70.41 165,89.21 125.68,96 99,96 72.32,96 33,89.21 33,70.41 33,51.61 72.32,14 99,14 Z M 99,14")
                    ]), M)
                ]))
            ]))
        ])));
    }), EZ = F3(function(n, r, e) {
        return o(e, A2(oL, n, l([
            A2(RL, M, qZ(r)),
            A2(tw, l([
                uw("canvasDiamondVerticalStripedDrawing-group")
            ]), l([
                A2(bw, l([
                    uw("canvasDiamondVerticalStripedDrawing-diamondShadow"),
                    _L("evenodd"),
                    Cw("none"),
                    aL(Jp(oZ(r))),
                    jL("M 102,7 C 133.67,7 197,70.33 197,102 197,133.67 133.67,197 102,197 70.33,197 7,133.67 7,102 7,70.33 70.33,7 102,7 Z M 102,7")
                ]), M),
                A2(bw, l([
                    uw("canvasDiamondVerticalStripedDrawing-outerDiamond"),
                    _L("evenodd"),
                    Cw("none"),
                    aL("url(#diamondGradient-outerDiamond)"),
                    jL("M 100,5 C 131.67,5 195,68.33 195,100 195,131.67 131.67,195 100,195 68.33,195 5,131.67 5,100 5,68.33 68.33,5 100,5 Z M 100,5")
                ]), M),
                A2(bw, l([
                    uw("canvasDiamondVerticalStripedDrawing-bezier2"),
                    Cw("none"),
                    aL(Jp(UZ(r))),
                    jL("M 50,31.81 C 50,69.18 50,130.82 50,168.19 42.93,161.95 36.1,155.03 30,147.92 30,118.4 30,81.6 30,52.08 36.1,44.97 42.93,38.05 50,31.81 Z M 150,31.81 C 157.07,38.05 163.9,44.97 170,52.08 170,81.6 170,118.4 170,147.92 163.9,155.03 157.07,161.95 150,168.19 150,130.82 150,69.18 150,31.81 Z M 90,6.69 C 90,37.19 90,162.81 90,193.31 83.82,191.4 77,187.97 70,183.48 70,145.85 70,54.15 70,16.52 77,12.03 83.82,8.6 90,6.69 Z M 110,6.69 C 116.18,8.6 123,12.03 130,16.52 130,54.15 130,145.85 130,183.48 123,187.97 116.18,191.4 110,193.31 110,162.81 110,37.19 110,6.69 Z M 110,6.69")
                ]), M),
                A2(tw, l([
                    uw("canvasDiamondVerticalStripedDrawing-groupHighlights")
                ]), l([
                    A2(bw, l([
                        uw("canvasDiamondVerticalStripedDrawing-outerDiamond2"),
                        _L("evenodd"),
                        Cw("none"),
                        aL("url(#squareBottomHighlight-outerDiamond2)"),
                        jL("M 100,5 C 131.67,5 195,68.33 195,100 195,131.67 131.67,195 100,195 68.33,195 5,131.67 5,100 5,68.33 68.33,5 100,5 Z M 100,5")
                    ]), M),
                    A2(bw, l([
                        uw("canvasDiamondVerticalStripedDrawing-bottom"),
                        _L("evenodd"),
                        Cw("none"),
                        aL("url(#diamondHighlightGradientReversed-bottom)"),
                        jL("M 101.18,136.66 C 116.79,136.66 148,144 148,152.34 148,160.68 116.79,186.71 101.18,186.71 85.58,186.71 54.37,160.68 54.37,152.34 54.37,144 85.58,136.66 101.18,136.66 Z M 101.18,136.66")
                    ]), M),
                    A2(bw, l([
                        uw("canvasDiamondVerticalStripedDrawing-top"),
                        _L("evenodd"),
                        Cw("none"),
                        aL("url(#diamondHighlightGradient-top)"),
                        jL("M 99,14 C 125.68,14 165,51.61 165,70.41 165,89.21 125.68,96 99,96 72.32,96 33,89.21 33,70.41 33,51.61 72.32,14 99,14 Z M 99,14")
                    ]), M)
                ]))
            ]))
        ])));
    }), TZ = F3(function(n, r, e) {
        var t = e.cp;
        return A3(n ? EZ : AZ, r, gs(e.bQ), t);
    }), IZ = function(n) {
        return l([
            A2(zw, l([
                uw("innerSquareGradient-bezier"),
                Bw("100.6"),
                Gw("16.71"),
                Ow("100.6"),
                Ww("184"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    lZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("squareBottomHighlight-bezier5"),
                Bw("100.6"),
                Gw("16.71"),
                Ow("100.6"),
                Ww("184"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.44"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("hexagonBottomHighlightGradient-bezier4"),
                Bw("65.05"),
                Gw("38.36"),
                Ow("142.16"),
                Ww("171.92"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.79"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("hexagonHighlightGradient-bezier3"),
                Bw("100.6"),
                Gw("24.71"),
                Ow("100.6"),
                Ww("164.42"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.23"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("0.53"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ]))
        ]);
    }, jZ = A2(tw, l([
        uw("canvasHexagonVerticalStripedDrawing-group")
    ]), l([
        A2(bw, l([
            uw("canvasHexagonVerticalStripedDrawing-bezier5"),
            _L("evenodd"),
            Cw("none"),
            aL("url(#squareBottomHighlight-bezier5)"),
            jL("M 193.2,100.35 C 193.2,104.93 191.99,109.44 189.7,113.4 L 156.46,170.95 C 151.81,179 143.14,184 133.84,184 L 67.36,184 C 58.06,184 49.39,179 44.74,170.95 L 11.5,113.4 C 9.21,109.44 8,104.93 8,100.35 8,95.78 9.21,91.26 11.5,87.3 L 44.74,29.76 C 49.39,21.71 58.06,16.71 67.36,16.71 L 133.84,16.71 C 143.14,16.71 151.81,21.71 156.46,29.76 L 189.7,87.3 C 191.99,91.26 193.2,95.78 193.2,100.35 Z M 193.2,100.35")
        ]), M),
        A2(bw, l([
            uw("canvasHexagonVerticalStripedDrawing-bezier4"),
            _L("evenodd"),
            Cw("none"),
            aL("url(#hexagonBottomHighlightGradient-bezier4)"),
            jL("M 180.2,105.14 C 180.2,108.96 179.2,112.73 177.31,116.04 L 149.81,164.1 C 145.96,170.82 138.79,175 131.1,175 L 76.1,175 C 68.41,175 61.24,170.82 57.39,164.1 L 29.89,116.04 C 28,112.73 27,108.96 27,105.14 27,101.32 28,97.55 29.89,94.24 L 57.39,46.19 C 61.24,39.46 68.41,35.29 76.1,35.29 L 131.1,35.29 C 138.79,35.29 145.96,39.46 149.81,46.19 L 177.31,94.24 C 179.2,97.55 180.2,101.32 180.2,105.14 Z M 180.2,105.14")
        ]), M),
        A2(bw, l([
            uw("canvasHexagonVerticalStripedDrawing-bezier3"),
            Uw("0.9"),
            _L("evenodd"),
            Cw("none"),
            aL("url(#hexagonHighlightGradient-bezier3)"),
            jL("M 177.2,94.56 C 177.2,98.39 176.2,102.16 174.31,105.46 L 146.81,153.52 C 142.96,160.25 135.79,164.42 128.1,164.42 L 73.1,164.42 C 65.41,164.42 58.24,160.25 54.39,153.52 L 26.89,105.46 C 25,102.16 24,98.39 24,94.56 24,90.74 25,86.97 26.89,83.66 L 54.39,35.61 C 58.24,28.88 65.41,24.71 73.1,24.71 L 128.1,24.71 C 135.79,24.71 142.96,28.88 146.81,35.61 L 174.31,83.66 C 176.2,86.97 177.2,90.74 177.2,94.56 Z M 177.2,94.56")
        ]), M)
    ])), RZ = F3(function(n, r, e) {
        return o(e, A2(oL, n, l([
            A2(RL, M, IZ(r)),
            A2(tw, l([
                uw("canvasHexagonHorizontalStripedDrawing-group2")
            ]), l([
                A2(bw, l([
                    uw("canvasHexagonHorizontalStripedDrawing-bezier6"),
                    _L("evenodd"),
                    Cw("none"),
                    aL(Jp(oZ(r))),
                    jL("M 195.2,102.35 C 195.2,106.93 193.99,111.44 191.7,115.4 L 158.46,172.95 C 153.81,181 145.14,186 135.84,186 L 69.36,186 C 60.06,186 51.39,181 46.74,172.95 L 13.5,115.4 C 11.21,111.44 10,106.93 10,102.35 10,97.78 11.21,93.26 13.5,89.3 L 46.74,31.76 C 51.39,23.71 60.06,18.71 69.36,18.71 L 135.84,18.71 C 145.14,18.71 153.81,23.71 158.46,31.76 L 191.7,89.3 C 193.99,93.26 195.2,97.78 195.2,102.35 Z M 195.2,102.35")
                ]), M),
                A2(bw, l([
                    uw("canvasHexagonHorizontalStripedDrawing-bezier"),
                    _L("evenodd"),
                    Cw("none"),
                    aL("url(#innerSquareGradient-bezier)"),
                    jL("M 193.2,100.35 C 193.2,104.93 191.99,109.44 189.7,113.4 L 156.46,170.95 C 151.81,179 143.14,184 133.84,184 L 67.36,184 C 58.06,184 49.39,179 44.74,170.95 L 11.5,113.4 C 9.21,109.44 8,104.93 8,100.35 8,95.78 9.21,91.26 11.5,87.3 L 44.74,29.76 C 49.39,21.71 58.06,16.71 67.36,16.71 L 133.84,16.71 C 143.14,16.71 151.81,21.71 156.46,29.76 L 189.7,87.3 C 191.99,91.26 193.2,95.78 193.2,100.35 Z M 193.2,100.35")
                ]), M),
                A2(bw, l([
                    uw("canvasHexagonHorizontalStripedDrawing-bezier2"),
                    Cw("none"),
                    aL(Jp(UZ(r))),
                    jL("M 156.62,30.04 C 157.48,31.51 162.38,40 168.15,50 L 33.05,50 C 38.82,40 43.73,31.51 44.6,30 L 156.6,30 156.62,30.04 Z M 179.71,70 C 185.31,79.69 189.7,87.3 189.7,87.3 190.21,88.18 190.66,89.08 191.06,90 L 10.14,90 C 10.54,89.08 10.99,88.18 11.5,87.3 11.5,87.3 15.9,79.69 21.49,70 L 179.71,70 Z M 191.35,110 C 190.89,111.17 190.34,112.31 189.7,113.4 189.7,113.4 185.52,120.65 180.12,130 L 21.09,130 C 15.68,120.65 11.5,113.4 11.5,113.4 10.87,112.31 10.32,111.17 9.85,110 L 191.35,110 Z M 168.56,150 C 163.23,159.24 158.56,167.31 157.01,170 L 44.19,170 C 42.64,167.31 37.98,159.24 32.64,150 L 168.56,150 Z M 168.56,150")
                ]), M),
                jZ
            ]))
        ])));
    }), QZ = F3(function(n, r, e) {
        return o(e, A2(oL, n, l([
            A2(RL, M, IZ(r)),
            A2(tw, l([
                uw("canvasHexagonVerticalStripedDrawing-group2")
            ]), l([
                A2(bw, l([
                    uw("canvasHexagonVerticalStripedDrawing-bezier6"),
                    _L("evenodd"),
                    Cw("none"),
                    aL(Jp(oZ(r))),
                    jL("M 195.2,102.35 C 195.2,106.93 193.99,111.44 191.7,115.4 L 158.46,172.95 C 153.81,181 145.14,186 135.84,186 L 69.36,186 C 60.06,186 51.39,181 46.74,172.95 L 13.5,115.4 C 11.21,111.44 10,106.93 10,102.35 10,97.78 11.21,93.26 13.5,89.3 L 46.74,31.76 C 51.39,23.71 60.06,18.71 69.36,18.71 L 135.84,18.71 C 145.14,18.71 153.81,23.71 158.46,31.76 L 191.7,89.3 C 193.99,93.26 195.2,97.78 195.2,102.35 Z M 195.2,102.35")
                ]), M),
                A2(bw, l([
                    uw("canvasHexagonVerticalStripedDrawing-bezier"),
                    _L("evenodd"),
                    Cw("none"),
                    aL("url(#innerSquareGradient-bezier)"),
                    jL("M 193.2,100.35 C 193.2,104.93 191.99,109.44 189.7,113.4 L 156.46,170.95 C 151.81,179 143.14,184 133.84,184 L 67.36,184 C 58.06,184 49.39,179 44.74,170.95 L 11.5,113.4 C 9.21,109.44 8,104.93 8,100.35 8,95.78 9.21,91.26 11.5,87.3 L 44.74,29.76 C 49.39,21.71 58.06,16.71 67.36,16.71 L 133.84,16.71 C 143.14,16.71 151.81,21.71 156.46,29.76 L 189.7,87.3 C 191.99,91.26 193.2,95.78 193.2,100.35 Z M 193.2,100.35")
                ]), M),
                A2(bw, l([
                    uw("canvasHexagonVerticalStripedDrawing-bezier2"),
                    Cw("none"),
                    aL(Jp(UZ(r))),
                    jL("M 50,23.32 C 50,62.05 50,139.14 50,177.39 47.94,175.56 46.15,173.4 44.74,170.95 44.74,170.95 37.64,158.65 30,145.43 30,117.43 30,83.38 30,55.28 37.64,42.05 44.74,29.76 44.74,29.76 45.7,28.1 46.82,26.58 48.09,25.19 48.7,24.54 49.33,23.91 50,23.32 Z M 150,22.31 C 152.57,24.34 154.78,26.85 156.46,29.76 156.46,29.76 162.84,40.79 170,53.19 170,82.38 170,118.44 170,147.51 162.84,159.92 156.46,170.95 156.46,170.95 154.78,173.86 152.57,176.37 150,178.39 150,140.17 150,61.03 150,22.31 Z M 130,184 L 110,184 C 110,146.77 110,54.62 110,16.71 L 130,16.71 C 130,54.62 130,146.77 130,184 Z M 90,184 L 70,184 C 70,146.77 70,54.62 70,16.71 L 90,16.71 C 90,54.62 90,146.77 90,184 Z M 90,184")
                ]), M),
                jZ
            ]))
        ])));
    }), PZ = F3(function(n, r, e) {
        var t = e.cp;
        return A3(n ? QZ : RZ, r, gs(e.bQ), t);
    }), VZ = function(n) {
        return l([
            A2(zw, l([
                uw("squareGradient-outerOval"),
                Bw("100"),
                Gw("10"),
                Ow("100"),
                Ww("190"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    lZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("ovalBottomHighlight-bottomHighlight"),
                Bw("100"),
                Gw("10"),
                Ow("100"),
                Ww("190"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.75"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("ovalBottomHighlightGradient-bottomRight"),
                Bw("89.86"),
                Gw("72.46"),
                Ow("142.17"),
                Ww("163.07"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.82"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("ovalHighlightGradient-top"),
                Bw("100.89"),
                Gw("21.21"),
                Ow("100.89"),
                Ww("126.93"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.36"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ]))
        ]);
    }, FZ = A2(tw, l([
        uw("canvasOvalVerticalStripedDrawing-groupHighlights")
    ]), l([
        A2(bw, l([
            uw("canvasOvalVerticalStripedDrawing-bottomHighlight"),
            Cw("none"),
            aL("url(#ovalBottomHighlight-bottomHighlight)"),
            jL("M 190,98.93 C 190,153.35 153.47,190 100.53,190 47.59,190 10,153.35 10,98.93 10,44.52 47.59,10 100.53,10 153.47,10 190,44.52 190,98.93 Z M 190,98.93")
        ]), M),
        A2(bw, l([
            uw("canvasOvalVerticalStripedDrawing-bottomRight"),
            Cw("none"),
            aL("url(#ovalBottomHighlightGradient-bottomRight)"),
            jL("M 167.39,117.34 C 167.39,148.33 146.44,169.21 116.09,169.21 85.73,169.21 64.18,148.33 64.18,117.34 64.18,86.34 85.73,66.67 116.09,66.67 146.44,66.67 167.39,86.34 167.39,117.34 Z M 167.39,117.34")
        ]), M),
        A2(bw, l([
            uw("canvasOvalVerticalStripedDrawing-top"),
            Uw("0.9"),
            Cw("none"),
            aL("url(#ovalHighlightGradient-top)"),
            jL("M 167.39,73.45 C 167.39,105.4 140.4,126.93 101.28,126.93 62.16,126.93 34.39,105.4 34.39,73.45 34.39,41.49 62.16,21.21 101.28,21.21 140.4,21.21 167.39,41.49 167.39,73.45 Z M 167.39,73.45")
        ]), M)
    ])), NZ = function(n) {
        return A2(bw, l([
            uw("canvasOvalHorizontalStripedDrawing-bezier"),
            Cw("none"),
            aL(Jp(UZ(n))),
            jL("M 177.59,50 L 22.7,50 C 27.35,42.32 33.16,35.61 39.97,30 L 160.63,30 C 167.34,35.61 173.05,42.32 177.59,50 Z M 189.66,90 L 10.35,90 C 10.91,82.94 12.13,76.26 13.97,70 L 186.13,70 C 187.92,76.26 189.12,82.94 189.66,90 Z M 189.48,110 C 188.8,117.03 187.48,123.72 185.57,130 L 14.55,130 C 12.59,123.72 11.23,117.03 10.54,110 L 189.48,110 Z M 176.68,150 C 172.04,157.65 166.28,164.37 159.55,170 L 41.07,170 C 34.24,164.37 28.37,157.65 23.63,150 L 176.68,150 Z M 176.68,150")
        ]), M);
    }, JZ = A2(bw, l([
        uw("canvasOvalVerticalStripedDrawing-outerOval"),
        Cw("none"),
        aL("url(#squareGradient-outerOval)"),
        jL("M 190,98.93 C 190,153.35 153.47,190 100.53,190 47.59,190 10,153.35 10,98.93 10,44.52 47.59,10 100.53,10 153.47,10 190,44.52 190,98.93 Z M 190,98.93")
    ]), M), _Z = function(n) {
        return A2(bw, l([
            uw("canvasOvalVerticalStripedDrawing-ovalShadow"),
            Cw("none"),
            aL(Jp(oZ(n))),
            jL("M 192,100.93 C 192,155.35 155.47,192 102.53,192 49.59,192 12,155.35 12,100.93 12,46.52 49.59,12 102.53,12 155.47,12 192,46.52 192,100.93 Z M 192,100.93")
        ]), M);
    }, YZ = F3(function(n, r, e) {
        return o(e, A2(oL, n, l([
            A2(RL, M, VZ(r)),
            A2(tw, l([
                uw("canvasOvalHorizontalStripedDrawing-group")
            ]), l([
                _Z(r),
                JZ,
                NZ(r),
                FZ
            ]))
        ])));
    }), XZ = function(n) {
        return A2(bw, l([
            uw("canvasOvalVerticalStripedDrawing-bezier2"),
            Cw("none"),
            aL(Jp(UZ(n))),
            jL("M 50,22.95 C 50,61.23 50,137.71 50,176.41 42.38,171.67 35.65,165.79 30,158.91 30,124.05 30,74.34 30,39.84 34.91,34.04 40.62,29 47.03,24.81 48.01,24.17 49,23.55 50,22.95 Z M 150,22.51 C 157.64,27.01 164.36,32.64 170,39.31 170,74.01 170,124.38 170,159.45 164.36,166.33 157.64,172.18 150,176.87 150,138.17 150,60.79 150,22.51 Z M 90,10.47 C 90,44.99 90,154.94 90,189.5 82.99,188.83 76.31,187.48 70,185.51 70,148.53 70,50.98 70,14.26 76.31,12.38 82.99,11.11 90,10.47 Z M 110,10.38 C 117.02,10.95 123.7,12.16 130,13.98 130,50.58 130,148.95 130,185.8 123.7,187.71 117.02,188.99 110,189.6 110,155.12 110,44.83 110,10.38 Z M 110,10.38")
        ]), M);
    }, nm = F3(function(n, r, e) {
        return o(e, A2(oL, n, l([
            A2(RL, M, VZ(r)),
            A2(tw, l([
                uw("canvasOvalVerticalStripedDrawing-group")
            ]), l([
                _Z(r),
                JZ,
                XZ(r),
                FZ
            ]))
        ])));
    }), rm = F3(function(n, r, e) {
        var t = e.cp;
        return A3(n ? nm : YZ, r, gs(e.bQ), t);
    }), em = function(n) {
        return l([
            A2(zw, l([
                uw("canvasSquareStriped-squareGradient-outerSquare"),
                Bw("98"),
                Gw("8"),
                Ow("98"),
                Ww("188"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    lZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("canvasSquareStriped-squareBottomHighlight-bottomHighligh"),
                Bw("98"),
                Gw("8"),
                Ow("98"),
                Ww("188"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.44"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("canvasSquareStriped-squareHighlightCorner-bottomRight"),
                Bw("50.22"),
                Gw("13.91"),
                Ow("146.76"),
                Ww("181.12"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.92"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("canvasSquareStriped-squareHighlightGradient-top"),
                Bw("98.49"),
                Gw("16.76"),
                Ow("98.49"),
                Ww("92.65"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.24"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ]))
        ]);
    }, tm = F3(function(n, r, e) {
        return o(e, A2(oL, n, l([
            A2(RL, M, em(r)),
            A2(tw, l([
                uw("canvasSquareStriped-group"),
                Ew("")
            ]), l([
                A2(tw, l([
                    uw("canvasSquareStriped-group2")
                ]), l([
                    A2(Aw, l([
                        uw("canvasSquareStriped-squareShadow"),
                        Cw("none"),
                        aL(Jp(oZ(r))),
                        cL("10"),
                        bL("10"),
                        Lw("180"),
                        aw("180"),
                        GZ("40")
                    ]), M),
                    A2(Aw, l([
                        uw("canvasSquareStriped-outerSquare"),
                        Cw("none"),
                        aL("url(#canvasSquareStriped-squareGradient-outerSquare)"),
                        cL("8"),
                        bL("8"),
                        Lw("180"),
                        aw("180"),
                        GZ("40")
                    ]), M),
                    A2(bw, l([
                        uw("canvasSquareStriped-bezier"),
                        Cw("none"),
                        aL(Jp(UZ(r))),
                        jL("M 185.08,32.58 C 186.7,37.68 187.42,42.59 187.74,48.86 L 8.23,48.86 C 8.52,42.82 9.15,38.32 10.55,34.07 L 10.92,32.58 C 11.31,31.49 11.75,30.44 12.24,29.41 L 183.76,29.41 C 184.25,30.44 184.69,31.49 185.08,32.58 Z M 188,87.78 L 8,87.78 C 8,78.6 8,70.81 8,68.32 L 188,68.32 C 188,70.81 188,78.6 188,87.78 Z M 188,107.24 C 188,115.86 188,123.38 188,126.7 L 8,126.7 C 8,123.38 8,115.86 8,107.24 L 188,107.24 Z M 187.81,146.16 C 187.55,152.7 186.93,157.45 185.45,161.93 L 185.08,163.42 C 184.81,164.17 184.52,164.9 184.2,165.62 L 11.8,165.62 C 11.48,164.9 11.19,164.17 10.92,163.42 9.22,158.05 8.51,152.91 8.21,146.16 L 187.81,146.16 Z M 187.81,146.16")
                    ]), M),
                    A2(tw, l([
                        uw("canvasSquareStriped-groupHighlights")
                    ]), l([
                        A2(bw, l([
                            uw("canvasSquareStriped-bottomRight"),
                            Cw("none"),
                            aL("url(#canvasSquareStriped-squareHighlightCorner-bottomRight)"),
                            jL("M 76.25,16.76 L 120.72,16.76 C 137.85,16.76 146.42,16.76 154.14,19.31 L 155.64,19.67 C 165.71,23.34 173.64,31.27 177.3,41.33 180.22,50.55 180.22,59.12 180.22,76.25 L 180.22,118.78 C 180.22,135.91 180.22,144.47 177.67,152.2 L 177.3,153.69 C 173.64,163.76 165.71,171.69 155.64,175.35 146.42,178.27 137.85,178.27 120.72,178.27 L 76.25,178.27 C 59.12,178.27 50.55,178.27 42.83,175.72 L 41.33,175.35 C 31.27,171.69 23.34,163.76 19.67,153.69 16.76,144.47 16.76,135.91 16.76,118.78 L 16.76,76.25 C 16.76,59.12 16.76,50.55 19.31,42.83 L 19.67,41.33 C 23.34,31.27 31.27,23.34 41.33,19.67 50.55,16.76 59.12,16.76 76.25,16.76 Z M 76.25,16.76")
                        ]), M),
                        A2(bw, l([
                            uw("canvasSquareStriped-top"),
                            Cw("none"),
                            aL("url(#canvasSquareStriped-squareHighlightGradient-top)"),
                            jL("M 66.55,16.76 L 120.72,16.76 C 139.62,16.76 147.98,16.76 155.51,19.24 L 156.97,19.6 C 170.92,24.68 180.22,37.95 180.22,52.81 180.22,54.7 180.22,54.7 180.22,54.7 L 180.22,54.7 180.22,54.7 180.22,56.6 C 180.22,71.46 170.92,84.73 156.97,89.81 147.98,92.65 139.62,92.65 122.92,92.65 L 76.25,92.65 C 57.35,92.65 49,92.65 41.47,90.16 L 40.01,89.81 C 26.05,84.73 16.76,71.46 16.76,56.6 16.76,54.7 16.76,54.7 16.76,54.7 L 16.76,54.7 16.76,54.7 16.76,52.81 C 16.76,37.95 26.05,24.68 40.01,19.6 49,16.76 57.35,16.76 74.05,16.76 L 76.25,16.76 66.55,16.76 Z M 66.55,16.76")
                        ]), M),
                        A2(Aw, l([
                            uw("canvasSquareStriped-bottomHighligh"),
                            Uw("0.4"),
                            Cw("none"),
                            aL("url(#canvasSquareStriped-squareBottomHighlight-bottomHighligh)"),
                            cL("8"),
                            bL("8"),
                            Lw("180"),
                            aw("180"),
                            GZ("40")
                        ]), M)
                    ]))
                ]))
            ]))
        ])));
    }), am = F3(function(n, r, e) {
        return o(e, A2(oL, n, l([
            A2(RL, M, em(r)),
            A2(tw, l([
                uw("canvasSquareStriped-group3"),
                Ew("")
            ]), l([
                A2(tw, l([
                    uw("canvasSquareStriped-group4")
                ]), l([
                    A2(Aw, l([
                        uw("canvasSquareStriped-squareShadow"),
                        Cw("none"),
                        nZ(oZ(r)),
                        cL("10"),
                        bL("10"),
                        Lw("180"),
                        aw("180"),
                        GZ("40")
                    ]), M),
                    A2(Aw, l([
                        uw("canvasSquareStriped-outerSquare"),
                        Cw("none"),
                        aL("url(#canvasSquareStriped-squareGradient-outerSquare)"),
                        cL("8"),
                        bL("8"),
                        Lw("180"),
                        aw("180"),
                        GZ("40")
                    ]), M),
                    A2(bw, l([
                        uw("canvasSquareStriped-bezier"),
                        Cw("none"),
                        aL(Jp(UZ(r))),
                        jL("M 48.86,8.26 C 48.86,40.18 48.86,157.7 48.86,187.77 42.82,187.48 38.32,186.85 34.07,185.45 L 32.58,185.08 C 31.49,184.69 30.44,184.25 29.41,183.76 29.41,149.84 29.41,47.43 29.41,12.24 30.44,11.75 31.49,11.31 32.58,10.92 37.68,9.3 42.59,8.58 48.86,8.26 Z M 146.16,8.19 C 152.7,8.45 157.45,9.07 161.93,10.55 L 163.42,10.92 C 164.17,11.19 164.9,11.48 165.62,11.8 165.62,46.71 165.62,150.6 165.62,184.2 164.9,184.52 164.17,184.81 163.42,185.08 158.05,186.78 152.91,187.49 146.16,187.79 146.16,157.73 146.16,40.02 146.16,8.19 Z M 126.7,188 L 107.24,188 C 107.24,158.23 107.24,39.63 107.24,8 L 126.7,8 C 126.7,39.63 126.7,158.23 126.7,188 Z M 87.78,188 L 68.32,188 C 68.32,158.23 68.32,39.63 68.32,8 L 87.78,8 C 87.78,39.63 87.78,158.23 87.78,188 Z M 87.78,188")
                    ]), M),
                    A2(tw, l([
                        uw("canvasSquareStriped-groupHighlights")
                    ]), l([
                        A2(Aw, l([
                            uw("canvasSquareStriped-bottomHighligh"),
                            Uw("0.4"),
                            Cw("none"),
                            aL("url(#canvasSquareStriped-squareBottomHighlight-bottomHighligh)"),
                            cL("8"),
                            bL("8"),
                            Lw("180"),
                            aw("180"),
                            GZ("40")
                        ]), M),
                        A2(bw, l([
                            uw("canvasSquareStriped-bottomRight"),
                            Cw("none"),
                            aL("url(#canvasSquareStriped-squareHighlightCorner-bottomRight)"),
                            jL("M 76.25,16.76 L 120.72,16.76 C 137.85,16.76 146.42,16.76 154.14,19.31 L 155.64,19.67 C 165.71,23.34 173.64,31.27 177.3,41.33 180.22,50.55 180.22,59.12 180.22,76.25 L 180.22,118.78 C 180.22,135.91 180.22,144.47 177.67,152.2 L 177.3,153.69 C 173.64,163.76 165.71,171.69 155.64,175.35 146.42,178.27 137.85,178.27 120.72,178.27 L 76.25,178.27 C 59.12,178.27 50.55,178.27 42.83,175.72 L 41.33,175.35 C 31.27,171.69 23.34,163.76 19.67,153.69 16.76,144.47 16.76,135.91 16.76,118.78 L 16.76,76.25 C 16.76,59.12 16.76,50.55 19.31,42.83 L 19.67,41.33 C 23.34,31.27 31.27,23.34 41.33,19.67 50.55,16.76 59.12,16.76 76.25,16.76 Z M 76.25,16.76")
                        ]), M),
                        A2(bw, l([
                            uw("canvasSquareStriped-top"),
                            Cw("none"),
                            aL("url(#canvasSquareStriped-squareHighlightGradient-top)"),
                            jL("M 66.55,16.76 L 120.72,16.76 C 139.62,16.76 147.98,16.76 155.51,19.24 L 156.97,19.6 C 170.92,24.68 180.22,37.95 180.22,52.81 180.22,54.7 180.22,54.7 180.22,54.7 L 180.22,54.7 180.22,54.7 180.22,56.6 C 180.22,71.46 170.92,84.73 156.97,89.81 147.98,92.65 139.62,92.65 122.92,92.65 L 76.25,92.65 C 57.35,92.65 49,92.65 41.47,90.16 L 40.01,89.81 C 26.05,84.73 16.76,71.46 16.76,56.6 16.76,54.7 16.76,54.7 16.76,54.7 L 16.76,54.7 16.76,54.7 16.76,52.81 C 16.76,37.95 26.05,24.68 40.01,19.6 49,16.76 57.35,16.76 74.05,16.76 L 76.25,16.76 66.55,16.76 Z M 66.55,16.76")
                        ]), M)
                    ]))
                ]))
            ]))
        ])));
    }), um = F3(function(n, r, e) {
        var t = e.cp;
        return A3(n ? am : tm, r, gs(e.bQ), t);
    }), im = function(n) {
        return A2(bw, l([
            uw("bezier"),
            Cw("none"),
            aL(Jp(UZ(n))),
            jL("M 152.28,50 L 46.72,50 C 51.66,42.55 56.99,35.76 62.61,30 L 136.39,30 C 142.01,35.76 147.34,42.55 152.28,50 Z M 172.91,90 L 26.09,90 C 28.78,83.25 31.81,76.52 35.13,70 L 163.87,70 C 167.19,76.52 170.22,83.25 172.91,90 Z M 184.82,130 L 14.18,130 C 15.37,123.66 17.02,116.92 19.1,110 L 179.9,110 C 181.98,116.92 183.63,123.66 184.82,130 Z M 186.93,150 C 186.95,156.8 186.02,162.44 184.03,166.42 183.4,167.66 182.57,168.86 181.54,170 L 17.46,170 C 16.43,168.86 15.6,167.66 14.97,166.42 12.98,162.44 12.05,156.8 12.07,150 L 186.93,150 Z M 186.93,150")
        ]), M);
    }, om = function(n) {
        return A2(bw, l([
            uw("bezier"),
            Cw("none"),
            aL(Jp(UZ(n))),
            jL("M 150,46.65 C 157.63,57.59 164.4,70.15 170,83.01 170,117.53 170,154.83 170,177.81 164.45,180.35 157.64,182.46 150,184.14 150,154.76 150,90.87 150,46.65 Z M 50,45.24 C 50,89.6 50,154.76 50,184.35 42.41,182.74 35.61,180.71 30,178.25 30,154.82 30,116.11 30,80.74 35.65,68.12 42.41,55.86 50,45.24 Z M 110,12.58 C 116.9,14.64 123.61,18.63 130,24.03 130,66.79 130,154.65 130,187.36 123.54,188.08 116.81,188.57 110,188.81 110,154.2 110,49.01 110,12.58 Z M 90,12.3 C 90,48.47 90,154.18 90,188.85 83.19,188.63 76.47,188.17 70,187.47 70,154.63 70,65.69 70,23.2 76.4,17.96 83.11,14.16 90,12.3 Z M 90,12.3")
        ]), M);
    }, cm = A2(bw, l([
        uw("backgroundTriangle"),
        _L("evenodd"),
        Cw("none"),
        aL("url(#squareGradient-backgroundTriangle)"),
        jL("M 99.5,11 C 153,11 199.11,136.31 184.03,166.42 168.94,196.53 30.06,196.53 14.97,166.42 -0.11,136.31 46,11 99.5,11 Z M 99.5,11")
    ]), M), fm = function(n) {
        return A2(RL, M, l([
            A2(zw, l([
                uw("squareGradient-backgroundTriangle"),
                Bw("99.5"),
                Gw("11"),
                Ow("99.5"),
                Ww("189"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    lZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("triangleBottomHighlight-bottomHighlight"),
                Bw("99.5"),
                Gw("11"),
                Ow("99.5"),
                Ww("189"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.75"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("triangleBottomHighlightGradient-innerTriangleBottomHighlight"),
                Bw("49.69"),
                Gw("45.96"),
                Ow("131.98"),
                Ww("188.48"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.76"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("triangleHighlightGradient-triangleTopHighlight"),
                Bw("100"),
                Gw("23"),
                Ow("100"),
                Ww("93"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.41"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ]))
        ]));
    }, bm = A2(tw, l([
        uw("groupHighlights")
    ]), l([
        A2(bw, l([
            uw("bottomHighlight"),
            _L("evenodd"),
            Cw("none"),
            aL("url(#triangleBottomHighlight-bottomHighlight)"),
            jL("M 99.5,11 C 153,11 199.11,136.31 184.03,166.42 168.94,196.53 30.06,196.53 14.97,166.42 -0.11,136.31 46,11 99.5,11 Z M 99.5,11")
        ]), M),
        A2(bw, l([
            uw("innerTriangleBottomHighlight"),
            _L("evenodd"),
            Cw("none"),
            aL("url(#triangleBottomHighlightGradient-innerTriangleBottomHighlight)"),
            jL("M 99.43,23 C 150,23 187.46,134.23 174.13,160.96 160.79,187.68 38.06,187.68 24.73,160.96 11.39,134.23 48.86,23 99.43,23 Z M 99.43,23")
        ]), M),
        A2(bw, l([
            uw("triangleTopHighlight"),
            _L("evenodd"),
            Cw("none"),
            aL("url(#triangleHighlightGradient-triangleTopHighlight)"),
            jL("M 100,23 C 130,23 151.74,72.28 143.9,84.12 136.06,95.96 63.94,95.96 56.1,84.12 48.26,72.28 70,23 100,23 Z M 100,23")
        ]), M)
    ])), sm = function(n) {
        return A2(bw, l([
            uw("triangleShadow"),
            _L("evenodd"),
            Cw("none"),
            aL(Jp(oZ(n))),
            jL("M 101.5,13 C 155,13 201.11,138.31 186.03,168.42 170.94,198.53 32.06,198.53 16.97,168.42 1.89,138.31 48,13 101.5,13 Z M 101.5,13")
        ]), M);
    }, Mm = F4(function(n, r, e, t) {
        return o(e, A2(oL, n, l([
            fm(r),
            A2(tw, l([
                uw("group")
            ]), l([
                sm(r),
                cm,
                t(r),
                bm
            ]))
        ])));
    }), dm = F3(function(n, r, e) {
        var t = e.cp;
        return A4(Mm, r, gs(e.bQ), t, function(n) {
            return n ? om : im;
        }(n));
    }), Cm = function(n) {
        return A2(RL, M, l([
            A2(zw, l([
                uw("canvasTriangleWithKanaDrawing-squareGradient-backgroundTriangle"),
                Bw("99.5"),
                Gw("11"),
                Ow("99.5"),
                Ww("189"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    lZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("canvasTriangleWithKanaDrawing-innerSquareGradient-innerTriangle2"),
                Bw("99.43"),
                Gw("23"),
                Ow("99.43"),
                Ww("181"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    bZ(n),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    nZ(n),
                    kw("1")
                ]), M)
            ])),
            A2(YL, l([
                uw("canvasTriangleWithKanaDrawing-shadow2-outer"),
                nw("objectBoundingBox")
            ]), l([
                A2(NL, l([
                    dw("2")
                ]), M),
                A2(JL, l([
                    QL("1"),
                    PL("1"),
                    Mw("blur")
                ]), M),
                A2(FL, l([
                    rw(Jp(CZ(n))),
                    ew("1")
                ]), M),
                A2(VL, l([
                    iw("blur"),
                    fw("in"),
                    Mw("colorShadow")
                ]), M),
                A2(VL, l([
                    ow("SourceGraphic"),
                    iw("colorShadow"),
                    fw("over")
                ]), M)
            ])),
            A2(zw, l([
                uw("canvasTriangleWithKanaDrawing-squareBottomHighlight-backgroundTriangle2"),
                Bw("99.5"),
                Gw("11"),
                Ow("99.5"),
                Ww("189"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.44"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("canvasTriangleWithKanaDrawing-triangleBottomHighlightGradient-innerTriangleBottomHighlight2"),
                Bw("49.69"),
                Gw("45.96"),
                Ow("131.98"),
                Ww("188.48"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.76"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ])),
            A2(zw, l([
                uw("canvasTriangleWithKanaDrawing-triangleHighlightGradient-triangleTopHighlight"),
                Bw("100"),
                Gw("23"),
                Ow("100"),
                Ww("93"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.41"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ])),
            A2(zw, l([
                uw("canvasTriangleWithKanaDrawing-innerSquareGradiant-innerTriangle"),
                Bw("99.93"),
                Gw("35.5"),
                Ow("99.93"),
                Ww("173.5"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    Hw(Jp(fZ(n))),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.19"),
                    Hw(Jp(A2(cZ, fZ(n), dZ(n)))),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    Hw(Jp(dZ(n))),
                    kw("1")
                ]), M)
            ])),
            A2(YL, l([
                uw("canvasTriangleWithKanaDrawing-shadow3-inner"),
                nw("objectBoundingBox")
            ]), l([
                A2(NL, l([
                    ow("SourceAlpha"),
                    dw("1"),
                    Mw("blur")
                ]), M),
                A2(JL, l([
                    QL("0"),
                    PL("6")
                ]), M),
                A2(VL, l([
                    iw("SourceAlpha"),
                    fw("arithmetic"),
                    sZ("-1.15"),
                    MZ("1.15"),
                    Mw("shadowDiff")
                ]), M),
                A2(FL, l([
                    rw(Jp(n)),
                    ew("1")
                ]), M),
                A2(VL, l([
                    iw("shadowDiff"),
                    fw("in")
                ]), M),
                A2(VL, l([
                    iw("SourceGraphic"),
                    fw("over")
                ]), M)
            ])),
            A2(zw, l([
                uw("canvasTriangleWithKanaDrawing-triangleInnerHighlight-innerTriangleHighlight"),
                Bw("100"),
                Gw("45"),
                Ow("100"),
                Ww("111.5"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0"),
                    eZ(Hw),
                    kw("1")
                ]), M),
                A2(xw, l([
                    Kw("0.26"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0")
                ]), M)
            ])),
            A2(zw, l([
                uw("canvasTriangleWithKanaDrawing-triangleBottomInnerHighlightGradient-innerTriangleBottomHighlight"),
                Bw("51.57"),
                Gw("77.25"),
                Ow("148.28"),
                Ww("173.95"),
                yw("userSpaceOnUse")
            ]), l([
                A2(xw, l([
                    Kw("0.77"),
                    eZ(Hw),
                    kw("0")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("0.5")
                ]), M),
                A2(xw, l([
                    Kw("1"),
                    eZ(Hw),
                    kw("1")
                ]), M)
            ]))
        ]));
    }, lm = A2(tw, M, l([
        A2(bw, l([
            _L("evenodd"),
            Cw("none"),
            aL("url(#canvasTriangleWithKanaDrawing-squareBottomHighlight-backgroundTriangle2)"),
            jL("M 99.5,11 C 153,11 199.11,136.31 184.03,166.42 168.94,196.53 30.06,196.53 14.97,166.42 -0.11,136.31 46,11 99.5,11 Z M 99.5,11")
        ]), M),
        A2(bw, l([
            _L("evenodd"),
            Cw("none"),
            aL("url(#canvasTriangleWithKanaDrawing-triangleBottomHighlightGradient-innerTriangleBottomHighlight2)"),
            jL("M 99.43,23 C 150,23 187.46,134.23 174.13,160.96 160.79,187.68 38.06,187.68 24.73,160.96 11.39,134.23 48.86,23 99.43,23 Z M 99.43,23")
        ]), M),
        A2(bw, l([
            _L("evenodd"),
            Cw("none"),
            aL("url(#canvasTriangleWithKanaDrawing-triangleHighlightGradient-triangleTopHighlight)"),
            jL("M 100,23 C 130,23 151.74,72.28 143.9,84.12 136.06,95.96 63.94,95.96 56.1,84.12 48.26,72.28 70,23 100,23 Z M 100,23")
        ]), M)
    ])), vm = A2(tw, M, l([
        A2(bw, l([
            _L("evenodd"),
            Cw("none"),
            aL("url(#canvasTriangleWithKanaDrawing-innerSquareGradiant-innerTriangle)"),
            XL("url(#canvasTriangleWithKanaDrawing-shadow3-inner)"),
            jL("M 99.93,35.5 C 140,35.5 177.04,132.65 165.36,155.99 153.68,179.34 46.17,179.34 34.49,155.99 22.82,132.65 59.86,35.5 99.93,35.5 Z M 99.93,35.5")
        ]), M),
        A2(bw, l([
            _L("evenodd"),
            Cw("none"),
            aL("url(#canvasTriangleWithKanaDrawing-triangleInnerHighlight-innerTriangleHighlight)"),
            jL("M 100,45 C 130,45 143.69,91.81 137.07,103.06 130.45,114.31 69.55,114.31 62.93,103.06 56.31,91.81 70,45 100,45 Z M 100,45")
        ]), M),
        A2(bw, l([
            _L("evenodd"),
            Cw("none"),
            aL("url(#canvasTriangleWithKanaDrawing-triangleBottomInnerHighlightGradient-innerTriangleBottomHighlight)"),
            jL("M 99.93,35.5 C 123.29,35.5 177.04,132.65 165.36,155.99 153.68,179.34 46.17,179.34 34.49,155.99 22.82,132.65 76.57,35.5 99.93,35.5 Z M 99.93,35.5")
        ]), M)
    ])), gm = function(n) {
        return A2(tw, M, l([
            A2(bw, l([
                uw("canvasTriangleWithKanaDrawing-triangleShadow"),
                _L("evenodd"),
                Cw("none"),
                aL(Jp(LZ(n))),
                jL("M 101.5,13 C 155,13 201.11,138.31 186.03,168.42 170.94,198.53 32.06,198.53 16.97,168.42 1.89,138.31 48,13 101.5,13 Z M 101.5,13")
            ]), M),
            A2(bw, l([
                uw("canvasTriangleWithKanaDrawing-backgroundTriangle"),
                _L("evenodd"),
                Cw("none"),
                aL("url(#canvasTriangleWithKanaDrawing-squareGradient-backgroundTriangle)"),
                jL("M 99.5,11 C 153,11 199.11,136.31 184.03,166.42 168.94,196.53 30.06,196.53 14.97,166.42 -0.11,136.31 46,11 99.5,11 Z M 99.5,11")
            ]), M),
            A2(bw, l([
                uw("canvasTriangleWithKanaDrawing-innerTriangle2"),
                _L("evenodd"),
                Cw("none"),
                aL("url(#canvasTriangleWithKanaDrawing-innerSquareGradient-innerTriangle2)"),
                XL("url(#canvasTriangleWithKanaDrawing-shadow2-outer)"),
                jL("M 99.43,23 C 150,23 187.46,134.23 174.13,160.96 160.79,187.68 38.06,187.68 24.73,160.96 11.39,134.23 48.86,23 99.43,23 Z M 99.43,23")
            ]), M)
        ]));
    }, hm = F3(function(n, r, e) {
        var t = e.bQ;
        return o(e.cp, A2(oL, r, l([
            Cm(gs(t)),
            gm(gs(t)),
            lm,
            function() {
                if (n.$) return pL("");
                var r = n.a;
                return A2(tw, M, l([
                    vm,
                    A3(ZZ, "text", l([
                        aL(Jp(LZ(gs(t)))),
                        gZ("Helvetica-Bold, Helvetica, sans-serif"),
                        pZ("bold"),
                        hZ("95"),
                        cL("53"),
                        bL("55"),
                        lL("middle")
                    ]), l([
                        A2(mZ, l([
                            cL("50%"),
                            bL("75%")
                        ]), l([
                            pL(r)
                        ]))
                    ]))
                ]));
            }()
        ])));
    }), pm = F3(function(n, r, e) {
        var t = n.bF;
        switch(t.$){
            case 1:
                return A3(kZ, Gs(o(n.cp, function(n) {
                    return A2(oL, n, l([
                        DZ,
                        A2(tw, l([
                            uw("canvas3-group2")
                        ]), l([
                            A2(tw, l([
                                uw("canvas3-group")
                            ]), l([
                                A2(EL, l([
                                    uw("canvas3-oval2"),
                                    Cw("none"),
                                    aL("rgb(53, 53, 53)"),
                                    XL("url(#canvas3-shadowCirlce-outer)"),
                                    TL("100"),
                                    IL("100"),
                                    sw("80")
                                ]), M),
                                A2(EL, l([
                                    uw("canvas3-ovalGreen"),
                                    mw("mix-blend-mode: screen;"),
                                    Cw("none"),
                                    aL("url(#canvas3-gradientGreen-ovalGreen)"),
                                    TL("100"),
                                    IL("100"),
                                    sw("80")
                                ]), M),
                                A2(EL, l([
                                    uw("canvas3-ovalBlue"),
                                    mw("mix-blend-mode: screen;"),
                                    Cw("none"),
                                    aL("url(#canvas3-gradientBlue-ovalBlue)"),
                                    TL("100"),
                                    IL("100"),
                                    sw("80")
                                ]), M),
                                A2(EL, l([
                                    uw("canvas3-ovalYellow"),
                                    mw("mix-blend-mode: screen;"),
                                    Cw("none"),
                                    aL("url(#canvas3-gradientYellow-ovalYellow)"),
                                    TL("100"),
                                    IL("100"),
                                    sw("80")
                                ]), M),
                                A2(EL, l([
                                    uw("canvas3-ovalRed"),
                                    mw("mix-blend-mode: screen;"),
                                    Cw("none"),
                                    aL("url(#canvas3-gradientRed-ovalRed)"),
                                    TL("100"),
                                    IL("100"),
                                    sw("80")
                                ]), M),
                                A2(EL, l([
                                    uw("canvas3-ovalPurple"),
                                    mw("mix-blend-mode: screen;"),
                                    Cw("none"),
                                    aL("url(#canvas3-gradientPurple-ovalPurple)"),
                                    TL("100"),
                                    IL("100"),
                                    sw("80")
                                ]), M),
                                A2(bw, l([
                                    uw("canvas3-bezier"),
                                    _L("evenodd"),
                                    mw("mix-blend-mode: screen;"),
                                    Cw("none"),
                                    aL("url(#canvas3-gradient4-bezier)"),
                                    jL("M 100,24.53 C 143.5,24.53 169.43,64.88 169.43,91.28 169.43,117.69 143.5,90.94 100,90.94 56.5,90.94 30.57,117.69 30.57,91.28 30.57,64.88 56.5,24.53 100,24.53 Z M 100,24.53")
                                ]), M),
                                A2(bw, l([
                                    uw("canvas3-text7"),
                                    Cw("none"),
                                    eZ(aL),
                                    XL("url(#canvas3-kanjiShadow-outer)"),
                                    jL("M 147.27,83.87 C 149.47,83.87 150.68,81.91 150.68,79.52 150.68,77.23 149.47,75.38 147.27,75.38 L 103.68,75.38 C 104.23,68.85 104.45,61.88 104.45,54.26 104.45,51.87 102.8,50.56 100.04,50.56 97.4,50.56 95.53,51.65 95.53,54.26 95.53,62.32 95.31,69.29 94.87,75.38 L 55.02,75.38 C 52.82,75.38 51.61,77.23 51.61,79.52 51.61,81.91 52.82,83.87 55.02,83.87 L 93.99,83.87 C 92.56,94.33 90.03,102.49 85.51,110.66 78.47,123.61 68.12,132.43 52.82,139.29 51.28,140.05 50.4,141.36 50.4,142.88 50.4,143.65 50.62,144.52 51.06,145.28 52.05,147.24 53.59,148 55.13,148 55.79,148 56.56,147.78 57.33,147.46 72.2,140.81 84.96,129.49 92.78,115.34 96.3,109.02 98.83,102.49 100.59,95.2 103.79,105.76 108.85,115.12 115.12,123.07 122.94,132.98 133.84,141.79 144.4,146.91 145.29,147.35 146.28,147.56 147.16,147.56 148.7,147.56 150.24,146.8 151.12,145.28 151.67,144.41 152,143.32 152,142.34 152,140.81 151.23,139.4 149.47,138.64 139.89,134.28 129.87,126.99 121.73,117.41 114.13,108.48 107.86,97.27 104.56,83.87 L 147.27,83.87 Z M 147.27,83.87")
                                ]), M)
                            ]))
                        ]))
                    ]));
                }(e(n)))), r, n);
            case 0:
                return A3(kZ, aZ(e(n)), r, n);
            case 2:
                return A3(kZ, A2(TZ, t.a, e(n)), r, n);
            case 3:
                return A3(kZ, A2(PZ, t.a, e(n)), r, n);
            case 4:
                return A3(kZ, A2(rm, t.a, e(n)), r, n);
            case 5:
                return A3(kZ, A2(dm, t.a, e(n)), r, n);
            case 6:
                return A3(kZ, A2(um, t.a, e(n)), r, n);
            case 7:
                return A3(kZ, A2($Z, t.a, e(n)), r, n);
            case 8:
                return A3(kZ, A2(zZ, t.a, e(n)), r, n);
            case 9:
                return A3(kZ, A2(HZ, t.a, e(n)), r, n);
            case 10:
                return A3(kZ, A2(hm, t.a, e(n)), r, n);
            default:
                return A3(kZ, A2(WZ, t.a, e(n)), r, n);
        }
    }), Lm = F2(function(n, r) {
        return A2(Wu, function(r) {
            return e(n, r.a);
        }, r);
    }), wm = F2(function(n, r) {
        return !A2(Lm, n, r);
    }), Zm = function(n) {
        return Fp("column" + ze(n));
    }, mm = function(n) {
        return Fp(0 > n ? "row" + ze(Vb(n)) + "Above" : "row" + ze(n));
    }, Sm = F2(function(n, r) {
        var e = n.b;
        return r.b ? r : l([
            mm(n.a),
            Zm(e)
        ]);
    }), $m = Fp("hint-above-animation"), Dm = Fp("hint-below-animation"), ym = Fp("hint-left-animation"), zm = Fp("hint-right-animation"), Km = function(n) {
        var r = n.a, t = n.b;
        return e(Gf(r), t) ? l([
            ym
        ]) : e(fp(r), t) ? l([
            zm
        ]) : e(cp(r), t) ? l([
            Dm
        ]) : e($f(r), t) ? l([
            $m
        ]) : M;
    }, xm = F2(function(n, r) {
        var t = r.a, a = r.b, u = o(e(n, t), e(n, a));
        n: for(;;){
            if (u.a) {
                if (u.b) break n;
                return Km(o(a, t));
            }
            if (u.b) return Km(o(t, a));
            break n;
        }
        return M;
    }), Hm = F3(function(n, r, e) {
        var t = r.b, a = n.ds.co;
        if (a.$) return e;
        var u = a.a;
        return s(e, s(l([
            mm(r.a),
            Zm(t)
        ]), A2(xm, r, u)));
    }), km = Fp("swap-animation"), Bm = F2(function(n, r) {
        var t = r.b, a = o(e(n, r.a), e(n, t));
        n: for(;;){
            if (a.a) {
                if (a.b) break n;
                return l([
                    km
                ]);
            }
            if (a.b) return l([
                km
            ]);
            break n;
        }
        return M;
    }), Om = Fp("invalid-swap"), Gm = Fp("invalid-swap-above-animation"), Wm = Fp("invalid-swap-below-animation"), qm = Fp("invalid-swap-left-animation"), Um = Fp("invalid-swap-right-animation"), Am = F2(function(n, r) {
        return e(Gf(n), r) ? l([
            Om,
            qm
        ]) : e(fp(n), r) ? l([
            Om,
            Um
        ]) : e(cp(n), r) ? l([
            Om,
            Wm
        ]) : e($f(n), r) ? l([
            Om,
            Gm
        ]) : M;
    }), Em = F2(function(n, r) {
        var t = r.a, a = r.b, u = o(e(n, t), e(n, a));
        n: for(;;){
            if (u.a) {
                if (u.b) break n;
                return A2(Am, a, t);
            }
            if (u.b) return A2(Am, t, a);
            break n;
        }
        return M;
    }), Tm = Fp("invalid-drag-swap"), Im = F2(function(n, r) {
        var t = r.b, a = o(e(n, r.a), e(n, t));
        n: for(;;){
            if (a.a) {
                if (a.b) break n;
                return l([
                    Tm
                ]);
            }
            if (a.b) return l([
                Tm
            ]);
            break n;
        }
        return M;
    }), jm = F3(function(n, r, e) {
        var t = n.ds, a = r.a, i = r.b, o = c(t.cy, t.cz, n.cx.cR);
        n: for(;;){
            if (1 === o.a.$) {
                if (o.b.$ || o.c.$) break n;
                var f = o.b.a;
                return s(e, s(l([
                    mm(a),
                    Zm(i)
                ]), A2(Im, r, f)));
            }
            if (1 === o.b.$) {
                if (1 === o.c.$) {
                    var b = o.a.a;
                    return s(e, s(l([
                        mm(a),
                        Zm(i)
                    ]), A2(Em, r, b)));
                }
                b = o.a.a;
                var M = o.c.a, d = M.b;
                return 0 > u(M.a, 3) && 0 > u(d, 3) ? s(e, s(l([
                    mm(a),
                    Zm(i)
                ]), A2(Em, r, b))) : s(e, A2(Bm, r, b));
            }
            break n;
        }
        return e;
    }), Rm = Fp("boardCenter"), Qm = Fp("shuffleAnimation"), Pm = function(n) {
        return mw("transition-delay: " + ze(n) + "ms;");
    }, Vm = F2(function(n, r) {
        var e = n.a5, t = r.a, a = r.b, u = A2(Co, A2(Qi, 0, 250), vi(t + a)).a;
        switch(e.dh){
            case 0:
                return l([
                    Rm,
                    Qm,
                    Pm(u)
                ]);
            case 1:
                return l([
                    mm(t),
                    Zm(a),
                    Qm,
                    Pm(500 + u)
                ]);
            default:
                return M;
        }
    }), Fm = F2(function(n, r) {
        var t = r.a, a = r.b, u = o(e(n, t), e(n, a));
        n: for(;;){
            if (u.a) {
                if (u.b) break n;
                return a;
            }
            if (u.b) return t;
            break n;
        }
        return n;
    }), Nm = F3(function(n, r, e) {
        var t = n.ds.dr;
        if (t.$) return e;
        var a = t.a, u = A2(Fm, r, a), i = u.b;
        return s(e, s(l([
            mm(u.a),
            Zm(i)
        ]), A2(Bm, r, a)));
    }), Jm = {
        $: 8
    }, _m = F2(function(n, r) {
        return e(n, cp(r));
    }), Ym = F2(function(n, r) {
        return u(Vb(r), Vb(n)) > 0 && u(r, 3) > 0;
    }), Xm = F2(function(n, r) {
        return e(n, $f(r));
    }), nS = F2(function(n, r) {
        return u(Vb(r), Vb(n)) > 0 && 0 > u(r, -3);
    }), rS = F2(function(n, r) {
        return u(Vb(n), Vb(r)) > 0 && u(n, 3) > 0;
    }), eS = F2(function(n, r) {
        return e(n, fp(r));
    }), tS = F2(function(n, r) {
        return u(Vb(n), Vb(r)) > 0 && 0 > u(n, -3);
    }), aS = F2(function(n, r) {
        return e(n, Gf(r));
    }), uS = F2(function(n, r) {
        var t = o(n.cS, n.cR);
        if (t.a.$ || t.b.$) return Jm;
        var a = t.a.a, u = t.b.a, i = u.a, c = u.b;
        return A2(tS, i, c) ? e(r, a) ? {
            $: 0,
            a: i
        } : A2(aS, a, r) ? {
            $: 5,
            a: i
        } : Jm : A2(rS, i, c) ? e(r, a) ? function(n) {
            return {
                $: 1,
                a: n
            };
        }(i) : A2(eS, a, r) ? function(n) {
            return {
                $: 4,
                a: n
            };
        }(i) : Jm : A2(Ym, i, c) ? e(r, a) ? function(n) {
            return {
                $: 3,
                a: n
            };
        }(c) : A2(_m, a, r) ? function(n) {
            return {
                $: 6,
                a: n
            };
        }(c) : Jm : A2(nS, i, c) ? e(r, a) ? function(n) {
            return {
                $: 2,
                a: n
            };
        }(c) : A2(Xm, a, r) ? function(n) {
            return {
                $: 7,
                a: n
            };
        }(c) : Jm : Jm;
    }), iS = N, oS = F2(function(n, r) {
        return mw(0 > r ? "left: max(calc(" + ze(n) + " * var(--tileWidthAndHeight) + " + iS(r) + "px), " + ze(n - 1) + " * var(--tileWidthAndHeight));" : "left: min(calc(" + ze(n) + " * var(--tileWidthAndHeight) + " + iS(r) + "px), " + ze(n + 1) + " * var(--tileWidthAndHeight));");
    }), cS = F2(function(n, r) {
        return mw(0 > r ? "top: max(calc(" + ze(n) + " * var(--tileWidthAndHeight) + " + iS(r) + "px), " + ze(n - 1) + " * var(--tileWidthAndHeight));" : "top: min(calc(" + ze(n) + " * var(--tileWidthAndHeight) + " + iS(r) + "px), " + ze(n + 1) + " * var(--tileWidthAndHeight));");
    }), fS = F3(function(n, r, e) {
        var t = r.a, a = r.b;
        if (Be(e) > 0 || !n.cx.cB) return e;
        var u = A2(uS, n.cx, r);
        switch(u.$){
            case 0:
            case 1:
                return A2(se, A2(oS, a, u.a), A2(se, mm(t), e));
            case 2:
            case 3:
                return A2(se, A2(cS, t, u.a), A2(se, Zm(a), e));
            case 4:
            case 5:
                return A2(se, A2(oS, a, -1 * u.a), A2(se, mm(t), e));
            case 6:
            case 7:
                return A2(se, A2(cS, t, -1 * u.a), A2(se, Zm(a), e));
            default:
                return e;
        }
    }), bS = F2(function(n, r) {
        return A2(Sm, r, A3(fS, n, r, A3(Hm, n, r, A3(jm, n, r, A3(Nm, n, r, A2(Vm, n, r))))));
    }), sS = function(n) {
        return pw(function(n) {
            return A2(Ke, " ", l([
                ze(n.bl),
                ze(n.bm),
                n.bk,
                n.aE
            ]));
        }(n));
    }, MS = F4(function(n, r, e, t) {
        var a = t.aw;
        return s(l([
            sS(r),
            e
        ]), A2(bS, n, a));
    }), dS = F3(function(n, r, e) {
        return A2(wm, e.aw, r.ca) ? A3(pm, e, n, A3(MS, r, Vw, Qw)) : Ye;
    }), CS = F3(function(n, r, e) {
        return A2(Qu, Ye, A2(Vo, function(e) {
            return Se(A3(dS, n, r, e));
        }, e));
    }), lS = F3(function(n, r, e) {
        var t;
        return t = A2(Rw, function(e) {
            return A3(CS, n, r, e);
        }, e), A3(Lf, F2(function(n, r) {
            return A2(gb, r, n);
        }), Ye, t);
    }), vS = function(n) {
        return Fp(n ? "fadedIn" : "fadedOut");
    }, gS = F2(function(n, r) {
        var e = n.bG, t = n.cK;
        return A3(mL, A2(SL, n.by, l([
            5,
            6
        ])), A2(zL, l([
            Tw,
            vS(5 === n.by)
        ]), s(function(n) {
            var r;
            return l([
                o("shuffling-notification", (r = n.a5.dh, A2(oL, A2(Sw, r, l([
                    Lw("471"),
                    pw("0 0 375 120"),
                    uw("shuffling-notification")
                ])), l([
                    qw,
                    A2(tw, l([
                        uw("shuffleDrawing-group2"),
                        Dw("url(#shuffleDrawing-rectangle)")
                    ]), l([
                        A2($w, l([
                            uw("shuffleDrawing-rectangle")
                        ]), l([
                            A2(Aw, l([
                                cL("0"),
                                bL("-120"),
                                Lw("375"),
                                aw("120"),
                                Ew("translate(0, 120)")
                            ]), M)
                        ])),
                        A2(tw, l([
                            uw("shuffleDrawing-stripesBackground"),
                            XL("url(#shuffleDrawing-levelCompleteOuterShadow-outer)")
                        ]), l([
                            A2(Aw, l([
                                uw("shuffleDrawing-rectangle4"),
                                Cw("none"),
                                aL("url(#shuffleDrawing-lightStripeGradiantBottom-rectangle4)"),
                                cL("-86"),
                                bL("97"),
                                Lw("547"),
                                aw("3")
                            ]), M),
                            A2(Aw, l([
                                uw("shuffleDrawing-rectangle6"),
                                Cw("none"),
                                aL("url(#shuffleDrawing-lightStripeGradiantTop-rectangle6)"),
                                cL("-86"),
                                bL("-2.5"),
                                Lw("547"),
                                aw("100")
                            ]), M),
                            A2(tw, l([
                                uw("shuffleDrawing-group3"),
                                Dw("url(#shuffleDrawing-rectangle5)")
                            ]), l([
                                A2($w, l([
                                    uw("shuffleDrawing-rectangle5")
                                ]), l([
                                    A2(Aw, l([
                                        cL("0"),
                                        bL("0"),
                                        Lw("375"),
                                        aw("120")
                                    ]), M)
                                ])),
                                A2(tw, l([
                                    uw("shuffleDrawing-group5"),
                                    Dw("url(#shuffleDrawing-bezier)")
                                ]), l([
                                    A2($w, l([
                                        uw("shuffleDrawing-bezier")
                                    ]), l([
                                        A2(bw, l([
                                            jL("M 21.2,100 L 48.17,100 139.86,-0 112.89,-0 21.2,100 Z M 74.68,100 L 101.65,100 193.34,-0 166.38,-0 74.68,100 Z M 128.17,100 L 155.14,100 246.83,-0 219.86,-0 128.17,100 Z M -32.29,100 L -5.32,100 86.37,-0 59.4,-0 -32.29,100 Z M 235.37,100 L 262.34,100 354.03,-0 327.06,-0 235.37,100 Z M 288.85,100 L 315.82,100 407.51,-0 380.55,-0 288.85,100 Z M 342.34,100 L 369.31,100 461,-0 434.03,-0 342.34,100 Z M 181.88,100 L 208.85,100 300.54,-0 273.57,-0 181.88,100 Z M -86,100 L -59.03,100 32.66,-0 5.69,-0 -86,100 Z M -86,100")
                                        ]), M)
                                    ])),
                                    A2(tw, l([
                                        uw("shuffleDrawing-group6")
                                    ]), l([
                                        A2(Aw, l([
                                            uw("shuffleDrawing-bottomShade"),
                                            Cw("none"),
                                            aL("url(#shuffleDrawing-darkStripeGradiantBottom-bottomShade)"),
                                            cL("-86"),
                                            bL("97"),
                                            Lw("547"),
                                            aw("3")
                                        ]), M),
                                        A2(Aw, l([
                                            uw("shuffleDrawing-topShade"),
                                            Cw("none"),
                                            aL("url(#shuffleDrawing-darkStripeGradiantTop-topShade)"),
                                            cL("-86"),
                                            bL("-3"),
                                            Lw("547"),
                                            aw("100")
                                        ]), M)
                                    ]))
                                ]))
                            ]))
                        ])),
                        A2(tw, l([
                            uw("shuffleDrawing-topHighlight"),
                            Uw("0.6"),
                            mw("mix-blend-mode: screen;")
                        ]), l([
                            A2(Aw, l([
                                uw("shuffleDrawing-rectangle2"),
                                mw("mix-blend-mode: screen;"),
                                Cw("none"),
                                aL("url(#shuffleDrawing-highlight-rectangle2)"),
                                cL("0"),
                                bL("6"),
                                Lw("375"),
                                aw("18")
                            ]), M),
                            A2(Aw, l([
                                uw("shuffleDrawing-rectangle3"),
                                mw("mix-blend-mode: screen;"),
                                Cw("none"),
                                aL("url(#shuffleDrawing-reverseHighlight-rectangle3)"),
                                cL("0"),
                                bL("0"),
                                Lw("375"),
                                aw("6")
                            ]), M)
                        ]))
                    ])),
                    A2(tw, l([
                        uw("shuffleDrawing-group4")
                    ]), l([
                        A2(tw, l([
                            uw("shuffleDrawing-group")
                        ]), l([
                            A2(Aw, l([
                                uw("shuffleDrawing-beigeBackground"),
                                Cw("none"),
                                aL("rgb(252, 246, 213)"),
                                XL("url(#shuffleDrawing-levelCompleteInnerShadow-outer)"),
                                cL("-94"),
                                bL("12"),
                                Lw("555"),
                                aw("77.5")
                            ]), M),
                            A2(bw, l([
                                uw("shuffleDrawing-bottomBeigeStipe"),
                                Cw("none"),
                                aL("rgb(251, 225, 173)"),
                                jL("M -94,81.73 L 461,81.73 461,84.42 -94,84.42 -94,81.73 Z M -94,81.73")
                            ]), M),
                            A2(bw, l([
                                uw("shuffleDrawing-topBeigeStripe"),
                                Cw("none"),
                                aL("rgb(251, 225, 173)"),
                                jL("M -94,16.59 L 461,16.59 461,19.28 -94,19.28 -94,16.59 Z M -94,16.59")
                            ]), M)
                        ])),
                        A2(bw, l([
                            uw("shuffleDrawing-beigeStipeShadow"),
                            Cw("none"),
                            aL("url(#shuffleDrawing-gradient3-beigeStipeShadow)"),
                            jL("M 0.07,86.5 L 374.93,86.5 374.93,89.63 0.07,89.63 0.07,86.5 Z M 0.07,86.5")
                        ]), M)
                    ])),
                    A2(bw, l([
                        uw("shuffleDrawing-textShuffling"),
                        Cw("none"),
                        aL("rgb(71, 148, 129)"),
                        jL("M 146.31,60.32 C 144.7,59.34 143.29,58.85 142.09,58.85 141.17,58.85 140.46,59.05 139.96,59.45 139.46,59.85 139.18,60.37 139.11,61 139.06,61.65 139.34,62.22 139.94,62.72 140.54,63.23 141.39,63.72 142.49,64.2 143.69,64.73 144.63,65.36 145.32,66.07 146.02,66.79 146.36,67.78 146.36,69.05 146.36,70 146.13,70.9 145.65,71.76 145.17,72.62 144.48,73.32 143.55,73.85 142.62,74.38 141.5,74.65 140.19,74.65 138.97,74.65 137.81,74.45 136.71,74.05 135.61,73.65 134.64,73.08 133.79,72.35 L 135.34,70.18 C 135.94,70.73 136.67,71.18 137.54,71.54 138.4,71.9 139.22,72.07 139.99,72.07 140.89,72.07 141.65,71.85 142.28,71.4 142.9,70.95 143.25,70.33 143.31,69.55 143.36,68.9 143.13,68.33 142.62,67.84 142.12,67.35 141.41,66.9 140.51,66.5 139.58,66.07 138.82,65.66 138.24,65.29 137.65,64.91 137.15,64.42 136.71,63.81 136.28,63.2 136.06,62.48 136.06,61.62 136.06,60.52 136.32,59.57 136.85,58.75 137.38,57.93 138.1,57.31 139.01,56.89 139.93,56.46 140.96,56.26 142.11,56.28 143.31,56.33 144.35,56.52 145.21,56.85 146.08,57.18 146.91,57.63 147.71,58.2 L 146.31,60.32 Z M 157.14,63.47 C 158.07,63.47 158.82,63.74 159.4,64.26 159.98,64.79 160.26,65.47 160.26,66.3 L 160.24,66.65 159.29,74.5 156.49,74.5 157.31,67.62 C 157.35,67.07 157.24,66.65 156.99,66.34 156.74,66.03 156.33,65.88 155.76,65.88 154.88,65.88 154.11,66.25 153.46,66.99 152.81,67.73 152.42,68.67 152.29,69.82 L 151.71,74.5 148.91,74.5 151.29,55 154.04,55 152.76,65.6 C 153.25,64.95 153.86,64.43 154.61,64.05 155.36,63.67 156.2,63.47 157.14,63.47 Z M 174.64,63.93 L 173.31,74.5 170.79,74.5 170.84,72.7 C 170.37,73.38 169.75,73.93 168.99,74.34 168.22,74.75 167.39,74.95 166.49,74.95 165.59,74.95 164.86,74.7 164.3,74.19 163.74,73.68 163.46,73.01 163.46,72.18 163.46,72.01 163.47,71.88 163.49,71.8 L 164.44,63.93 167.24,63.93 166.39,70.8 C 166.35,71.33 166.46,71.75 166.7,72.06 166.94,72.37 167.34,72.53 167.89,72.55 168.72,72.55 169.46,72.18 170.1,71.43 170.74,70.67 171.12,69.73 171.24,68.6 L 171.81,63.93 174.64,63.93 Z M 179.04,66.38 L 177.24,66.38 177.56,63.9 179.36,63.9 179.86,59.75 C 180.05,58.27 180.56,57.11 181.41,56.28 182.26,55.44 183.39,55.03 184.79,55.03 185.2,55.03 185.65,55.09 186.11,55.21 186.58,55.34 186.98,55.52 187.31,55.75 L 185.86,57.78 C 185.63,57.47 185.28,57.32 184.81,57.32 183.6,57.32 182.88,58.16 182.66,59.82 L 182.16,63.9 185.46,63.9 185.14,66.38 181.84,66.38 180.86,74.5 178.06,74.5 179.04,66.38 Z M 201.11,55 L 198.74,74.5 195.94,74.5 198.31,55 201.11,55 Z M 189.09,66.38 L 187.29,66.38 187.61,63.9 189.41,63.9 189.91,59.75 C 190.1,58.27 190.61,57.11 191.46,56.28 192.31,55.44 193.44,55.03 194.84,55.03 195.25,55.03 195.7,55.09 196.16,55.21 196.63,55.34 197.03,55.52 197.36,55.75 L 195.91,57.78 C 195.68,57.47 195.33,57.32 194.86,57.32 193.65,57.32 192.93,58.16 192.71,59.82 L 192.21,63.9 195.11,63.9 194.81,66.38 191.89,66.38 190.91,74.5 188.11,74.5 189.09,66.38 Z M 206.69,63.93 L 205.39,74.5 202.59,74.5 203.89,63.93 206.69,63.93 Z M 204.09,60.28 C 204.1,59.82 204.27,59.45 204.59,59.15 204.9,58.85 205.3,58.7 205.79,58.7 206.2,58.7 206.57,58.82 206.88,59.05 207.18,59.28 207.34,59.62 207.34,60.07 207.34,60.53 207.18,60.9 206.85,61.21 206.52,61.52 206.12,61.68 205.64,61.68 205.24,61.66 204.88,61.53 204.56,61.3 204.25,61.07 204.09,60.73 204.09,60.28 Z M 217.46,63.47 C 218.41,63.47 219.17,63.73 219.75,64.25 220.33,64.77 220.61,65.44 220.61,66.28 220.61,66.44 220.6,66.57 220.59,66.65 L 219.64,74.5 216.84,74.5 217.69,67.65 C 217.72,67.08 217.6,66.65 217.34,66.34 217.07,66.03 216.64,65.88 216.04,65.88 215.17,65.88 214.42,66.25 213.79,66.99 213.15,67.73 212.77,68.67 212.64,69.82 L 212.06,74.5 209.26,74.5 210.54,63.93 213.06,63.93 213.09,65.62 C 213.55,64.96 214.17,64.43 214.93,64.05 215.68,63.67 216.53,63.47 217.46,63.47 Z M 236.31,63.93 L 234.91,75.05 C 234.75,76.5 234.09,77.65 232.94,78.5 231.79,79.35 230.36,79.78 228.66,79.78 227.38,79.78 226.34,79.59 225.54,79.21 224.74,78.84 223.97,78.3 223.24,77.6 L 225.14,75.7 C 225.65,76.23 226.21,76.64 226.8,76.91 227.39,77.19 228.1,77.32 228.91,77.32 229.81,77.32 230.56,77.08 231.15,76.59 231.74,76.1 232.09,75.43 232.19,74.57 L 232.39,72.88 C 231.99,73.46 231.45,73.92 230.78,74.26 230.1,74.6 229.32,74.78 228.44,74.78 227.45,74.78 226.57,74.55 225.79,74.11 225,73.67 224.39,73.04 223.94,72.21 223.49,71.39 223.26,70.42 223.26,69.3 223.26,68.47 223.49,67.6 223.95,66.69 224.41,65.78 225.1,65.01 226.03,64.39 226.95,63.76 228.06,63.45 229.36,63.45 230.3,63.45 231.11,63.6 231.81,63.91 232.51,64.22 233.02,64.64 233.34,65.18 L 233.74,63.93 236.31,63.93 Z M 232.99,68 C 232.84,67.32 232.48,66.77 231.91,66.36 231.35,65.95 230.66,65.75 229.86,65.75 229.01,65.75 228.31,65.94 227.75,66.31 227.19,66.69 226.78,67.15 226.53,67.7 226.27,68.25 226.14,68.78 226.14,69.3 226.14,70.27 226.43,71.04 227.03,71.61 227.62,72.19 228.41,72.47 229.41,72.47 230.1,72.47 230.74,72.28 231.34,71.89 231.94,71.5 232.4,70.97 232.71,70.3 L 232.99,68 Z M 238.41,73.15 C 238.41,72.68 238.59,72.28 238.95,71.95 239.31,71.62 239.7,71.45 240.14,71.45 240.47,71.45 240.77,71.59 241.03,71.86 241.28,72.14 241.41,72.47 241.41,72.85 241.41,73.32 241.24,73.71 240.89,74.03 240.54,74.34 240.16,74.5 239.76,74.5 239.4,74.5 239.08,74.38 238.81,74.12 238.55,73.87 238.41,73.55 238.41,73.15 Z M 238.41,73.15")
                    ]), M),
                    A2(bw, l([
                        uw("shuffleDrawing-textNoMoreSwaps"),
                        Cw("none"),
                        aL("rgb(71, 148, 129)"),
                        jL("M 72.31,26.53 L 70.08,44.62 70.01,44.62 58.92,32.38 57.55,44 54.74,44 56.95,25.93 57.07,25.93 68.11,38.34 69.5,26.53 72.31,26.53 Z M 79.75,44.26 C 78.87,44.26 78.01,44.08 77.17,43.7 76.33,43.32 75.64,42.76 75.1,42 74.55,41.24 74.28,40.32 74.28,39.25 74.28,38.32 74.48,37.41 74.89,36.52 75.3,35.64 75.95,34.9 76.84,34.3 77.72,33.71 78.85,33.42 80.21,33.42 81.15,33.42 82.04,33.62 82.87,34.02 83.7,34.42 84.38,35 84.89,35.76 85.4,36.52 85.66,37.41 85.66,38.43 85.66,39.26 85.47,40.13 85.09,41.02 84.72,41.92 84.09,42.68 83.21,43.32 82.33,43.95 81.18,44.26 79.75,44.26 Z M 79.82,42.03 C 80.53,42.03 81.11,41.85 81.58,41.49 82.04,41.13 82.38,40.69 82.6,40.16 82.81,39.63 82.92,39.1 82.92,38.55 82.92,37.85 82.77,37.28 82.48,36.85 82.18,36.42 81.82,36.1 81.38,35.91 80.95,35.72 80.53,35.62 80.11,35.62 79.41,35.62 78.82,35.8 78.36,36.16 77.9,36.52 77.55,36.97 77.33,37.51 77.1,38.04 76.99,38.58 76.99,39.13 76.99,40.1 77.28,40.83 77.86,41.31 78.43,41.79 79.09,42.03 79.82,42.03 Z M 109.56,33.39 C 110.47,33.39 111.19,33.63 111.71,34.11 112.23,34.59 112.49,35.24 112.49,36.06 112.49,36.22 112.48,36.34 112.46,36.44 L 111.55,44 108.86,44 109.68,37.47 C 109.71,36.93 109.64,36.51 109.48,36.21 109.31,35.92 108.98,35.75 108.5,35.72 107.67,35.72 106.95,36.09 106.34,36.84 105.74,37.58 105.37,38.45 105.24,39.44 L 104.66,44 101.98,44 102.77,37.47 102.79,37.11 C 102.79,36.25 102.38,35.78 101.57,35.72 100.75,35.72 100.04,36.09 99.43,36.84 98.82,37.58 98.46,38.45 98.33,39.44 L 97.78,44 95.09,44 96.31,33.85 98.74,33.85 98.71,35.6 C 99.21,34.9 99.8,34.35 100.5,33.97 101.2,33.58 101.98,33.39 102.84,33.39 103.66,33.39 104.31,33.57 104.81,33.92 105.3,34.27 105.59,34.79 105.67,35.48 106.2,34.84 106.8,34.33 107.48,33.96 108.16,33.58 108.86,33.39 109.56,33.39 Z M 120.5,44.26 C 119.62,44.26 118.76,44.08 117.92,43.7 117.08,43.32 116.39,42.76 115.85,42 115.3,41.24 115.03,40.32 115.03,39.25 115.03,38.32 115.24,37.41 115.64,36.52 116.05,35.64 116.7,34.9 117.59,34.3 118.48,33.71 119.6,33.42 120.96,33.42 121.9,33.42 122.79,33.62 123.62,34.02 124.46,34.42 125.13,35 125.64,35.76 126.15,36.52 126.41,37.41 126.41,38.43 126.41,39.26 126.22,40.13 125.84,41.02 125.47,41.92 124.84,42.68 123.96,43.32 123.08,43.95 121.93,44.26 120.5,44.26 Z M 120.58,42.03 C 121.28,42.03 121.86,41.85 122.33,41.49 122.79,41.13 123.13,40.69 123.35,40.16 123.56,39.63 123.67,39.1 123.67,38.55 123.67,37.85 123.52,37.28 123.23,36.85 122.93,36.42 122.57,36.1 122.14,35.91 121.7,35.72 121.28,35.62 120.86,35.62 120.16,35.62 119.58,35.8 119.11,36.16 118.65,36.52 118.3,36.97 118.08,37.51 117.86,38.04 117.74,38.58 117.74,39.13 117.74,40.1 118.03,40.83 118.61,41.31 119.18,41.79 119.84,42.03 120.58,42.03 Z M 132.14,36.22 C 132.62,35.36 133.3,34.67 134.16,34.16 135.02,33.65 135.82,33.39 136.54,33.39 L 136.08,36.08 C 135.34,36.02 134.67,36.15 134.05,36.48 133.44,36.8 132.94,37.25 132.55,37.82 132.17,38.39 131.94,38.99 131.86,39.63 L 131.3,44 128.64,44 129.86,33.85 132.29,33.85 132.14,36.22 Z M 143.11,41.96 C 143.77,41.96 144.45,41.74 145.15,41.29 L 146.11,43.38 C 145.6,43.65 145.06,43.86 144.48,44.01 143.9,44.16 143.35,44.24 142.82,44.24 141.16,44.24 139.84,43.79 138.85,42.9 137.87,42 137.38,40.72 137.38,39.06 137.38,38.16 137.6,37.28 138.04,36.4 138.48,35.53 139.14,34.82 140.04,34.26 140.94,33.7 142.02,33.42 143.3,33.42 146.28,33.42 148.02,35.06 148.51,38.36 L 140.47,40.5 C 140.73,40.99 141.1,41.36 141.58,41.6 142.06,41.84 142.57,41.96 143.11,41.96 Z M 143.23,35.53 C 142.24,35.53 141.46,35.84 140.9,36.48 140.34,37.11 140.06,37.86 140.06,38.74 L 140.06,38.91 145.61,37.4 C 145.43,36.82 145.14,36.37 144.72,36.03 144.3,35.7 143.81,35.53 143.23,35.53 Z M 165.07,33.39 C 165.94,33.39 166.73,33.58 167.45,33.97 168.17,34.35 168.74,34.89 169.15,35.59 169.57,36.28 169.78,37.09 169.78,38 169.78,39.12 169.51,40.16 168.98,41.12 168.46,42.08 167.72,42.84 166.76,43.41 165.81,43.98 164.71,44.26 163.46,44.26 162.89,44.26 162.32,44.16 161.75,43.94 161.18,43.72 160.71,43.43 160.34,43.06 L 159.7,48.87 157.03,48.87 158.93,33.66 161.26,33.66 161.23,34.83 C 162.62,33.87 163.9,33.39 165.07,33.39 Z M 163.39,42.01 C 164.1,42.01 164.73,41.84 165.29,41.5 165.85,41.17 166.28,40.72 166.58,40.17 166.89,39.62 167.04,39.03 167.04,38.41 167.04,37.58 166.75,36.89 166.18,36.34 165.6,35.8 164.92,35.53 164.14,35.53 163.45,35.53 162.83,35.72 162.29,36.09 161.74,36.47 161.3,37 160.97,37.69 L 160.7,39.8 C 160.86,40.42 161.16,40.95 161.6,41.37 162.04,41.8 162.64,42.01 163.39,42.01 Z M 177.19,44.26 C 176.31,44.26 175.45,44.08 174.61,43.7 173.77,43.32 173.08,42.76 172.54,42 171.99,41.24 171.72,40.32 171.72,39.25 171.72,38.32 171.92,37.41 172.33,36.52 172.74,35.64 173.39,34.9 174.28,34.3 175.16,33.71 176.29,33.42 177.65,33.42 178.59,33.42 179.48,33.62 180.31,34.02 181.14,34.42 181.82,35 182.33,35.76 182.84,36.52 183.1,37.41 183.1,38.43 183.1,39.26 182.91,40.13 182.53,41.02 182.16,41.92 181.53,42.68 180.65,43.32 179.77,43.95 178.62,44.26 177.19,44.26 Z M 177.26,42.03 C 177.97,42.03 178.55,41.85 179.02,41.49 179.48,41.13 179.82,40.69 180.04,40.16 180.25,39.63 180.36,39.1 180.36,38.55 180.36,37.85 180.21,37.28 179.92,36.85 179.62,36.42 179.26,36.1 178.82,35.91 178.39,35.72 177.97,35.62 177.55,35.62 176.85,35.62 176.26,35.8 175.8,36.16 175.34,36.52 174.99,36.97 174.77,37.51 174.54,38.04 174.43,38.58 174.43,39.13 174.43,40.1 174.72,40.83 175.3,41.31 175.87,41.79 176.53,42.03 177.26,42.03 Z M 188.64,44.22 C 187.98,44.22 187.27,44.08 186.49,43.81 185.72,43.54 185.06,43.05 184.54,42.34 L 185.86,40.9 C 186.34,41.48 186.8,41.86 187.26,42.04 187.72,42.23 188.18,42.32 188.64,42.32 189.14,42.32 189.5,42.2 189.73,41.96 189.96,41.72 190.08,41.46 190.08,41.17 190.08,40.9 189.98,40.67 189.79,40.5 189.6,40.32 189.4,40.19 189.18,40.1 188.96,40.01 188.56,39.86 187.97,39.63 186.48,39.04 185.74,38.1 185.74,36.8 185.74,36.32 185.86,35.82 186.1,35.31 186.34,34.8 186.74,34.36 187.31,34 187.88,33.64 188.61,33.46 189.5,33.46 191.1,33.46 192.38,33.9 193.34,34.78 L 192.12,36.34 C 191.8,35.99 191.45,35.73 191.06,35.56 190.68,35.4 190.29,35.31 189.89,35.31 189.42,35.31 189.07,35.42 188.83,35.64 188.59,35.85 188.47,36.11 188.47,36.42 188.49,36.74 188.63,36.99 188.9,37.17 189.18,37.36 189.58,37.55 190.13,37.76 190.24,37.79 190.41,37.86 190.63,37.95 191.34,38.27 191.88,38.64 192.25,39.06 192.63,39.47 192.82,40.02 192.82,40.69 192.82,41.28 192.66,41.84 192.36,42.38 192.06,42.92 191.59,43.36 190.97,43.7 190.34,44.04 189.57,44.22 188.64,44.22 Z M 198.82,44.22 C 198.16,44.22 197.44,44.08 196.67,43.81 195.89,43.54 195.24,43.05 194.71,42.34 L 196.03,40.9 C 196.51,41.48 196.98,41.86 197.44,42.04 197.89,42.23 198.35,42.32 198.82,42.32 199.31,42.32 199.68,42.2 199.91,41.96 200.14,41.72 200.26,41.46 200.26,41.17 200.26,40.9 200.16,40.67 199.97,40.5 199.78,40.32 199.57,40.19 199.36,40.1 199.14,40.01 198.74,39.86 198.14,39.63 196.66,39.04 195.91,38.1 195.91,36.8 195.91,36.32 196.03,35.82 196.27,35.31 196.51,34.8 196.92,34.36 197.48,34 198.05,33.64 198.78,33.46 199.68,33.46 201.28,33.46 202.56,33.9 203.52,34.78 L 202.3,36.34 C 201.98,35.99 201.62,35.73 201.24,35.56 200.86,35.4 200.46,35.31 200.06,35.31 199.6,35.31 199.25,35.42 199.01,35.64 198.77,35.85 198.65,36.11 198.65,36.42 198.66,36.74 198.81,36.99 199.08,37.17 199.35,37.36 199.76,37.55 200.3,37.76 200.42,37.79 200.58,37.86 200.81,37.95 201.51,38.27 202.05,38.64 202.43,39.06 202.8,39.47 202.99,40.02 202.99,40.69 202.99,41.28 202.84,41.84 202.54,42.38 202.23,42.92 201.77,43.36 201.14,43.7 200.52,44.04 199.74,44.22 198.82,44.22 Z M 209.59,33.85 L 208.34,44 205.66,44 206.9,33.85 209.59,33.85 Z M 207.1,30.34 C 207.11,29.91 207.27,29.55 207.58,29.26 207.88,28.98 208.26,28.83 208.73,28.83 209.13,28.83 209.48,28.94 209.77,29.17 210.07,29.39 210.22,29.72 210.22,30.15 210.22,30.58 210.06,30.95 209.75,31.24 209.44,31.54 209.05,31.69 208.58,31.69 208.2,31.67 207.86,31.55 207.55,31.33 207.25,31.1 207.1,30.78 207.1,30.34 Z M 219.62,33.39 C 220.5,33.39 221.31,33.58 222.04,33.97 222.76,34.35 223.34,34.92 223.76,35.68 224.19,36.44 224.4,37.38 224.4,38.48 224.4,39.49 224.16,40.44 223.67,41.32 223.18,42.21 222.49,42.92 221.59,43.46 220.7,44 219.66,44.26 218.5,44.26 217.7,44.26 217,44.12 216.4,43.82 215.8,43.52 215.3,43.12 214.92,42.61 L 214.73,44 212.04,44 214.34,25.28 217.01,25.28 215.83,34.9 C 216.26,34.46 216.81,34.09 217.48,33.81 218.14,33.53 218.86,33.39 219.62,33.39 Z M 218.18,41.98 C 218.97,41.98 219.62,41.81 220.14,41.47 220.66,41.12 221.04,40.7 221.28,40.18 221.52,39.67 221.64,39.16 221.64,38.65 221.64,37.67 221.37,36.9 220.84,36.34 220.3,35.78 219.58,35.5 218.66,35.5 217.96,35.5 217.33,35.69 216.78,36.07 216.23,36.44 215.82,36.94 215.54,37.57 L 215.26,39.75 C 215.48,40.39 215.82,40.92 216.29,41.35 216.75,41.77 217.38,41.98 218.18,41.98 Z M 231.6,25.28 L 229.32,44 226.63,44 228.91,25.28 231.6,25.28 Z M 238.54,41.96 C 239.19,41.96 239.87,41.74 240.58,41.29 L 241.54,43.38 C 241.02,43.65 240.48,43.86 239.9,44.01 239.33,44.16 238.78,44.24 238.25,44.24 236.58,44.24 235.26,43.79 234.28,42.9 233.29,42 232.8,40.72 232.8,39.06 232.8,38.16 233.02,37.28 233.46,36.4 233.9,35.53 234.57,34.82 235.46,34.26 236.36,33.7 237.45,33.42 238.73,33.42 241.7,33.42 243.44,35.06 243.94,38.36 L 235.9,40.5 C 236.15,40.99 236.52,41.36 237,41.6 237.48,41.84 237.99,41.96 238.54,41.96 Z M 238.66,35.53 C 237.66,35.53 236.89,35.84 236.33,36.48 235.77,37.11 235.49,37.86 235.49,38.74 L 235.49,38.91 241.03,37.4 C 240.86,36.82 240.56,36.37 240.14,36.03 239.73,35.7 239.23,35.53 238.66,35.53 Z M 256.39,44.22 C 255.74,44.22 255.02,44.08 254.24,43.81 253.47,43.54 252.82,43.05 252.29,42.34 L 253.61,40.9 C 254.09,41.48 254.56,41.86 255.01,42.04 255.47,42.23 255.93,42.32 256.39,42.32 256.89,42.32 257.25,42.2 257.48,41.96 257.72,41.72 257.83,41.46 257.83,41.17 257.83,40.9 257.74,40.67 257.54,40.5 257.35,40.32 257.15,40.19 256.93,40.1 256.72,40.01 256.31,39.86 255.72,39.63 254.23,39.04 253.49,38.1 253.49,36.8 253.49,36.32 253.61,35.82 253.85,35.31 254.09,34.8 254.49,34.36 255.06,34 255.63,33.64 256.36,33.46 257.26,33.46 258.86,33.46 260.14,33.9 261.1,34.78 L 259.87,36.34 C 259.55,35.99 259.2,35.73 258.82,35.56 258.43,35.4 258.04,35.31 257.64,35.31 257.18,35.31 256.82,35.42 256.58,35.64 256.34,35.85 256.22,36.11 256.22,36.42 256.24,36.74 256.38,36.99 256.66,37.17 256.93,37.36 257.34,37.55 257.88,37.76 257.99,37.79 258.16,37.86 258.38,37.95 259.09,38.27 259.63,38.64 260,39.06 260.38,39.47 260.57,40.02 260.57,40.69 260.57,41.28 260.42,41.84 260.11,42.38 259.81,42.92 259.34,43.36 258.72,43.7 258.1,44.04 257.32,44.22 256.39,44.22 Z M 278.47,33.85 L 272.64,44.31 272.47,44.31 270.12,37.57 266.4,44.29 266.23,44.29 262.92,33.85 265.56,33.85 267.26,39.06 269.42,35.31 268.92,33.85 271.25,33.85 272.98,39.25 275.83,33.85 278.47,33.85 Z M 291.43,33.85 L 290.21,44 287.52,44 287.69,42.54 C 287.27,42.97 286.72,43.36 286.02,43.71 285.32,44.06 284.5,44.23 283.56,44.22 282.82,44.23 282.12,44.04 281.46,43.64 280.8,43.24 280.26,42.66 279.86,41.9 279.46,41.14 279.26,40.26 279.26,39.27 279.26,38.3 279.5,37.36 279.97,36.45 280.44,35.55 281.11,34.81 281.98,34.24 282.84,33.68 283.83,33.39 284.95,33.39 286.65,33.39 287.86,34.02 288.58,35.26 L 288.96,33.85 291.43,33.85 Z M 288.26,37.76 C 288.15,37.1 287.84,36.58 287.32,36.19 286.8,35.8 286.17,35.6 285.43,35.6 284.66,35.6 284.03,35.78 283.52,36.13 283.02,36.48 282.65,36.92 282.41,37.44 282.17,37.96 282.05,38.46 282.05,38.96 282.05,39.89 282.32,40.64 282.88,41.2 283.43,41.77 284.15,42.06 285.05,42.06 285.67,42.06 286.25,41.87 286.78,41.5 287.3,41.14 287.71,40.62 288,39.97 L 288.26,37.76 Z M 301.34,33.39 C 302.21,33.39 303,33.58 303.72,33.97 304.44,34.35 305.01,34.89 305.42,35.59 305.84,36.28 306.05,37.09 306.05,38 306.05,39.12 305.78,40.16 305.26,41.12 304.73,42.08 303.99,42.84 303.04,43.41 302.08,43.98 300.98,44.26 299.74,44.26 299.16,44.26 298.59,44.16 298.02,43.94 297.45,43.72 296.98,43.43 296.62,43.06 L 295.97,48.87 293.3,48.87 295.2,33.66 297.53,33.66 297.5,34.83 C 298.9,33.87 300.18,33.39 301.34,33.39 Z M 299.66,42.01 C 300.37,42.01 301,41.84 301.56,41.5 302.12,41.17 302.55,40.72 302.86,40.17 303.16,39.62 303.31,39.03 303.31,38.41 303.31,37.58 303.02,36.89 302.45,36.34 301.87,35.8 301.19,35.53 300.41,35.53 299.72,35.53 299.1,35.72 298.56,36.09 298.02,36.47 297.58,37 297.24,37.69 L 296.98,39.8 C 297.14,40.42 297.44,40.95 297.88,41.37 298.32,41.8 298.91,42.01 299.66,42.01 Z M 311.54,44.22 C 310.89,44.22 310.17,44.08 309.4,43.81 308.62,43.54 307.97,43.05 307.44,42.34 L 308.76,40.9 C 309.24,41.48 309.71,41.86 310.16,42.04 310.62,42.23 311.08,42.32 311.54,42.32 312.04,42.32 312.4,42.2 312.64,41.96 312.87,41.72 312.98,41.46 312.98,41.17 312.98,40.9 312.89,40.67 312.7,40.5 312.5,40.32 312.3,40.19 312.08,40.1 311.87,40.01 311.46,39.86 310.87,39.63 309.38,39.04 308.64,38.1 308.64,36.8 308.64,36.32 308.76,35.82 309,35.31 309.24,34.8 309.64,34.36 310.21,34 310.78,33.64 311.51,33.46 312.41,33.46 314.01,33.46 315.29,33.9 316.25,34.78 L 315.02,36.34 C 314.7,35.99 314.35,35.73 313.97,35.56 313.58,35.4 313.19,35.31 312.79,35.31 312.33,35.31 311.98,35.42 311.74,35.64 311.5,35.85 311.38,36.11 311.38,36.42 311.39,36.74 311.54,36.99 311.81,37.17 312.08,37.36 312.49,37.55 313.03,37.76 313.14,37.79 313.31,37.86 313.54,37.95 314.24,38.27 314.78,38.64 315.16,39.06 315.53,39.47 315.72,40.02 315.72,40.69 315.72,41.28 315.57,41.84 315.26,42.38 314.96,42.92 314.5,43.36 313.87,43.7 313.25,44.04 312.47,44.22 311.54,44.22 Z M 322.51,25.9 L 320.83,39.58 318.43,39.58 320.11,25.9 322.51,25.9 Z M 319.15,44.19 C 318.69,44.19 318.32,44.07 318.05,43.83 317.78,43.59 317.64,43.29 317.64,42.92 317.64,42.5 317.79,42.15 318.08,41.86 318.38,41.58 318.75,41.43 319.2,41.43 319.65,41.43 320,41.56 320.27,41.8 320.53,42.05 320.66,42.35 320.66,42.7 320.66,42.85 320.66,42.95 320.64,43.02 320.58,43.38 320.41,43.67 320.14,43.88 319.86,44.09 319.54,44.19 319.15,44.19 Z M 319.15,44.19")
                    ]), M)
                ]))))
            ]);
        }(n), ma(ve(A2(jw, function(n) {
            return ve(n);
        }, A3(lS, gf(t.dw), n, e)))))), r);
    }), hS = F4(function(n, r, e, t) {
        return {
            aE: t,
            bk: e,
            bl: n,
            bm: r
        };
    }), pS = {
        $: 13
    }, LS = F7(function(n, r, e, t, a, u, i) {
        return {
            av: r,
            aE: t,
            aH: i,
            aI: n,
            aO: e,
            bb: u,
            bi: a
        };
    }), wS = function(n) {
        return A3(ZZ, "text", l([
            aL("rgb(39, 90, 80)"),
            hZ("30"),
            lL("middle"),
            Fp("level-label")
        ]), l([
            A2(mZ, l([
                cL("140"),
                bL("75")
            ]), l([
                pL("Level " + ze(n))
            ]))
        ]));
    }, ZS = $L("className"), mS = ze(25), SS = vr("fill-opacity"), $S = A2(gr, "http://www.w3.org/XML/1998/namespace", "xml:space"), DS = function(n) {
        return A2(oL, l([
            cL("225"),
            bL("20"),
            Lw(mS),
            aw(mS),
            $S("preserve"),
            uw("canvasCloseButton"),
            pw("0 0 50 50"),
            WL(n),
            uw("modal-close-button"),
            aL("red")
        ]), l([
            A2(Aw, l([
                Cw("none"),
                Lw("50"),
                aw("50"),
                SS("0")
            ]), M),
            A2(bw, l([
                aL("rgb(47, 106, 93)"),
                jL("M 43.35,7.35 L 8.35,42.35 7.65,41.65 42.65,6.65 43.35,7.35 Z M 42.65,6.65 L 43.35,7.35 8.35,42.35 7.65,41.65 42.65,6.65 Z M 8.35,6.65 L 43.35,41.65 42.65,42.35 7.65,7.35 8.35,6.65 Z M 8.35,6.65")
            ]), M)
        ]));
    }, yS = F2(function(n, r) {
        return A2(ZL, ZS(n ? "dismissed" : "active"), r);
    }), zS = A2(RL, M, l([
        A2(zw, l([
            uw("canvasWindow-gradient-rectangle"),
            Bw("137"),
            Gw("10"),
            Ow("137"),
            Ww("470"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(181, 227, 150)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(92, 188, 168)"),
                kw("1")
            ]), M)
        ])),
        A2(YL, l([
            uw("canvasWindow-shadow-outer"),
            nw("objectBoundingBox")
        ]), l([
            A2(NL, l([
                dw("2.5")
            ]), M),
            A2(JL, l([
                QL("3"),
                PL("3"),
                Mw("blur")
            ]), M),
            A2(FL, l([
                rw("rgb(85, 85, 85)"),
                ew("1")
            ]), M),
            A2(VL, l([
                iw("blur"),
                fw("in"),
                Mw("colorShadow")
            ]), M),
            A2(VL, l([
                ow("SourceGraphic"),
                iw("colorShadow"),
                fw("over")
            ]), M)
        ]))
    ])), KS = function(n) {
        return A2(Aw, l([
            Cw("none"),
            aL("url(#canvasWindow-gradient-rectangle)"),
            XL("url(#canvasWindow-shadow-outer)"),
            cL("12"),
            bL("10"),
            Lw("250"),
            aw(iS(n)),
            GZ("15")
        ]), M);
    }, xS = function(n) {
        var r = n.av, e = n.aE, t = n.bi, a = n.bb, u = n.aH;
        return A2(BL, A2(yS, n.aO, l([
            DL(n.aI),
            ZS("modal")
        ])), A2(se, A2(oL, l([
            Lw("420"),
            aw("680"),
            sS(t)
        ]), s(l([
            zS,
            KS(e),
            DS(r)
        ]), a)), u));
    }, HS = {
        $: 5
    }, kS = function(n) {
        return A3(ZZ, "text", l([
            aL("rgb(255, 255, 255)"),
            hZ("30"),
            cL("79.53"),
            lL("middle")
        ]), l([
            A2(mZ, l([
                cL("50%"),
                bL("40")
            ]), l([
                pL(n)
            ]))
        ]));
    }, BS = l([
        A2(Aw, l([
            aL("rgb(47, 106, 93)"),
            cL("9.15"),
            bL("4"),
            Lw("200"),
            aw("50"),
            GZ("10")
        ]), M),
        A2(bw, l([
            aL("rgb(35, 80, 70)"),
            jL("M 209,36.46 C 209,38.4 209,39.71 209,39.71 209,44.12 209,46.32 208.56,48.3 L 208.5,48.69 C 207.87,51.27 206.51,53.31 204.79,54.25 203.21,55 201.74,55 198.81,55 L 19.19,55 C 16.26,55 14.79,55 13.47,54.35 L 13.21,54.25 C 11.49,53.31 10.13,51.27 9.5,48.69 9,46.32 9,44.12 9,39.71 9,39.71 9,38.4 9,36.46 9,38.4 9,39.71 9,39.71 9.01,39.7 9.5,45.43 9.5,45.43 10.13,48.02 11.49,50.05 13.21,51 L 13.47,51.09 C 14.79,51.74 16.26,51.74 19.19,51.74 L 198.81,51.74 C 201.74,51.74 203.21,51.74 204.79,51 206.51,50.05 207.87,48.02 208.5,45.43 L 208.56,45.04 208.99,39.69 C 209,39.71 209,38.4 209,36.46 Z M 209,36.46")
        ]), M)
    ]), OS = F3(function(n, r, e) {
        var t = n.bl, a = n.bm, u = n.bk, i = n.aE;
        return A2(oL, l([
            pw("0 0 220 60"),
            Lw(iS(u)),
            aw(iS(i)),
            cL(iS(t)),
            bL(iS(a)),
            WL(r),
            uw("modal-button")
        ]), s(BS, e));
    }), GS = function(n) {
        var r, e = n.cQ, t = n.cK;
        return xS(A7(LS, "defeatModal", wg(pS), e.b_, 220, A4(Pw, 0, 0, "275", "300"), l([
            wS(t.cp),
            A3(ZZ, "text", l([
                aL("red"),
                gZ("Josefin Sans, sans-serif"),
                hZ("30"),
                cL("79.53"),
                lL("middle")
            ]), l([
                A2(mZ, l([
                    cL("50%"),
                    bL("130")
                ]), l([
                    pL("Out of Moves!")
                ]))
            ])),
            (r = A4(hS, 30, 160, 220, 60), A3(OS, r, wg(HS), l([
                kS("Retry")
            ])))
        ]), M));
    }, WS = {
        $: 14
    }, qS = F4(function(n, r, e, t) {
        return {
            aE: t,
            bk: e,
            bl: n,
            bm: r
        };
    }), US = vr("points"), AS = iL("polygon"), ES = F2(function(n, r) {
        return A3(OS, r, wg({
            $: 1,
            a: n
        }), l([
            kS("Retry")
        ]));
    }), TS = function(n) {
        var r, e = n.cK, t = n.cQ;
        return xS(A7(LS, "errorModal", wg(WS), t.b4, 220, A4(Pw, 0, 0, "275", "300"), l([
            A2(ES, e.cp, A4(hS, 30, 160, 220, 60)),
            (r = A4(qS, 100, 45, 75, 75), A2(oL, l([
                cL(iS(r.bl)),
                bL(iS(r.bm)),
                Lw(iS(r.bk)),
                aw(iS(r.aE)),
                pw("0 0 512 512")
            ]), l([
                A2(EL, l([
                    TL("256"),
                    IL("268"),
                    sw("244"),
                    aL("#C0392B")
                ]), M),
                A2(EL, l([
                    TL("256"),
                    IL("244"),
                    sw("244"),
                    aL("#E74C3C")
                ]), M),
                A2(AS, l([
                    aL("#C0392B"),
                    US("135.1,180.2 221.5,268 135.1,353.6 169.7,388.1 256,302.5 342.3,388.1 376.9,353.6 290.5,268 376.9,180.2 342.3,146.4 256,232 169.7,146.4")
                ]), M),
                A2(AS, l([
                    aL("#ECF0F1"),
                    US("135.1,156.2 221.5,244 135.1,329.6 169.7,363.4 256,277.8 342.3,363.4 376.9,329.6 290.5,244 376.9,156.2 342.3,121.6 256,207.2 169.7,121.6")
                ]), M)
            ]))),
            A3(ZZ, "text", l([
                aL("rgb(35, 80, 70)"),
                gZ("Josefin Sans, sans-serif"),
                hZ("18"),
                cL("79.53"),
                lL("middle")
            ]), l([
                A2(mZ, l([
                    cL("50%"),
                    bL("50%")
                ]), l([
                    pL("Unable to retrieve level!")
                ]))
            ]))
        ]), M));
    }, IS = function(n) {
        return ZS(n ? "firework firework-animated" : "firework");
    }, jS = F2(function(n, r) {
        return A2(BL, l([
            DL("firework-" + ze(r)),
            IS(n)
        ]), M);
    }), RS = F2(function(n, r) {
        return A2(se, A2(BL, M, function(n) {
            return A2(Et, function(r) {
                return A2(jS, n, r);
            }, A2(We, 1, 6));
        }(n)), r);
    }), QS = Fp("bottomLeftImage"), PS = Fp("bottomRightImage"), VS = F2(function(n, r) {
        return A2(vr, function(n) {
            return pr.test(n) ? "data-" + n : n;
        }(n), mr(r));
    }), FS = VS, NS = Fp("animateToCenter"), JS = F3(function(n, r, e) {
        return n && r ? A2(se, NS, e) : e;
    }), _S = Fp("animated-image-check"), YS = F2(function(n, r) {
        return n ? A2(se, _S, r) : r;
    }), XS = vr("visibility"), n$ = function(n) {
        return XS(n ? "visible" : "hidden");
    }, r$ = Fp("animateWiggle"), e$ = F2(function(n, r) {
        return n ? A2(se, r$, r) : r;
    }), t$ = F2(function(n, r) {
        return r ? function(n) {
            return A2(oL, A2(YS, n, l([
                pw("0 0 100 100"),
                n$(n),
                Fp("image-check")
            ])), l([
                A2(bw, l([
                    _L("evenodd"),
                    Cw("rgb(255, 255, 255)"),
                    hw("1"),
                    lw("round"),
                    vw("round"),
                    gw("1.5"),
                    aL("rgb(35, 168, 17)"),
                    jL("M 11.5,59.72 C 22.26,62.73 32.42,69.99 41.13,80 57.15,54.38 77.48,33.06 91,27.94 85.14,23.92 80.46,19.77 76.92,15.5 64.79,23.08 50.32,43.3 40.27,63.17 35.7,56.64 29.74,50.91 22.53,47.26 19.04,51.53 15.37,55.69 11.5,59.72 Z M 11.5,59.72")
                ]), M)
            ]));
        }(n) : function(n) {
            return A2(oL, A2(e$, n, l([
                pw("0 0 100 100"),
                Fp("image-x")
            ])), l([
                A2(bw, l([
                    n$(n),
                    _L("evenodd"),
                    Cw("rgb(255, 255, 255)"),
                    hw("1"),
                    gw("10"),
                    aL("rgb(255, 47, 47)"),
                    jL("M 49.11,42.34 L 73.24,18.23 80.96,25.84 56.78,49.99 80.93,74.11 73.31,81.82 49.11,57.64 24.93,81.79 17.27,74.15 41.45,49.99 17.29,25.86 24.95,18.2 49.11,42.34 Z M 49.11,42.34")
                ]), M)
            ]));
        }(n);
    }), a$ = Fp("animateFadeOut"), u$ = F2(function(n, r) {
        return n ? A2(se, a$, r) : r;
    }), i$ = F2(function(n, r) {
        return r;
    }), o$ = Fp("kana-image"), c$ = Fp("kana-image-border"), f$ = br("object"), b$ = F2(function(n, r) {
        return A2(se, WL(XM({
            $: 0,
            a: n
        })), r);
    }), s$ = $L("type"), M$ = F4(function(n, r, t, a) {
        var u, i = n.ct, c = n.by, f = A2(Wu, function(n) {
            return e(n, r.cp);
        }, i.dM), b = e(i.dc, Se(a)), s = e(r.cp, a), d = f || b && !s, C = !f && 6 !== c;
        return o(ze(r.cp), A2(BL, A2(i$, C, A3(JS, s, b, A2(b$, r.cp, A2(u$, d, l([
            t
        ]))))), l([
            A2(f$, l([
                A2(FS, "data", "../Images/ImageMatchBorder.svg"),
                s$("image/svg+xml"),
                c$
            ]), M),
            A2(f$, l([
                A2(FS, "data", (u = r.cp, "../Images/KanaWords/" + ze(u) + ".svg")),
                s$("image/svg+xml"),
                o$
            ]), M),
            A2(t$, e(i.dc, Se(r.cp)), s)
        ])));
    }), d$ = {
        bE: 70,
        ch: 227,
        c6: 84
    }, C$ = vr("preserveAspectRatio"), l$ = F3(function(n, r, e) {
        return n ? A2(se, o("image-score", A2(oL, l([
            Fp("image-score"),
            pw("0 0 600 75"),
            C$("xMinYMid meet")
        ]), l([
            A3(ZZ, "text", l([
                aL(Jp(d$)),
                hZ("175"),
                cL("50%"),
                bL("50%"),
                lL("middle"),
                dL("middle"),
                A2(FS, "transform-origin", "50% 0px")
            ]), l([
                pL("+" + ze(r) + "!")
            ]))
        ]))), e) : e;
    }), v$ = Fp("topLeftImage"), g$ = Fp("topRightImage"), h$ = Fp("clickDisabled"), p$ = Fp("clickEnabled"), L$ = function(n) {
        return 6 === n ? p$ : h$;
    }, w$ = Fp("kanaImagesContainer"), Z$ = F2(function(n, r) {
        var t = n.by;
        return A3(mL, A2(SL, n.by, l([
            5,
            6
        ])), A2(zL, l([
            w$,
            L$(t),
            vS(6 === n.by)
        ]), function(n) {
            var r = A2(Qu, 0, A2(Vo, function(n) {
                return Se(n.cp);
            }, n.bY)), t = o(A2(eh, n.c4.cs, n.cK.cI), 6 === n.by);
            if (t.a.b && t.a.b.b && t.a.b.b.b && t.a.b.b.b.b && !t.a.b.b.b.b.b && t.b) {
                var a = t.a, u = a.a, i = a.b, c = i.a, f = i.b, b = f.a, s = f.b.a;
                return A3(l$, e(n.ct.dc, Se(r)), A3(od, n.ct.dc, r, n.ct), l([
                    A4(M$, n, u, v$, r),
                    A4(M$, n, c, g$, r),
                    A4(M$, n, b, QS, r),
                    A4(M$, n, s, PS, r)
                ]));
            }
            return M;
        }(n)), r);
    }), m$ = F3(function(n, r, e) {
        return {
            a0: e,
            bf: n,
            bg: r
        };
    }), S$ = Fp("kanaExplosion"), $$ = l([
        Fp("kanaExplosionParticle"),
        Fp("kanaExplosionAnimation")
    ]), D$ = function(n) {
        return A2(tw, $$, l([
            A2(bw, l([
                Cw("none"),
                aL(Jp(n)),
                jL("M 10.75,0 C 10.75,5.94 5.94,10.75 0,10.75 -5.94,10.75 -10.75,5.94 -10.75,-0 -10.75,-5.94 -5.94,-10.75 0,-10.75 5.94,-10.75 10.75,-5.94 10.75,0 Z M 10.75,0")
            ]), M)
        ]));
    }, y$ = F3(function(n, r, e) {
        return s(r, s(n, e));
    }), z$ = function(n) {
        return A3(y$, n, "(", ")");
    }, K$ = F2(function(n, r) {
        var e, t;
        return "translate" + (e = o(n, r), t = e.b, z$(A2(Ke, ",", l([
            iS(e.a),
            iS(t)
        ]))));
    }), x$ = function(n) {
        var r, e = c(n.bf, n.bg, n.a0), t = e.c;
        return Ew(A2(Ke, " ", l([
            A2(K$, e.a, e.b),
            (r = t, "rotate" + z$(iS(r)))
        ])));
    }, H$ = F2(function(n, r) {
        return A2(tw, l([
            x$(r)
        ]), l([
            D$(n)
        ]));
    }), k$ = F3(function(n, r, e) {
        var t = e.a, a = e.b;
        return o(r, A2(oL, l([
            S$,
            sS(A4(Pw, 0, 0, "200", "200")),
            Fp("row" + ze(t) + "KanaExplosion"),
            Fp("column" + ze(a) + "KanaExplosion")
        ]), l([
            A2(tw, l([
                x$(A3(m$, 100, 100, 0))
            ]), l([
                A2(H$, n, A3(m$, -1.26, -18, 0)),
                A2(H$, n, A3(m$, -18.49, 0, -90)),
                A2(H$, n, A3(m$, -1.74, 19, -180)),
                A2(H$, n, A3(m$, 14.02, 0, -270)),
                A2(H$, n, A3(m$, -3.95, 11.35, -150)),
                A2(H$, n, A3(m$, -8.35, -6.74, -52)),
                A2(H$, n, A3(m$, 4.64, -11.36, -316)),
                A2(H$, n, A3(m$, -7.48, -3.11, -40)),
                A2(H$, n, A3(m$, 10.71, -17.39, 31)),
                A2(H$, n, A3(m$, 6.04, 7.3, -141)),
                A2(H$, n, A3(m$, -29.03, -9.88, -54)),
                A2(H$, n, A3(m$, 13.69, -10.72, 132)),
                A2(H$, n, A3(m$, 22.36, -6.93, 117)),
                A2(H$, n, A3(m$, 1.82, 19.55, -162)),
                A2(H$, n, A3(m$, 3.28, 8.43, -125)),
                A2(H$, n, A3(m$, 5.24, -11.31, 62))
            ]))
        ])));
    }), B$ = F2(function(n, r) {
        var e = n.b7;
        return A3(mL, A2(SL, n.by, l([
            5,
            6
        ])), A2(zL, l([
            DL("kanaExplosions")
        ]), A2(Et, function(n) {
            var r = n.a;
            return A3(k$, n.b, ze(n.c), r);
        }, e)), r);
    }), O$ = Fp("kana-word-center-animation"), G$ = function(n) {
        var r = n.aw, e = r.a, t = r.b, a = l([
            Qw,
            sS(Vw),
            O$,
            Fp("column" + ze(t)),
            Fp("row" + ze(e))
        ]), u = n.bF;
        switch(u.$){
            case 7:
                return l([
                    A3($Z, u.a, a, n)
                ]);
            case 8:
                return l([
                    A3(zZ, u.a, a, n)
                ]);
            case 9:
                return l([
                    A3(HZ, u.a, a, n)
                ]);
            case 10:
                return l([
                    A3(hm, u.a, a, n)
                ]);
            case 11:
                return l([
                    A3(WZ, u.a, a, n)
                ]);
            default:
                return M;
        }
    }, W$ = uw("kanaToKanawordAnimations"), q$ = F2(function(n, r) {
        return A3(mL, A2(SL, n.by, l([
            5,
            6
        ])), A2(zL, l([
            W$
        ]), A2(_g, G$, n.bH)), r);
    }), U$ = F2(function(n, r) {
        return n + "Stroke" + ze(r) + "Background";
    }), A$ = F2(function(n, r) {
        return n + "Stroke" + ze(r) + "ClipPath";
    }), E$ = F2(function(n, r) {
        return "url(#" + A2(A$, n, r) + ")";
    }), T$ = F4(function(n, r, e, t) {
        return A2(bw, l([
            Fp("background-path"),
            uw(A2(U$, r, e)),
            Dw(A2(E$, r, e)),
            hw(iS(t)),
            lw("round"),
            vw("round"),
            gw("10"),
            aL("none"),
            jL(n)
        ]), M);
    }), I$ = F2(function(n, r) {
        var e = r.dp;
        if (e.b) {
            var t = e.a, a = e.b;
            return A2(se, A4(T$, t.a, r.cV, n, t.c), A2(I$, n + 1, b(r, {
                dp: a
            })));
        }
        return M;
    }), j$ = function(n) {
        return A2(I$, 1, n);
    }, R$ = F2(function(n, r) {
        return n + "Stroke" + ze(r);
    }), Q$ = vr("stroke-dasharray"), P$ = F2(function(n, r) {
        return A2(Ke, ",", l([
            ze(A2(HM, n, r)),
            ze(r)
        ]));
    }), V$ = function(n) {
        return XS(n > 1 ? "visible" : "hidden");
    }, F$ = F6(function(n, r, e, t, a, u) {
        return A2(bw, l([
            Cw("rgb(0, 0, 0)"),
            hw(iS(e)),
            lw("round"),
            vw("round"),
            aL("none"),
            uw(A2(R$, n, r)),
            Dw(A2(E$, n, r)),
            jL(t),
            Q$(A2(P$, a, u)),
            V$(a)
        ]), M);
    }), N$ = F3(function(n, r, e) {
        if (e.$) return M;
        var t = e.a;
        return l([
            A2($w, l([
                uw(A2(A$, r, n))
            ]), l([
                A2(bw, l([
                    jL(t)
                ]), M)
            ]))
        ]);
    }), J$ = F3(function(n, r, e) {
        return u(n, r) > 0 ? 0 : e;
    }), _$ = F3(function(n, r, e) {
        var t = e.bZ, a = e.cV, u = o(e.dp, e.$7);
        if (u.a.b && u.b.b) {
            var i = u.a, c = i.a, f = c.b, d = i.b, C = u.b, l = C.a, v = C.b;
            return A2(se, A6(F$, a, n, c.c, c.a, A3(J$, n, r, t), l), s(A3(_$, n + 1, r, b(e, {
                bZ: t - l,
                $7: v,
                dp: d
            })), A3(N$, n, a, f)));
        }
        return M;
    }), Y$ = F2(function(n, r) {
        return A3(_$, 1, n, r);
    }), X$ = Fp("kanaTileScaledUp"), nD = F2(function(n, r) {
        return n ? A2(se, X$, r) : r;
    }), rD = Fp("animate-scale-up"), eD = F2(function(n, r) {
        return e(n, Se(!0)) ? A2(se, rD, r) : r;
    }), tD = l([
        "kya",
        "kyu",
        "kyo",
        "sha",
        "shu",
        "sho",
        "cha",
        "chu",
        "cho",
        "nya",
        "hya",
        "hyu",
        "hyo",
        "nyu",
        "nyo",
        "mya",
        "myu",
        "myo",
        "rya",
        "ryu",
        "ryo",
        "gya",
        "gyu",
        "gyo",
        "ja",
        "ju",
        "jo",
        "ja2",
        "ju2",
        "jo2",
        "bya",
        "byu",
        "byo",
        "pya",
        "pyu",
        "pyo",
        "kki"
    ]), aD = function(n) {
        return A2(Wu, function(r) {
            return e(r, n);
        }, tD);
    }, uD = function(n) {
        return aD(n.cV);
    }, iD = A2(RL, M, l([
        A2(YL, l([
            uw("canvasKanaWordKanaBackgroundDrawing-shadow-outer"),
            nw("objectBoundingBox")
        ]), l([
            A2(NL, l([
                dw("2.5")
            ]), M),
            A2(JL, l([
                QL("2"),
                PL("2"),
                Mw("blur")
            ]), M),
            A2(FL, l([
                rw("rgb(85, 85, 85)"),
                ew("0.7")
            ]), M),
            A2(VL, l([
                iw("blur"),
                fw("in"),
                Mw("colorShadow")
            ]), M),
            A2(VL, l([
                ow("SourceGraphic"),
                iw("colorShadow"),
                fw("over")
            ]), M)
        ]))
    ])), oD = F3(function(n, r) {
        return A2(oL, n, s(l([
            iD,
            A2(Aw, l([
                Cw("none"),
                aL("rgb(251, 251, 248)"),
                XL("url(#canvasKanaWordKanaBackgroundDrawing-shadow-outer)"),
                cL("13"),
                bL("13"),
                Lw("75"),
                aw("75"),
                GZ("10")
            ]), M)
        ]), r));
    }), cD = F3(function(n, r) {
        return A2(oL, n, s(l([
            iD,
            A2(Aw, l([
                Cw("none"),
                aL("rgb(251, 251, 248)"),
                XL("url(#canvasKanaWordKanaBackgroundDrawing-shadow-outer)"),
                cL("13"),
                bL("13"),
                Lw("135"),
                aw("75"),
                GZ("10")
            ]), M),
            A2(Aw, l([
                Cw("none"),
                aL("rgb(0, 0, 0)"),
                XL("url(#canvasKanaWordKanaBackgroundDrawing-shadow-outer)"),
                cL("13"),
                bL("13"),
                Lw("135"),
                aw("75"),
                GZ("10"),
                SS("0")
            ]), M)
        ]), r));
    }), fD = F4(function(n, r, e, t) {
        return aD(t) ? A3(cD, n, r, e) : A3(oD, n, r, e);
    }), bD = function(n) {
        return pw(n ? "0 0 160 100" : "0 0 100 100");
    }, sD = function(n) {
        return Fp(n ? "kana-tile-wider" : "kana-tile");
    }, MD = F3(function(n, r, e) {
        var t = uD(e);
        return A2(BL, A2(eD, n, A2(nD, r, l([
            sD(t)
        ]))), l([
            A4(fD, l([
                bD(t)
            ]), M, r, e.cV),
            A2(oL, l([
                Fp("strokes"),
                bD(t)
            ]), s(j$(e), A2(Y$, e.dn, e)))
        ]));
    }), dD = "var(--word-kana-tile-width-wider)", CD = "var(--word-kana-tile-width)", lD = function(n) {
        return Zs(n) ? "" : z$(A2(Ke, " + ", s(function(n) {
            switch(n){
                case 0:
                    return M;
                case 1:
                    return l([
                        CD
                    ]);
                default:
                    return l([
                        ze(n) + " * " + CD
                    ]);
            }
        }(Be(A2(Wa, function(n) {
            return !aD(n.cV);
        }, n))), function(n) {
            switch(n){
                case 0:
                    return M;
                case 1:
                    return l([
                        dD
                    ]);
                default:
                    return l([
                        ze(n) + " * " + dD
                    ]);
            }
        }(Be(A2(Wa, function(n) {
            return uD(n);
        }, n))))));
    }, vD = Cr, gD = vD, hD = F2(function(n, r) {
        return n.bw.bu ? 5 === n.by ? A2(se, A2(gD, "left", "calc( 0.5 * " + lD(n.bw.bv) + " - " + function(n) {
            return "( 0.5 * (" + A2(Qu, CD, A2(Vo, function(n) {
                return Se(uD(n) ? dD : CD);
            }, A2(rf, n.bw.bV, n.bw.bv))) + "))";
        }(n) + ")"), r) : 6 === n.by ? A2(se, A2(gD, "left", "0"), r) : r : A2(se, A2(gD, "left", "100vw"), r);
    }), pD = Fp("scaledUpWord"), LD = F2(function(n, r) {
        var e = Tg(n.bw);
        return e.$ || e.a ? r : A2(se, pD, r);
    }), wD = Fp("wordCountLabel"), ZD = F2(function(n, r) {
        return yg(n) ? A2(se, wD, r) : function(n) {
            return n.bw.bV > 0 && 5 === n.by;
        }(n) ? A2(se, A2(gD, "transform", function(n) {
            return "translate(calc(-1 * " + lD(A2(Ya, n.bw.bV, n.bw.bv)) + "), 0px)";
        }(n)), r) : r;
    }), mD = F2(function(n, r) {
        return Is(n.bw.bv) ? A2(se, A2(gD, "width", "calc(" + lD(n.bw.bv) + ")"), r) : r;
    }), SD = F2(function(n, r) {
        var t = r.bw;
        return yg(r) ? Se(!1) : A2(Vo, function(r) {
            return Se(e(r, n));
        }, t.bq);
    }), $D = F2(function(n, r) {
        return e(r.bw.bV, n) && 5 === r.by;
    }), DD = F2(function(n, r) {
        var e = n.bw;
        return A3(mL, A2(SL, n.by, l([
            5,
            6
        ])), A2(BL, function(n) {
            return A2(LD, n, A2(ZD, n, A2(hD, n, A2(mD, n, l([
                DL("wordContainer")
            ])))));
        }(n), A2(qe, F2(function(r, e) {
            return A3(MD, A2(SD, r, n), A2($D, r, n), e);
        }), e.bv)), r);
    }), yD = F2(function(n, r) {
        return A3(mL, n, Fp("active"), r);
    }), zD = A2(RL, M, l([
        A2(YL, l([
            uw("levelCompleteDrawing-levelCompleteOuterShadow-outer"),
            nw("objectBoundingBox")
        ]), l([
            A2(NL, l([
                dw("2.5")
            ]), M),
            A2(JL, l([
                QL("0"),
                PL("3"),
                Mw("blur")
            ]), M),
            A2(FL, l([
                rw("rgb(85, 85, 85)"),
                ew("1")
            ]), M),
            A2(VL, l([
                iw("blur"),
                fw("in"),
                Mw("colorShadow")
            ]), M),
            A2(VL, l([
                ow("SourceGraphic"),
                iw("colorShadow"),
                fw("over")
            ]), M)
        ])),
        A2(zw, l([
            uw("levelCompleteDrawing-lightStripeGradiantBottom-rectangle4"),
            Bw("187.5"),
            Gw("97"),
            Ow("187.5"),
            Ww("100"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(49, 104, 90)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0"),
                Hw("rgb(70, 146, 129)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.5"),
                Hw("rgb(92, 188, 168)"),
                kw("1")
            ]), M)
        ])),
        A2(zw, l([
            uw("levelCompleteDrawing-lightStripeGradiantTop-rectangle6"),
            Bw("187.5"),
            Gw("-2.5"),
            Ow("187.5"),
            Ww("97.5"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0.94"),
                Hw("rgb(92, 188, 168)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(70, 146, 129)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(49, 104, 90)"),
                kw("1")
            ]), M)
        ])),
        A2(zw, l([
            uw("levelCompleteDrawing-darkStripeGradiantBottom-bottomShade"),
            Bw("187.5"),
            Gw("97"),
            Ow("187.5"),
            Ww("100"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(49, 104, 90)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0"),
                Hw("rgb(60, 126, 109)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.5"),
                Hw("rgb(71, 148, 129)"),
                kw("1")
            ]), M)
        ])),
        A2(zw, l([
            uw("levelCompleteDrawing-darkStripeGradiantTop-topShade"),
            Bw("187.5"),
            Gw("-3"),
            Ow("187.5"),
            Ww("97"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0.93"),
                Hw("rgb(71, 148, 129)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(60, 126, 109)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(49, 104, 90)"),
                kw("1")
            ]), M)
        ])),
        A2(zw, l([
            uw("levelCompleteDrawing-highlight-rectangle2"),
            Bw("187.5"),
            Gw("6"),
            Ow("187.5"),
            Ww("24"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(251, 251, 248)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.25"),
                Hw("rgb(126, 126, 124)"),
                kw("0.5")
            ]), M),
            A2(xw, l([
                Kw("0.58"),
                Hw("rgb(0, 0, 0)"),
                kw("0")
            ]), M)
        ])),
        A2(zw, l([
            uw("levelCompleteDrawing-reverseHighlight-rectangle3"),
            Bw("187.5"),
            Gw("-0"),
            Ow("187.5"),
            Ww("6"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(0, 0, 0)"),
                kw("0")
            ]), M),
            A2(xw, l([
                Kw("0.43"),
                Hw("rgb(126, 126, 124)"),
                kw("0.5")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(251, 251, 248)"),
                kw("1")
            ]), M)
        ])),
        A2(YL, l([
            uw("levelCompleteDrawing-levelCompleteInnerShadow-outer"),
            nw("objectBoundingBox")
        ]), l([
            A2(NL, l([
                dw("1")
            ]), M),
            A2(JL, l([
                QL("0"),
                PL("1"),
                Mw("blur")
            ]), M),
            A2(FL, l([
                rw("rgb(85, 85, 85)"),
                ew("1")
            ]), M),
            A2(VL, l([
                iw("blur"),
                fw("in"),
                Mw("colorShadow")
            ]), M),
            A2(VL, l([
                ow("SourceGraphic"),
                iw("colorShadow"),
                fw("over")
            ]), M)
        ])),
        A2(zw, l([
            uw("levelCompleteDrawing-gradient3-beigeStipeShadow"),
            Bw("187.5"),
            Gw("81"),
            Ow("187.5"),
            Ww("84.13"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(252, 246, 213)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.68"),
                Hw("rgb(211, 208, 192)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(170, 170, 170)"),
                kw("1")
            ]), M)
        ]))
    ])), KD = iL("animate"), xD = vr("attributeName"), HD = vr("begin"), kD = vr("dur"), BD = vr("repeatCount"), OD = function(n) {
        var r;
        return A2(KD, l([
            xD("opacity"),
            kD("1.5s"),
            (r = "0;1;0", A2(vr, "values", function(n) {
                return Lr.test(n) ? "" : n;
            }(r))),
            BD("indefinite"),
            HD(iS(n))
        ]), M);
    }, GD = F2(function(n, r) {
        return A2(EL, l([
            aL("#fff"),
            Cw("none"),
            TL(iS(n)),
            IL("50"),
            sw("6")
        ]), l([
            OD(r)
        ]));
    }), WD = vr("enable-background"), qD = 3 * .1, UD = vr("overflow"), AD = F2(function(n, r) {
        return "translate(" + iS(n) + " " + iS(r) + ")";
    }), ED = F2(function(n, r) {
        return Ew(A2(AD, n, r));
    }), TD = A2(oL, l([
        uw("animatedDots"),
        cL("50%"),
        bL("50%"),
        pw("0 0 100 100"),
        WD("new 0 0 0 0"),
        Lw("75"),
        aw("75"),
        UD("visible")
    ]), l([
        A2(tw, l([
            A2(ED, -27.5, -27.5)
        ]), l([
            A2(GD, 6, .1),
            A2(GD, 26, .2),
            A2(GD, 46, qD)
        ]))
    ])), ID = A2(RL, M, l([
        A2(zw, l([
            uw("canvasLoading-gradient2-rectangle"),
            Bw("214"),
            Gw("-0"),
            Ow("214"),
            Ww("926"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(150, 50, 226)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(245, 157, 13)"),
                kw("1")
            ]), M)
        ]))
    ])), jD = function(n) {
        return function(n) {
            return A2(SL, n.by, l([
                3,
                2
            ]));
        }(n) ? Uw("1") : Uw("0");
    }, RD = function(n) {
        return A2(oL, l([
            uw("loading"),
            aw("100vh"),
            Lw("100vw"),
            jD(n)
        ]), l([
            ID,
            A2(Aw, l([
                Cw("none"),
                aL("url(#canvasLoading-gradient2-rectangle)"),
                cL("0"),
                bL("0"),
                Lw("100%"),
                aw("100%")
            ]), M),
            A3(ZZ, "text", l([
                aL("rgb(255, 255, 255)"),
                gZ("AvenirNext-Regular, 'Avenir Next', sans-serif"),
                hZ("30"),
                cL("152.92"),
                bL("417"),
                lL("middle")
            ]), l([
                A2(mZ, l([
                    cL("50%"),
                    bL("50%")
                ]), l([
                    pL("Loading")
                ]))
            ])),
            TD
        ]));
    }, QD = function(n) {
        var r, e;
        return A2(BL, l([
            DL("modal-background"),
            (r = n, e = r.cQ, A2(SL, 0, l([
                e.dH,
                e.b_,
                e.b4,
                e.df,
                e.cM.aO,
                e.cL
            ])) ? Fp("active") : Fp("dismissed"))
        ]), M);
    }, PD = Fp("moves"), VD = Fp("moves-container"), FD = function(n) {
        return ze(n.ct.bT) + "/" + ze(Be(n.cK.cI));
    }, ND = F2(function(n, r) {
        return iS(n) + "px " + iS(r) + "px";
    }), JD = F2(function(n, r) {
        return A2(FS, "transform-origin", A2(ND, n, r));
    }), _D = F2(function(n, r) {
        return "translate(" + iS(n) + ", " + iS(r) + ")";
    }), YD = F2(function(n, r) {
        return Ew(A2(_D, n, r));
    }), XD = aL("rgb(255, 255, 255)"), ny = F4(function(n, r, e, t) {
        return n ? s(t, l([
            A2(EL, l([
                XD,
                sw("12.03"),
                Fp("animatedScoreCircle"),
                A2(YD, r, e),
                A2(JD, r, e)
            ]), M)
        ])) : t;
    }), ry = F2(function(n, r) {
        return A4(ny, n, 126.5, 18.5, r);
    }), ey = F2(function(n, r) {
        return A4(ny, n, 353.8, 18.5, r);
    }), ty = F2(function(n, r) {
        return A4(ny, n, 240.2, 18.5, r);
    }), ay = A2(EL, l([
        Cw("none"),
        aL("rgb(0, 0, 0)"),
        TL("341.79"),
        IL("50.7"),
        sw("32.5")
    ]), M), uy = jL("M 44.08,40.7 L 309.29,40.7 C 314.82,40.7 319.29,45.17 319.29,50.7 319.29,56.22 314.82,60.7 309.29,60.7 L 44.08,60.7 C 38.56,60.7 34.08,56.22 34.08,50.7 34.08,45.17 38.56,40.7 44.08,40.7 Z M 44.08,40.7"), iy = A2(bw, l([
        Cw("none"),
        aL("rgb(0, 0, 0)"),
        uy
    ]), M), oy = A2($w, l([
        uw("canvasStars-bezierProgressClip")
    ]), l([
        A2(bw, l([
            uy
        ]), M)
    ])), cy = function(n) {
        return Q$(A2(Ke, ",", l([
            iS(278 * n),
            iS(278)
        ])));
    }, fy = jL("M 33.69,50.7 L 311.21,50.7"), by = vr("stroke-dashoffset"), sy = function(n) {
        return A2(bw, l([
            Cw("rgb(255, 255, 255)"),
            hw("20"),
            gw("10"),
            cy(n),
            by("0"),
            aL("none"),
            fy
        ]), M);
    }, My = function(n) {
        return A2(tw, l([
            Dw("url(#canvasStars-bezierProgressClip)")
        ]), l([
            oy,
            sy(n)
        ]));
    }, dy = F3(function(n, r, e) {
        return "translate(" + iS(n) + ", " + iS(r) + ") scale(" + iS(e) + ", " + iS(e) + ")";
    }), Cy = F3(function(n, r, e) {
        return Ew(A3(dy, n, r, e));
    }), ly = F4(function(n, r, e, t) {
        return A2(tw, l([
            A3(Cy, r, e, t)
        ]), l([
            iy,
            My(n),
            ay
        ]));
    }), vy = function(n) {
        var r, e, t;
        return A2(tw, l([
            A2(YD, 12, 63.08)
        ]), A2(ey, n.bs, A2(ty, n.bt, A2(ry, n.br, l([
            (t = n.dt, A4(ly, t, 227.4, 0, .37)),
            (e = n.dD, A4(ly, e, 113.73, 0, .37)),
            (r = n.c_, A4(ly, r, 0, 0, .37))
        ])))));
    }, gy = pw("0 0 400 100"), hy = A2(RL, M, l([
        A2(YL, l([
            uw("canvasStarOneAnimation-shadowStar-outer"),
            nw("objectBoundingBox")
        ]), l([
            A2(NL, l([
                dw("1")
            ]), M),
            A2(JL, l([
                QL("1"),
                PL("1"),
                Mw("blur")
            ]), M),
            A2(FL, l([
                rw("rgb(0, 0, 0)"),
                ew("1")
            ]), M),
            A2(VL, l([
                iw("blur"),
                fw("in"),
                Mw("colorShadow")
            ]), M),
            A2(VL, l([
                ow("SourceGraphic"),
                iw("colorShadow"),
                fw("over")
            ]), M)
        ]))
    ])), py = jL("M 25.06,0.56 L 32.65,15.84 49.47,18.36 37.34,30.33 40.14,47.17 25.06,39.29 9.97,47.17 12.77,30.33 0.64,18.36 17.46,15.84 25.06,0.56 Z M 25.06,0.56"), Ly = F2(function(n, r) {
        return A2(bw, l([
            A2(YD, n, r),
            Uw("0.3"),
            _L("evenodd"),
            Cw("rgb(0, 0, 0)"),
            hw("0.5"),
            gw("10"),
            aL("rgb(0, 0, 0)"),
            py
        ]), M);
    }), wy = A2(Ly, 0, 0), Zy = jL("M 0.06,-24.44 L 7.65,-9.16 24.47,-6.64 12.34,5.33 15.14,22.17 0.06,14.29 -15.03,22.17 -12.23,5.33 -24.36,-6.64 -7.54,-9.16 0.06,-24.44 Z M 0.06,-24.44"), my = F4(function(n, r, e, t) {
        return n ? s(t, l([
            A2(tw, l([
                A2(YD, r, e),
                A2(JD, r, e),
                Fp("animatedStar")
            ]), l([
                A2(bw, l([
                    _L("evenodd"),
                    XL("url(#canvasStarOneAnimation-shadowStar-outer)"),
                    XD,
                    Zy
                ]), M),
                A2(bw, l([
                    _L("evenodd"),
                    Cw("rgb(0, 0, 0)"),
                    hw("0.5"),
                    gw("10"),
                    aL("none"),
                    Zy
                ]), M)
            ]))
        ])) : t;
    }), Sy = F2(function(n, r) {
        return A4(my, n, 25, 25, r);
    }), $y = A2(Ly, 227.26, 0), Dy = F2(function(n, r) {
        return A4(my, n, 252, 25, r);
    }), yy = A2(Ly, 112.97, 0), zy = F2(function(n, r) {
        return A4(my, n, 138, 25, r);
    }), Ky = function(n) {
        return A2(tw, l([
            A2(YD, 61, 15)
        ]), A2(Dy, n.bs, A2(zy, n.bt, A2(Sy, n.br, l([
            hy,
            $y,
            yy,
            wy
        ])))));
    }, xy = Fp("score-view-container"), Hy = Fp("words"), ky = F2(function(n, r) {
        var e;
        return A3(mL, A2(SL, n.by, l([
            5,
            6
        ])), A2(BL, l([
            VD
        ]), l([
            A2(BL, l([
                PD
            ]), l([
                A2(BL, M, l([
                    qL("Moves")
                ])),
                A2(BL, M, l([
                    qL(ze(n.cK.cU))
                ]))
            ])),
            A2(BL, l([
                xy
            ]), l([
                (e = n.da, A2(oL, l([
                    gy
                ]), l([
                    Ky(e),
                    vy(e)
                ]))),
                qL(ze(n.da.cf))
            ])),
            A2(BL, l([
                Hy
            ]), l([
                A2(BL, M, l([
                    qL("Words")
                ])),
                A2(BL, M, l([
                    qL(FD(n))
                ]))
            ]))
        ])), r);
    }), By = F4(function(n, r, e, t) {
        return {
            da: n,
            a9: r,
            bl: e,
            bm: t
        };
    }), Oy = {
        $: 12
    }, Gy = A2(EL, l([
        TL("50"),
        IL("50"),
        sw("75"),
        aL("hsla(0, 0%, 100%, 0.75)")
    ]), M), Wy = jL("M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"), qy = A2(oL, l([
        pw("0 0 100 100"),
        Lw("20"),
        cL("25"),
        bL("50"),
        UD("visible"),
        Fp("arrow"),
        SS("50%"),
        WL(wg({
            $: 10
        }))
    ]), l([
        Gy,
        A2(bw, l([
            Wy,
            aL("rgb(39, 90, 80)"),
            SS("100%")
        ]), M)
    ])), Uy = A2(oL, l([
        pw("0 0 100 100"),
        cL("225"),
        bL("50"),
        Lw("20"),
        UD("visible"),
        Fp("arrow"),
        SS("50%"),
        WL(wg({
            $: 9
        }))
    ]), l([
        Gy,
        A2(bw, l([
            Wy,
            Ew("translate(100, 100) rotate(180)"),
            aL("rgb(39, 90, 80)"),
            SS("100%")
        ]), M)
    ])), Ay = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ey = F4(function(n, r, e, t) {
        return A2(EL, l([
            TL(ze(e)),
            IL(ze(t)),
            sw("4"),
            aL("white"),
            WL(n),
            Fp("dot"),
            SS(r ? "100%" : "50%")
        ]), M);
    }), Ty = F3(function(n, r, e) {
        return A2(oL, M, l([
            A4(Ey, wg(Ay(0)), !n, r, e),
            A4(Ey, wg(Ay(1)), 1 === n, r + 20, e),
            A4(Ey, wg(Ay(2)), 2 === n, r + 40, e),
            A4(Ey, wg(Ay(3)), 3 === n, r + 60, e)
        ]));
    }), Iy = function(n) {
        return "word-" + ze(1 + n) + "-selected";
    }, jy = function(n) {
        return iS((function(n) {
            return A3(ke, F2(function(n, r) {
                return uD(n) ? r + 75 : r + 45;
            }), 0, n);
        }(n) + 10) / 2);
    }, Ry = F2(function(n, r) {
        return n + "Stroke" + ze(r) + "ClipPath";
    }), Qy = F4(function(n, r, e, t) {
        return A2(bw, l([
            Cw("rgb(0, 0, 0)"),
            Dw("url(#" + A2(Ry, r, e) + ")"),
            hw(iS(t)),
            lw("round"),
            vw("round"),
            gw("10"),
            aL("none"),
            jL(n)
        ]), M);
    }), Py = F2(function(n, r) {
        var e = r.dp;
        if (e.b) {
            var t = e.a, a = e.b;
            return A2(se, A4(Qy, t.a, r.cV, n, t.c), A2(Py, n + 1, b(r, {
                dp: a
            })));
        }
        return M;
    }), Vy = F2(function(n, r) {
        return A2(tw, n, A2(Py, 1, r));
    }), Fy = F2(function(n, r) {
        return A2(se, WL(Wc(A2(Vs, 1, ze(n.bB)))), r);
    }), Ny = F4(function(n, r, e, t) {
        return A4(fD, A2(Fy, t, l([
            cL(iS(235 * r + A2(Qu, 0, A2(rf, e, n)))),
            Fp("kana-tile")
        ])), l([
            A2(Vy, M, t)
        ]), !1, t.cV);
    }), Jy = A2(ke, A2(Yt, Se, Gs), $e), _y = function(n) {
        return A3(ke, F2(function(n, r) {
            return uD(n) ? A2(Za, r, l([
                75 + A2(Qu, 0, Jy(r))
            ])) : A2(Za, r, l([
                45 + A2(Qu, 0, Jy(r))
            ]));
        }), l([
            0
        ]), n);
    }, Yy = F2(function(n, r) {
        return A2(oL, l([
            Fp("kana-word"),
            cL("50%")
        ]), l([
            A2(tw, l([
                mw("transform: translateX(-" + jy(r) + "px)")
            ]), A2(qe, A2(Ny, _y(r), n), r))
        ]));
    }), Xy = F2(function(n, r) {
        return A2(oL, l([
            cL(ze(20)),
            bL("170"),
            Lw(iS(235)),
            Fp("kana-words")
        ]), l([
            A2(tw, l([
                Fp(Iy(n))
            ]), A2(qe, Yy, A2(Et, lg, r)))
        ]));
    }), nz = F2(function(n, r) {
        return A2(oL, l([
            Fp("carousel"),
            bL("10")
        ]), l([
            qy,
            Uy,
            A3(Ty, n, 110, 375),
            A2(Xy, n, A2(Et, function(n) {
                return n.cH;
            }, r))
        ]));
    }), rz = function(n) {
        return A2(vr, "height", ze(n));
    }, ez = function(n) {
        return "../Images/KanaWords/" + ze(n) + ".svg";
    }, tz = function(n) {
        return A2(vr, "width", ze(n));
    }, az = function(n) {
        return A2(f$, l([
            A2(FS, "data", ez(n)),
            s$("image/svg+xml"),
            tz(200),
            rz(200),
            Fp("svg-image"),
            A2(gD, "cursor", "pointer")
        ]), M);
    }, uz = A2(f$, l([
        A2(FS, "data", "../Images/ImageMatchBorder.svg"),
        s$("image/svg+xml"),
        tz(215),
        rz(215),
        Fp("svg-image-frame")
    ]), M), iz = A2(RL, M, l([
        A2(YL, l([
            uw("circle-shadow"),
            nw("objectBoundingBox")
        ]), l([
            A2(NL, l([
                dw("2.5")
            ]), M),
            A2(JL, l([
                QL("3"),
                PL("3"),
                Mw("blur")
            ]), M),
            A2(FL, l([
                rw("rgb(85, 85, 85)"),
                ew("1")
            ]), M),
            A2(VL, l([
                iw("blur"),
                fw("in"),
                Mw("colorShadow")
            ]), M),
            A2(VL, l([
                ow("SourceGraphic"),
                iw("colorShadow"),
                fw("over")
            ]), M)
        ]))
    ])), oz = A2(oL, l([
        Lw("20.625"),
        aw("15"),
        pw("0 0 110 80"),
        uw("image-speaker-icon")
    ]), l([
        iz,
        A2(EL, l([
            sw("75"),
            TL("50"),
            IL("35"),
            Cw("none"),
            aL("rgb(251, 251, 248)"),
            XL("url(#circle-shadow)")
        ]), M),
        A2(bw, l([
            Cw("none"),
            aL("rgb(1, 117, 227)"),
            jL("M 91.58,74.22 C 93.1,75.34 95.25,74.9 96.42,73.15 103.25,63.53 107.06,50.93 107.06,37.75 107.06,24.56 103.11,12.01 96.42,2.35 95.25,0.54 93.1,0.15 91.58,1.27 89.97,2.39 89.73,4.45 90.95,6.25 96.86,14.8 100.37,25.98 100.37,37.75 100.37,49.46 96.86,60.74 90.95,69.24 89.73,71.05 89.97,73.1 91.58,74.22 Z M 44.22,71.97 C 46.91,71.97 48.96,70.02 48.96,67.29 L 48.96,8.55 C 48.96,5.86 46.91,3.62 44.12,3.62 42.17,3.62 40.85,4.45 38.66,6.54 L 22.59,21.49 C 22.4,21.68 22.1,21.83 21.81,21.83 L 11.12,21.83 C 5.5,21.83 2.62,24.71 2.62,30.76 L 2.62,44.87 C 2.62,50.88 5.5,53.81 11.12,53.81 L 21.81,53.81 C 22.1,53.81 22.4,53.91 22.59,54.1 L 38.66,69.34 C 40.66,71.19 42.27,71.97 44.22,71.97 Z M 76.79,64.11 C 78.4,65.19 80.4,64.85 81.58,63.14 86.46,56.35 89.29,47.12 89.29,37.75 89.29,28.37 86.51,19.04 81.58,12.36 80.4,10.65 78.4,10.3 76.79,11.38 75.18,12.45 74.89,14.5 76.16,16.31 80.21,22.07 82.5,29.84 82.5,37.75 82.5,45.66 80.11,53.37 76.16,59.18 74.93,60.99 75.18,63.04 76.79,64.11 Z M 62.09,54.2 C 63.56,55.18 65.61,54.88 66.78,53.18 69.71,49.27 71.42,43.51 71.42,37.75 71.42,31.98 69.71,26.27 66.78,22.32 65.61,20.61 63.56,20.31 62.09,21.34 60.34,22.56 60.04,24.71 61.41,26.52 63.46,29.3 64.63,33.55 64.63,37.75 64.63,41.95 63.41,46.14 61.41,48.98 60.09,50.83 60.34,52.93 62.09,54.2 Z M 62.09,54.2")
        ]), M)
    ])), cz = F2(function(n, r) {
        var e, t;
        return A2(BL, l([
            A2(gD, "position", "absolute"),
            A2(gD, "width", "215px"),
            A2(gD, "height", "215px"),
            WL(wg((t = r, {
                $: 8,
                a: t
            }))),
            A2(gD, "left", (e = n, e > 0 ? "calc(" + ze(e) + " * var(--carousel-image-width) )" : "0px"))
        ]), l([
            uz,
            az(r),
            oz
        ]));
    }), fz = function(n) {
        return Fp("image-" + ze(1 + n) + "-selected");
    }, bz = F2(function(n, r) {
        return A2(BL, l([
            A2(gD, "position", "absolute"),
            A2(gD, "overflow", "hidden"),
            A2(gD, "top", "318.5px"),
            A2(gD, "z-index", "100"),
            A2(gD, "width", "215px"),
            A2(gD, "height", "215px"),
            A2(gD, "left", "calc(50% - 5px)"),
            A2(gD, "transform", "translateX(-50%)")
        ]), l([
            A2(BL, l([
                Fp("image-group"),
                fz(n)
            ]), A2(qe, cz, r))
        ]));
    }), sz = {
        $: 2
    }, Mz = A2(bw, l([
        _L("evenodd"),
        Cw("rgb(255, 255, 255)"),
        hw("3"),
        lw("round"),
        vw("round"),
        gw("10"),
        aL("rgb(255, 255, 255)"),
        jL("M 118.65,29.5 L 98.65,39.5 98.65,19.5 118.65,29.5 Z M 118.65,29.5")
    ]), M), dz = F2(function(n, r) {
        var e = r.c$, t = r.dE;
        return u(n, r.du) > -1 ? 3 : u(n, t) > -1 ? 2 : u(n, e) > -1 ? 1 : 0;
    }), Cz = A2(RL, M, l([
        A2(zw, l([
            uw("canvasBannerDrawing-gradient2-rectangle"),
            Bw("41.57"),
            Gw("32.2"),
            Ow("232.07"),
            Ww("32.2"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(122, 189, 144)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.3"),
                Hw("rgb(133, 195, 146)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.5"),
                Hw("rgb(145, 202, 147)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("0.99"),
                Hw("rgb(122, 189, 144)"),
                kw("1")
            ]), M)
        ])),
        A2(YL, l([
            uw("canvasBannerDrawing-starShadow-outer"),
            nw("objectBoundingBox")
        ]), l([
            A2(NL, l([
                dw("1")
            ]), M),
            A2(JL, l([
                QL("0"),
                PL("3"),
                Mw("blur")
            ]), M),
            A2(FL, l([
                rw("rgb(0, 0, 0)"),
                ew("1")
            ]), M),
            A2(VL, l([
                iw("blur"),
                fw("in"),
                Mw("colorShadow")
            ]), M),
            A2(VL, l([
                ow("SourceGraphic"),
                iw("colorShadow"),
                fw("over")
            ]), M)
        ]))
    ])), lz = l([
        Cz,
        A2(bw, l([
            uw("canvasBannerDrawing-bezier2"),
            Cw("none"),
            aL("rgb(85, 170, 144)"),
            jL("M 222.48,66.9 L 264.5,66.9 247.92,44.52 264.5,20.4 222.48,20.4 222.48,66.9 Z M 222.48,66.9")
        ]), M),
        A2(Aw, l([
            uw("canvasBannerDrawing-rectangle5"),
            Cw("none"),
            aL("rgb(78, 141, 116)"),
            cL("222.5"),
            bL("20.5"),
            Lw("19"),
            aw("46.5")
        ]), M),
        A2(bw, l([
            uw("canvasBannerDrawing-bezier"),
            Cw("none"),
            aL("rgb(49, 104, 90)"),
            jL("M 233.72,55.83 L 222.48,66.9 222.73,55.83 233.72,55.83 Z M 233.72,55.83")
        ]), M),
        A2(bw, l([
            uw("canvasBannerDrawing-bezier5"),
            Cw("none"),
            aL("rgb(85, 170, 144)"),
            jL("M 51.52,66.9 L 9.5,66.9 26.08,44.52 9.5,20.4 51.52,20.4 51.52,66.9 Z M 51.52,66.9")
        ]), M),
        A2(Aw, l([
            uw("canvasBannerDrawing-rectangle4"),
            Cw("none"),
            aL("rgb(78, 141, 116)"),
            cL("34"),
            bL("20.5"),
            Lw("17"),
            aw("46")
        ]), M),
        A2(bw, l([
            uw("canvasBannerDrawing-bezier12"),
            Cw("none"),
            aL("rgb(49, 104, 90)"),
            jL("M 40.28,55.83 L 51.52,66.9 51.27,55.83 40.28,55.83 Z M 40.28,55.83")
        ]), M),
        A2(Aw, l([
            uw("canvasBannerDrawing-rectangle"),
            Cw("none"),
            aL("url(#canvasBannerDrawing-gradient2-rectangle)"),
            cL("40"),
            bL("9"),
            Lw("194"),
            aw("46.4")
        ]), M)
    ]), vz = F2(function(n, r) {
        if (n.$) return r;
        var e = n.a;
        return A2(se, A2(bw, l([
            uw("canvasBannerDrawing-rectangle2"),
            Cw("none"),
            aL("rgb(71, 148, 129)"),
            jL("M 65,87 C 65,89.76 67.24,92 70,92 L 204,92 C 206.76,92 209,89.76 209,87 L 209,53 65,53 Z M 65,87")
        ]), M), A2(se, A2(bw, l([
            uw("canvasBannerDrawing-rectangle3"),
            Cw("none"),
            aL("rgb(49, 104, 90)"),
            jL("M 65,60 L 209,60 209,49 C 209,46.24 206.76,44 204,44 L 70,44 C 67.24,44 65,46.24 65,49 Z M 65,60")
        ]), M), A2(se, A3(ZZ, "text", l([
            aL("rgb(255, 255, 255)"),
            gZ("Josefin Sans, sans-serif"),
            hZ("17"),
            cL("123"),
            bL("60"),
            lL("middle")
        ]), l([
            A2(mZ, l([
                cL("140"),
                bL("82")
            ]), l([
                pL(ze(e))
            ]))
        ])), r)));
    }), gz = F3(function(n, r, e) {
        return {
            ap: e,
            bf: n,
            bg: r
        };
    }), hz = F3(function(n, r, e) {
        return "translate(" + iS(n) + ", " + iS(r) + ") scale(" + iS(e) + ", " + iS(e) + ")";
    }), pz = F3(function(n, r, e) {
        return Ew(A3(hz, n, r, e));
    }), Lz = function(n) {
        var r = n.bf, e = n.bg, t = n.ap;
        return A2(bw, l([
            _L("evenodd"),
            Cw("none"),
            aL("rgb(78, 141, 116)"),
            SS("0.41"),
            A3(pz, r, e, t),
            jL("M 25.07,0.56 L 32.67,15.95 49.5,18.49 37.36,30.54 40.17,47.5 25.07,39.57 9.97,47.5 12.78,30.54 0.64,18.49 17.47,15.95 25.07,0.56 Z M 25.07,0.56")
        ]), M);
    }, wz = Lz(A3(gz, 0, 0, .64)), Zz = Lz(A3(gz, 90, 0, .64)), mz = Lz(A3(gz, 45, 0, .64)), Sz = F3(function(n, r, e) {
        var t = r.bf, a = r.bg, u = r.ap;
        return n ? A2(ZL, A2(bw, l([
            _L("evenodd"),
            Cw("none"),
            aL("rgb(255, 255, 255)"),
            Ew("scale(0.64, 0.64)"),
            A3(pz, t, a, u),
            XL("url(#canvasBannerDrawing-starShadow-outer)"),
            jL("M 25.06,0.56 L 32.65,15.84 49.47,18.36 37.34,30.33 40.14,47.17 25.06,39.29 9.97,47.17 12.77,30.33 0.64,18.36 17.46,15.84 25.06,0.56 Z M 25.06,0.56")
        ]), M), e) : e;
    }), $z = function(n) {
        return A2(Sz, function(n) {
            return 1 === n || 2 === n || 3 === n;
        }(n), A3(gz, 0, 0, .64));
    }, Dz = function(n) {
        return A2(Sz, function(n) {
            return 3 === n;
        }(n), A3(gz, 90, 0, .64));
    }, yz = function(n) {
        return A2(Sz, function(n) {
            return 2 === n || 3 === n;
        }(n), A3(gz, 45, 0, .64));
    }, zz = function(n) {
        var r = n.da, e = n.a9, t = n.bm;
        return A2(oL, l([
            cL(iS(n.bl)),
            bL(iS(t)),
            Lw("250"),
            aw("100"),
            uw("starBanner"),
            pw("0 0 275 100")
        ]), A2(vz, r, s(lz, function(n) {
            return l([
                A2(tw, l([
                    Ew("translate(77, 15)")
                ]), A2(Dz, n, A2(yz, n, A2($z, n, l([
                    wz,
                    mz,
                    Zz
                ])))))
            ]);
        }(e))));
    }, Kz = function(n) {
        var r, e, t = n.cQ, a = n.cK, u = n.c4, i = n.da;
        return xS(A7(LS, "previewLevelModal", wg(Oy), t.cM.aO, 460, A4(Pw, 0, 0, "275", "480"), l([
            (e = a.cp, A3(ZZ, "text", l([
                aL("rgb(39, 90, 80)"),
                gZ("Josefin Sans, sans-serif"),
                pZ("100"),
                hZ("30"),
                lL("middle"),
                Fp("level-label")
            ]), l([
                A2(mZ, l([
                    cL("140"),
                    bL("75")
                ]), l([
                    pL("Level " + ze(e))
                ]))
            ]))),
            zz(A4(By, i.cn, A2(Qu, 0, A2(Vo, function(n) {
                return Se(A2(dz, n, a));
            }, i.cn)), 12, 80)),
            (r = A4(hS, 30, 395, 220, 60), A3(OS, r, wg(sz), l([
                Mz
            ]))),
            A2(nz, t.cM.cr, A2(eh, u.cJ, a.cI))
        ]), l([
            A2(bz, t.cM.cr, A2(Et, function(n) {
                return n.cp;
            }, A2(eh, u.cJ, a.cI)))
        ])));
    }, xz = aL("none"), Hz = Cw("#FF00FF"), kz = vw("round"), Bz = gw("10"), Oz = hw("5"), Gz = function(n) {
        return A2(bw, A2(ZL, jL(n), l([
            Hz,
            Oz,
            kz,
            Bz,
            xz
        ])), M);
    }, Wz = l([
        Gz("M 9,8 C 12.75,4.25 27.28,4 19,4 10.72,4 4,10.72 4,19 4,27.28 5.25,11.75 9,8 Z M 9,8"),
        Gz("M 91.01,8 C 87.26,4.25 72.73,4 81.01,4 89.3,4 96.01,10.72 96.01,19 96.01,27.28 94.76,11.75 91.01,8 Z M 91.01,8"),
        Gz("M 91.01,91.4 C 87.26,95.15 72.73,95.4 81.01,95.4 89.3,95.4 96.01,88.68 96.01,80.4 96.01,72.11 94.76,87.65 91.01,91.4 Z M 91.01,91.4"),
        Gz("M 9,91.4 C 12.75,95.15 27.28,95.4 19,95.4 10.72,95.4 4,88.68 4,80.4 4,72.11 5.25,87.65 9,91.4 Z M 9,91.4")
    ]), qz = F2(function(n, r) {
        return A3(mL, A2(SL, n.by, l([
            5,
            6
        ])), A2(BL, l([
            DL("selectedItemsContainer"),
            vS(5 === n.by)
        ]), function(n) {
            return A3(Zf, F3(function(r, t, a) {
                return A3(mL, 1 === a && e(n.ds.cd, Se(r)), function(n) {
                    return A2(oL, function(n) {
                        var r, e;
                        return l([
                            Fp((r = n, e = r.b, "selected-board-item row" + ze(r.a) + " column" + ze(e))),
                            pw("0 0 100 100")
                        ]);
                    }(n), Wz);
                }(r), t);
            }), M, n.cK.dw);
        }(n)), r);
    }), Uz = {
        $: 11
    }, Az = {
        $: 6
    }, Ez = F2(function(n, r) {
        return A3(OS, r, n, l([
            kS("Ok")
        ]));
    }), Tz = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Iz = " " + iS(.25) + "s", jz = function(n) {
        return n ? "rgb(60, 171, 72)" : "rgb(218, 56, 54)";
    }, Rz = function(n) {
        return A2(bw, l([
            aL(jz(n)),
            mw("transition: fill" + Iz + " ease;"),
            jL("M 72.64,45.68 L 26.69,45.68 C 15.26,45.68 6,36.57 6,25.34 6,14.11 15.26,5 26.69,5 L 72.64,5 C 84.07,5 93.33,14.11 93.33,25.34 93.33,36.57 84.07,45.68 72.64,45.68 Z M 72.64,45.68")
        ]), M);
    }, Qz = function(n) {
        return n ? "70.9" : "28.05";
    }, Pz = function(n) {
        return A2(EL, l([
            aL("rgb(255, 255, 254)"),
            IL("25.33"),
            sw("16"),
            TL(Qz(n)),
            mw("transition: cx" + Iz + " ease;")
        ]), M);
    }, Vz = F4(function(n, r, e, t) {
        var a;
        return A2(oL, l([
            Lw(iS(t.bk)),
            aw(iS(t.aE)),
            cL(iS(t.bl)),
            bL(iS(t.bm)),
            pw("0 0 100 50"),
            mw("cursor: pointer; overflow: visible;"),
            cw(r)
        ]), l([
            Rz(e),
            Pz(e),
            (a = n, A3(ZZ, "text", l([
                aL("rgb(255, 255, 255)"),
                gZ("Josefin Sans, sans-serif"),
                hZ("32"),
                lL("start")
            ]), l([
                A2(mZ, l([
                    cL("-225"),
                    bL("35")
                ]), l([
                    pL(a)
                ]))
            ])))
        ]));
    }), Fz = function(n) {
        return A4(Vz, "Sound Effects:", uc(Tz(0)), n.de.a8, A4(hS, 180, 100, 60, 30));
    }, Nz = function(n) {
        return A4(Vz, "Text Audio:", uc(Tz(2)), n.de.bd, A4(hS, 180, 140, 60, 30));
    }, Jz = A3(ZZ, "text", l([
        aL("rgb(39, 90, 80)"),
        hZ("32"),
        lL("middle")
    ]), l([
        A2(mZ, l([
            cL("50%"),
            bL("75")
        ]), l([
            pL("Settings")
        ]))
    ])), _z = function(n) {
        var r = n.cQ;
        return xS(A7(LS, "settingsModal", wg(Uz), r.df, 325, A4(Pw, 0, 0, "275", "300"), l([
            Jz,
            Fz(n),
            Nz(n),
            A2(Ez, wg(Az), A4(hS, 30, 260, 220, 60))
        ]), M));
    }, Yz = Fp("shrink-animation"), Xz = F2(function(n, r) {
        var e = r.aw, t = e.a, a = e.b;
        return l([
            sS(n),
            Qw,
            Yz,
            mm(t),
            Zm(a)
        ]);
    }), nK = function(n) {
        return ve(A3(pm, n, Gs(!0), Gs(A2(Xz, Vw, n))));
    }, rK = F2(function(n, r) {
        var e = n.dg;
        return A3(mL, A2(SL, n.by, l([
            5,
            6
        ])), A2(zL, l([
            DL("shrinkingBoardItems")
        ]), A2(_g, nK, e)), r);
    }), eK = "var(--tileWidthAndHeight)", tK = F2(function(n, r) {
        var e;
        return A3(mL, A2(SL, n.by, l([
            5,
            6
        ])), A2(oL, l([
            uw("tileMaskContainer")
        ]), l([
            A2(RL, M, l([
                A2($w, l([
                    uw("tileMask")
                ]), (e = n.cK.dw, A3(Zf, F3(function(n, r, e) {
                    var t, a, u;
                    return 1 === e ? A2(se, (a = (t = n).a, u = t.b, A2(Aw, l([
                        Fp("tile-mask-rect"),
                        mw("transform: translate(calc(" + ze(u) + " * " + eK + "), calc(" + ze(a) + " * " + eK + "));")
                    ]), M)), r) : r;
                }), M, e)))
            ]))
        ])), r);
    }), aK = F2(function(n, r) {
        return {
            aw: n,
            dv: r
        };
    }), uK = F3(function(n, r, e) {
        return {
            $: 2,
            a: n,
            b: r,
            c: e
        };
    }), iK = F4(function(n, r, e, t) {
        return {
            ci: r,
            cj: e,
            ck: t,
            cl: n
        };
    }), oK = F3(function(n, r, e) {
        switch(e){
            case 1:
                return A2(vf, fp(r), n);
            case 3:
                return A2(vf, Gf(r), n);
            case 0:
                return A2(vf, cp(r), n);
            default:
                return A2(vf, $f(r), n);
        }
    }), cK = F2(function(n, r) {
        return A3(oK, r, n, 2);
    }), fK = F2(function(n, r) {
        return A3(oK, r, n, 1);
    }), bK = F2(function(n, r) {
        return A3(oK, r, n, 3);
    }), sK = F2(function(n, r) {
        return A3(oK, r, n, 0);
    }), MK = F2(function(n, r) {
        return A4(iK, A2(sK, r, n), A2(cK, r, n), A2(fK, r, n), A2(bK, r, n));
    }), dK = F4(function(n, r, e, t) {
        return {
            bK: e,
            bL: t,
            dA: n,
            dB: r
        };
    }), CK = B, lK = F4(function(n, r, e, t) {
        var a;
        return A2(e, n, r) ? 2 : A2(t, n, r) ? A2(CK, 2, (a = n).a + a.b) ? 0 : 1 : 3;
    }), vK = F2(function(n, r) {
        return A2(vf, $f(n), r) && A2(vf, fp(n), r);
    }), gK = A2(Yt, $f, fp), hK = F2(function(n, r) {
        return A2(vf, gK(n), r) && A2(mp, fp(n), r) && A2(mp, $f(n), r);
    }), pK = F2(function(n, r) {
        return A4(lK, n, r, hK, vK);
    }), LK = F2(function(n, r) {
        return A2(vf, $f(n), r) && A2(vf, Gf(n), r);
    }), wK = A2(Yt, $f, Gf), ZK = F2(function(n, r) {
        return A2(vf, wK(n), r) && A2(mp, Gf(n), r) && A2(mp, $f(n), r);
    }), mK = F2(function(n, r) {
        return A4(lK, n, r, ZK, LK);
    }), SK = F2(function(n, r) {
        return A2(vf, cp(n), r) && A2(vf, fp(n), r);
    }), $K = A2(Yt, cp, fp), DK = F2(function(n, r) {
        return A2(vf, $K(n), r) && A2(mp, fp(n), r) && A2(mp, cp(n), r);
    }), yK = F2(function(n, r) {
        return A4(lK, n, r, DK, SK);
    }), zK = F2(function(n, r) {
        return A2(vf, cp(n), r) && A2(vf, Gf(n), r);
    }), KK = A2(Yt, cp, Gf), xK = F2(function(n, r) {
        return A2(vf, KK(n), r) && A2(mp, Gf(n), r) && A2(mp, cp(n), r);
    }), HK = F2(function(n, r) {
        return A4(lK, n, r, xK, zK);
    }), kK = F2(function(n, r) {
        return A4(dK, A2(yK, r, n), A2(HK, r, n), A2(pK, r, n), A2(mK, r, n));
    }), BK = F3(function(n, r, e) {
        return n ? A2(CK, 2, e.a + e.b) ? {
            $: 0,
            a: e
        } : {
            $: 1,
            a: e
        } : A3(uK, e, A2(MK, r, e), A2(kK, r, e));
    }), OK = F2(function(n, r) {
        return {
            bJ: n,
            bU: r
        };
    }), GK = F3(function(n, r, e) {
        return {
            $: 5,
            a: n,
            b: r,
            c: e
        };
    }), WK = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), qK = F3(function(n, r, e) {
        return n ? A2(Za, r, e) : e;
    }), UK = F3(function(n, r, e) {
        return {
            bE: e,
            ch: r,
            c6: n
        };
    }), AK = function(n) {
        return n(Jp(A3(UK, 115, 230, 115)));
    }, EK = l([
        A2(tw, M, l([
            A2(bw, l([
                uw("canvasKanaTile-rectangleDarker"),
                Cw("none"),
                AK(aL),
                jL("M 0,100 L 100,100 100,-0 0,-0 0,100 Z M 0,100")
            ]), M)
        ]))
    ]), TK = function(n) {
        return n(Jp(A3(UK, 2, 204, 157)));
    }, IK = F2(function(n, r) {
        return n ? l([
            r
        ]) : M;
    }), jK = function(n) {
        return A2(bw, l([
            uw("rightBorder"),
            Cw("none"),
            n(aL),
            _L("evenodd"),
            jL("M 6,100 C 4.41,100 2.88,99.37 1.76,98.24 0.63,97.12 0,95.59 0,94 L 0,94 0,100 6,100 6,100 Z M 6,100")
        ]), M);
    }, RK = A2(bw, l([
        uw("rightBorder"),
        Cw("none"),
        TK(aL),
        jL("M 6,100 C 6,98.41 5.37,96.88 4.24,95.76 3.12,94.63 1.59,94 0,94 L 0,94 0,100 6,100 6,100 Z M 6,100")
    ]), M), QK = function(n) {
        return n(Jp(A3(UK, 170, 255, 170)));
    }, PK = function(n) {
        return A2(bw, l([
            uw("rightBorder"),
            Cw("none"),
            n(aL),
            _L("evenodd"),
            jL("M 94,100 C 95.59,100 97.12,99.37 98.24,98.24 99.37,97.12 100,95.59 100,94 L 100,94 100,100 94,100 94,100 Z M 94,100")
        ]), M);
    }, VK = A2(bw, l([
        uw("rightBorder"),
        Cw("none"),
        TK(aL),
        jL("M 99.98,100 L 94,100 C 94,99.03 94.23,98.11 94.64,97.3 95.62,95.36 97.67,94.02 99.98,94 100.03,95.98 99.98,97.99 99.98,100 Z M 99.98,100")
    ]), M), FK = function(n) {
        return A2(bw, l([
            uw("rightBorder"),
            Cw("none"),
            n(aL),
            _L("evenodd"),
            jL("M 6,0 C 4.41,0 2.88,0.63 1.76,1.76 0.63,2.88 0,4.41 0,6 L 0,6 0,-0 6,-0 6,0 Z M 6,0")
        ]), M);
    }, NK = A2(bw, l([
        uw("rightBorder"),
        Cw("none"),
        TK(aL),
        jL("M 0.02,-0 L 6,-0 C 6,0.97 5.77,1.89 5.36,2.7 4.38,4.64 2.33,5.98 0.02,6 -0.03,4.02 0.02,2.01 0.02,-0 Z M 0.02,-0")
    ]), M), JK = function(n) {
        return A2(bw, l([
            uw("rightBorder"),
            Cw("none"),
            n(aL),
            _L("evenodd"),
            jL("M 94,0 C 95.59,0 97.12,0.63 98.24,1.76 99.37,2.88 100,4.41 100,6 L 100,6 100,-0 94,-0 94,0 Z M 94,0")
        ]), M);
    }, _K = A2(bw, l([
        uw("rightBorder"),
        Cw("none"),
        TK(aL),
        jL("M 99.98,-0 L 94,-0 C 94,0.97 94.23,1.89 94.64,2.7 95.62,4.64 97.67,5.98 99.98,6 100.03,4.02 99.98,2.01 99.98,-0 Z M 99.98,-0")
    ]), M), YK = function(n) {
        var r = n.bJ, e = n.bU;
        return A2(Za, function(n) {
            return A2(IK, n.ck, A2(bw, l([
                uw("rightBorder"),
                Cw("none"),
                TK(aL),
                jL("M 94,100 L 100,100 100,-0 94,-0 94,100 Z M 94,100")
            ]), M));
        }(r), A2(Za, function(n) {
            return A2(IK, n.cj, A2(bw, l([
                uw("leftBorder"),
                Cw("none"),
                TK(aL),
                jL("M 0,100 L 6,100 6,-0 0,-0 0,100 Z M 0,100")
            ]), M));
        }(r), A2(Za, function(n) {
            return A2(IK, n.ci, A2(bw, l([
                uw("rightBorder"),
                Cw("none"),
                TK(aL),
                jL("M 0,100 L 100,100 100,94 0,94 0,100 Z M 0,100")
            ]), M));
        }(r), A2(Za, function(n) {
            return A2(IK, n.cl, A2(bw, l([
                uw("rightBorder"),
                Cw("none"),
                TK(aL),
                jL("M 0,6 L 100,6 100,-0 0,-0 0,6 Z M 0,6")
            ]), M));
        }(r), A2(Za, function(n) {
            switch(n.bL){
                case 2:
                    return l([
                        VK
                    ]);
                case 0:
                    return l([
                        PK(AK)
                    ]);
                case 1:
                    return l([
                        PK(QK)
                    ]);
                default:
                    return M;
            }
        }(e), A2(Za, function(n) {
            switch(n.bK){
                case 2:
                    return l([
                        RK
                    ]);
                case 0:
                    return l([
                        jK(AK)
                    ]);
                case 1:
                    return l([
                        jK(QK)
                    ]);
                default:
                    return M;
            }
        }(e), A2(Za, function(n) {
            switch(n.dB){
                case 2:
                    return l([
                        _K
                    ]);
                case 0:
                    return l([
                        JK(AK)
                    ]);
                case 1:
                    return l([
                        JK(QK)
                    ]);
                default:
                    return M;
            }
        }(e), function(n) {
            switch(n.dA){
                case 2:
                    return l([
                        NK
                    ]);
                case 0:
                    return l([
                        FK(AK)
                    ]);
                case 1:
                    return l([
                        FK(QK)
                    ]);
                default:
                    return M;
            }
        }(e))))))));
    }, XK = function(n) {
        return !function(n) {
            return 2 === n.$;
        }(n);
    }, nx = l([
        A2(bw, l([
            uw("canvasKanaTile-rectangleLighter"),
            Cw("none"),
            QK(aL),
            jL("M 0,100 L 100,100 100,-0 0,-0 0,100 Z M 0,100")
        ]), M)
    ]), rx = GL, ex = function(n) {
        return A2(rx, "mouseup", A3(vt, n, A2(pu, "clientX", Lu), A2(pu, "clientY", Lu)));
    }, tx = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ax = F3(function(n, r, e) {
        return {
            $: 4,
            a: n,
            b: r,
            c: e
        };
    }), ux = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ix = F2(function(n, r) {
        return A2(OL, n, {
            $: 3,
            a: r
        });
    }), ox = F2(function(n, r) {
        return {
            bl: n,
            bm: r
        };
    }), cx = F2(function(n, r) {
        return A3(At, pu, r, n);
    }), fx = F3(function(n, r, e) {
        return A2(lt, function(n) {
            return {
                cN: e(n),
                ao: r.ao,
                as: r.as
            };
        }, A2(cx, l([
            n,
            "0"
        ]), A3(vt, F2(function(n, r) {
            return A2(ox, n, r);
        }), A2(pu, "clientX", Lu), A2(pu, "clientY", Lu))));
    }), bx = F2(function(n, r) {
        return A2(ix, "touchend", A3(fx, "changedTouches", n, A2(Yt, ux(2), r)));
    })({
        ao: !0,
        as: !1
    }), sx = F2(function(n, r) {
        return A2(lt, r, A2(cx, l([
            n,
            "0"
        ]), A3(vt, ox, A2(pu, "clientX", Lu), A2(pu, "clientY", Lu))));
    }), Mx = function(n) {
        return A2(GL, "touchmove", A2(sx, "changedTouches", A2(Yt, ux(1), n)));
    }, dx = F3(function(n, r, e) {
        var t, a = e.a, u = e.b;
        return l([
            sS(n),
            r,
            mm(a),
            Zm(u),
            (t = function(n) {
                return fc(tx(n));
            }, A2(GL, "touchstart", A2(sx, "touches", A2(Yt, ux(0), t)))),
            Mx(function(n) {
                return fc(tx(n));
            }),
            bx(function(n) {
                return fc(A3(ax, a, u, n));
            })
        ]);
    }), Cx = Fp("tile"), lx = A4(Pw, 0, 0, "100", "100"), vx = F2(function(n, r) {
        var e, t, a = r.dv, u = r.aw, i = function(n) {
            switch(n.$){
                case 0:
                    return nx;
                case 1:
                    return EK;
                default:
                    return YK(A2(OK, n.b, n.c));
            }
        }(a);
        return i.b ? l([
            A2(oL, A3(qK, !n && XK(a), l([
                WL(fc((t = u, {
                    $: 0,
                    a: t
                }))),
                (e = F2(function(n, r) {
                    return fc(A3(GK, u, n, r));
                }), A2(rx, "mousedown", A3(vt, e, A2(pu, "clientX", Lu), A2(pu, "clientY", Lu)))),
                ex(F2(function(n, r) {
                    return fc(A2(WK, n, r));
                }))
            ]), A3(dx, lx, Cx, u)), function() {
                switch(a.$){
                    case 0:
                        return nx;
                    case 1:
                        return EK;
                    default:
                        return YK(A2(OK, a.b, a.c));
                }
            }())
        ]) : M;
    }), gx = F5(function(n, r, e, t, a) {
        return zb(A2(vx, n, A2(aK, o(e, t), A3(BK, a, r, o(e, t)))));
    }), hx = F4(function(n, r, e, t) {
        return A3(wf, F3(function(e, a, u) {
            return A2(gb, a, A5(gx, n, r, t, e, u));
        }), Ye, e);
    }), px = F4(function(n, r, e, t) {
        return ve(A4(hx, n, r, t, e));
    }), Lx = F2(function(n, r) {
        var e, t;
        return A3(mL, A2(SL, n.by, l([
            5,
            6
        ])), A2(BL, l([
            DL("tilesContainer"),
            vS(5 === n.by)
        ]), ma(ve(A2(cb, A2(px, (e = n).cA, (t = e.cK).dw), t.dw)))), r);
    }), wx = Fp("drop-animation"), Zx = q, mx = F3(function(n, r, e) {
        return mw("--top-start: calc( " + ze(n) + " * " + eK + ");--top-finish: calc(" + ze(r) + " * " + eK + ");" + function(n) {
            return "animation-duration: " + iS(function(n) {
                return Zx(function(n) {
                    return n / 15;
                }(Vb(n)));
            }(n)) + "s;";
        }(e));
    }), Sx = F2(function(n, r) {
        var e = r.a.a, t = r.b, a = t.a, u = t.b, i = a - e;
        return l([
            sS(n),
            Qw,
            wx,
            mm(a),
            Zm(u),
            A3(mx, e, a, i)
        ]);
    }), $x = F2(function(n, r) {
        return ve(A3(pm, r, Gs(!0), Gs(A2(Sx, Vw, n))));
    }), Dx = uw("kanaAnimations"), yx = Fp("tileMask"), zx = F3(function(n, r, e) {
        var t = e.aw, a = t.a, u = t.b, i = r.a, o = a - i;
        return l([
            sS(n),
            Qw,
            wx,
            mm(a),
            Zm(u),
            A3(mx, i, a, o)
        ]);
    }), Kx = F3(function(n, r, e) {
        return A3(pm, n, r, A2(zx, Vw, e));
    }), xx = F2(function(n, r) {
        return A3(mL, A2(SL, n.by, l([
            5,
            6
        ])), A2(zL, l([
            Dx,
            yx
        ]), s(ma(A2(Et, function(n) {
            var r = n.b;
            return ve(A2(Qu, Ye, A2(Vo, function(n) {
                return Se(A3(Kx, n, Gs(!0), r));
            }, n.a)));
        }, n.dC)), function(n) {
            var r = n.bG, e = n.ca;
            return A3(ke, F2(function(n, e) {
                var t = A2(yf, n.a, r);
                return t.$ ? e : s(e, A2($x, n, t.a));
            }), M, e);
        }(n))), r);
    }), Hx = {
        $: 15
    }, kx = iL("ellipse"), Bx = A2(RL, M, l([
        A2(tZ, l([
            uw("canvas2-gradient7-bezier138"),
            TL("114.72"),
            IL("173.63"),
            sw("10.25"),
            Yw("114.72"),
            Xw("173.63"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(244, 151, 124)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(254, 209, 167)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient7-clip"),
            TL("114.72"),
            IL("173.63"),
            sw("10.25"),
            Yw("114.72"),
            Xw("173.63"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(244, 151, 124)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(254, 209, 167)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-oval17"),
            TL("114.82"),
            IL("173.78"),
            sw("10.63"),
            Yw("114.82"),
            Xw("173.78"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-clip2"),
            TL("114.82"),
            IL("173.78"),
            sw("10.63"),
            Yw("114.82"),
            Xw("173.78"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-oval19"),
            TL("115.22"),
            IL("174.56"),
            sw("13.6"),
            Yw("115.22"),
            Xw("174.56"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-clip3"),
            TL("115.22"),
            IL("174.56"),
            sw("13.6"),
            Yw("115.22"),
            Xw("174.56"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-oval21"),
            TL("114.91"),
            IL("173.82"),
            sw("10.63"),
            Yw("114.91"),
            Xw("173.82"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-clip4"),
            TL("114.91"),
            IL("173.82"),
            sw("10.63"),
            Yw("114.91"),
            Xw("173.82"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-oval23"),
            TL("114.21"),
            IL("174.23"),
            sw("13.35"),
            Yw("114.21"),
            Xw("174.23"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-clip5"),
            TL("114.21"),
            IL("174.23"),
            sw("13.35"),
            Yw("114.21"),
            Xw("174.23"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-oval25"),
            TL("116.22"),
            IL("173.75"),
            sw("13.35"),
            Yw("116.22"),
            Xw("173.75"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-clip6"),
            TL("116.22"),
            IL("173.75"),
            sw("13.35"),
            Yw("116.22"),
            Xw("173.75"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-oval27"),
            TL("115.49"),
            IL("173.75"),
            sw("13.6"),
            Yw("115.49"),
            Xw("173.75"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-clip7"),
            TL("115.49"),
            IL("173.75"),
            sw("13.6"),
            Yw("115.49"),
            Xw("173.75"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient7-bezier140"),
            TL("171.49"),
            IL("173.35"),
            sw("10.49"),
            Yw("171.49"),
            Xw("173.35"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(244, 151, 124)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(254, 209, 167)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient7-clip8"),
            TL("171.49"),
            IL("173.35"),
            sw("10.49"),
            Yw("171.49"),
            Xw("173.35"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(244, 151, 124)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(254, 209, 167)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient9-bezier142"),
            TL("170.55"),
            IL("173.35"),
            sw("10.21"),
            Yw("170.55"),
            Xw("173.35"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(78, 24, 11)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(81, 33, 15)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient9-clip9"),
            TL("170.55"),
            IL("173.35"),
            sw("10.21"),
            Yw("170.55"),
            Xw("173.35"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(78, 24, 11)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(81, 33, 15)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-oval35"),
            TL("170.07"),
            IL("173.91"),
            sw("13.14"),
            Yw("170.07"),
            Xw("173.91"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-clip10"),
            TL("170.07"),
            IL("173.91"),
            sw("13.14"),
            Yw("170.07"),
            Xw("173.91"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-oval37"),
            TL("171.33"),
            IL("172.94"),
            sw("11.56"),
            Yw("171.33"),
            Xw("172.94"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-clip11"),
            TL("171.33"),
            IL("172.94"),
            sw("11.56"),
            Yw("171.33"),
            Xw("172.94"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-oval39"),
            TL("171.18"),
            IL("173.66"),
            sw("10.63"),
            Yw("171.18"),
            Xw("173.66"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-clip12"),
            TL("171.18"),
            IL("173.66"),
            sw("10.63"),
            Yw("171.18"),
            Xw("173.66"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-oval41"),
            TL("171.51"),
            IL("174.47"),
            sw("13.35"),
            Yw("171.51"),
            Xw("174.47"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-clip13"),
            TL("171.51"),
            IL("174.47"),
            sw("13.35"),
            Yw("171.51"),
            Xw("174.47"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-oval43"),
            TL("170.07"),
            IL("173"),
            sw("12.76"),
            Yw("170.07"),
            Xw("173"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-clip14"),
            TL("170.07"),
            IL("173"),
            sw("12.76"),
            Yw("170.07"),
            Xw("173"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-oval45"),
            TL("170.72"),
            IL("174.56"),
            sw("13.6"),
            Yw("170.72"),
            Xw("174.56"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ])),
        A2(tZ, l([
            uw("canvas2-gradient8-clip15"),
            TL("170.72"),
            IL("174.56"),
            sw("13.6"),
            Yw("170.72"),
            Xw("174.56"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(184, 96, 80)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(191, 133, 108)"),
                kw("1")
            ]), M)
        ]))
    ])), Ox = vr("ry"), Gx = A2(oL, l([
        pw("0 0 312 335"),
        Lw("156"),
        aw("167.5"),
        cL("65"),
        bL("90")
    ]), l([
        Bx,
        A2(tw, M, l([
            A2(bw, l([
                uw("canvas2-bezier68"),
                Cw("none"),
                aL("rgb(254, 209, 167)"),
                jL("M 119.47,198.74 L 111.01,211.47 104.69,221 C 98.81,216.84 89.55,207.95 84.65,203.18 80.42,199.06 62.01,177.28 58.6,169.43 55.09,166.97 48.65,163.86 45.62,160.88 42.59,157.9 38.75,156.43 36.95,154.92 35.43,153.64 32.76,151.69 32.65,149.95 32.64,149.63 32.7,149.31 32.88,149.01 34.02,147.08 42.4,153.03 46.85,154.12 45.71,152.46 42.59,149.91 40.36,148.02 38.14,146.13 33.11,141.5 34.44,139.7 35.77,137.91 42.87,143.58 44.29,144.71 45.71,145.85 49.93,148.49 50.07,148.64 47.56,145.37 45.26,143.84 44.15,142.58 41.17,139.23 37.09,134.22 38.66,132.42 40.22,130.63 46.33,136.77 48.37,138.47 50.4,140.17 53.77,143.58 54.43,143.86 53.72,142.02 51.07,138.99 49.55,136.77 48.04,134.55 43.82,130.63 45.95,128.73 48.08,126.84 52.96,134.41 55.05,136.68 57.13,138.94 60.64,142.68 61.58,144.29 62.3,145.51 64.96,151.52 67.53,154.97 68.34,156.06 69.14,156.89 69.87,157.24 71.04,157.78 75,160.91 79.74,164.94 87.29,171.37 96.82,180.09 100.14,184.27 105.54,191.08 119.47,198.74 119.47,198.74 Z M 119.47,198.74")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier69"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 52.32,146.06 C 47.85,144.36 38.93,133.58 38.93,132.27 38.36,133.08 38.25,135.92 42.38,140.46 46.5,145 50.12,148.5 50.12,148.5 L 52.32,146.06 Z M 52.32,146.06")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier70"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 57.15,144.36 C 56.19,142.05 53.85,139.32 52.29,137.02 50.72,134.71 46.18,129.36 46.64,128.51 45.11,129.43 44.72,131.06 46.96,133.83 49.2,136.59 54.77,144.53 54.77,144.53 L 57.15,144.36 Z M 57.15,144.36")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier71"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 34.96,139.63 C 35.55,141.71 46.33,150.79 47.75,151.19 47.59,152.01 46.71,153.88 46.71,153.88 45.38,152.46 40.91,148.19 39.04,146.65 37.16,145.11 32.76,140.53 34.96,139.63 Z M 34.96,139.63")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier72"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 111.01,211.47 L 104.69,221 C 98.81,216.84 89.55,207.95 84.65,203.18 80.42,199.06 62.01,177.28 58.6,169.43 55.09,166.97 48.65,163.86 45.62,160.88 42.59,157.9 38.75,156.43 36.95,154.92 35.43,153.64 32.76,151.69 32.65,149.95 35.36,152.63 42.36,155.92 45.71,157 46.47,158.94 55.28,165.08 60.87,165.65 63.15,175.39 93.18,206.49 107.67,205.26 L 111.01,211.47 Z M 111.01,211.47")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier73"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 79.74,164.94 C 74.84,162.48 68.04,159.02 66.27,159.55 67.13,158.59 67.49,156.88 67.53,154.97 68.34,156.06 69.14,156.89 69.87,157.24 71.04,157.78 75,160.91 79.74,164.94 Z M 79.74,164.94")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier74"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 100.64,183.88 C 95.3,177.14 73.39,158.18 70.14,156.66 67.93,155.63 64.68,149.04 63.12,145.88 62.66,144.97 62.34,144.31 62.13,143.96 61.25,142.47 58.34,139.31 56.22,137 55.97,136.74 55.74,136.48 55.52,136.24 55.06,135.75 54.47,134.99 53.78,134.11 51.06,130.64 48.83,127.98 46.93,127.81 46.4,127.76 45.91,127.91 45.53,128.26 43.41,130.14 45.92,133.24 47.76,135.51 48.25,136.1 48.71,136.67 49.02,137.13 49.54,137.89 50.17,138.71 50.83,139.58 51.03,139.85 51.23,140.11 51.43,140.37 50.49,139.5 49.55,138.63 48.78,137.98 48.44,137.7 47.99,137.3 47.46,136.82 44.25,133.93 41.21,131.35 39.31,131.46 38.85,131.49 38.46,131.68 38.17,132 36.71,133.69 38.4,137.08 43.67,143.01 44.07,143.45 44.6,143.92 45.2,144.47 45.43,144.67 45.66,144.87 45.91,145.1 45.42,144.76 44.99,144.45 44.69,144.21 39.87,140.36 36.6,138.52 34.98,138.73 34.53,138.79 34.17,139 33.93,139.32 32.4,141.39 36.36,145.46 39.95,148.51 40.2,148.72 40.46,148.94 40.72,149.16 42.04,150.27 43.55,151.55 44.73,152.7 43.42,152.14 41.96,151.4 40.54,150.68 36.34,148.55 33.31,147.02 32.33,148.69 31.03,150.9 33.87,153.22 35.94,154.91 36.15,155.09 36.35,155.25 36.54,155.41 37.27,156.02 38.27,156.6 39.43,157.28 41.27,158.34 43.36,159.55 45.17,161.33 47.15,163.28 50.42,165.21 53.58,167.07 55.26,168.06 56.85,169 58.09,169.85 60.18,174.51 66.94,183.26 70.82,188.1 76.5,195.2 82.09,201.58 84.2,203.64 93.43,212.62 100,218.47 104.32,221.52 L 105.06,220.48 C 100.8,217.47 94.27,211.66 85.1,202.72 80.56,198.31 62.49,176.78 59.19,169.18 L 59.11,169.01 58.97,168.91 C 57.67,168 56,167.02 54.23,165.97 51.28,164.23 47.94,162.26 46.07,160.42 44.14,158.53 41.89,157.22 40.08,156.17 38.97,155.53 38.01,154.98 37.36,154.43 37.17,154.27 36.97,154.1 36.75,153.93 35.23,152.68 32.69,150.6 33.43,149.33 33.43,149.33 33.68,149.05 35.3,149.64 36.59,150.11 38.23,150.94 39.96,151.82 42.35,153.03 44.82,154.28 46.7,154.74 L 47.38,153.76 C 46.32,152.22 43.79,150.08 41.55,148.19 41.28,147.96 41.02,147.75 40.78,147.53 36.21,143.65 34.39,140.85 34.96,140.08 34.97,140.06 35,140.02 35.14,140 35.59,139.94 37.55,140.14 43.89,145.21 44.87,145.99 47.07,147.42 48.52,148.37 49.04,148.71 49.58,149.06 49.66,149.12 49.64,149.11 49.63,149.09 49.62,149.09 L 50.58,148.25 C 48.87,146.03 47.24,144.58 46.06,143.51 45.48,143 44.98,142.55 44.63,142.16 38.43,135.18 38.72,133.32 39.14,132.84 39.18,132.79 39.24,132.75 39.39,132.74 39.41,132.73 39.43,132.73 39.45,132.73 41.01,132.73 44.78,136.13 46.61,137.77 47.14,138.25 47.61,138.67 47.96,138.96 48.83,139.69 49.94,140.73 51.02,141.74 52.93,143.52 54.25,144.88 54.68,145.07 L 55.77,144.85 C 55.77,144.85 53.16,140.54 51.85,138.81 51.2,137.95 50.58,137.14 50.08,136.41 49.73,135.9 49.26,135.32 48.76,134.7 47.24,132.84 45.17,130.28 46.38,129.21 46.5,129.1 46.63,129.06 46.81,129.08 48.31,129.21 51,132.63 52.77,134.9 53.48,135.8 54.09,136.58 54.57,137.11 54.79,137.35 55.03,137.6 55.28,137.87 57.24,140 60.22,143.23 61.03,144.61 61.21,144.92 61.55,145.59 61.97,146.45 64.4,151.36 67.19,156.69 69.6,157.81 72.61,159.22 94.46,178.14 99.64,184.67 105.06,191.5 118.58,198.98 119.16,199.3 L 119.77,198.18 C 119.64,198.1 105.9,190.5 100.64,183.88 Z M 100.64,183.88")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier75"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 46.4,156.45 C 47.74,151.98 51.72,146.28 57.3,144.32 57.3,144.32 53.14,144.11 49.57,148.31 45.68,152.87 46.4,156.45 46.4,156.45 Z M 46.4,156.45")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier76"),
                Cw("none"),
                aL("rgb(254, 209, 167)"),
                jL("M 68.55,158.51 L 67.11,159.53 61.58,163.43 C 58.22,159.17 58.55,152.04 61.58,147.08 61.96,143.43 59.64,141.21 61.06,137.53 61.79,135.62 63.27,135.02 64.56,135.15 65.77,135.27 66.82,136.05 66.93,137.01 67.17,138.99 66.27,141.64 67.41,144.14 68.55,146.65 71.25,153.98 68.55,158.51 Z M 68.55,158.51")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier77"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 68.55,158.51 L 67.11,159.53 C 66.77,159.48 66.48,159.49 66.27,159.55 68.74,156.76 67.13,147.88 65.32,145.42 63.52,142.96 65.99,137.01 64.19,135.45 L 64.56,135.15 C 65.77,135.27 66.82,136.05 66.93,137.01 67.17,138.99 66.27,141.64 67.41,144.14 68.55,146.65 71.25,153.98 68.55,158.51 Z M 68.55,158.51")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier78"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 67.54,139.34 C 67.6,138.49 67.66,137.69 67.57,136.93 67.43,135.73 66.23,134.71 64.72,134.53 63.25,134.34 61.36,134.97 60.46,137.3 59.58,139.6 60.03,141.39 60.47,143.12 60.78,144.34 61.08,145.49 60.96,146.87 58.85,150.4 58.11,154.69 58.77,158.42 59.38,161.82 62.08,163.03 62.08,163.03 59.03,159.17 59.05,152.45 62.13,147.41 L 62.2,147.28 62.22,147.14 C 62.39,145.48 62.05,144.12 61.71,142.81 61.29,141.13 60.92,139.68 61.66,137.76 62.45,135.7 64.08,135.73 64.56,135.79 65.46,135.9 66.23,136.47 66.3,137.08 66.38,137.72 66.32,138.46 66.26,139.25 66.15,140.84 66.02,142.63 66.83,144.41 67.24,145.32 70.8,153.48 68,158.19 68,158.19 70.12,157.86 70.33,154.27 70.6,149.8 68.52,145.05 67.99,143.88 67.32,142.4 67.43,140.84 67.54,139.34 Z M 67.54,139.34")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier79"),
                Cw("none"),
                aL("rgb(254, 209, 167)"),
                jL("M 280.14,169.15 C 278.13,170.37 274.12,171.24 270.67,173.72 267.22,176.21 260.38,178.32 256.54,180.22 251.98,187.46 230.4,206.09 225.66,209.63 220.14,213.77 211.59,219.62 205.24,223.11 204.51,223.52 203.81,223.88 203.15,224.22 L 191.93,199.98 C 191.93,199.98 206.85,194.51 213.23,188.6 219.6,182.69 244.04,167.4 247.25,166.46 250.46,165.51 256.23,156.36 257.41,154.91 258.59,153.46 262.62,150.3 265.03,148.38 267.25,146.6 272.5,140.72 274.73,141.55 L 274.74,141.55 C 274.92,141.62 275.09,141.74 275.23,141.9 277.04,144.1 272.28,147.34 270.45,149.3 268.61,151.27 265.53,153.85 264.55,155.57 L 264.55,155.57 C 265.24,155.39 269.09,152.54 271.36,151.16 273.39,149.94 279.16,145.7 281.28,146.24 281.54,146.3 281.74,146.44 281.88,146.65 283.15,148.66 278.36,153 274.9,155.86 273.67,156.88 271.33,158 268.53,160.57 268.4,160.69 268.27,160.82 268.13,160.95 268.29,160.83 272.86,158.85 274.44,157.95 275.83,157.15 282.16,153.51 284.32,154.04 284.6,154.11 284.82,154.26 284.94,154.48 285.97,156.46 280.31,160.28 277.82,161.81 275.65,163.15 272.73,164.87 271.11,166.27 270.87,166.47 270.66,166.67 270.48,166.86 274.58,166.5 282.39,162.75 284.56,163.48 284.81,163.57 284.98,163.71 285.07,163.93 285.9,166.01 282.15,167.93 280.14,169.15 Z M 280.14,169.15")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier80"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 263.52,156.39 C 263.52,156.39 262.33,155.79 261.64,155.59 262.43,155.4 265.19,151.96 266.97,150.38 268.74,148.81 274.36,143.26 274.61,141.7 L 274.73,141.55 274.74,141.55 C 274.92,141.62 275.09,141.74 275.23,141.9 277.04,144.1 272.28,147.34 270.45,149.3 268.61,151.27 265.53,153.85 264.55,155.57 L 263.52,156.39 Z M 263.52,156.39")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier81"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 281.29,146.86 C 281.3,146.84 281.3,146.57 281.28,146.24 281.54,146.3 281.74,146.44 281.88,146.65 283.15,148.66 278.36,153 274.9,155.86 273.67,156.88 271.33,158 268.53,160.57 268.46,160.62 268.39,160.66 268.32,160.7 268.32,160.7 266.83,158.89 266.22,158.29 270.7,156.98 280.54,147.95 281.29,146.86 Z M 281.29,146.86")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier82"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 269.34,163.14 C 273.36,162.25 283.59,155.91 284.3,154.17 284.31,154.15 284.32,154.11 284.32,154.04 284.6,154.11 284.82,154.26 284.94,154.48 285.97,156.46 280.31,160.28 277.82,161.81 275.65,163.15 272.73,164.87 271.11,166.27 270.93,166.33 270.76,166.39 270.63,166.44 270.63,166.44 269.71,163.67 269.34,163.14 Z M 269.34,163.14")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier83"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 280.14,169.15 C 278.13,170.37 274.12,171.24 270.67,173.72 267.22,176.21 260.38,178.32 256.54,180.22 251.98,187.46 230.4,206.09 225.66,209.63 220.14,213.77 211.59,219.62 205.24,223.11 204.59,217.69 203.84,211.14 203.64,208.19 224.67,205.73 252.14,179.07 253.56,174.63 261.8,174.25 269.49,171.4 270.59,169.63 276.2,169 283.59,164.95 284.3,163.89 284.36,163.77 284.46,163.63 284.56,163.48 284.81,163.57 284.98,163.71 285.07,163.93 285.9,166.01 282.15,167.93 280.14,169.15 Z M 280.14,169.15")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier84"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 277.24,164.41 C 275.72,164.91 274.17,165.42 272.79,165.77 274.13,164.82 275.82,163.78 277.29,162.89 277.59,162.7 277.88,162.53 278.16,162.36 282.17,159.88 286.7,156.46 285.5,154.19 285.31,153.83 284.99,153.57 284.55,153.45 282.98,152.99 279.47,154.32 274.12,157.39 273.79,157.58 273.32,157.82 272.79,158.08 273.06,157.9 273.32,157.73 273.58,157.57 274.26,157.12 274.85,156.74 275.31,156.36 281.42,151.3 283.61,148.2 282.42,146.31 282.19,145.95 281.82,145.7 281.37,145.6 279.52,145.2 276.12,147.3 272.5,149.67 271.91,150.06 271.4,150.39 271.03,150.62 270.16,151.14 269.1,151.85 268.04,152.58 268.28,152.35 268.52,152.12 268.75,151.89 269.54,151.13 270.29,150.41 270.91,149.74 271.3,149.33 271.84,148.84 272.41,148.32 274.57,146.36 277.53,143.68 275.72,141.5 275.39,141.1 274.93,140.87 274.4,140.84 272.49,140.72 269.89,143.02 266.67,146.04 265.86,146.8 265.15,147.46 264.63,147.88 264.38,148.08 264.11,148.3 263.82,148.53 261.37,150.48 258.02,153.16 256.92,154.51 256.66,154.82 256.24,155.42 255.66,156.26 253.63,159.15 249.41,165.16 247.07,165.85 243.63,166.86 219.1,182.29 212.79,188.14 206.59,193.89 191.85,199.32 191.71,199.38 L 192.15,200.58 C 192.76,200.35 207.27,195 213.66,189.07 219.77,183.4 244.25,168 247.43,167.07 249.99,166.32 253.56,161.47 256.7,156.99 257.25,156.21 257.68,155.59 257.91,155.31 258.92,154.07 262.35,151.33 264.62,149.52 264.9,149.29 265.18,149.08 265.43,148.88 265.99,148.43 266.71,147.75 267.55,146.96 269.65,145 272.82,142.02 274.32,142.11 274.5,142.12 274.63,142.18 274.73,142.31 275.76,143.55 273.33,145.76 271.54,147.38 270.96,147.91 270.4,148.42 269.98,148.87 269.37,149.51 268.64,150.22 267.86,150.97 266.3,152.48 264.01,154.92 263.31,156.14 L 264.14,156.55 C 264.6,156.43 266.09,155.46 268.24,153.99 269.46,153.16 270.71,152.3 271.69,151.71 272.08,151.47 272.6,151.13 273.21,150.73 275.29,149.37 279.61,146.53 281.1,146.85 281.25,146.88 281.3,146.94 281.33,146.99 281.67,147.53 281.68,149.42 274.49,155.37 274.09,155.71 273.53,156.07 272.88,156.5 271.54,157.37 269.71,158.56 267.69,160.49 L 268.51,161.46 C 268.5,161.47 268.48,161.48 268.46,161.49 268.56,161.44 269.14,161.18 269.71,160.92 271.29,160.21 273.67,159.13 274.76,158.5 281.8,154.45 283.76,154.55 284.2,154.67 284.33,154.71 284.36,154.76 284.37,154.78 284.81,155.63 282.59,158.12 277.48,161.27 277.21,161.44 276.92,161.62 276.62,161.8 274.12,163.33 271.29,165.06 270.01,166.42 L 270.54,167.49 C 272.46,167.32 275.1,166.46 277.64,165.62 279.49,165.02 281.23,164.45 282.58,164.18 284.26,163.84 284.47,164.16 284.47,164.16 285.01,165.52 282.18,167.2 280.49,168.2 280.25,168.34 280.02,168.48 279.81,168.6 279.09,169.04 278.06,169.45 276.87,169.91 274.92,170.68 272.49,171.63 270.3,173.21 268.17,174.74 264.56,176.18 261.38,177.46 259.48,178.22 257.68,178.94 256.26,179.65 L 256.1,179.73 256,179.88 C 251.51,187 229.78,205.76 225.28,209.12 218.85,213.93 209.1,220.52 202.86,223.65 L 203.44,224.79 C 209.74,221.63 219.58,214.98 226.05,210.15 230.7,206.66 252.13,188.2 256.98,180.71 258.34,180.05 260.05,179.37 261.86,178.64 265.26,177.28 268.79,175.87 271.04,174.24 273.11,172.76 275.35,171.88 277.33,171.1 278.58,170.61 279.66,170.19 280.48,169.69 280.68,169.57 280.91,169.43 281.15,169.29 283.45,167.93 286.6,166.07 285.66,163.69 284.95,161.89 281.72,162.95 277.24,164.41 Z M 277.24,164.41")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier85"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 261.64,155.59 C 266.85,158.38 269.92,164.61 270.57,169.23 270.57,169.23 271.92,166.08 268.98,161.19 265.76,155.84 261.64,155.59 261.64,155.59 Z M 261.64,155.59")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier86"),
                Cw("none"),
                aL("rgb(254, 209, 167)"),
                jL("M 253.23,146.91 C 252.69,148.83 253.18,151.58 251.68,153.89 250.17,156.19 246.39,163.03 248.37,167.92 L 254.5,173.83 C 258.47,170.14 259.23,163.03 256.99,157.67 257.17,154.01 259.8,152.17 258.95,148.31 258.11,144.45 253.76,144.98 253.23,146.91 Z M 253.23,146.91")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier87"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 255.17,145.51 C 258.58,146.98 255.27,155.16 254.04,157.66 256.59,159.79 256.09,170.49 254.07,173.37 256.36,171.94 258.11,168.72 258.39,165.89 258.68,163.05 256.97,158.04 256.97,157.43 258.3,154.68 261.66,145.47 255.17,145.51 Z M 255.17,145.51")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier88"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 259.58,148.17 C 259.05,145.74 257.28,144.83 255.8,144.79 254.28,144.75 252.94,145.57 252.61,146.74 252.41,147.47 252.34,148.27 252.28,149.12 252.15,150.62 252.03,152.18 251.14,153.54 250.48,154.55 247.8,158.45 247.36,162.65 246.91,166.93 248.96,167.68 248.96,167.68 246.91,162.6 251.66,155.08 252.21,154.24 253.28,152.6 253.42,150.81 253.55,149.22 253.61,148.44 253.67,147.69 253.84,147.08 254.01,146.48 254.86,146.04 255.76,146.06 256.24,146.08 257.86,146.29 258.33,148.44 258.77,150.46 258.19,151.84 257.51,153.43 256.98,154.68 256.43,155.96 256.35,157.64 L 256.34,157.78 256.4,157.91 C 258.68,163.36 257.67,170.01 254.07,173.37 254.07,173.37 257.38,172.36 258.4,168.06 259.2,164.74 259.01,160.94 257.64,157.56 257.73,156.18 258.19,155.09 258.68,153.93 259.38,152.29 260.11,150.58 259.58,148.17 Z M 259.58,148.17")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier89"),
                Cw("none"),
                aL("rgb(132, 193, 40)"),
                jL("M 188.1,237.31 C 185.45,241.84 188.01,254.23 189.05,262.83 190.09,271.43 196.34,283.16 196.25,287.03 196.15,290.91 179.39,301.02 153.05,301.4 149.49,301.45 146.15,301.36 143.04,301.16 123.1,299.87 112.07,293.94 107.48,290.34 102.18,286.18 106.25,269.92 108.81,268.12 108.81,263.78 118.19,235.7 119.42,233.34 113.73,231.92 102.65,227.85 100.09,223.6 100.66,214.05 107.77,196.28 112.6,193.07 116.39,197.6 139.31,205.64 146.42,205.17 L 146.32,205.54 C 146.32,205.54 142.49,213.03 149.59,213.44 159.49,214.01 162.99,207.53 165.27,203.65 168.21,202.33 196.53,194.11 198.9,193.92 202,196.93 207.55,213.87 208.38,222.15 208.51,223.49 208.52,224.61 208.37,225.4 205.06,228.14 190.75,232.77 188.1,237.31 Z M 188.1,237.31")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier90"),
                Cw("none"),
                aL("rgb(108, 166, 18)"),
                jL("M 188.1,237.31 C 185.45,241.84 188.01,254.23 189.05,262.83 190.09,271.43 196.34,283.16 196.25,287.03 196.15,290.91 179.39,301.02 153.05,301.4 149.49,301.45 146.15,301.36 143.04,301.16 182.92,293.23 180.38,279.12 177.73,277.93 172.33,280.98 160.75,281.76 158.54,280.34 176.31,278.07 182.42,259.57 180.21,255.24 175.17,261.13 165.15,266.8 161.6,266.52 178.65,260.21 182.56,233.41 181.21,230.43 180.5,232.77 179.15,236.24 176.38,236.95 180.5,231.99 179.15,220.86 177.44,219.65 187.82,220.29 196.56,214.9 197.76,210.6 L 208.38,222.15 C 208.51,223.49 208.52,224.61 208.37,225.4 205.06,228.14 190.75,232.77 188.1,237.31 Z M 188.1,237.31")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier91"),
                Cw("none"),
                aL("rgb(108, 166, 18)"),
                jL("M 118.9,233.41 C 118.9,233.41 124.15,222.09 128.32,217.69 120.13,215.38 110.61,209.51 110.75,208.14 109.71,210.46 105.07,225.4 105.07,227.85 107.01,228.89 118.9,233.41 118.9,233.41 Z M 118.9,233.41")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier92"),
                Cw("none"),
                aL("rgb(108, 166, 18)"),
                jL("M 159.68,216.75 C 172.61,211.78 189.88,199.8 191.72,196.11 186.54,197.18 167.68,204.06 167.68,204.06 L 159.68,216.75 Z M 159.68,216.75")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier93"),
                Cw("none"),
                aL("rgb(73, 107, 22)"),
                jL("M 207.78,225.05 C 206.5,226.01 203.78,227.28 200.9,228.61 195.46,231.13 189.3,233.98 187.55,236.99 185.29,240.84 186.57,249.75 187.69,257.61 187.96,259.49 188.21,261.26 188.41,262.91 188.99,267.66 191.07,273.19 192.91,278.07 194.38,281.99 195.65,285.37 195.61,287.02 195.58,288.39 192.03,291.76 184.25,294.94 175.44,298.53 164.36,300.6 153.04,300.76 152.39,300.77 151.73,300.78 151.09,300.78 140.13,300.78 130.35,299.44 122.02,296.79 114.3,294.34 109.85,291.38 107.88,289.84 105.81,288.22 105.47,284.59 105.54,281.83 105.69,275.96 107.88,269.56 109.18,268.65 L 109.45,268.46 109.45,268.13 C 109.45,266.37 111.25,259.66 114.26,250.18 116.27,243.87 118.26,238.07 119.32,235.27 119.63,234.44 120.18,232.86 120.18,232.86 L 119.57,232.72 C 113.19,231.13 103.23,227.22 100.74,223.44 101.38,214.1 107.98,197.68 112.52,193.92 117.34,198.6 137.86,205.65 145.49,205.82 144.99,207.02 144.04,209.85 145.22,211.9 145.98,213.22 147.44,213.95 149.55,214.07 149.97,214.1 150.39,214.11 150.79,214.11 159.9,214.11 163.49,207.96 165.64,204.29 L 165.72,204.16 C 169.4,202.64 194.98,195.23 198.66,194.59 200.24,196.4 202.66,202.1 204.77,209.03 206.96,216.22 208.12,222.44 207.78,225.05 Z M 199.35,193.46 L 199.14,193.26 198.85,193.28 C 196.51,193.47 168.04,201.7 165.01,203.07 L 164.82,203.16 164.53,203.65 C 162.39,207.3 159.16,212.83 150.79,212.83 L 150.79,212.83 C 150.41,212.83 150.02,212.82 149.63,212.8 147.97,212.7 146.86,212.19 146.33,211.27 145.17,209.26 146.88,205.87 146.89,205.83 L 146.93,205.77 147.25,204.47 146.37,204.53 C 146.19,204.54 145.99,204.55 145.78,204.55 137.91,204.55 116.52,196.77 113.09,192.66 L 112.72,192.22 112.24,192.53 C 109.89,194.1 106.87,199.03 104.15,205.72 101.52,212.19 99.72,219.03 99.45,223.56 L 99.44,223.76 99.54,223.93 C 102.34,228.58 113.79,232.48 118.54,233.77 116.6,238.61 108.52,262.7 108.18,267.82 106.33,269.59 104.4,276.37 104.26,281.79 104.18,284.85 104.6,288.9 107.09,290.84 109.12,292.44 113.72,295.5 121.63,298.01 130.08,300.69 139.99,302.05 151.09,302.05 151.74,302.05 152.4,302.05 153.06,302.04 164.54,301.87 175.78,299.77 184.73,296.12 191.94,293.18 196.83,289.53 196.89,287.05 196.93,285.15 195.68,281.83 194.1,277.63 192.29,272.81 190.24,267.35 189.68,262.75 189.48,261.09 189.23,259.32 188.96,257.43 187.86,249.78 186.62,241.1 188.65,237.63 190.21,234.97 196.43,232.09 201.44,229.77 204.67,228.27 207.47,226.97 208.78,225.89 L 208.96,225.74 209,225.51 C 209.59,222.31 207.83,214.7 205.99,208.65 204.24,202.93 201.46,195.51 199.35,193.46 Z M 199.35,193.46")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier94"),
                Cw("none"),
                aL("rgb(73, 107, 22)"),
                jL("M 117.78,235.86 L 119.01,236.07 C 119.57,234.24 123.27,225.32 124.51,223 124.51,223 121.9,225.32 119.71,230.79 118.81,233.06 118.02,235.07 117.78,235.86 Z M 117.78,235.86")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier95"),
                Cw("none"),
                aL("rgb(230, 230, 230)"),
                jL("M 112.6,193.07 C 107.77,196.28 100.66,214.05 100.09,223.6 100.93,225 102.69,226.37 104.88,227.64 107.49,214.03 112.84,203.76 117.44,196.41 115.16,195.21 113.42,194.05 112.6,193.07 Z M 112.6,193.07")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier96"),
                Cw("none"),
                aL("rgb(179, 179, 179)"),
                jL("M 104.73,205.19 C 106.34,207.55 109.04,208.99 110.99,208.62 109.9,210.22 105.07,224.45 105.07,227.1 103.83,227.19 100.42,225.21 100.09,223.6 99.81,221.61 103.41,207.69 104.73,205.19 Z M 104.73,205.19")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier97"),
                Cw("none"),
                aL("rgb(102, 102, 102)"),
                jL("M 104.43,226.63 C 102.64,225.51 101.41,224.44 100.74,223.44 101.38,214.1 107.98,197.68 112.52,193.92 113.36,194.74 114.71,195.65 116.54,196.65 112.56,203.09 107.19,213 104.43,226.63 Z M 113.09,192.66 L 112.72,192.22 112.24,192.53 C 109.89,194.1 106.87,199.03 104.15,205.72 101.52,212.19 99.72,219.03 99.45,223.56 L 99.44,223.76 99.54,223.93 C 100.37,225.31 102.06,226.74 104.56,228.19 L 105.33,228.65 105.5,227.76 C 108.25,213.46 113.94,203.21 117.98,196.74 L 118.35,196.16 117.74,195.84 C 114.81,194.31 113.59,193.26 113.09,192.66 Z M 113.09,192.66")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier98"),
                Cw("none"),
                aL("rgb(230, 230, 230)"),
                jL("M 149.59,213.44 C 142.49,213.03 146.32,205.54 146.32,205.54 L 146.42,205.17 C 145.08,205.25 143.19,205.04 140.96,204.61 138.65,210.12 137.82,217.92 145.56,219.72 156.67,222.31 166.33,216.86 169.95,202.06 167.6,202.8 165.88,203.38 165.27,203.65 163,207.53 159.49,214.01 149.59,213.44 Z M 149.59,213.44")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier99"),
                Cw("none"),
                aL("rgb(179, 179, 179)"),
                jL("M 156.27,212.44 C 162.52,210.03 164.28,215.38 157.03,219.06 164.04,216.04 168.11,210.55 169.44,204.22 165.55,203.94 163.66,205.73 163.66,205.73 163.56,208.1 159.82,211.07 156.27,212.44 Z M 156.27,212.44")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier100"),
                Cw("none"),
                aL("rgb(60, 92, 10)"),
                jL("M 148.24,206.16 C 148.67,208.69 147.15,211.78 146.13,212.35 145.16,210.7 145.8,207.25 145.8,207.25 L 148.24,206.16 Z M 148.24,206.16")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier101"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 148.41,206.73 C 148.41,209.51 146.8,211.88 146.32,212.49 148.03,213.72 151.06,214.67 155.28,212.87 159.49,211.07 162,209.37 163.66,205.73 160.15,204.22 148.41,206.73 148.41,206.73 Z M 148.41,206.73")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier102"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 147.08,202.09 C 147.99,204.43 147.93,209.54 145.75,212.23 L 146.75,213.03 C 149.34,209.82 149.29,204.25 148.27,201.63 L 147.08,202.09 Z M 147.08,202.09")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier103"),
                Cw("none"),
                aL("rgb(102, 102, 102)"),
                jL("M 150.73,219.71 C 149.12,219.71 147.43,219.5 145.71,219.1 143.36,218.56 141.72,217.39 140.82,215.63 139.07,212.23 140.47,207.59 141.36,205.33 142.99,205.63 144.38,205.8 145.49,205.82 144.99,207.02 144.04,209.85 145.22,211.9 145.98,213.22 147.44,213.95 149.55,214.07 149.97,214.1 150.39,214.11 150.79,214.11 L 150.79,214.11 C 159.9,214.11 163.49,207.96 165.64,204.29 L 165.72,204.16 C 166.15,203.98 167.09,203.65 169.04,203.02 166.09,213.79 159.62,219.71 150.73,219.71 Z M 165.01,203.07 L 164.82,203.16 164.53,203.65 C 162.39,207.3 159.16,212.83 150.79,212.83 L 150.79,212.83 C 150.41,212.83 150.02,212.82 149.63,212.8 147.97,212.7 146.86,212.19 146.33,211.27 145.17,209.26 146.88,205.87 146.89,205.83 L 146.93,205.77 147.25,204.47 146.37,204.53 C 146.19,204.54 145.99,204.55 145.78,204.55 144.59,204.55 143.01,204.36 141.09,203.98 L 140.57,203.88 140.37,204.36 C 139.46,206.55 137.55,212.07 139.68,216.21 140.76,218.32 142.69,219.71 145.42,220.35 147.23,220.77 149.02,220.98 150.73,220.98 L 150.73,220.98 C 155.45,220.98 159.56,219.42 162.95,216.34 166.5,213.11 169.07,208.36 170.57,202.21 L 170.84,201.11 169.76,201.45 C 167.21,202.25 165.61,202.8 165.01,203.07 Z M 165.01,203.07")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier104"),
                Cw("none"),
                aL("rgb(230, 230, 230)"),
                jL("M 192.37,195.52 C 196.08,201.77 200.71,218.89 200.66,229.42 204.02,227.87 207.06,226.48 208.37,225.4 209.42,219.72 202.5,197.41 198.9,193.92 198.26,193.97 195.75,194.6 192.37,195.52 Z M 192.37,195.52")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier105"),
                Cw("none"),
                aL("rgb(179, 179, 179)"),
                jL("M 205.39,207.86 C 203.64,211.88 199.99,211.64 197.76,210.6 198.62,212.16 200.8,226.34 200.61,228.66 203.12,228.94 208.42,225.92 208.75,224.78 209.08,223.65 205.39,207.86 205.39,207.86 Z M 205.39,207.86")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier106"),
                Cw("none"),
                aL("rgb(102, 102, 102)"),
                jL("M 207.78,225.05 C 206.56,225.97 204.02,227.16 201.29,228.43 201.19,223.63 200.2,217.25 198.55,210.71 197,204.6 195.08,199.17 193.33,195.92 196.75,195 198.12,194.69 198.66,194.59 200.24,196.41 202.66,202.1 204.77,209.03 206.96,216.22 208.12,222.44 207.78,225.05 Z M 199.35,193.46 L 199.14,193.26 198.85,193.28 C 198.21,193.33 195.97,193.88 192.2,194.9 L 191.39,195.12 191.82,195.84 C 195.47,201.99 200.07,219.03 200.02,229.42 L 200.02,230.42 201.44,229.77 C 204.67,228.27 207.47,226.97 208.78,225.89 L 208.96,225.74 209,225.51 C 209.59,222.31 207.83,214.7 205.99,208.65 204.24,202.93 201.46,195.51 199.35,193.46 Z M 199.35,193.46")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier107"),
                Cw("none"),
                aL("rgb(73, 107, 22)"),
                jL("M 185.25,227.19 C 185.62,228.81 186.79,236.17 186.4,241.37 L 187.6,241.74 C 187.71,240.35 187.69,238.79 187.65,237.21 187.46,230.15 185.25,227.19 185.25,227.19 Z M 185.25,227.19")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier108"),
                Cw("none"),
                aL("rgb(73, 107, 22)"),
                jL("M 175.41,258.86 C 167.95,264.96 155.6,270.61 143.32,268.16 143.32,268.16 145.8,270.02 149.33,270.02 159.85,270.04 169.8,265.1 176.22,259.85 179.11,257.48 181.39,255.05 182.74,252.76 184.1,250.46 183.1,247.99 183.1,247.99 183.1,250.77 180.08,255.03 175.41,258.86 Z M 175.41,258.86")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier109"),
                Cw("none"),
                aL("rgb(73, 107, 22)"),
                jL("M 114,280.23 C 111.18,277.4 110.12,273.45 109.72,270.76 109.47,269.07 109.45,267.81 109.46,267.68 L 108.2,267.74 C 108.15,270.84 109.13,277.16 113.09,281.13 114.22,282.26 115.5,283.18 116.97,283.78 120.48,285.21 123.38,283.7 123.38,283.7 119.49,283.75 116.33,282.57 114,280.23 Z M 114,280.23")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier110"),
                Cw("none"),
                aL("rgb(73, 107, 22)"),
                jL("M 141.31,275.4 C 132,270.33 125.62,261.78 122.88,250.67 122.88,250.67 122.34,254.93 125.31,260.8 128.73,267.59 134.03,272.89 140.7,276.52 146.83,279.85 153.93,281.53 161.37,281.53 164.48,281.53 167.66,281.33 170.81,280.65 176.22,279.48 178.32,277.35 178.32,277.35 165.3,281.82 151.81,281.11 141.31,275.4 Z M 141.31,275.4")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier111"),
                Cw("none"),
                aL("rgb(70, 37, 16)"),
                jL("M 227.61,83.74 C 235.42,86.57 244.94,100.47 242.38,114.37 239.84,128.18 230.98,147.59 207.44,168.7 207.3,168.84 207.15,168.97 207,169.1 L 203.42,168.89 198.37,168.6 99.43,162.86 C 86.92,153.93 78.68,135.78 79.25,113.66 79.82,91.54 111.84,35.86 118.38,34.72 133.63,21.2 170.39,30.18 183.08,35.76 188.04,37.94 193.87,42.38 199.08,47.48 207.21,55.44 213.84,65 213.32,70.05 221.64,53.89 235.21,55.38 241.96,65.44 233.36,61.4 221.28,71.12 218.94,76.72 231.58,67.64 244.59,77.85 244.09,89.27 242.17,83.45 229.88,80.47 227.61,83.74 Z M 227.61,83.74")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier112"),
                Cw("none"),
                aL("rgb(53, 28, 12)"),
                jL("M 227.61,83.74 C 235.42,86.57 244.94,100.47 242.38,114.37 239.84,128.18 230.98,147.59 207.44,168.7 206.06,168.81 204.71,168.88 203.42,168.89 201.62,168.92 199.92,168.85 198.33,168.68 198.35,168.65 198.36,168.63 198.37,168.6 205.04,156.96 212.39,136.61 209.56,126.84 210.69,127.27 213.68,137.34 215.38,142.58 216.24,132.94 223.13,117.2 221.07,109.76 223.27,111.03 226.68,124.01 223.7,129.25 233.86,119.12 233.29,95.93 227.68,93.45 229.1,93.1 233.5,94.09 235.92,96.78 234.07,92.74 225.47,85.86 219.65,88.77 224.98,78.7 231.37,78.07 240.54,82.39 232.51,70.55 222.77,76.08 214.32,82.04 216.8,70.76 224.27,65.23 236.7,62.47 230.3,61.19 222.84,63.03 218.58,69.98 218.65,69.77 219.36,65.16 220.14,64.03 214.6,65.87 213.39,77.64 205.86,86.43 209.89,74.02 206.31,58.76 199.08,47.48 207.21,55.44 213.84,65 213.32,70.05 221.64,53.89 235.21,55.38 241.96,65.44 233.36,61.4 221.28,71.12 218.94,76.72 231.58,67.64 244.59,77.85 244.09,89.27 242.17,83.45 229.88,80.47 227.61,83.74 Z M 227.61,83.74")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier113"),
                Cw("none"),
                aL("rgb(31, 16, 8)"),
                jL("M 236.18,74.42 C 231.39,71.84 225.9,72 220.8,74.79 223.08,71.65 227.45,68 232.06,66.23 234.58,65.26 238.31,64.44 241.68,66.02 L 243.77,67 242.49,65.09 C 239,59.88 233.73,56.95 228.4,57.26 222.8,57.58 217.68,61.32 213.82,67.84 213,63.72 209.42,57.83 203.76,51.46 197.18,44.06 189.35,37.82 183.34,35.18 176.6,32.22 164.22,28.68 151.75,27.45 141.08,26.39 126.6,26.7 118.07,34.14 116.27,34.64 113.23,37.98 109.06,44.06 105.02,49.95 100.38,57.75 96.01,66.02 91.21,75.11 87.08,84.07 84.09,91.92 80.59,101.1 78.75,108.4 78.61,113.64 78.34,124.37 80.15,134.68 83.85,143.45 87.43,151.94 92.69,158.83 99.06,163.38 L 99.8,162.34 C 86.98,153.19 79.35,134.54 79.89,113.67 80.13,104.19 86.58,86.59 97.14,66.62 107.05,47.87 115.93,35.79 118.49,35.35 L 118.66,35.32 118.8,35.2 C 126.96,27.97 141.15,27.68 151.62,28.71 163.95,29.93 176.17,33.42 182.82,36.35 188.68,38.92 196.33,45.04 202.8,52.31 209.27,59.59 213.06,66.36 212.69,69.99 L 212.34,73.36 213.89,70.34 C 217.64,63.05 222.82,58.86 228.47,58.53 232.76,58.29 237.03,60.36 240.2,64.16 237.63,63.55 234.7,63.85 231.6,65.04 225.37,67.43 219.87,72.84 218.35,76.47 L 217.48,78.55 219.31,77.24 C 224.6,73.44 230.52,72.83 235.57,75.55 239.77,77.81 242.68,82.11 243.33,86.72 241.14,84.17 237.13,82.43 233.56,81.91 230.41,81.45 228.05,81.98 227.08,83.37 L 226.6,84.05 227.39,84.34 C 231.23,85.73 235.42,89.9 238.32,95.21 241.67,101.34 242.89,108.1 241.75,114.25 239.44,126.82 231.46,146.45 206.57,168.63 L 207.43,169.58 C 232.58,147.16 240.66,127.25 243.01,114.48 244.2,108.04 242.93,100.98 239.45,94.6 236.64,89.46 232.64,85.33 228.8,83.54 229.75,83.03 231.4,82.89 233.37,83.17 237.46,83.77 242.4,86.18 243.48,89.47 L 244.58,92.78 244.73,89.29 C 244.86,86.29 244.1,83.29 242.54,80.61 241,77.98 238.8,75.84 236.18,74.42 Z M 236.18,74.42")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier114"),
                Cw("none"),
                aL("rgb(254, 209, 167)"),
                jL("M 86.51,147.66 C 84.3,159.3 94.58,170.91 102.78,167.76 102.46,162.73 101.63,148.6 101.63,148.6 101.63,148.6 88.71,136.02 86.51,147.66 Z M 86.51,147.66")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier115"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 87.76,144.41 C 95.99,143.72 98.38,153.93 96.58,160.52 96.06,162.45 94.79,164.67 92.67,165.23 95.73,167.87 99.43,169.05 102.78,167.76 102.46,162.73 101.63,148.6 101.63,148.6 101.63,148.6 91.69,138.92 87.76,144.41 Z M 87.76,144.41")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier116"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 90.99,146.85 C 88.21,147.49 88.65,151.12 88.65,151.12 88.66,151.1 88.76,148.4 91.17,147.89 92.33,147.64 94.16,148.89 95.75,151.13 L 96.22,149.99 C 94.35,147.64 92.57,146.49 90.99,146.85 Z M 90.99,146.85")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier117"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 92.59,149.28 C 91.06,150.48 91.1,153.15 91.1,153.27 91.1,153.27 91.68,150.44 93.19,149.83 93.73,149.61 94.31,149.67 95.1,149.88 L 95.37,148.87 C 94.26,148.57 93.32,148.71 92.59,149.28 Z M 92.59,149.28")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier118"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 99.94,167.76 L 99.94,167.76 C 96.91,167.76 93.68,165.97 91.1,162.86 87.56,158.6 86.04,152.96 87.02,147.76 87.6,144.72 88.92,143.25 91.07,143.25 94.95,143.25 100.19,147.97 101.12,148.84 101.22,150.56 101.92,162.48 102.23,167.4 101.49,167.64 100.73,167.76 99.94,167.76 Z M 102.16,148.57 L 102.15,148.37 102,148.23 C 101.75,147.98 95.75,142.2 91.07,142.2 89.22,142.2 86.83,143.13 85.99,147.56 84.95,153.06 86.55,159.03 90.29,163.53 93.07,166.89 96.59,168.81 99.94,168.81 L 99.94,168.81 C 100.98,168.81 102,168.62 102.96,168.25 L 103.32,168.11 103.3,167.73 C 102.99,162.76 102.17,148.71 102.16,148.57 Z M 102.16,148.57")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier119"),
                Cw("none"),
                aL("rgb(70, 37, 16)"),
                jL("M 91.08,141.7 C 93.71,143.82 96.94,150.67 97.01,155.84 98.97,152.33 97.83,144.5 97.83,144.04 97.83,143.58 92.86,141.13 91.08,141.7 Z M 91.08,141.7")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier120"),
                Cw("none"),
                aL("rgb(31, 16, 8)"),
                jL("M 91.27,141.94 C 93.59,143.91 95.24,147.88 96.02,153.42 96.65,157.8 96.62,162.57 96.31,165.34 L 97.58,165.48 C 97.87,162.84 97.97,158.04 97.29,153.24 96.92,150.6 96.46,148.27 95.63,146.4 94.03,142.77 91.27,141.94 91.27,141.94 Z M 91.27,141.94")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier121"),
                Cw("none"),
                aL("rgb(70, 37, 16)"),
                jL("M 174.97,46.89 L 86.92,107.42 C 86.82,107.48 86.69,107.57 86.55,107.68 83.93,109.64 75.15,118.24 75.41,129.25 75.11,128.61 74.82,127.97 74.56,127.33 68.02,111.6 72.82,96.6 79.41,88.08 79.08,88.19 78.74,88.31 78.41,88.44 69.88,91.78 61.93,102.61 60.64,107.28 60.42,105.54 60.31,103.85 60.27,102.19 59.88,82.28 71.82,67.69 85.95,58.67 80.6,58.79 73.62,59.99 69.25,62.84 102.07,23.92 160.26,30.3 174.97,46.89 Z M 174.97,46.89")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier122"),
                Cw("none"),
                aL("rgb(53, 28, 12)"),
                jL("M 78.41,88.44 C 69.88,91.78 61.93,102.61 60.64,107.28 60.42,105.54 60.31,103.85 60.27,102.19 66.08,90.55 80.87,82.37 85.57,83.24 82.59,84.38 78.47,88.35 78.47,88.35 78.47,88.35 78.45,88.38 78.41,88.44 Z M 78.41,88.44")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier123"),
                Cw("none"),
                aL("rgb(53, 28, 12)"),
                jL("M 88.06,101.93 C 87.07,104.55 86.59,107.43 86.55,107.68 83.93,109.64 75.15,118.24 75.41,129.25 75.11,128.61 74.82,127.97 74.56,127.33 74.89,112.73 83.03,104.4 88.06,101.93 Z M 88.06,101.93")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier124"),
                Cw("none"),
                aL("rgb(31, 16, 8)"),
                jL("M 169.15,41.39 C 166.21,39.63 162.7,38.08 158.72,36.81 151.08,34.38 142.24,33.15 133.15,33.26 121.52,33.4 109.87,35.76 99.47,40.07 87.37,45.09 77.04,52.61 68.76,62.43 L 65.95,65.76 69.6,63.38 C 73.13,61.07 78.65,59.82 83.52,59.43 79.53,62.2 75.92,65.36 72.81,68.72 68.04,73.87 64.51,79.57 62.31,85.66 59.86,92.47 59.08,99.77 60,107.35 L 60.39,110.55 61.25,107.45 C 61.86,105.28 64.29,101 68.21,96.75 71.3,93.41 74.54,90.92 77.61,89.48 75.51,92.59 73.8,96.18 72.64,99.93 70.5,106.81 69.15,117.53 74.84,129.53 L 76.13,132.25 76.05,129.24 C 75.91,123.25 78.58,118.09 80.84,114.82 83.42,111.09 86.29,108.59 87.27,107.95 L 86.58,106.88 C 84.74,108.06 76.03,115.83 74.89,126.46 70.68,115.86 71.94,106.49 73.86,100.3 76.17,92.84 80.82,86.04 85.7,83 85.7,83 82.4,83.41 79.02,87.54 73.98,89.22 69.57,93.39 67.27,95.89 64.64,98.75 62.35,101.97 61.02,104.62 58.76,72.89 87.38,55.82 105.08,50.67 105.08,50.67 100.23,50.77 94.15,53.44 91.16,54.76 88.29,56.31 85.58,58.05 81.38,58.17 76.22,58.92 72.01,60.68 87.13,44.32 109.22,34.83 133.17,34.54 142.12,34.43 150.82,35.63 158.33,38.02 165.55,40.33 171.14,43.54 174.49,47.31 174.49,47.31 173.71,44.14 169.15,41.39 Z M 169.15,41.39")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier125"),
                Cw("none"),
                aL("rgb(254, 209, 167)"),
                jL("M 197.14,189.89 C 185.63,205.2 149.55,207.65 139.88,207.86 133.84,207.99 120.28,202.26 110.28,194.3 105.7,190.64 101.87,186.53 99.86,182.29 93.79,169.51 99.52,150.19 97.16,141.21 95.87,136.33 95.28,130.64 95.32,125.41 95.35,121.03 95.82,116.96 96.68,113.99 L 122.54,94.39 199.27,93.54 207.37,128.64 C 208.86,135.23 208.65,174.58 197.14,189.89 Z M 197.14,189.89")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier126"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 135.16,200.64 C 135.16,200.64 139.86,205.01 145.62,200.62 144.88,202.93 142.4,204.52 140.37,204.47 137.88,204.4 136,202.48 135.16,200.64 Z M 135.16,200.64")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier127"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 140.27,203.09 C 136.95,202.96 135.24,200.63 135.24,200.63 138.36,202.52 142.35,202.48 145.66,200.52 145.66,200.52 143.62,203.23 140.27,203.09 Z M 140.27,203.09")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier128"),
                Cw("none"),
                aL("rgb(70, 37, 16)"),
                jL("M 181.34,139.15 C 181.34,139.15 173.65,125.68 158.1,131.17 159.39,129.05 166.48,124.54 173.8,128.62 179.41,131.75 181.34,139.15 181.34,139.15 Z M 181.34,139.15")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier129"),
                Cw("none"),
                aL("rgb(255, 255, 255)"),
                jL("M 154.57,164.56 C 154.57,164.56 152.66,152.8 161.65,145.74 169.03,139.94 176.42,144.25 176.38,153.97 176.34,162.09 171.37,168.09 154.57,164.56 Z M 154.57,164.56")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier130"),
                Cw("none"),
                aL("rgb(229, 229, 229)"),
                jL("M 161.65,145.74 C 152.66,152.8 154.57,164.56 154.57,164.56 155.36,161.33 156.07,159.22 157.01,156.96 159.98,149.9 166.77,145.01 172.58,148.45 175.59,150.31 176.23,156.75 174.08,160.76 174.77,159.15 176.38,158.11 176.38,153.97 176.37,144.25 169.03,139.94 161.65,145.74 Z M 161.65,145.74")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval7"),
                Cw("none"),
                aL("rgb(96, 75, 59)"),
                TL("166.2"),
                IL("157.57"),
                GZ("6.65"),
                Ox("7.4")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier131"),
                Cw("none"),
                aL("rgb(72, 56, 44)"),
                jL("M 163.55,152.72 C 161.96,153.04 160.64,153.81 159.58,154.91 160.5,151.81 163.1,149.56 166.17,149.56 169.53,149.56 172.33,152.25 172.96,155.82 171.09,152.65 167.04,151.98 163.55,152.72 Z M 163.55,152.72")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier132"),
                Cw("none"),
                aL("rgb(191, 183, 177)"),
                jL("M 169.22,157.52 C 169.22,157.52 171.82,157.91 170.64,160.77 169.47,163.64 165.28,164.78 162.77,162.5 160.25,160.22 161.34,157.56 162.75,157.48 164.16,157.41 169.22,157.52 169.22,157.52 Z M 169.22,157.52")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier133"),
                Cw("none"),
                aL("rgb(48, 38, 30)"),
                jL("M 159.73,157.35 C 159.73,161.35 162.61,164.59 166.17,164.59 169.72,164.59 172.61,161.35 172.61,157.35 172.61,153.36 169.72,150.12 166.17,150.12 162.61,150.12 159.73,153.36 159.73,157.35 Z M 158.74,157.35 C 158.74,152.75 162.07,149.01 166.17,149.01 170.26,149.01 173.59,152.75 173.59,157.35 173.59,161.95 170.26,165.7 166.17,165.7 162.07,165.7 158.74,161.95 158.74,157.35 Z M 158.74,157.35")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval8"),
                Cw("none"),
                aL("rgb(26, 26, 26)"),
                TL("166.25"),
                IL("157.52"),
                GZ("4.4"),
                Ox("4.75")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval9"),
                Cw("none"),
                aL("rgb(255, 255, 255)"),
                TL("-0"),
                IL("0"),
                GZ("1.67"),
                Ox("1.88"),
                Ew("translate(163.6, 154.69) rotate(0.05)")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval10"),
                Cw("none"),
                aL("rgb(255, 255, 255)"),
                TL("168.2"),
                IL("160.77"),
                GZ("0.85"),
                Ox("1.05")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier134"),
                Cw("none"),
                aL("rgb(81, 33, 15)"),
                jL("M 161.99,146.17 C 154.25,152.25 154.86,162.07 155.07,164.1 158.15,164.72 160.92,165.04 163.32,165.04 L 163.32,165.04 C 171.59,165.04 175.79,161.32 175.82,153.97 175.84,150.45 174.84,147.49 173,145.65 171.71,144.36 170.08,143.68 168.27,143.68 166.24,143.68 164.07,144.54 161.99,146.17 Z M 154.46,165.1 L 154.09,165.02 154.03,164.65 C 154.01,164.52 153.54,161.57 154.19,157.7 154.8,154.12 156.52,149.06 161.3,145.31 163.58,143.52 165.99,142.57 168.27,142.57 170.38,142.57 172.28,143.37 173.78,144.87 175.83,146.92 176.95,150.16 176.93,153.98 176.89,161.94 172.19,166.14 163.32,166.14 L 163.32,166.14 C 160.74,166.14 157.76,165.79 154.46,165.1 Z M 154.46,165.1")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier135"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 177.77,144.82 C 177.77,144.82 172.46,137.42 164.56,139.71 159.2,141.26 156.4,146.84 156.4,146.84 156.4,146.84 165.88,133.51 177.77,144.82 Z M 177.77,144.82")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier136"),
                Cw("none"),
                aL("rgb(70, 37, 16)"),
                jL("M 103.45,140.92 C 103.45,140.92 106.53,128.25 121.88,131.84 120.83,128.66 113,125.93 107.05,132.3 102.77,136.88 103.45,140.92 103.45,140.92 Z M 103.45,140.92")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier137"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 105.38,148.82 C 105.38,148.82 107.1,139 116.22,140.75 122.91,142.04 124.12,147.51 124.12,147.51 122.48,142.42 109.94,136.38 105.38,148.82 Z M 105.38,148.82")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval11"),
                Cw("none"),
                aL("rgb(191, 133, 108)"),
                TL("109.35"),
                IL("170.37"),
                GZ("0.9"),
                Ox("0.5")
            ]), M),
            A2(EL, l([
                uw("canvas2-oval12"),
                Cw("none"),
                aL("rgb(191, 133, 108)"),
                TL("114.75"),
                IL("170.42"),
                sw("0.75")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval13"),
                Cw("none"),
                aL("rgb(191, 133, 108)"),
                TL("120.2"),
                IL("171.17"),
                GZ("0.5"),
                Ox("0.9")
            ]), M),
            A2(EL, l([
                uw("canvas2-oval14"),
                Cw("none"),
                aL("rgb(191, 133, 108)"),
                TL("117.6"),
                IL("173.42"),
                sw("0.55")
            ]), M),
            A2(EL, l([
                uw("canvas2-oval15"),
                Cw("none"),
                aL("rgb(191, 133, 108)"),
                TL("111.55"),
                IL("174.87"),
                sw("0.55")
            ]), M),
            A2(EL, l([
                uw("canvas2-oval16"),
                Cw("none"),
                aL("rgb(191, 133, 108)"),
                TL("113.95"),
                IL("173.02"),
                sw("0.75")
            ]), M),
            A2(tw, l([
                uw("canvas2-group2"),
                Dw("url(#canvas2-clip)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip")
                ]), l([
                    A2(bw, l([
                        jL("M 116.9,181.66 C 115.76,181.66 114.57,181.56 113.36,181.36 106.17,180.18 100.95,175.75 101.71,171.48 102.33,167.93 106.88,165.6 112.53,165.6 113.68,165.6 114.87,165.7 116.08,165.9 123.26,167.08 128.48,171.51 127.73,175.78 127.1,179.33 122.55,181.66 116.9,181.66 Z M 111.1,174.06 C 110.86,174.06 110.67,174.24 110.67,174.47 110.67,174.7 110.86,174.88 111.1,174.88 111.33,174.88 111.52,174.7 111.52,174.47 111.52,174.24 111.33,174.06 111.1,174.06 Z M 113.55,172.54 C 113.23,172.54 112.98,172.79 112.98,173.09 112.98,173.4 113.23,173.65 113.55,173.65 113.86,173.65 114.11,173.4 114.11,173.09 114.11,172.79 113.86,172.54 113.55,172.54 Z M 117.34,172.61 C 117.11,172.61 116.92,172.8 116.92,173.03 116.92,173.25 117.11,173.44 117.34,173.44 117.58,173.44 117.77,173.25 117.77,173.03 117.77,172.8 117.58,172.61 117.34,172.61 Z M 119.86,170.44 C 119.47,170.44 119.15,170.75 119.15,171.13 119.15,171.51 119.47,171.82 119.86,171.82 120.25,171.82 120.57,171.51 120.57,171.13 120.57,170.75 120.25,170.44 119.86,170.44 Z M 114.36,170.03 C 114.05,170.03 113.8,170.28 113.8,170.58 113.8,170.89 114.05,171.13 114.36,171.13 114.68,171.13 114.93,170.89 114.93,170.58 114.93,170.28 114.68,170.03 114.36,170.03 Z M 109.4,169.72 C 109,169.72 108.69,170.03 108.69,170.41 108.69,170.79 109,171.1 109.4,171.1 109.79,171.1 110.11,170.79 110.11,170.41 110.11,170.03 109.79,169.72 109.4,169.72 Z M 109.4,169.72")
                    ]), M)
                ])),
                A2(bw, l([
                    uw("canvas2-bezier138"),
                    _L("evenodd"),
                    Cw("none"),
                    aL("url(#canvas2-gradient7-bezier138)"),
                    jL("M 116.9,181.66 C 115.76,181.66 114.57,181.56 113.36,181.36 106.17,180.18 100.95,175.75 101.71,171.48 102.33,167.93 106.88,165.6 112.53,165.6 113.68,165.6 114.87,165.7 116.08,165.9 123.26,167.08 128.48,171.51 127.73,175.78 127.1,179.33 122.55,181.66 116.9,181.66 Z M 111.1,174.06 C 110.86,174.06 110.67,174.24 110.67,174.47 110.67,174.7 110.86,174.88 111.1,174.88 111.33,174.88 111.52,174.7 111.52,174.47 111.52,174.24 111.33,174.06 111.1,174.06 Z M 113.55,172.54 C 113.23,172.54 112.98,172.79 112.98,173.09 112.98,173.4 113.23,173.65 113.55,173.65 113.86,173.65 114.11,173.4 114.11,173.09 114.11,172.79 113.86,172.54 113.55,172.54 Z M 117.34,172.61 C 117.11,172.61 116.92,172.8 116.92,173.03 116.92,173.25 117.11,173.44 117.34,173.44 117.58,173.44 117.77,173.25 117.77,173.03 117.77,172.8 117.58,172.61 117.34,172.61 Z M 119.86,170.44 C 119.47,170.44 119.15,170.75 119.15,171.13 119.15,171.51 119.47,171.82 119.86,171.82 120.25,171.82 120.57,171.51 120.57,171.13 120.57,170.75 120.25,170.44 119.86,170.44 Z M 114.36,170.03 C 114.05,170.03 113.8,170.28 113.8,170.58 113.8,170.89 114.05,171.13 114.36,171.13 114.68,171.13 114.93,170.89 114.93,170.58 114.93,170.28 114.68,170.03 114.36,170.03 Z M 109.4,169.72 C 109,169.72 108.69,170.03 108.69,170.41 108.69,170.79 109,171.1 109.4,171.1 109.79,171.1 110.11,170.79 110.11,170.41 110.11,170.03 109.79,169.72 109.4,169.72 Z M 109.4,169.72")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group3"),
                Dw("url(#canvas2-clip2)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip2")
                ]), l([
                    A2(kx, l([
                        TL("109.35"),
                        IL("170.37"),
                        GZ("0.9"),
                        Ox("0.5")
                    ]), M)
                ])),
                A2(kx, l([
                    uw("canvas2-oval17"),
                    Cw("none"),
                    aL("url(#canvas2-gradient8-oval17)"),
                    TL("109.35"),
                    IL("170.37"),
                    GZ("0.9"),
                    Ox("0.5")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group4"),
                Dw("url(#canvas2-clip3)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip3")
                ]), l([
                    A2(EL, l([
                        TL("114.75"),
                        IL("170.42"),
                        sw("0.75")
                    ]), M)
                ])),
                A2(EL, l([
                    uw("canvas2-oval19"),
                    Cw("none"),
                    aL("url(#canvas2-gradient8-oval19)"),
                    TL("114.75"),
                    IL("170.42"),
                    sw("0.75")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group5"),
                Dw("url(#canvas2-clip4)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip4")
                ]), l([
                    A2(kx, l([
                        TL("120.2"),
                        IL("171.17"),
                        GZ("0.5"),
                        Ox("0.9")
                    ]), M)
                ])),
                A2(kx, l([
                    uw("canvas2-oval21"),
                    Cw("none"),
                    aL("url(#canvas2-gradient8-oval21)"),
                    TL("120.2"),
                    IL("171.17"),
                    GZ("0.5"),
                    Ox("0.9")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group6"),
                Dw("url(#canvas2-clip5)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip5")
                ]), l([
                    A2(EL, l([
                        TL("117.6"),
                        IL("173.42"),
                        sw("0.55")
                    ]), M)
                ])),
                A2(EL, l([
                    uw("canvas2-oval23"),
                    Cw("none"),
                    aL("url(#canvas2-gradient8-oval23)"),
                    TL("117.6"),
                    IL("173.42"),
                    sw("0.55")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group7"),
                Dw("url(#canvas2-clip6)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip6")
                ]), l([
                    A2(EL, l([
                        TL("111.55"),
                        IL("174.87"),
                        sw("0.55")
                    ]), M)
                ])),
                A2(EL, l([
                    uw("canvas2-oval25"),
                    Cw("none"),
                    aL("url(#canvas2-gradient8-oval25)"),
                    TL("111.55"),
                    IL("174.87"),
                    sw("0.55")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group8"),
                Dw("url(#canvas2-clip7)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip7")
                ]), l([
                    A2(EL, l([
                        TL("113.95"),
                        IL("173.02"),
                        sw("0.75")
                    ]), M)
                ])),
                A2(EL, l([
                    uw("canvas2-oval27"),
                    Cw("none"),
                    aL("url(#canvas2-gradient8-oval27)"),
                    TL("113.95"),
                    IL("173.02"),
                    sw("0.75")
                ]), M)
            ])),
            A2(EL, l([
                uw("canvas2-oval29"),
                Cw("none"),
                aL("rgb(191, 133, 108)"),
                TL("175.3"),
                IL("170.32"),
                sw("0.9")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval30"),
                Cw("none"),
                aL("rgb(191, 133, 108)"),
                TL("168.75"),
                IL("174.47"),
                GZ("0.75"),
                Ox("0.5")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval31"),
                Cw("none"),
                aL("rgb(191, 133, 108)"),
                TL("164.65"),
                IL("171.52"),
                GZ("0.5"),
                Ox("0.9")
            ]), M),
            A2(EL, l([
                uw("canvas2-oval32"),
                Cw("none"),
                aL("rgb(191, 133, 108)"),
                TL("168.85"),
                IL("172.02"),
                sw("0.55")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval33"),
                Cw("none"),
                aL("rgb(191, 133, 108)"),
                TL("172"),
                IL("173.02"),
                GZ("0.55"),
                Ox("0.5")
            ]), M),
            A2(EL, l([
                uw("canvas2-oval34"),
                Cw("none"),
                aL("rgb(191, 133, 108)"),
                TL("171.05"),
                IL("169.07"),
                sw("0.75")
            ]), M),
            A2(tw, l([
                uw("canvas2-group9"),
                Dw("url(#canvas2-clip8)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip8")
                ]), l([
                    A2(bw, l([
                        jL("M 170.49,181.6 C 163.82,181.6 158.43,178.51 158.12,174.32 157.85,170.57 161.75,167.1 167.3,165.73 167.91,165.64 168.5,165.52 169.06,165.38 169.66,165.28 170.27,165.21 170.89,165.17 171.43,165.13 171.96,165.11 172.48,165.11 179.15,165.11 184.54,168.2 184.85,172.39 185.17,176.91 179.46,181.01 172.08,181.54 171.54,181.58 171.01,181.6 170.49,181.6 Z M 169.15,174.16 C 168.83,174.16 168.57,174.42 168.57,174.74 168.57,175.06 168.83,175.32 169.15,175.32 169.46,175.32 169.72,175.06 169.72,174.74 169.72,174.42 169.46,174.16 169.15,174.16 Z M 173.07,172.94 C 172.83,172.94 172.64,173.13 172.64,173.37 172.64,173.61 172.83,173.8 173.07,173.8 173.31,173.8 173.5,173.61 173.5,173.37 173.5,173.13 173.31,172.94 173.07,172.94 Z M 165.04,170.53 C 164.64,170.53 164.32,170.85 164.32,171.25 164.32,171.64 164.64,171.97 165.04,171.97 165.44,171.97 165.76,171.64 165.76,171.25 165.76,170.85 165.44,170.53 165.04,170.53 Z M 169.4,170.99 C 169.16,170.99 168.96,171.19 168.96,171.43 168.96,171.67 169.16,171.86 169.4,171.86 169.64,171.86 169.83,171.67 169.83,171.43 169.83,171.19 169.64,170.99 169.4,170.99 Z M 175.66,169.77 C 175.27,169.77 174.94,170.09 174.94,170.49 174.94,170.89 175.27,171.21 175.66,171.21 176.06,171.21 176.38,170.89 176.38,170.49 176.38,170.09 176.06,169.77 175.66,169.77 Z M 171.74,168.55 C 171.42,168.55 171.16,168.81 171.16,169.12 171.16,169.44 171.42,169.7 171.74,169.7 172.06,169.7 172.31,169.44 172.31,169.12 172.31,168.81 172.06,168.55 171.74,168.55 Z M 171.74,168.55")
                    ]), M)
                ])),
                A2(bw, l([
                    uw("canvas2-bezier140"),
                    _L("evenodd"),
                    Cw("none"),
                    aL("url(#canvas2-gradient7-bezier140)"),
                    jL("M 170.49,181.6 C 163.82,181.6 158.43,178.51 158.12,174.32 157.85,170.57 161.75,167.1 167.3,165.73 167.91,165.64 168.5,165.52 169.06,165.38 169.66,165.28 170.27,165.21 170.89,165.17 171.43,165.13 171.96,165.11 172.48,165.11 179.15,165.11 184.54,168.2 184.85,172.39 185.17,176.91 179.46,181.01 172.08,181.54 171.54,181.58 171.01,181.6 170.49,181.6 Z M 169.15,174.16 C 168.83,174.16 168.57,174.42 168.57,174.74 168.57,175.06 168.83,175.32 169.15,175.32 169.46,175.32 169.72,175.06 169.72,174.74 169.72,174.42 169.46,174.16 169.15,174.16 Z M 173.07,172.94 C 172.83,172.94 172.64,173.13 172.64,173.37 172.64,173.61 172.83,173.8 173.07,173.8 173.31,173.8 173.5,173.61 173.5,173.37 173.5,173.13 173.31,172.94 173.07,172.94 Z M 165.04,170.53 C 164.64,170.53 164.32,170.85 164.32,171.25 164.32,171.64 164.64,171.97 165.04,171.97 165.44,171.97 165.76,171.64 165.76,171.25 165.76,170.85 165.44,170.53 165.04,170.53 Z M 169.4,170.99 C 169.16,170.99 168.96,171.19 168.96,171.43 168.96,171.67 169.16,171.86 169.4,171.86 169.64,171.86 169.83,171.67 169.83,171.43 169.83,171.19 169.64,170.99 169.4,170.99 Z M 175.66,169.77 C 175.27,169.77 174.94,170.09 174.94,170.49 174.94,170.89 175.27,171.21 175.66,171.21 176.06,171.21 176.38,170.89 176.38,170.49 176.38,170.09 176.06,169.77 175.66,169.77 Z M 171.74,168.55 C 171.42,168.55 171.16,168.81 171.16,169.12 171.16,169.44 171.42,169.7 171.74,169.7 172.06,169.7 172.31,169.44 172.31,169.12 172.31,168.81 172.06,168.55 171.74,168.55 Z M 171.74,168.55")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group10"),
                Dw("url(#canvas2-clip9)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip9")
                ]), l([
                    A2(bw, l([
                        jL("M 166.59,166.22 C 167.07,165.85 167.57,165.55 168.08,165.3 167.61,165.67 167.11,165.98 166.59,166.22 Z M 166.59,166.22")
                    ]), M)
                ])),
                A2(bw, l([
                    uw("canvas2-bezier142"),
                    _L("evenodd"),
                    Cw("none"),
                    aL("url(#canvas2-gradient9-bezier142)"),
                    jL("M 166.59,166.22 C 167.07,165.85 167.57,165.55 168.08,165.3 167.61,165.67 167.11,165.98 166.59,166.22 Z M 166.59,166.22")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group11"),
                Dw("url(#canvas2-clip10)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip10")
                ]), l([
                    A2(EL, l([
                        TL("175.3"),
                        IL("170.32"),
                        sw("0.9")
                    ]), M)
                ])),
                A2(EL, l([
                    uw("canvas2-oval35"),
                    Cw("none"),
                    aL("url(#canvas2-gradient8-oval35)"),
                    TL("175.3"),
                    IL("170.32"),
                    sw("0.9")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group12"),
                Dw("url(#canvas2-clip11)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip11")
                ]), l([
                    A2(kx, l([
                        TL("168.75"),
                        IL("174.47"),
                        GZ("0.75"),
                        Ox("0.5")
                    ]), M)
                ])),
                A2(kx, l([
                    uw("canvas2-oval37"),
                    Cw("none"),
                    aL("url(#canvas2-gradient8-oval37)"),
                    TL("168.75"),
                    IL("174.47"),
                    GZ("0.75"),
                    Ox("0.5")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group13"),
                Dw("url(#canvas2-clip12)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip12")
                ]), l([
                    A2(kx, l([
                        TL("164.65"),
                        IL("171.52"),
                        GZ("0.5"),
                        Ox("0.9")
                    ]), M)
                ])),
                A2(kx, l([
                    uw("canvas2-oval39"),
                    Cw("none"),
                    aL("url(#canvas2-gradient8-oval39)"),
                    TL("164.65"),
                    IL("171.52"),
                    GZ("0.5"),
                    Ox("0.9")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group14"),
                Dw("url(#canvas2-clip13)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip13")
                ]), l([
                    A2(EL, l([
                        TL("168.85"),
                        IL("172.02"),
                        sw("0.55")
                    ]), M)
                ])),
                A2(EL, l([
                    uw("canvas2-oval41"),
                    Cw("none"),
                    aL("url(#canvas2-gradient8-oval41)"),
                    TL("168.85"),
                    IL("172.02"),
                    sw("0.55")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group15"),
                Dw("url(#canvas2-clip14)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip14")
                ]), l([
                    A2(kx, l([
                        TL("172"),
                        IL("173.02"),
                        GZ("0.55"),
                        Ox("0.5")
                    ]), M)
                ])),
                A2(kx, l([
                    uw("canvas2-oval43"),
                    Cw("none"),
                    aL("url(#canvas2-gradient8-oval43)"),
                    TL("172"),
                    IL("173.02"),
                    GZ("0.55"),
                    Ox("0.5")
                ]), M)
            ])),
            A2(tw, l([
                uw("canvas2-group16"),
                Dw("url(#canvas2-clip15)")
            ]), l([
                A2($w, l([
                    uw("canvas2-clip15")
                ]), l([
                    A2(EL, l([
                        TL("171.05"),
                        IL("169.07"),
                        sw("0.75")
                    ]), M)
                ])),
                A2(EL, l([
                    uw("canvas2-oval45"),
                    Cw("none"),
                    aL("url(#canvas2-gradient8-oval45)"),
                    TL("171.05"),
                    IL("169.07"),
                    sw("0.75")
                ]), M)
            ])),
            A2(bw, l([
                uw("canvas2-bezier144"),
                Cw("none"),
                aL("rgb(255, 255, 255)"),
                jL("M 126.38,165.49 C 126.38,165.49 127.18,151.35 120.12,146.5 113.06,141.64 105.69,147.19 107.45,155.32 108.44,159.87 111.47,170.4 126.38,165.49 Z M 126.38,165.49")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier145"),
                Cw("none"),
                aL("rgb(229, 229, 229)"),
                jL("M 120.12,146.5 C 116.89,144.28 112.11,143.86 108.88,147.51 111.5,145.58 115.57,145.97 117.13,147.37 122.08,151.67 126.24,158.9 120.43,164.12 116.08,165.02 111.96,164.33 109.25,160.65 111.46,164.92 116.1,168.87 126.38,165.49 126.38,165.49 127.18,151.35 120.12,146.5 Z M 120.12,146.5")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval47"),
                Cw("none"),
                aL("rgb(96, 75, 59)"),
                TL("119.35"),
                IL("158.52"),
                GZ("6.6"),
                Ox("8")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier146"),
                Cw("none"),
                aL("rgb(72, 56, 44)"),
                jL("M 112.4,156.64 C 112.4,156.64 119.03,150.31 125.27,155.89 124.63,153.2 123.06,149.64 118.17,150.41 113.19,151.2 112.4,156.64 112.4,156.64 Z M 112.4,156.64")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier147"),
                Cw("none"),
                aL("rgb(48, 38, 30)"),
                jL("M 119.21,150.99 C 115.79,150.99 113,154.31 113,158.38 113,162.45 115.79,165.77 119.21,165.77 122.63,165.77 125.41,162.45 125.41,158.38 125.41,154.31 122.63,150.99 119.21,150.99 Z M 119.21,166.84 C 115.19,166.84 111.93,163.04 111.93,158.38 111.93,153.71 115.19,149.92 119.21,149.92 123.22,149.92 126.49,153.71 126.49,158.38 126.49,163.04 123.22,166.84 119.21,166.84 Z M 119.21,166.84")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier148"),
                Cw("none"),
                aL("rgb(191, 183, 177)"),
                jL("M 115.64,159.86 C 115.64,159.86 114.19,159.27 114.62,161.2 115.05,163.14 117.09,165.36 120.54,164.59 123.39,163.94 125.81,159.43 123.57,158.72 122.98,160.76 115.64,159.86 115.64,159.86 Z M 115.64,159.86")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval48"),
                Cw("none"),
                aL("rgb(26, 26, 26)"),
                TL("-0"),
                IL("-0"),
                GZ("4.18"),
                Ox("4.7"),
                Ew("translate(119.39, 158.66) rotate(-3.25)")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval49"),
                Cw("none"),
                aL("rgb(255, 255, 255)"),
                TL("116.65"),
                IL("155.57"),
                GZ("2.05"),
                Ox("1.9")
            ]), M),
            A2(kx, l([
                uw("canvas2-oval50"),
                Cw("none"),
                aL("rgb(255, 255, 255)"),
                TL("-0"),
                IL("-0"),
                GZ("1.2"),
                Ox("1.35"),
                Ew("translate(121.89, 162.07) rotate(-0.05)")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier149"),
                Cw("none"),
                aL("rgb(81, 33, 15)"),
                jL("M 114.75,145.22 C 112.65,145.22 110.77,146.12 109.45,147.74 107.9,149.66 107.36,152.38 107.98,155.2 108.57,157.93 110.36,166.23 119.36,166.23 L 119.36,166.23 C 121.29,166.23 123.48,165.85 125.85,165.1 125.91,162.87 125.92,151.14 119.81,146.94 118.18,145.81 116.43,145.22 114.75,145.22 Z M 119.36,167.3 L 119.36,167.3 C 115.32,167.3 112.14,165.77 109.93,162.76 108.13,160.31 107.35,157.4 106.92,155.43 106.24,152.29 106.86,149.24 108.61,147.07 110.12,145.21 112.35,144.15 114.75,144.15 116.64,144.15 118.61,144.81 120.42,146.06 127.65,151.02 126.95,164.93 126.91,165.52 L 126.89,165.89 126.55,166 C 123.92,166.86 121.5,167.3 119.36,167.3 Z M 119.36,167.3")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier150"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 130.58,173.28 C 130.58,173.28 134.2,179.47 139.22,174.36 143.08,170.44 138.22,166.7 138.22,166.7 139.94,167.59 143.46,172.1 141.95,175.57 141.02,177.72 140.19,178.54 137.68,178.83 135.17,179.11 131.62,177.07 130.58,173.28 Z M 130.58,173.28")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier151"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 136.93,178.08 C 135.67,178.08 134.42,177.9 133.35,177.49 130.43,176.39 129.18,174.01 129.83,170.78 130.38,168.07 132.55,166.14 135.35,165.81 140.01,165.27 140.95,169.93 140.95,169.93 140,167.81 137.85,166.61 135.47,166.88 133.61,167.08 131.44,168.27 130.89,171 130.2,174.39 132.05,175.86 133.73,176.49 136.97,177.71 141.29,176.67 142.05,175.35 142.05,175.35 140.8,177.86 136.93,178.08 Z M 136.93,178.08")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier152"),
                Cw("none"),
                aL("rgb(88, 9, 13)"),
                jL("M 158.42,179.65 C 155.04,184.01 153.32,190.39 149.9,194.67 147.73,197.39 144.88,199.26 140.49,199.26 135.95,199.26 133.82,198.09 132.25,195.48 131.51,194.26 130.9,192.71 130.23,190.82 128.17,185.03 126.02,183.42 125.58,183.14 128.28,184.66 143.16,188.29 158.42,179.65 Z M 158.42,179.65")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier153"),
                Cw("none"),
                aL("rgb(66, 7, 10)"),
                jL("M 147.86,196.77 C 146.29,197.49 144.4,197.9 142.35,197.9 137,197.9 132.67,195.04 132.67,191.5 132.67,187.96 137,185.09 142.35,185.09 147.66,185.09 151.98,187.92 152.04,191.42 L 147.86,196.77 Z M 147.86,196.77")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier154"),
                Cw("none"),
                aL("rgb(255, 102, 102)"),
                jL("M 149.84,195.07 C 147.68,197.78 144.83,199.66 140.43,199.66 135.9,199.66 133.76,198.48 132.2,195.88 132.14,195.69 132.43,195.19 132.97,194.61 134.58,192.86 138.33,190.39 140.92,193.4 145.6,190.66 148.35,191.42 149.65,193.97 149.71,194.1 149.77,194.23 149.83,194.36 149.85,194.57 149.86,194.81 149.84,195.07 Z M 149.84,195.07")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier155"),
                Cw("none"),
                aL("rgb(234, 92, 92)"),
                jL("M 149.65,193.97 C 148.18,192.13 145.19,191.53 142.21,193.49 140.26,194.77 139.49,198.21 139.49,198.21 139.49,198.21 139.14,196.63 139.76,195.13 140.38,193.63 140.14,193.36 138.44,192.79 136.79,192.24 133.7,194.1 132.97,194.61 134.58,192.86 138.33,190.39 140.92,193.4 145.6,190.66 148.35,191.42 149.65,193.97 Z M 149.65,193.97")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier156"),
                Cw("none"),
                aL("rgb(255, 255, 255)"),
                jL("M 130.32,184.55 C 130.32,184.55 129.71,188.13 137.76,188.6 141.22,188.8 151.89,187.81 153.04,182.23 148.93,183.65 140.86,186.49 130.32,184.55 Z M 130.32,184.55")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier157"),
                Cw("none"),
                aL("rgb(204, 204, 204)"),
                jL("M 153.04,182.23 C 148.93,183.65 140.86,186.49 130.32,184.55 130.32,184.55 130.04,186.22 132.41,187.42 131.99,186.77 132.22,186.06 132.53,186.09 137.69,186.67 143.57,186.09 149.7,184.7 149.83,184.67 150.42,184.98 149.81,186.15 151.46,185.2 152.69,183.93 153.04,182.23 Z M 153.04,182.23")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier158"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 127.67,184.5 C 128.57,185.71 129.66,187.62 130.74,190.64 132.83,196.51 134.21,198.73 140.49,198.73 148.06,198.73 150.82,192.95 153.75,186.84 154.66,184.92 155.61,182.95 156.72,181.17 149.23,184.92 142.17,185.74 137.42,185.74 133.32,185.74 129.9,185.15 127.67,184.5 Z M 140.49,199.8 C 133.58,199.8 131.9,197.12 129.72,191 127.69,185.28 125.57,183.77 125.29,183.59 125.27,183.58 125.24,183.56 125.22,183.55 L 125.74,182.61 C 125.74,182.61 125.78,182.63 125.85,182.67 127.01,183.33 131.34,184.67 137.42,184.67 142.46,184.67 150.15,183.72 158.15,179.18 L 160.27,178.03 158.85,179.98 C 157.21,182.08 155.94,184.74 154.72,187.31 151.78,193.45 148.74,199.8 140.49,199.8 Z M 140.49,199.8")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier159"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 122.74,184.18 C 122.74,184.18 126.36,184.81 126.57,180.78 125.86,182.34 123.76,184.13 122.74,184.18 Z M 122.74,184.18")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier160"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 159.18,175.83 C 159.18,175.83 158.37,179.24 162.42,179.87 160.88,178.94 159.35,176.93 159.18,175.83 Z M 159.18,175.83")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier161"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 197.14,189.89 C 185.63,205.2 149.55,207.65 139.88,207.86 133.84,207.99 120.28,202.26 110.28,194.3 119.43,200.27 133.71,206.58 140.57,206.25 149.59,205.83 169.91,202.9 184.12,194.77 198.33,186.64 200.13,165.84 199.28,156.01 198.43,146.18 193.5,115.93 188.39,112.14 167.83,120.08 140.64,113.28 136.56,109.97 136.66,109.69 154.09,101.93 154,99.48 131.45,101.46 107.67,122.64 101.11,131.12 100.9,127.21 102.27,116.11 102.56,113.85 101.12,114.92 97.98,118.88 95.32,125.41 95.35,121.03 95.82,116.96 96.68,113.99 L 122.54,94.39 199.27,93.54 207.37,128.64 C 208.86,135.23 208.65,174.58 197.14,189.89 Z M 197.14,189.89")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier162"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 206.74,128.92 C 207.46,132.1 207.79,143.59 206.49,156.07 205.37,166.9 202.74,181.51 196.62,189.65 191.8,196.06 182.06,200.91 167.68,204.06 154.61,206.92 142.22,207.31 139.87,207.36 139.8,207.37 139.74,207.37 139.67,207.37 131.01,207.37 106.71,195.38 100.43,182.16 96.84,174.58 97.47,164.63 98.03,155.85 98.41,149.94 98.74,144.84 97.77,141.19 95.53,132.67 95.32,121.11 97.3,114.31 L 96.07,113.95 C 94.04,120.95 94.24,132.8 96.54,141.52 97.45,144.97 97.11,150.21 96.76,155.77 96.19,164.7 95.54,174.83 99.28,182.7 103.21,190.99 113.1,197.65 118.64,200.89 126.62,205.55 135.03,208.64 139.68,208.64 139.75,208.64 139.82,208.64 139.89,208.64 142.27,208.59 154.77,208.19 167.95,205.31 182.65,202.09 192.64,197.08 197.65,190.41 203.94,182.04 206.62,167.19 207.76,156.2 209.09,143.42 208.75,131.98 207.99,128.64 L 206.74,128.92 Z M 206.74,128.92")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier163"),
                Cw("none"),
                aL("rgb(70, 37, 16)"),
                jL("M 113.07,101.6 C 108.57,103.04 104.49,107.04 101.2,111.43 96.38,117.87 95.14,123.79 95.02,125.14 L 95.4,128.34 C 94.93,131.77 95.87,135.12 96.64,138.46 90.64,132.14 87.6,124.59 86.82,116.96 85.36,102.59 91.94,87.95 101.99,80.76 L 113.07,101.6 Z M 113.07,101.6")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier164"),
                Cw("none"),
                aL("rgb(102, 52, 25)"),
                jL("M 184.03,38.6 C 168.78,31.22 142.15,26.5 124.44,32.55 147.74,31.7 169.06,35.01 177.68,46.44 176.45,40.96 163.66,33.96 157.12,33.11 167.07,32.17 182.23,37.93 184.03,38.6 Z M 184.03,38.6")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier165"),
                Cw("none"),
                aL("rgb(102, 52, 25)"),
                jL("M 81.19,54.76 C 95.04,45.19 133.83,23.07 172.62,49.44 155.57,42.85 129.18,43.8 123.78,45.97 146.04,47.1 170.39,55.05 174.27,59.11 141.3,59.02 122.73,62.89 118.38,66.58 131.54,63.18 149.73,64.31 154.85,64.97 138.84,65.26 104.42,84.11 94.83,109.85 94.83,94.32 107.48,76.6 126.05,69.98 115.82,68.47 93.56,81.52 85.98,92.2 92.04,77.17 106.55,55.4 147.26,55.82 113.58,52.42 82.89,70.5 76.71,77.94 83.99,66.11 101.23,55.14 128.13,50.79 117.9,48.15 100.94,49.37 99.81,50.22 107.77,45.21 133.82,39.26 146.32,41.91 121.69,36.52 87.01,49.94 81.19,54.76 Z M 81.19,54.76")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier166"),
                Cw("none"),
                aL("rgb(53, 28, 12)"),
                jL("M 103.31,105.34 C 103.31,105.34 101.61,110.25 101.32,111.01 101.3,111.06 101.26,111.21 101.2,111.43 96.38,117.87 95.24,123.08 95.13,124.43 L 95.4,128.34 C 94.93,131.77 95.87,135.12 96.64,138.46 90.64,132.14 87.6,124.59 86.82,116.96 86.82,116.93 86.83,116.9 86.83,116.87 86.83,118.67 89.58,124.62 92.61,125.85 91.85,122.07 95.17,110.63 103.31,105.34 Z M 103.31,105.34")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier167"),
                Cw("none"),
                aL("rgb(31, 16, 8)"),
                jL("M 87.31,110.83 C 87.93,98.97 93.84,87.37 102.36,81.28 102.36,81.28 98.51,82.34 94.83,86.83 93.27,88.73 91.95,90.9 90.77,93.2 87.99,98.63 86.35,104.7 86.04,110.76 85.46,121.78 89.24,131.87 96.72,139.46 L 96.06,136.87 C 89.88,129.76 86.8,120.68 87.31,110.83 Z M 87.31,110.83")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier168"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 96.24,119.98 L 94.76,122.52 C 94.44,128.43 94.98,135.19 96.35,140.78 L 97.69,140.84 C 96.05,134.44 95.55,126.42 96.24,119.98 Z M 96.24,119.98")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier169"),
                Cw("none"),
                aL("rgb(31, 16, 8)"),
                jL("M 113.27,102.21 L 112.88,101 C 105.71,103.29 99.46,111.73 95.98,118.41 93.6,122.98 93.95,125.98 93.95,125.98 94.48,124.25 96.48,119.67 99.58,114.88 102.67,110.11 107.55,104.04 113.27,102.21 Z M 113.27,102.21")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier170"),
                Cw("none"),
                aL("rgb(70, 37, 16)"),
                jL("M 218.32,152.04 C 212.18,155.92 209.91,164.15 206.31,168.78 205.97,169.22 205.62,169.63 205.25,170 205.25,169.62 205.24,169.24 205.23,168.84 205.13,165.69 204.64,161.85 203.67,157.75 201.98,150.66 198.84,142.8 193.78,136.44 188.63,129.95 187.42,121.28 188.62,113.37 189.06,110.5 189.81,107.73 190.81,105.21 174.3,113.59 144.89,114.16 136.3,109.59 135.62,109.23 135.07,108.83 134.67,108.41 141.54,107.08 150.66,101.69 156.42,97.06 L 156.3,97.06 C 131.28,97.07 104.64,119.45 101.28,128.69 101.25,128.53 101.22,128.37 101.2,128.21 96.41,98.86 119.85,81.17 139.5,78.35 L 203.8,92.46 C 203.13,93.11 211.12,124.35 215.52,141.32 217.17,147.68 218.32,152.04 218.32,152.04 Z M 218.32,152.04")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier171"),
                Cw("none"),
                aL("rgb(53, 28, 12)"),
                jL("M 156.3,97.06 C 131.28,97.07 104.64,119.45 101.28,128.69 101.25,128.53 101.22,128.37 101.2,128.21 104.16,118.2 112.56,105.71 121.69,100.99 121.31,101.75 116.77,105.9 117.62,108.55 121.69,103.64 137.61,94.37 146.42,93.14 145.57,93.62 139.88,95.79 140.35,97.4 144.24,95.13 156.84,94.28 161.39,90.97 161.1,92.74 158.41,95.92 156.3,97.06 Z M 156.3,97.06")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier172"),
                Cw("none"),
                aL("rgb(53, 28, 12)"),
                jL("M 188.62,113.37 C 189.06,110.5 189.81,107.73 190.81,105.21 174.3,113.59 144.89,114.16 136.3,109.59 163.68,112.36 181.78,103.15 186.49,99.71 186.25,100.75 183.88,105.2 180.76,106.9 187.39,104.91 193.97,100.61 199.18,94.47 199.45,101.98 196.47,106.99 188.62,113.37 Z M 188.62,113.37")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier173"),
                Cw("none"),
                aL("rgb(53, 28, 12)"),
                jL("M 218.95,142.3 C 218.78,141.61 215.72,142.07 215.52,141.32 215.47,141.75 215.42,142.17 215.38,142.58 213.68,137.34 210.69,127.27 209.56,126.84 211.64,133.99 208.25,146.82 203.67,157.75 203.65,157.8 203.63,157.84 203.61,157.89 204.47,161.48 205.27,165.15 205.51,168.83 205.77,168.81 206.04,168.8 206.31,168.78 209.91,164.15 212.18,155.92 218.32,152.04 218.32,152.04 220.3,147.47 218.95,142.3 Z M 218.95,142.3")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier174"),
                Cw("none"),
                aL("rgb(31, 16, 8)"),
                jL("M 217.98,151.5 C 213.8,154.14 211.36,158.71 209.2,162.75 208.09,164.81 207.04,166.79 205.85,168.33 205.66,163.88 204.74,158.67 203.25,153.78 201.19,146.96 198.08,140.83 194.29,136.04 187.69,127.74 187.65,115.18 191.32,105.66 196.41,102.97 197.23,100.06 197.23,100.06 188.28,108.63 167.72,112.14 152.41,111.77 144.86,111.59 138.86,110.46 136.11,108.74 142.64,107.1 149.63,102.68 152.45,100.77 154.79,99.18 157.39,97.23 159.35,95.37 161.76,93.08 161.32,90.8 161.32,90.8 161.18,91.73 159.4,93.8 156.25,96.37 141.58,96.42 127.79,103.99 120.77,108.57 112.03,114.29 104.59,121.32 101.66,126.48 100.26,115.69 102.71,105.64 108.78,97.31 115.78,87.7 127.61,80.66 139.65,78.93 139.65,78.93 136.23,77.89 131.02,79.73 128.04,80.78 125.1,82.08 122.31,83.68 116.49,87.02 111.45,91.47 107.74,96.56 101.08,105.7 98.65,116.83 100.71,128.75 L 101.11,131.12 101.94,128.86 C 103.47,124.66 110.67,116.7 121.47,109.64 128.1,105.31 140.86,98.27 154.57,97.69 153.7,98.34 152.76,99.02 151.74,99.71 145.59,103.88 139.16,106.89 134.55,107.78 L 133.4,108 134.21,108.85 C 136.53,111.3 143.15,112.83 152.38,113.05 153.1,113.06 153.82,113.07 154.56,113.07 162.18,113.07 170.43,112.16 177.52,110.5 182.12,109.43 186.2,108.07 189.66,106.47 188.41,110.1 187.67,114.07 187.57,117.98 187.43,123.12 188.31,130.57 193.28,136.84 202.22,148.09 204.61,162.98 204.61,170 L 204.61,171.54 205.7,170.45 C 207.48,168.68 208.86,166.09 210.32,163.35 212.51,159.26 214.77,155.04 218.66,152.58 L 217.98,151.5 Z M 217.98,151.5")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier175"),
                Cw("none"),
                aL("rgb(255, 177, 144)"),
                jL("M 202.28,164.22 L 203.4,175.34 C 217.12,179.39 229.45,162.76 222.03,153.25 213.57,142.43 203.26,158.21 202.28,164.22 Z M 202.28,164.22")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier176"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 213.69,149.09 C 207.36,150.87 202.68,160.36 202.11,164.65 202.11,164.65 207.46,151.71 213.95,150.11 216.7,149.43 219.27,150.57 221.61,153.57 225.25,158.23 223.93,164.24 221.03,167.98 213.91,177.15 202.7,175.33 202.7,175.33 204,175.98 205.3,176.19 206.73,176.19 212.79,176.18 218.97,172.85 221.9,168.57 225.57,163.19 225.78,157.2 222.44,152.93 219.17,148.75 215.87,148.48 213.69,149.09 Z M 213.69,149.09")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier177"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 216.63,154.6 C 215.58,154.02 213.65,153.73 211.61,155.45 207.2,159.15 204.99,166.07 204.99,166.07 208.02,159.75 212.86,154.01 216.21,155.56 218.61,156.67 220.14,159.74 219.02,163.26 219.31,163.26 221.86,157.44 216.63,154.6 Z M 216.63,154.6")
            ]), M),
            A2(bw, l([
                uw("canvas2-bezier178"),
                Cw("none"),
                aL("rgb(161, 65, 29)"),
                jL("M 214.09,157.73 C 212.28,157.14 210.08,158.25 207.76,160.18 L 207.57,161.38 C 209.64,159.66 211.88,158.1 213.98,158.56 216.15,159.02 216.68,160.4 216.71,160.44 216.71,160.44 216.43,158.49 214.09,157.73 Z M 214.09,157.73")
            ]), M)
        ]))
    ])), Wx = {
        $: 4
    }, qx = A2(RL, M, l([
        A2(zw, l([
            Bw("-18.79"),
            Gw("-11.31"),
            Ow("18.78"),
            Ww("11.31"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(52, 0, 38)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(19, 157, 235)"),
                kw("1")
            ]), M)
        ])),
        A2(zw, l([
            uw("partyPopperDrawing-gradient5-clip"),
            Bw("-18.79"),
            Gw("-11.31"),
            Ow("18.78"),
            Ww("11.31"),
            yw("userSpaceOnUse")
        ]), l([
            A2(xw, l([
                Kw("0"),
                Hw("rgb(52, 0, 38)"),
                kw("1")
            ]), M),
            A2(xw, l([
                Kw("1"),
                Hw("rgb(19, 157, 235)"),
                kw("1")
            ]), M)
        ]))
    ])), Ux = F5(function(n, r, e, t, a) {
        return A2(oL, l([
            cL(iS(n)),
            bL(iS(r)),
            Lw(iS(e)),
            aw(iS(t)),
            pw("0 0 202 220"),
            mw("overflow:visible")
        ]), l([
            A2(tw, l([
                Ew("rotate(" + iS(a) + ")")
            ]), l([
                qx,
                A2(bw, l([
                    uw("partyPopperDrawing-bezier"),
                    Cw("none"),
                    aL("rgb(239, 15, 122)"),
                    jL("M 95.24,38.18 C 95.31,35.42 95.15,32.66 95.08,29.9 95.01,27.12 95.13,24.36 95.25,21.59 95.37,18.93 95.69,16.19 97.4,14.05 97.91,13.41 98.65,13.04 99.36,12.67 99.84,12.42 100.65,12.21 101.03,11.81 101.23,11.59 101.03,10.79 100.99,10.59 100.84,9.65 100.61,8.72 100.36,7.79 100.11,6.87 99.84,5.95 99.5,5.06 99.54,5.16 99.03,3.86 98.91,3.98 98.58,4.33 97.88,4.52 97.46,4.73 96.78,5.07 96.05,5.42 95.52,5.96 93.7,7.77 93.26,10.64 93.07,13.07 92.63,18.7 93.04,24.3 93,29.94 92.96,35.43 91.69,40.48 88.74,45.14 85.91,49.61 81.95,53.27 77.92,56.64 77.7,56.82 77.93,57.72 77.95,57.86 78.11,58.8 78.33,59.74 78.58,60.66 78.64,60.86 79.87,64.6 80.03,64.47 84,61.16 87.8,57.58 90.67,53.25 93.68,48.71 95.09,43.6 95.24,38.18 Z M 95.24,38.18")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier2"),
                    Cw("none"),
                    aL("rgb(0, 174, 239)"),
                    jL("M 6.72,164.99 C 22.57,159.45 117.87,126.12 118.17,125.88 121.78,123.02 113.68,106.83 100.09,89.74 86.49,72.65 72.55,61.12 68.94,63.98 68.61,64.24 4.48,165.77 4.48,165.77 4.48,165.77 4.51,165.76 4.55,165.75 3.93,166.37 3.31,166.97 2.79,167.61 1.56,169.12 1.13,171.21 0.7,173.06 -0.32,177.43 -0.34,182.61 1.39,186.8 3.17,191.07 7.18,193.93 9.16,198.11 12.19,204.51 9.78,212.09 11.37,218.81 11.58,219.73 12.99,219.55 12.84,218.59 11.9,212.66 12.8,206.63 11.64,200.73 10.79,196.41 7.96,193.36 5.26,190.08 1.43,185.42 1.05,180 1.9,174.21 2.32,171.37 3.21,168.98 5.11,166.81 5.66,166.18 6.23,165.6 6.72,164.99 Z M 6.72,164.99")
                ]), M),
                A2(tw, l([
                    uw("partyPopperDrawing-group"),
                    Dw("url(#partyPopperDrawing-clip)")
                ]), l([
                    A2($w, l([
                        uw("partyPopperDrawing-clip")
                    ]), l([
                        A2(kx, l([
                            TL("0"),
                            IL("-0"),
                            GZ("9"),
                            Ox("39.8"),
                            Ew("translate(94.6, 94.56) rotate(-39.55)")
                        ]), M)
                    ])),
                    A2(kx, l([
                        uw("partyPopperDrawing-oval"),
                        Cw("none"),
                        aL("url(#partyPopperDrawing-gradient5-oval)"),
                        TL("0"),
                        IL("-0"),
                        GZ("9"),
                        Ox("39.8"),
                        Ew("translate(94.6, 94.56) rotate(-39.55)")
                    ]), M)
                ])),
                A2(AS, l([
                    uw("partyPopperDrawing-star2"),
                    Cw("none"),
                    aL("rgb(255, 255, 255)"),
                    US("0,-8.9 2.62,-3.6 8.46,-2.75 4.23,1.38 5.23,7.2 0,4.45 -5.23,7.2 -4.23,1.38 -8.46,-2.75 -2.62,-3.6"),
                    Ew("translate(65.6, 99.06) rotate(-69.2)")
                ]), M),
                A2(AS, l([
                    uw("partyPopperDrawing-star3"),
                    Cw("none"),
                    aL("rgb(255, 255, 255)"),
                    US("0,-4.4 1.29,-1.78 4.18,-1.36 2.09,0.68 2.59,3.56 0,2.2 -2.59,3.56 -2.09,0.68 -4.18,-1.36 -1.29,-1.78"),
                    Ew("translate(82.9, 115.91) rotate(-3.15)")
                ]), M),
                A2(AS, l([
                    uw("partyPopperDrawing-star4"),
                    Cw("none"),
                    aL("rgb(255, 255, 255)"),
                    US("0,-4.4 1.29,-1.78 4.18,-1.36 2.09,0.68 2.59,3.56 0,2.2 -2.59,3.56 -2.09,0.68 -4.18,-1.36 -1.29,-1.78"),
                    Ew("translate(46.7, 117.61) rotate(-3.15)")
                ]), M),
                A2(AS, l([
                    uw("partyPopperDrawing-star5"),
                    Cw("none"),
                    aL("rgb(255, 255, 255)"),
                    US("0,-8 2.35,-3.24 7.61,-2.47 3.8,1.24 4.7,6.47 0,4 -4.7,6.47 -3.8,1.24 -7.61,-2.47 -2.35,-3.24"),
                    Ew("translate(62.15, 129.91) rotate(-17.9)")
                ]), M),
                A2(AS, l([
                    uw("partyPopperDrawing-star6"),
                    Cw("none"),
                    aL("rgb(255, 255, 255)"),
                    US("0,-8 2.35,-3.24 7.61,-2.47 3.8,1.24 4.7,6.47 0,4 -4.7,6.47 -3.8,1.24 -7.61,-2.47 -2.35,-3.24"),
                    Ew("translate(38.45, 140.41) rotate(-17.9)")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier3"),
                    Cw("none"),
                    aL("rgb(239, 65, 54)"),
                    jL("M 121.94,108.66 C 123.77,113.09 127.8,113.43 132.16,113.97 137.06,114.57 140.55,113.13 144.75,110.71 146.92,109.46 149,108.24 151.43,107.58 150.85,107.46 150.27,107.34 149.69,107.23 150.48,107.48 151.27,107.73 152.06,107.99 153.37,108.41 154.72,108.81 156.08,109.08 160.24,109.9 165.71,111.47 169.53,108.95 169.37,109.05 165.11,107.78 164.66,107.71 163.52,107.54 160.71,106.75 159.64,107.46 157.18,108.33 157.53,108.76 160.67,108.77 159.88,108.52 159.09,108.26 158.3,108.01 156.55,107.45 154.77,107.01 152.96,106.67 149.85,106.08 146.34,105.34 143.15,105.73 140.05,106.11 137.52,107.68 134.86,109.22 132.94,110.34 131.03,111.37 128.94,112.09 125.97,112.7 127.69,113.13 134.1,113.38 132.84,112.83 132.3,111.28 131.83,110.15 130.96,108.04 122.31,109.57 121.94,108.66 Z M 121.94,108.66")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier4"),
                    Cw("none"),
                    aL("rgb(247, 148, 30)"),
                    jL("M 112.81,85.2 C 118.34,87.44 118.55,78.55 120.49,75.47 123.55,70.59 129.88,77.9 133.83,73.69 135.25,72.18 134.92,69.18 134.99,67.3 135.11,63.87 136.04,60.02 138.9,57.84 140.72,56.44 143.4,56.43 145.58,56.28 149,56.03 152.58,55.69 155.41,53.56 160.3,49.89 155.02,41.94 158.58,37.8 159.73,36.46 162.78,37.4 164.23,37.52 167.66,37.79 170.14,36.35 171.79,33.4 173.16,30.94 173.81,28.23 175.97,26.27 177.64,24.76 180.14,25.11 182.2,25.3 184.02,25.48 186.05,25.85 187.77,25.04 189.62,24.17 189.24,21.31 189.06,19.71 189,19.22 188.93,18.72 188.85,18.23 188.68,17.07 188.57,15.53 187.97,14.48 187.83,14.25 187.93,16.45 187.97,16.7 188.6,20.91 179.91,18.95 178,19 172.33,19.15 172.02,26.81 168.66,29.91 166.54,31.87 163.4,31.43 160.8,31.12 158.89,30.89 157.51,31.07 156.72,32.97 154.48,38.37 159.03,45.27 152.44,48.56 147.66,50.93 141.05,48.66 136.96,52.4 134.91,54.28 134.13,57.58 133.85,60.21 133.59,62.69 134.26,65.93 132.4,67.91 128.58,71.97 122.9,64.62 119.4,69.32 117.14,72.36 117.41,81.35 111.73,79.05 112.33,79.3 111.47,84.66 112.81,85.2 Z M 112.81,85.2")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier5"),
                    Cw("none"),
                    aL("rgb(0, 174, 239)"),
                    jL("M 115,52.24 C 118.21,51.99 116.18,47.64 116.37,45.69 116.69,42.59 121.5,44.61 122.4,41.63 122.72,40.56 121.84,39.19 121.42,38.26 120.66,36.57 120.19,34.49 121.04,32.75 121.59,31.63 122.88,30.99 123.9,30.39 125.49,29.45 127.14,28.42 128,26.71 129.49,23.77 125.02,21.19 125.75,18.33 125.98,17.41 127.68,17.13 128.41,16.84 130.14,16.15 130.99,14.86 131.08,13.04 131.15,11.52 130.81,10.05 131.39,8.59 131.84,7.45 133.13,7.02 134.17,6.62 135.09,6.27 136.16,5.96 136.8,5.16 137.49,4.29 136.62,3 136.14,2.27 135.99,2.05 135.84,1.82 135.69,1.6 135.32,1.08 134.9,0.36 134.36,0 134.24,-0.08 134.81,0.96 134.89,1.08 136.21,2.96 131.53,4.1 130.62,4.58 127.92,6.01 129.61,9.79 128.73,12.1 128.18,13.55 126.55,14.1 125.22,14.57 124.24,14.92 123.62,15.33 123.69,16.44 123.9,19.6 127.76,21.83 125.36,25.01 123.62,27.3 119.88,27.79 118.8,30.58 118.26,31.98 118.67,33.76 119.17,35.1 119.64,36.37 120.74,37.77 120.32,39.17 119.45,42.06 114.94,39.87 114.37,42.98 114.01,44.99 116.3,49.27 113,49.52 113.35,49.5 114.22,52.3 115,52.24 Z M 115,52.24")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier6"),
                    Cw("none"),
                    aL("rgb(238, 42, 123)"),
                    jL("M 133.49,93.75 C 135.73,96.06 137.78,91.71 139.4,90.62 141.98,88.87 143.51,93.86 146.38,92.64 147.41,92.21 147.9,90.66 148.34,89.74 149.15,88.07 150.45,86.37 152.34,85.92 153.54,85.63 154.87,86.2 155.97,86.6 157.72,87.22 159.56,87.84 161.42,87.4 164.64,86.66 163.76,81.58 166.42,80.31 167.28,79.9 168.58,81.03 169.27,81.4 170.91,82.28 172.45,82.11 173.9,81.02 175.12,80.1 176.03,78.9 177.52,78.41 178.68,78.02 179.84,78.74 180.81,79.28 181.67,79.77 182.59,80.4 183.62,80.37 184.73,80.34 185.16,78.84 185.42,78.02 185.5,77.76 185.57,77.5 185.64,77.24 185.81,76.63 186.09,75.84 186.02,75.2 186,75.05 185.57,76.16 185.53,76.29 184.93,78.51 181.07,75.64 180.11,75.25 177.28,74.09 175.45,77.81 173.12,78.61 171.65,79.12 170.19,78.21 168.98,77.49 168.08,76.96 167.36,76.75 166.56,77.52 164.27,79.7 165.02,84.1 161.05,84.28 158.17,84.42 155.4,81.85 152.57,82.81 151.14,83.29 150.04,84.75 149.33,85.99 148.66,87.16 148.28,88.9 146.93,89.47 144.16,90.65 142.96,85.78 140.21,87.34 138.43,88.35 136.6,92.85 134.3,90.47 134.54,90.73 132.95,93.19 133.49,93.75 Z M 133.49,93.75")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier7"),
                    Cw("none"),
                    aL("rgb(0, 166, 81)"),
                    jL("M 115.09,97.97 C 115.97,98.21 116.84,97.92 117.66,97.63 118.84,97.21 119.97,96.66 121.14,96.24 121.43,96.14 119.48,93.18 119.37,93.02 119.17,92.73 117.5,90.03 116.99,90.21 115.91,90.6 114.87,91.07 113.81,91.49 112.92,91.83 111.9,92.21 110.93,91.95 110.81,91.91 111.39,93.08 111.33,92.97 111.74,93.72 112.22,94.45 112.71,95.16 113.2,95.87 113.71,96.57 114.27,97.23 114.47,97.47 114.75,97.88 115.09,97.97 Z M 115.09,97.97")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier8"),
                    Cw("none"),
                    aL("rgb(0, 166, 81)"),
                    jL("M 98.63,72.69 C 99.51,72.93 100.38,72.64 101.2,72.35 102.39,71.93 103.51,71.38 104.69,70.96 104.97,70.86 103.03,67.9 102.92,67.74 102.71,67.45 101.05,64.75 100.54,64.93 99.46,65.32 98.42,65.79 97.35,66.21 96.47,66.56 95.45,66.93 94.48,66.67 94.35,66.63 94.93,67.8 94.87,67.69 95.29,68.44 95.76,69.17 96.25,69.88 96.74,70.59 97.25,71.29 97.81,71.95 98.01,72.19 98.3,72.6 98.63,72.69 Z M 98.63,72.69")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier9"),
                    Cw("none"),
                    aL("rgb(38, 34, 98)"),
                    jL("M 99.37,92.33 C 99.92,92.46 100.52,92.1 101.08,91.76 101.89,91.26 102.68,90.64 103.49,90.13 103.68,90.02 102.72,87.52 102.66,87.39 102.56,87.14 101.75,84.85 101.4,85.06 100.66,85.53 99.94,86.06 99.2,86.55 98.59,86.96 97.89,87.4 97.29,87.26 97.21,87.24 97.46,88.25 97.44,88.16 97.63,88.8 97.87,89.42 98.11,90.01 98.36,90.61 98.62,91.2 98.91,91.74 99.02,91.94 99.17,92.29 99.37,92.33 Z M 99.37,92.33")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier10"),
                    Cw("none"),
                    aL("rgb(38, 34, 98)"),
                    jL("M 115.77,7.31 C 116.32,7.43 116.92,7.08 117.48,6.73 118.29,6.23 119.08,5.61 119.89,5.11 120.08,4.99 119.12,2.49 119.06,2.36 118.96,2.11 118.16,-0.18 117.8,0.04 117.06,0.5 116.34,1.04 115.6,1.53 114.99,1.94 114.29,2.38 113.69,2.24 113.61,2.22 113.87,3.22 113.84,3.13 114.03,3.78 114.27,4.39 114.51,4.99 114.76,5.58 115.02,6.17 115.31,6.71 115.42,6.91 115.56,7.26 115.77,7.31 Z M 115.77,7.31")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier11"),
                    Cw("none"),
                    aL("rgb(38, 34, 98)"),
                    jL("M 139.85,36.11 C 140.4,36.24 140.99,35.88 141.56,35.54 142.37,35.04 143.16,34.42 143.97,33.92 144.16,33.79 143.19,31.3 143.14,31.17 143.04,30.92 142.23,28.63 141.88,28.85 141.14,29.31 140.41,29.84 139.68,30.33 139.06,30.74 138.37,31.18 137.76,31.04 137.68,31.03 137.94,32.03 137.91,31.94 138.11,32.58 138.34,33.2 138.59,33.79 138.83,34.39 139.09,34.98 139.39,35.52 139.5,35.72 139.64,36.07 139.85,36.11 Z M 139.85,36.11")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier12"),
                    Cw("none"),
                    aL("rgb(38, 34, 98)"),
                    jL("M 197.32,66 C 197.87,66.13 198.46,65.77 199.03,65.43 199.84,64.93 200.63,64.31 201.44,63.8 201.63,63.69 200.66,61.19 200.61,61.06 200.51,60.81 199.7,58.51 199.35,58.73 198.61,59.2 197.88,59.73 197.15,60.22 196.53,60.63 195.83,61.07 195.23,60.93 195.15,60.92 195.41,61.92 195.38,61.83 195.58,62.47 195.81,63.09 196.06,63.68 196.3,64.28 196.56,64.87 196.86,65.41 196.96,65.61 197.11,65.96 197.32,66 Z M 197.32,66")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier13"),
                    Cw("none"),
                    aL("rgb(38, 34, 98)"),
                    jL("M 77.04,41.66 C 77.59,41.79 78.19,41.43 78.75,41.08 79.56,40.58 80.35,39.96 81.16,39.46 81.35,39.34 80.39,36.84 80.34,36.71 80.23,36.46 79.43,34.17 79.07,34.39 78.33,34.85 77.61,35.39 76.87,35.88 76.26,36.29 75.56,36.73 74.96,36.59 74.88,36.57 75.14,37.57 75.11,37.48 75.3,38.13 75.54,38.74 75.78,39.34 76.03,39.93 76.29,40.52 76.59,41.07 76.69,41.26 76.84,41.61 77.04,41.66 Z M 77.04,41.66")
                ]), M),
                A2(bw, l([
                    uw("partyPopperDrawing-bezier14"),
                    Cw("none"),
                    aL("rgb(146, 39, 143)"),
                    jL("M 174.55,66.17 C 175.1,66.3 175.7,65.94 176.26,65.6 177.07,65.1 177.86,64.48 178.67,63.97 178.86,63.86 177.9,61.36 177.85,61.22 177.74,60.97 176.94,58.68 176.58,58.9 175.84,59.36 175.12,59.9 174.38,60.39 173.77,60.8 173.07,61.24 172.47,61.1 172.39,61.08 172.65,62.09 172.62,61.99 172.81,62.64 173.05,63.25 173.29,63.85 173.54,64.45 173.8,65.04 174.1,65.58 174.2,65.78 174.35,66.12 174.55,66.17 Z M 174.55,66.17")
                ]), M),
                A2(AS, l([
                    uw("partyPopperDrawing-star7"),
                    Cw("none"),
                    aL("rgb(238, 42, 123)"),
                    US("0,-4.4 1.29,-1.78 4.18,-1.36 2.09,0.68 2.59,3.56 0,2.2 -2.59,3.56 -2.09,0.68 -4.18,-1.36 -1.29,-1.78"),
                    Ew("translate(120.05, 55.76) rotate(-0.55)")
                ]), M),
                A2(AS, l([
                    uw("partyPopperDrawing-star8"),
                    Cw("none"),
                    aL("rgb(238, 42, 123)"),
                    US("0,-2.05 0.59,-0.81 1.95,-0.63 0.95,0.31 1.2,1.66 0,1 -1.2,1.66 -0.95,0.31 -1.95,-0.63 -0.59,-0.81"),
                    Ew("translate(153.6, 10.16) rotate(-17)")
                ]), M),
                A2(AS, l([
                    uw("partyPopperDrawing-star9"),
                    Cw("none"),
                    aL("rgb(238, 42, 123)"),
                    US("0,-2 0.59,-0.81 1.9,-0.62 0.95,0.31 1.18,1.62 0,1 -1.18,1.62 -0.95,0.31 -1.9,-0.62 -0.59,-0.81"),
                    Ew("translate(151.4, 71.06) rotate(-35)")
                ]), M),
                A2(AS, l([
                    uw("partyPopperDrawing-star10"),
                    Cw("none"),
                    aL("rgb(238, 42, 123)"),
                    US("0,-4.5 1.32,-1.82 4.28,-1.39 2.14,0.7 2.65,3.64 0,2.25 -2.65,3.64 -2.14,0.7 -4.28,-1.39 -1.32,-1.82"),
                    Ew("translate(177.75, 100.26) rotate(-69.35)")
                ]), M),
                A2(AS, l([
                    uw("partyPopperDrawing-star11"),
                    Cw("none"),
                    aL("rgb(247, 148, 30)"),
                    US("0,-2.3 0.68,-0.93 2.19,-0.71 1.09,0.36 1.35,1.86 0,1.15 -1.35,1.86 -1.09,0.36 -2.19,-0.71 -0.68,-0.93"),
                    Ew("translate(106.45, 27.06) rotate(-17.05)")
                ]), M),
                A2(AS, l([
                    uw("partyPopperDrawing-star12"),
                    Cw("none"),
                    aL("rgb(238, 42, 123)"),
                    US("0,-3.3 0.97,-1.33 3.14,-1.02 1.57,0.51 1.94,2.67 0,1.65 -1.94,2.67 -1.57,0.51 -3.14,-1.02 -0.97,-1.33"),
                    Ew("translate(190, 41.81) rotate(-65.6)")
                ]), M)
            ]))
        ]));
    }), Ax = function(n) {
        var r;
        return xS(A7(LS, "victoryModal", wg(Hx), n.cQ.dH, 380, A4(Pw, 0, 0, "275", "400"), l([
            wS(n.cK.cp),
            Gx,
            A5(Ux, 200, 100, 50.5, 55, 0),
            A5(Ux, 35, 140, 50.5, 55, 270),
            zz(A4(By, Se(n.da.cf), A2(dz, n.da.cf, n.cK), 12, 220)),
            (r = A4(hS, 30, 320, 220, 60), A3(OS, r, wg(Wx), l([
                kS("Next")
            ])))
        ]), M));
    };
    Lc = {
        Main: {
            init: Gu({
                bA: _u,
                bD: {
                    ce: Yu,
                    dz: Xu
                },
                cv: ac,
                cY: function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                },
                cZ: function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                },
                dq: yc,
                dF: Vp,
                dI: F2(function(n, r) {
                    var e;
                    return {
                        bI: l([
                            A2(BL, M, A2(RS, !r.cQ.cL, A2(tK, r, A2(Z$, r, A2(KL, r, A2(B$, r, A2(rK, r, A2(q$, r, A2(xx, r, A2(qz, r, A2(gS, r, A2(Lx, r, A2(DD, r, A2(ky, r, A2(Zw, r, l([
                                QD(r),
                                Kz(r),
                                Ax(r),
                                RD(r),
                                GS(r),
                                TS(r),
                                _z(r),
                                (e = !r.cQ.cL, A2(oL, A2(yD, e, l([
                                    Lw("471"),
                                    pw("0 0 375 120"),
                                    uw("level-complete-notification")
                                ])), l([
                                    zD,
                                    A2(tw, l([
                                        uw("levelCompleteDrawing-group2"),
                                        Dw("url(#levelCompleteDrawing-rectangle)")
                                    ]), l([
                                        A2($w, l([
                                            uw("levelCompleteDrawing-rectangle")
                                        ]), l([
                                            A2(Aw, l([
                                                cL("0"),
                                                bL("-120"),
                                                Lw("375"),
                                                aw("120"),
                                                Ew("translate(0, 120)")
                                            ]), M)
                                        ])),
                                        A2(tw, l([
                                            uw("levelCompleteDrawing-stripesBackground"),
                                            XL("url(#levelCompleteDrawing-levelCompleteOuterShadow-outer)")
                                        ]), l([
                                            A2(Aw, l([
                                                uw("levelCompleteDrawing-rectangle4"),
                                                Cw("none"),
                                                aL("url(#levelCompleteDrawing-lightStripeGradiantBottom-rectangle4)"),
                                                cL("-86"),
                                                bL("97"),
                                                Lw("547"),
                                                aw("3")
                                            ]), M),
                                            A2(Aw, l([
                                                uw("levelCompleteDrawing-rectangle6"),
                                                Cw("none"),
                                                aL("url(#levelCompleteDrawing-lightStripeGradiantTop-rectangle6)"),
                                                cL("-86"),
                                                bL("-2.5"),
                                                Lw("547"),
                                                aw("100")
                                            ]), M),
                                            A2(tw, l([
                                                uw("levelCompleteDrawing-group3"),
                                                Dw("url(#levelCompleteDrawing-rectangle5)")
                                            ]), l([
                                                A2($w, l([
                                                    uw("levelCompleteDrawing-rectangle5")
                                                ]), l([
                                                    A2(Aw, l([
                                                        cL("0"),
                                                        bL("0"),
                                                        Lw("375"),
                                                        aw("120")
                                                    ]), M)
                                                ])),
                                                A2(tw, l([
                                                    uw("levelCompleteDrawing-group5"),
                                                    Dw("url(#levelCompleteDrawing-bezier)")
                                                ]), l([
                                                    A2($w, l([
                                                        uw("levelCompleteDrawing-bezier")
                                                    ]), l([
                                                        A2(bw, l([
                                                            jL("M 21.2,100 L 48.17,100 139.86,-0 112.89,-0 21.2,100 Z M 74.68,100 L 101.65,100 193.34,-0 166.38,-0 74.68,100 Z M 128.17,100 L 155.14,100 246.83,-0 219.86,-0 128.17,100 Z M -32.29,100 L -5.32,100 86.37,-0 59.4,-0 -32.29,100 Z M 235.37,100 L 262.34,100 354.03,-0 327.06,-0 235.37,100 Z M 288.85,100 L 315.82,100 407.51,-0 380.55,-0 288.85,100 Z M 342.34,100 L 369.31,100 461,-0 434.03,-0 342.34,100 Z M 181.88,100 L 208.85,100 300.54,-0 273.57,-0 181.88,100 Z M -86,100 L -59.03,100 32.66,-0 5.69,-0 -86,100 Z M -86,100")
                                                        ]), M)
                                                    ])),
                                                    A2(tw, l([
                                                        uw("levelCompleteDrawing-group6")
                                                    ]), l([
                                                        A2(Aw, l([
                                                            uw("levelCompleteDrawing-bottomShade"),
                                                            Cw("none"),
                                                            aL("url(#levelCompleteDrawing-darkStripeGradiantBottom-bottomShade)"),
                                                            cL("-86"),
                                                            bL("97"),
                                                            Lw("547"),
                                                            aw("3")
                                                        ]), M),
                                                        A2(Aw, l([
                                                            uw("levelCompleteDrawing-topShade"),
                                                            Cw("none"),
                                                            aL("url(#levelCompleteDrawing-darkStripeGradiantTop-topShade)"),
                                                            cL("-86"),
                                                            bL("-3"),
                                                            Lw("547"),
                                                            aw("100")
                                                        ]), M)
                                                    ]))
                                                ]))
                                            ]))
                                        ])),
                                        A2(tw, l([
                                            uw("levelCompleteDrawing-topHighlight"),
                                            Uw("0.6"),
                                            mw("mix-blend-mode: screen;")
                                        ]), l([
                                            A2(Aw, l([
                                                uw("levelCompleteDrawing-rectangle2"),
                                                mw("mix-blend-mode: screen;"),
                                                Cw("none"),
                                                aL("url(#levelCompleteDrawing-highlight-rectangle2)"),
                                                cL("0"),
                                                bL("6"),
                                                Lw("375"),
                                                aw("18")
                                            ]), M),
                                            A2(Aw, l([
                                                uw("levelCompleteDrawing-rectangle3"),
                                                mw("mix-blend-mode: screen;"),
                                                Cw("none"),
                                                aL("url(#levelCompleteDrawing-reverseHighlight-rectangle3)"),
                                                cL("0"),
                                                bL("0"),
                                                Lw("375"),
                                                aw("6")
                                            ]), M)
                                        ]))
                                    ])),
                                    A2(tw, l([
                                        uw("levelCompleteDrawing-group4")
                                    ]), l([
                                        A2(tw, l([
                                            uw("levelCompleteDrawing-group")
                                        ]), l([
                                            A2(Aw, l([
                                                uw("levelCompleteDrawing-beigeBackground"),
                                                Cw("none"),
                                                aL("rgb(252, 246, 213)"),
                                                XL("url(#levelCompleteDrawing-levelCompleteInnerShadow-outer)"),
                                                cL("-94"),
                                                bL("16"),
                                                Lw("555"),
                                                aw("68")
                                            ]), M),
                                            A2(bw, l([
                                                uw("levelCompleteDrawing-bottomBeigeStipe"),
                                                Cw("none"),
                                                aL("rgb(251, 225, 173)"),
                                                jL("M -94,76.23 L 461,76.23 461,78.92 -94,78.92 -94,76.23 Z M -94,76.23")
                                            ]), M),
                                            A2(bw, l([
                                                uw("levelCompleteDrawing-topBeigeStripe"),
                                                Cw("none"),
                                                aL("rgb(251, 225, 173)"),
                                                jL("M -94,23.09 L 461,23.09 461,25.78 -94,25.78 -94,23.09 Z M -94,23.09")
                                            ]), M)
                                        ])),
                                        A2(bw, l([
                                            uw("levelCompleteDrawing-beigeStipeShadow"),
                                            Cw("none"),
                                            aL("url(#levelCompleteDrawing-gradient3-beigeStipeShadow)"),
                                            jL("M 0.07,81 L 374.93,81 374.93,84.13 0.07,84.13 0.07,81 Z M 0.07,81")
                                        ]), M),
                                        A2(bw, l([
                                            uw("levelCompleteDrawing-levelCompleteText"),
                                            Cw("none"),
                                            aL("rgb(71, 148, 129)"),
                                            jL("M 64.35,62.22 L 64.35,35.54 67.53,35.54 67.53,59.21 81.41,59.21 81.41,62.22 64.35,62.22 Z M 93.49,50.67 C 92.47,50.67 91.59,50.92 90.85,51.43 90.1,51.94 89.58,52.6 89.27,53.41 89.15,53.8 89.06,54.24 89,54.75 90.21,54.32 91.4,53.88 92.59,53.43 93.78,52.99 94.97,52.55 96.17,52.12 95.82,51.69 95.41,51.34 94.97,51.07 94.52,50.8 94.03,50.67 93.49,50.67 Z M 100.24,53.91 C 98.5,54.55 96.77,55.18 95.04,55.82 93.32,56.45 91.59,57.09 89.85,57.72 90.23,58.26 90.74,58.68 91.36,59 91.99,59.32 92.7,59.48 93.49,59.48 94.67,59.48 95.64,59.07 96.4,58.26 L 98.36,60.54 C 97.72,61.18 96.99,61.67 96.17,62.03 95.36,62.38 94.46,62.56 93.49,62.56 92.42,62.56 91.41,62.37 90.48,61.97 89.55,61.58 88.74,61.04 88.05,60.35 87.36,59.67 86.81,58.87 86.42,57.97 86.02,57.07 85.82,56.1 85.82,55.05 85.82,54.04 86.02,53.07 86.42,52.16 86.81,51.24 87.36,50.45 88.05,49.77 88.74,49.1 89.55,48.57 90.48,48.17 91.41,47.78 92.42,47.58 93.49,47.58 94.28,47.58 95.04,47.74 95.77,48.06 96.5,48.38 97.15,48.82 97.73,49.37 98.3,49.93 98.81,50.6 99.24,51.38 99.68,52.15 100.01,53 100.24,53.91 Z M 111.51,63.1 C 110.13,60.56 108.75,58.03 107.37,55.51 105.99,53 104.61,50.47 103.23,47.93 L 106.41,47.93 C 106.82,48.69 107.27,49.48 107.75,50.29 108.24,51.1 108.72,51.92 109.19,52.73 109.66,53.54 110.1,54.36 110.5,55.19 110.89,56.01 111.23,56.83 111.51,57.65 111.77,56.83 112.1,56.01 112.51,55.19 112.92,54.36 113.36,53.54 113.83,52.73 114.3,51.92 114.78,51.1 115.25,50.29 115.72,49.48 116.18,48.69 116.61,47.93 L 119.79,47.93 C 118.41,50.47 117.03,53 115.65,55.51 114.27,58.03 112.89,60.56 111.51,63.1 Z M 129.38,50.67 C 128.36,50.67 127.47,50.92 126.73,51.43 125.99,51.94 125.47,52.6 125.16,53.41 125.03,53.8 124.94,54.24 124.89,54.75 126.09,54.32 127.29,53.88 128.48,53.43 129.67,52.99 130.86,52.55 132.06,52.12 131.7,51.69 131.3,51.34 130.85,51.07 130.41,50.8 129.92,50.67 129.38,50.67 Z M 136.13,53.91 C 134.39,54.55 132.66,55.18 130.93,55.82 129.21,56.45 127.47,57.09 125.74,57.72 126.12,58.26 126.62,58.68 127.25,59 127.88,59.32 128.59,59.48 129.38,59.48 130.55,59.48 131.53,59.07 132.29,58.26 L 134.25,60.54 C 133.61,61.18 132.88,61.67 132.06,62.03 131.24,62.38 130.35,62.56 129.38,62.56 128.31,62.56 127.3,62.37 126.37,61.97 125.44,61.58 124.62,61.04 123.93,60.35 123.24,59.67 122.7,58.87 122.3,57.97 121.91,57.07 121.71,56.1 121.71,55.05 121.71,54.04 121.91,53.07 122.3,52.16 122.7,51.24 123.24,50.45 123.93,49.77 124.62,49.1 125.44,48.57 126.37,48.17 127.3,47.78 128.31,47.58 129.38,47.58 130.17,47.58 130.93,47.74 131.66,48.06 132.39,48.38 133.04,48.82 133.62,49.37 134.19,49.93 134.7,50.6 135.13,51.38 135.56,52.15 135.9,53 136.13,53.91 Z M 143.03,62.22 L 139.85,62.22 139.85,33.63 143.03,33.63 143.03,62.22 Z M 177.88,58.1 L 179.61,60.62 C 178.58,61.2 177.49,61.67 176.33,62.01 175.17,62.35 173.93,62.52 172.63,62.52 170.74,62.52 168.96,62.17 167.3,61.46 165.64,60.75 164.19,59.77 162.95,58.54 161.71,57.31 160.73,55.87 160.01,54.22 159.3,52.56 158.94,50.8 158.94,48.92 158.94,47.04 159.3,45.26 160.01,43.6 160.73,41.94 161.71,40.49 162.95,39.25 164.19,38.02 165.64,37.04 167.3,36.32 168.96,35.6 170.74,35.23 172.63,35.23 173.93,35.23 175.17,35.4 176.33,35.73 177.49,36.06 178.6,36.53 179.64,37.14 179.36,37.57 179.07,38 178.76,38.42 178.46,38.84 178.16,39.26 177.88,39.69 177.09,39.24 176.26,38.88 175.39,38.63 174.52,38.37 173.6,38.24 172.63,38.24 171.17,38.24 169.81,38.52 168.54,39.08 167.28,39.64 166.17,40.41 165.21,41.39 164.25,42.37 163.5,43.5 162.95,44.8 162.4,46.1 162.12,47.47 162.12,48.92 162.12,50.37 162.4,51.74 162.95,53.03 163.5,54.33 164.25,55.45 165.21,56.41 166.17,57.36 167.28,58.12 168.54,58.67 169.81,59.23 171.17,59.51 172.63,59.51 174.52,59.51 176.27,59.04 177.88,58.1 Z M 183.63,55.05 C 183.63,54.04 183.83,53.07 184.23,52.16 184.62,51.24 185.17,50.45 185.86,49.77 186.55,49.1 187.36,48.57 188.29,48.17 189.22,47.78 190.23,47.58 191.3,47.58 192.37,47.58 193.38,47.78 194.33,48.17 195.28,48.57 196.09,49.1 196.78,49.77 197.47,50.45 198.02,51.24 198.41,52.16 198.81,53.07 199.01,54.04 199.01,55.05 199.01,56.1 198.81,57.07 198.41,57.97 198.02,58.87 197.47,59.67 196.78,60.35 196.09,61.04 195.28,61.58 194.33,61.97 193.38,62.37 192.37,62.56 191.3,62.56 190.23,62.56 189.22,62.37 188.29,61.97 187.36,61.58 186.55,61.04 185.86,60.35 185.17,59.67 184.62,58.87 184.23,57.97 183.83,57.07 183.63,56.1 183.63,55.05 Z M 186.81,55.09 C 186.81,55.7 186.93,56.27 187.16,56.81 187.39,57.34 187.7,57.8 188.1,58.2 188.5,58.59 188.96,58.9 189.5,59.13 190.04,59.36 190.61,59.48 191.22,59.48 191.84,59.48 192.41,59.36 192.95,59.13 193.49,58.9 193.96,58.59 194.37,58.2 194.78,57.8 195.1,57.34 195.33,56.81 195.56,56.27 195.67,55.7 195.67,55.09 195.67,54.48 195.56,53.91 195.33,53.38 195.1,52.84 194.78,52.37 194.37,51.97 193.96,51.56 193.49,51.24 192.95,51.01 192.41,50.78 191.84,50.67 191.22,50.67 190.61,50.67 190.04,50.78 189.5,51.01 188.96,51.24 188.5,51.56 188.1,51.97 187.7,52.37 187.39,52.84 187.16,53.38 186.93,53.91 186.81,54.48 186.81,55.09 Z M 203.61,47.93 L 206.41,47.93 206.41,48.27 C 206.46,48.88 206.5,49.43 206.54,49.93 206.58,50.42 206.62,50.98 206.68,51.59 207.21,50.37 208.02,49.41 209.11,48.71 210.2,48.01 211.47,47.63 212.93,47.58 214.33,47.58 215.46,47.93 216.32,48.63 217.18,49.33 217.68,50.25 217.83,51.39 218.4,50.23 219.21,49.31 220.29,48.65 221.36,47.99 222.6,47.63 224.01,47.58 225.51,47.58 226.7,47.98 227.57,48.76 228.44,49.55 228.9,50.58 228.95,51.85 L 228.95,62.22 225.77,62.22 225.77,53.3 C 225.72,52.61 225.47,52.02 225.02,51.53 224.58,51.03 223.87,50.76 222.89,50.71 222.23,50.71 221.6,50.82 221,51.05 220.4,51.28 219.87,51.6 219.41,52 218.95,52.41 218.57,52.89 218.29,53.45 218.01,54.01 217.87,54.62 217.87,55.28 L 217.87,62.22 214.69,62.22 214.69,53.3 C 214.64,52.61 214.39,52.02 213.94,51.53 213.49,51.03 212.78,50.76 211.81,50.71 211.15,50.71 210.52,50.82 209.92,51.05 209.32,51.28 208.78,51.6 208.32,52 207.86,52.41 207.49,52.89 207.21,53.45 206.93,54.01 206.79,54.62 206.79,55.28 L 206.79,62.22 203.61,62.22 203.61,47.93 Z M 245.71,55.05 C 245.71,53.78 245.29,52.74 244.46,51.91 243.63,51.08 242.55,50.67 241.22,50.67 239.89,50.67 238.81,51.08 237.98,51.91 237.15,52.74 236.74,53.78 236.74,55.05 236.74,56.3 237.15,57.35 237.98,58.2 238.81,59.05 239.89,59.48 241.22,59.48 242.55,59.48 243.63,59.05 244.46,58.2 245.29,57.35 245.71,56.3 245.71,55.05 Z M 248.93,55.05 C 248.93,56.07 248.73,57.04 248.33,57.95 247.94,58.87 247.39,59.67 246.7,60.35 246.01,61.04 245.2,61.58 244.25,61.97 243.31,62.37 242.3,62.56 241.22,62.56 240.46,62.56 239.77,62.47 239.17,62.3 238.57,62.12 238.07,61.92 237.66,61.71 237.25,61.49 236.93,61.28 236.7,61.08 236.47,60.87 236.35,60.73 236.35,60.66 236.4,60.78 236.47,60.92 236.54,61.08 236.62,61.23 236.68,61.37 236.74,61.5 L 236.74,71.75 233.55,71.75 233.55,47.93 236.2,47.93 C 236.2,48.23 236.22,48.53 236.26,48.82 236.29,49.11 236.33,49.41 236.35,49.72 236.35,49.64 236.48,49.49 236.74,49.26 236.99,49.03 237.34,48.8 237.77,48.55 238.21,48.31 238.72,48.09 239.3,47.89 239.89,47.68 240.53,47.58 241.22,47.58 242.3,47.58 243.31,47.78 244.25,48.17 245.2,48.57 246.01,49.11 246.7,49.79 247.39,50.48 247.94,51.27 248.33,52.18 248.73,53.08 248.93,54.04 248.93,55.05 Z M 256.52,62.22 L 253.34,62.22 253.34,33.63 256.52,33.63 256.52,62.22 Z M 267.6,50.67 C 266.58,50.67 265.7,50.92 264.96,51.43 264.21,51.94 263.69,52.6 263.38,53.41 263.26,53.8 263.17,54.24 263.12,54.75 264.32,54.32 265.51,53.88 266.7,53.43 267.89,52.99 269.08,52.55 270.28,52.12 269.93,51.69 269.52,51.34 269.08,51.07 268.63,50.8 268.14,50.67 267.6,50.67 Z M 274.35,53.91 C 272.61,54.55 270.88,55.18 269.15,55.82 267.43,56.45 265.7,57.09 263.96,57.72 264.34,58.26 264.85,58.68 265.47,59 266.1,59.32 266.81,59.48 267.6,59.48 268.78,59.48 269.75,59.07 270.52,58.26 L 272.47,60.54 C 271.83,61.18 271.1,61.67 270.28,62.03 269.47,62.38 268.57,62.56 267.6,62.56 266.53,62.56 265.52,62.37 264.59,61.97 263.66,61.58 262.85,61.04 262.16,60.35 261.47,59.67 260.92,58.87 260.53,57.97 260.13,57.07 259.93,56.1 259.93,55.05 259.93,54.04 260.13,53.07 260.53,52.16 260.92,51.24 261.47,50.45 262.16,49.77 262.85,49.1 263.66,48.57 264.59,48.17 265.52,47.78 266.53,47.58 267.6,47.58 268.39,47.58 269.15,47.74 269.88,48.06 270.61,48.38 271.26,48.82 271.84,49.37 272.41,49.93 272.92,50.6 273.35,51.38 273.79,52.15 274.12,53 274.35,53.91 Z M 279.99,38.63 L 283.17,38.63 283.17,47.58 286.93,47.58 286.93,50.67 283.17,50.67 283.17,62.22 279.99,62.22 279.99,50.67 276.76,50.67 276.76,47.58 279.99,47.58 279.99,38.63 Z M 296.4,50.67 C 295.37,50.67 294.49,50.92 293.75,51.43 293.01,51.94 292.48,52.6 292.18,53.41 292.05,53.8 291.96,54.24 291.91,54.75 293.11,54.32 294.31,53.88 295.49,53.43 296.68,52.99 297.88,52.55 299.08,52.12 298.72,51.69 298.32,51.34 297.87,51.07 297.42,50.8 296.93,50.67 296.4,50.67 Z M 303.14,53.91 C 301.41,54.55 299.67,55.18 297.95,55.82 296.22,56.45 294.49,57.09 292.75,57.72 293.14,58.26 293.64,58.68 294.27,59 294.89,59.32 295.6,59.48 296.4,59.48 297.57,59.48 298.54,59.07 299.31,58.26 L 301.27,60.54 C 300.63,61.18 299.9,61.67 299.08,62.03 298.26,62.38 297.37,62.56 296.4,62.56 295.32,62.56 294.32,62.37 293.39,61.97 292.45,61.58 291.64,61.04 290.95,60.35 290.26,59.67 289.72,58.87 289.32,57.97 288.93,57.07 288.73,56.1 288.73,55.05 288.73,54.04 288.93,53.07 289.32,52.16 289.72,51.24 290.26,50.45 290.95,49.77 291.64,49.1 292.45,48.57 293.39,48.17 294.32,47.78 295.32,47.58 296.4,47.58 297.19,47.58 297.95,47.74 298.68,48.06 299.41,48.38 300.06,48.82 300.63,49.37 301.21,49.93 301.71,50.6 302.15,51.38 302.58,52.15 302.91,53 303.14,53.91 Z M 308.47,62.22 C 307.96,62.22 307.5,62.03 307.09,61.65 306.68,61.27 306.48,60.78 306.48,60.2 306.48,59.62 306.68,59.14 307.09,58.77 307.5,58.4 307.96,58.22 308.47,58.22 308.96,58.22 309.41,58.4 309.82,58.77 310.22,59.14 310.43,59.62 310.43,60.2 310.43,60.78 310.22,61.27 309.82,61.65 309.41,62.03 308.96,62.22 308.47,62.22 Z M 306.86,33.63 L 310.05,33.63 310.05,55.89 306.86,55.89 306.86,33.63 Z M 306.86,33.63")
                                        ]), M)
                                    ]))
                                ])))
                            ]))))))))))))))))
                        ]),
                        dy: "Kana Party"
                    };
                })
            })(gt(0))(0)
        }
    }, n.Elm ? function n(r, e) {
        for(var t in e)t in r ? "init" == t ? H(6) : n(r[t], e[t]) : r[t] = e[t];
    }(n.Elm, Lc) : n.Elm = Lc;
}($a0b4f895e1596b3b$exports);


// This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA
const $6b528e0c36449ff5$var$isLocalhost = Boolean(window.location.hostname === 'localhost' || // [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $6b528e0c36449ff5$export$6503ec6e8aabbaf(config) {
    if ('serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(undefined, window.location.href);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
        window.addEventListener('load', ()=>{
            const swUrl = `${undefined}/service-worker.js`;
            if ($6b528e0c36449ff5$var$isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                $6b528e0c36449ff5$var$checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(()=>{
                    console.log("This web app is being served cache-first by a service worker. To learn more, visit https://bit.ly/CRA-PWA");
                });
            } else // Is not localhost. Just register service worker
            $6b528e0c36449ff5$var$registerValidSW(swUrl, config);
        });
    }
}
function $6b528e0c36449ff5$var$registerValidSW(swUrl, config) {
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the updated precached content has been fetched,
                        // but the previous service worker will still serve the older
                        // content until all client tabs are closed.
                        console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                        // Execute callback
                        if (config && config.onUpdate) config.onUpdate(registration);
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log('Content is cached for offline use.');
                        // Execute callback
                        if (config && config.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch((error)=>{
        console.error('Error during service worker registration:', error);
    });
}
function $6b528e0c36449ff5$var$checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl).then((response)=>{
        // Ensure service worker exists, and that we really are getting a JS file.
        const contentType = response.headers.get('content-type');
        if (response.status === 404 || contentType != null && contentType.indexOf('javascript') === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration)=>{
            registration.unregister().then(()=>{
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $6b528e0c36449ff5$var$registerValidSW(swUrl, config);
    }).catch(()=>{
        console.log('No internet connection found. App is running in offline mode.');
    });
}
function $6b528e0c36449ff5$export$d07f55d4c15c0440() {
    if ('serviceWorker' in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    });
}


function $35da740d59af89ba$var$startAudio(e) {
    if (window.AudioContext = window.AudioContext || window.webkitAudioContext || !1, window.AudioContext) {
        let o = [], t = new AudioContext, n = {};
        function a(n, a) {
            let r = new XMLHttpRequest;
            r.open("GET", n, !0), r.responseType = "arraybuffer", r.onerror = function() {
                e.ports.audioPortFromJS.send({
                    type: 0,
                    requestId: a,
                    error: "NetworkError"
                });
            }, r.onload = function() {
                t.decodeAudioData(r.response, function(t) {
                    let r = o.length, s = n.endsWith(".mp3");
                    o.push({
                        isMp3: s,
                        buffer: t
                    }), e.ports.audioPortFromJS.send({
                        type: 1,
                        requestId: a,
                        bufferId: r,
                        durationInSeconds: (t.length - 0) / t.sampleRate
                    });
                }, function(o) {
                    e.ports.audioPortFromJS.send({
                        type: 0,
                        requestId: a,
                        error: o.message
                    });
                });
            }, r.send();
        }
        function r(e, o) {
            return (e - o) / 1e3 + t.currentTime;
        }
        function s(e, o, t) {
            o ? (e.loopStart = t + o.loopStart / 1e3, e.loopEnd = t + o.loopEnd / 1e3, e.loop = !0) : e.loop = !1;
        }
        function u(e, o, t, n, a) {
            let r = (a - e) / (t - e);
            return Number.isFinite(r) ? r * (n - o) + o : o;
        }
        function l(e, o) {
            return e.map((e)=>{
                let n = t.createGain();
                n.gain.setValueAtTime(e[0].volume, 0), n.gain.linearRampToValueAtTime(e[0].volume, 0);
                let a = r(o, o);
                for(let s = 1; s < e.length; s += 1){
                    let l = e[s - 1], i = r(l.time, o), d = e[s], p = r(d.time, o);
                    if (p > a && a >= i) {
                        let m = u(i, l.volume, p, d.volume, a);
                        n.gain.setValueAtTime(m, 0), n.gain.linearRampToValueAtTime(d.volume, p);
                    } else p > a ? n.gain.linearRampToValueAtTime(d.volume, p) : n.gain.setValueAtTime(d.volume, 0);
                }
                return n;
            });
        }
        function i(e) {
            for(let o = 1; o < e.length; o += 1)e[o - 1].connect(e[o]);
        }
        function d(e, o, n, a, u, d, p, m) {
            let c = e.buffer, f = e.isMp3 ? 0 / t.sampleRate : 0, $ = t.createBufferSource();
            if (p) {
                let b = 10 + p.loopEnd / 1e3 - c.length / c.sampleRate;
                if (b > 0) {
                    let g = c.getChannelData(0).length + Math.ceil(b * c.sampleRate), A = t.createBuffer(c.numberOfChannels, g, t.sampleRate);
                    for(let T = 0; T < c.numberOfChannels; T += 1)A.copyToChannel(c.getChannelData(T), T);
                    $.buffer = A;
                } else $.buffer = c;
            } else $.buffer = c;
            $.playbackRate.value = m, s($, p, f);
            let _ = l(n, d), I = t.createGain();
            return I.gain.setValueAtTime(o, 0), i([
                $,
                I,
                ..._,
                t.destination
            ]), a >= d ? $.start(r(a, d), f + u / 1e3) : $.start(0, (d - a) / 1e3 + f + u / 1e3), {
                sourceNode: $,
                gainNode: I,
                volumeAtGainNodes: _
            };
        }
        e.ports.audioPortFromJS.send({
            type: 2,
            samplesPerSecond: t.sampleRate
        }), e.ports.audioPortToJS.subscribe((e)=>{
            let r = new Date().getTime();
            for(let u = 0; u < e.audio.length; u += 1){
                let p = e.audio[u];
                switch(p.action){
                    case "stopSound":
                        {
                            let m = n[p.nodeGroupId];
                            n[p.nodeGroupId] = null, m.nodes.sourceNode.stop(), m.nodes.sourceNode.disconnect(), m.nodes.gainNode.disconnect(), m.nodes.volumeAtGainNodes.map((e)=>e.disconnect());
                            break;
                        }
                    case "setVolume":
                        n[p.nodeGroupId].nodes.gainNode.gain.setValueAtTime(p.volume, 0);
                        break;
                    case "setVolumeAt":
                        {
                            let c = n[p.nodeGroupId];
                            c.nodes.volumeAtGainNodes.map((e)=>e.disconnect()), c.nodes.gainNode.disconnect();
                            let f = l(p.volumeAt, r);
                            i([
                                c.nodes.gainNode,
                                ...f,
                                t.destination
                            ]), c.nodes.volumeAtGainNodes = f;
                            break;
                        }
                    case "setLoopConfig":
                        {
                            let $ = n[p.nodeGroupId], b = o[$.bufferId].isMp3 ? 0 / t.sampleRate : 0;
                            s($.nodes.sourceNode, p.loop, b);
                            break;
                        }
                    case "setPlaybackRate":
                        n[p.nodeGroupId].nodes.sourceNode.playbackRate.setValueAtTime(p.playbackRate, 0);
                        break;
                    case "startSound":
                        {
                            let g = d(o[p.bufferId], p.volume, p.volumeTimelines, p.startTime, p.startAt, r, p.loop, p.playbackRate);
                            n[p.nodeGroupId] = {
                                bufferId: p.bufferId,
                                nodes: g
                            };
                        }
                }
            }
            for(let A = 0; A < e.audioCmds.length; A += 1)a(e.audioCmds[A].audioUrl, e.audioCmds[A].requestId);
        });
    } else console.log("Web audio is not supported in your browser.");
}
var $35da740d59af89ba$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById('root')
});
$35da740d59af89ba$var$startAudio($35da740d59af89ba$var$app);
let $35da740d59af89ba$var$highScoresKey = "highScores";
$35da740d59af89ba$var$app.ports.highScoresPortToJS.subscribe(function(message) {
    let highScoreRequest = JSON.parse(message);
    let requestType = highScoreRequest.messageType;
    if (requestType === "requestScoreByLevelID" && highScoreRequest.levelID) {
        let levelID = highScoreRequest.levelID;
        let highScores = $35da740d59af89ba$var$getHighScores();
        let highScore = highScores[levelID];
        if (highScore) $35da740d59af89ba$var$app.ports.highScoresPortFromJS.send(highScores[levelID].toString());
    }
    if (requestType === "saveScoreByLevelID") {
        let highScore = JSON.parse(message);
        let keys = Object.keys(highScore).filter((key)=>isNaN(key) === false);
        let highScores = $35da740d59af89ba$var$getHighScores();
        keys.map((key)=>{
            if (key > 0 && highScore[key] <= highScores[key]) return;
            highScores[key] = highScore[key];
            localStorage.setItem($35da740d59af89ba$var$highScoresKey, JSON.stringify(highScores));
        });
    }
});
$35da740d59af89ba$var$app.ports.settingsPortToJS.subscribe(function(message) {
    let settingsRequest = JSON.parse(message);
    let requestType = settingsRequest.messageType;
    if (requestType === "saveSoundEffectsEnabled") localStorage.setItem("soundEffectsEnabled", settingsRequest.soundEffectsEnabled);
    if (requestType === "saveMusicEnabled") localStorage.setItem("musicEnabled", settingsRequest.musicEnabled);
    if (requestType === "saveTextAudioEnabled") localStorage.setItem("textAudioEnabled", settingsRequest.textAudioEnabled);
    if (requestType === "saveHintsEnabled") localStorage.setItem("hintsEnabled", settingsRequest.hintsEnabled);
    if (requestType === "requestSettings") {
        let soundEffectsEnabled = $35da740d59af89ba$var$getBoolSetting("soundEffectsEnabled");
        let textAudioEnabled = $35da740d59af89ba$var$getBoolSetting("textAudioEnabled");
        let musicEnabled = $35da740d59af89ba$var$getBoolSetting("musicEnabled");
        let hintsEnabled = $35da740d59af89ba$var$getBoolSetting("hintsEnabled");
        $35da740d59af89ba$var$app.ports.settingsPortFromJS.send({
            soundEffectsEnabled: soundEffectsEnabled,
            textAudioEnabled: textAudioEnabled,
            musicEnabled: musicEnabled,
            hintsEnabled: hintsEnabled
        });
    }
});
$35da740d59af89ba$var$app.ports.deviceClassPortToJS.subscribe(function(deviceClass) {
    if (deviceClass) $35da740d59af89ba$var$setDeviceClass(deviceClass);
});
function $35da740d59af89ba$var$getBoolSetting(key) {
    let stringSetting = localStorage.getItem(key);
    if (stringSetting !== null && stringSetting !== undefined) return stringSetting === "1";
    return stringSetting;
}
function $35da740d59af89ba$var$getHighScores() {
    let highScores = localStorage.getItem($35da740d59af89ba$var$highScoresKey);
    if (!highScores) {
        localStorage.setItem($35da740d59af89ba$var$highScoresKey, JSON.stringify({}));
        return {};
    }
    return JSON.parse(highScores);
}
var $35da740d59af89ba$var$root = document.querySelector(':root');
function $35da740d59af89ba$var$setDeviceClass(deviceClass) {
    $35da740d59af89ba$var$root.classList = [
        deviceClass
    ];
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
$6b528e0c36449ff5$export$d07f55d4c15c0440();


//# sourceMappingURL=kana-party-web-game.89b0d661.js.map
